// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { client } from '../client.gen';
import { addCompanyContactTag, addPersonContactTag, appVersion, closeMarketSearch, createEmailTemplate, createEventEmailTemplate, createMarketSearch, createPersonContactTagDefinition, deleteAllCandidatePathwayActivityTargets, deleteAPipeline, deleteCandidateCompanyMetadata, deleteCandidateFavorite, deleteCandidateFeedback, deleteCandidateGoal, deleteCandidateGoalActivity, deleteCandidatePathwayActivityTarget, deleteCandidateReferrer, deleteComment, deleteCompany, deleteEmailTemplate, deleteEmailTemplateDefault, deleteEvent, deleteEventEmailTemplate, deleteEventGuest, deleteEventLandingImage, deleteExecutiveActivation, deleteHighlight, deleteIdentityCandidate, deleteIdentityPerson, deleteInternalComment, deleteIntroductionTemplate, deleteMarketSearch, deletePeer, deletePeerComment, deletePersonContactTagDefinition, deletePersonImage, deleteRecommendation, deleteRecommendationAssignee, deleteSubmission, deleteTask, deleteTaskModule, deleteTeam, deleteTeamContactComment, deleteTeamMember, deleteUserV2, findIdentity, getAllEventGuests, getAutotagPreviewStatus, getCandidateActivityLogs, getCandidateActivityLogsSearch, getCandidateCommentary, getCandidateCompanyMetadata, getCandidateGoals, getCandidateGoalsWithActivities, getCandidateGoalV2, getCandidateImage, getCandidateIntroductionsTeamHistory, getCandidateIntroductionTemplates, getCandidateOffLimitsCompanies, getCandidateOffLimitsIdentities, getCandidatePathwayActivityTargets, getCandidateRecommendations, getCandidateRecommendationsCompareBackground, getCandidateRecommendationsComparePerformance, getCandidateRecommendationsComparePipelines, getCandidateRecommendationsCompareRecommendations, getCandidateResume, getCandidatesFind, getCandidateStats, getCandidateTasksOnboarding, getCandidateV2, getCompanies, getCompaniesFind, getCompaniesSectors, getCompany, getCompanyByName, getCompanyMembers, getContactsFind, getCountries, getEmailPreview, getEmailTemplate, getEsIndex, getEvent, getEventEmailBatches, getEventEmailEvents, getEventGuests, getEventLandingImagePublic, getEventRsvpLanding, getEventRsvpLandingImage, getEventRsvpPreview, getEvents, getExecutive, getExecutiveClientCandidate, getExecutiveClientContact, getExecutiveClientEvent, getExecutiveClientPersonDetail, getExecutiveClientSettings, getExecutiveClientTeam, getExecutiveClientTrending, getExecutiveClientTrendingRecommendation, getExecutives, getFilesImage, getFind, getHomeActivityLogs, getHomeAllIntros, getHomeCandidatesDownvotes, getHomeTeamActivity, getHomeTeamCandidates, getHomeTeamStats, getIdentity, getIdentityEmailEvents, getJobsAutoIntroductions, getJobsDraftStatusChangeEmails, getJobsFacilitatedIntroReminder, getJobsHubspotFieldSync, getJobsLinkedinBatchSync, getJobsMarketSearchClassificationCatchup, getJobsMarketSearchClosureVerification, getJobsMarketSearchResolveSweep, getJobsRefreshTeamInsights, getJobsResendinvite, getJobsScheduledIntros, getJobsScheduledP2pIntros, getMarketSearch, getMarketSearchContactOptions, getMarketSearchPipelineOptions, getMarketSearchTeamOptions, getNewCandidates, getPathwayActivityDefaults, getPeer, getPeerActivity, getPeopleAdvisors, getPeopleCurrent, getPeopleCurrentTeams, getPeopleFind, getPeopleInternal, getPersonImage, getPipelinesFind, getRecommendation, getRecommendationsFind, getRecsysAssignees, getRecsysCandidateOpportunities, getRecsysOpportunityRationale, getRecsysPipelineRecommendations, getReindexStatus, getSubmission, getTailoredHighlightsStatus, getTask, getTaskModule, getTeam, getTeamCandidate, getTeamCandidateActivity, getTeamCandidateRecommendations, getTeamContactComments, getTeamIntroInsight, getTeamMembers, getTeamPipeline, getTeamPipelineCandidates, getTeamPipelineCandidatesOffLimits, getTeamPipelineRecommendation, getTeamPipelineRecommendationBio, getTeamPipelineRecommendationChecksShared, getTeamPipelineRecommendationInternalComments, getTeamPipelineRecommendationIntroduction, getTeamPipelines, getTeamRecommendationBio, getTeamRecommendationIntroduction, getTeamsFind, getTeamTrending, getTeamTrendingRecommendation, getTeamTrendingRecommendationActivity, getTeamTrendingRecommendationComments, getTrendingMessageKeys, getTrendingMessages, getUserEvents, getUserV2, getV1Recommendation, getV1RecommendationPreview, getVerifyEmailOneTimeCode, healthCheck, importCandidateCompanyMetadata, linkMarketSearch, listCandidateCompanyMetadata, listCompanyContactTags, listEmailTemplateDefaults, listEmailTemplates, listEmailTypes, listEventEmailTemplates, listExecutiveClientEvents, listPersonContactTags, type Options, patchAliasToEsIndex, patchCandidate, patchCandidateGoals, patchCandidateGoalV2, patchCandidateV2, patchCompany, patchEvent, patchEventGuest, patchEventGuests, patchEventRsvp, patchExecutiveClientSettings, patchExecutiveSettings, patchPeopleCurrent, patchPerson, patchPersonContactTagDefinition, patchPersonEmailNotifications, patchTeam, patchTeamPipeline, patchUser, patchUserRoleRemoveCompany, postActivateExecutive, postAdminExecutiveClientActivity, postAdminPeersCandidatesFilter, postAdminPeersFilter, postAdminPeersMatches, postAdminPeersPublish, postAdminPipelineCandidatesFilter, postAutotagPreview, postBulkActivateExecutives, postCandidateActivityLog, postCandidateCompareAbout, postCandidateCompareGoals, postCandidateCompareP2P, postCandidateFavorite, postCandidateFeedbackFilter, postCandidateFeedbackV2, postCandidateGoalActivity, postCandidateGoalTasks, postCandidateHighlights, postCandidateHighlightsV2, postCandidateIntroTemplates, postCandidateMerge, postCandidateRecommendationsFilter, postCandidates, postCandidatesExportFailed, postCandidatesFilter, postCandidatesGoalsV2, postCandidateShowOnboardingSection, postCandidatesImportFromCsv, postCandidatesPerformanceFilter, postCandidatesPerformanceInRed, postCandidatesTrendingFilter, postCandidateTasksFilter, postClerkWebhook, postCompanies, postCompaniesSearchV2, postCompanyPeopleFilter, postCompanyTeams, postContactLists, postEmailResponseFeedback, postEsReindex, postEvent, postEventAnnouncementSend, postEventGuests, postEventGuestsSelection, postEventInvitePreview, postEventInviteSend, postEventLandingImage, postEventReminderPreview, postEventReminderSend, postEventRsvpPreview, postExecutiveClientActivity, postExecutiveClientContactPipelines, postExecutiveClientPeopleSearch, postFilesImage, postFilesLinkedinResume, posthogJs, posthogProxy, postHomeCandidates, postHomepageCandidates, postHomeTeamCandidateFeedback, postHomeTeamViews, postIdentity, postIdentityLogin, postIdentityMerge, postIdentityPerson, postLinkedinPreview, postLinkedinSyncCandidate, postPeerComment, postPeopleV2, postPersonClerkUser, postPersonContactFavorite, postPersonImage, postPipelineCandidates, postPipelinesFilter, postPipelineTransferToTeam, postPotentialGuests, postPotentialGuestsSelection, postRecommendationOffLimits, postRecsysCandidateContext, postRecsysOpportunityBadMatch, postRecsysOpportunityReviewed, postRecsysRecommendationFeedback, postRecsysRecommendations, postSendExecutiveInvitation, postShareRecommendations, postSubmissionCancelRecommendations, postSubmissionEmailPreview, postSubmissionFilter, postSubmissions, postSubmissionsFilter, postTailoredHighlights, postTaskModules, postTasks, postTasksFilter, postTeamCandidateFavorite, postTeamCandidatePipelines, postTeamCandidatesFilterV3, postTeamCandidateStatus, postTeamCandidateViews, postTeamContactComment, postTeamMembersBulkV2, postTeamMembersV2, postTeamMerge, postTeamPipelineRecommendationComments, postTeamPipelineRecommendationDislike, postTeamPipelineRecommendationFavorite, postTeamPipelineRecommendationInternalComments, postTeamPipelineRecommendationIntroduction, postTeamPipelineRecommendationViews, postTeamPipelines, postTeamPipelineSubmission, postTeamPipelineViews, postTeamRecommendationIntroduction, postTeams, postTeamsFilter, postTeamsSuggested, postTeamsV2, postTeamTeams, postTeamTransferToCompany, postTeamTrendingRecommendationComments, postTeamTrendingRecommendationDislike, postTeamTrendingRecommendationFavorite, postTeamTrendingRecommendationViews, postToken, postTrendingSchedule, postUserCompany, postUsersBulkDeleteV2, postUsersSearchV2, postUserTeam, postUtilsMailSend, postWebhooksEsEvents, previewEventEmail, putCandidate, putCandidateCommentary, putCandidateFeedback, putCandidateOffLimitsCompanies, putCandidateOffLimitsIdentities, putCandidatePathwayActivityTargets, putCandidateReferrer, putComment, putCompanies, putEmailTemplateDefault, putEvaluationHistoryIntroduction, putHighlight, putIdentityCandidate, putInternalComment, putIntroductionTemplate, putMultipleRecommendationDrafts, putPathwayActivityDefaults, putPeerAssignees, putPeerIntroduction, putPeerStatus, putPeopleCurrentPassword, putPersonPassword, putRecommendationCommentary, putRecommendationStatus, putRecommendationStatusV2, putSubmission, putSubmissionStatus, putTask, putTaskModule, putTaskModuleStatus, putTaskStatus, putTeam, putTeamCandidateStatus, putTeamContactComment, putTeamPipeline, putTeamPipelineRecommendationIntroEmailType, removeCompanyContactTag, removePersonContactTag, resolvePersonCandidateByEmail, revertEvaluationHistory, searchMarketSearches, updateEmailTemplate, updateEventEmailTemplate, updateExecutiveClientEventRsvp, updateMarketSearch, updatePersonMetadataV2, upsertCandidateCompanyMetadata } from '../sdk.gen';
import type { AddCompanyContactTagData, AddCompanyContactTagError, AddCompanyContactTagResponse, AddPersonContactTagData, AddPersonContactTagError, AddPersonContactTagResponse, AppVersionData, CloseMarketSearchData, CloseMarketSearchError, CloseMarketSearchResponse, CreateEmailTemplateData, CreateEmailTemplateError, CreateEmailTemplateResponse, CreateEventEmailTemplateData, CreateEventEmailTemplateError, CreateEventEmailTemplateResponse, CreateMarketSearchData, CreateMarketSearchError, CreateMarketSearchResponse, CreatePersonContactTagDefinitionData, CreatePersonContactTagDefinitionError, CreatePersonContactTagDefinitionResponse, DeleteAllCandidatePathwayActivityTargetsData, DeleteAllCandidatePathwayActivityTargetsError, DeleteAllCandidatePathwayActivityTargetsResponse, DeleteAPipelineData, DeleteAPipelineError, DeleteAPipelineResponse, DeleteCandidateCompanyMetadataData, DeleteCandidateCompanyMetadataError, DeleteCandidateCompanyMetadataResponse, DeleteCandidateFavoriteData, DeleteCandidateFavoriteError, DeleteCandidateFavoriteResponse, DeleteCandidateFeedbackData, DeleteCandidateFeedbackError, DeleteCandidateFeedbackResponse, DeleteCandidateGoalActivityData, DeleteCandidateGoalActivityError, DeleteCandidateGoalActivityResponse, DeleteCandidateGoalData, DeleteCandidateGoalError, DeleteCandidateGoalResponse, DeleteCandidatePathwayActivityTargetData, DeleteCandidatePathwayActivityTargetError, DeleteCandidatePathwayActivityTargetResponse, DeleteCandidateReferrerData, DeleteCandidateReferrerError, DeleteCandidateReferrerResponse, DeleteCommentData, DeleteCommentError, DeleteCommentResponse, DeleteCompanyData, DeleteCompanyError, DeleteCompanyResponse, DeleteEmailTemplateData, DeleteEmailTemplateDefaultData, DeleteEmailTemplateDefaultError, DeleteEmailTemplateDefaultResponse, DeleteEmailTemplateError, DeleteEmailTemplateResponse, DeleteEventData, DeleteEventEmailTemplateData, DeleteEventEmailTemplateError, DeleteEventEmailTemplateResponse, DeleteEventError, DeleteEventGuestData, DeleteEventGuestError, DeleteEventGuestResponse, DeleteEventLandingImageData, DeleteEventLandingImageError, DeleteEventLandingImageResponse, DeleteEventResponse, DeleteExecutiveActivationData, DeleteExecutiveActivationError, DeleteExecutiveActivationResponse, DeleteHighlightData, DeleteHighlightError, DeleteHighlightResponse2, DeleteIdentityCandidateData, DeleteIdentityCandidateError, DeleteIdentityCandidateResponse, DeleteIdentityPersonData, DeleteIdentityPersonError, DeleteIdentityPersonResponse, DeleteInternalCommentData, DeleteInternalCommentError, DeleteInternalCommentResponse, DeleteIntroductionTemplateData, DeleteIntroductionTemplateError, DeleteIntroductionTemplateResponse, DeleteMarketSearchData, DeleteMarketSearchError, DeleteMarketSearchResponse, DeletePeerCommentData, DeletePeerCommentError, DeletePeerCommentResponse, DeletePeerData, DeletePeerError, DeletePeerResponse, DeletePersonContactTagDefinitionData, DeletePersonContactTagDefinitionError, DeletePersonContactTagDefinitionResponse, DeletePersonImageData, DeletePersonImageError, DeleteRecommendationAssigneeData, DeleteRecommendationAssigneeError, DeleteRecommendationAssigneeResponse, DeleteRecommendationData, DeleteRecommendationError, DeleteRecommendationResponse, DeleteSubmissionData, DeleteSubmissionError, DeleteSubmissionResponse, DeleteTaskData, DeleteTaskError, DeleteTaskModuleData, DeleteTaskModuleError, DeleteTaskModuleResponse, DeleteTaskResponse, DeleteTeamContactCommentData, DeleteTeamContactCommentError, DeleteTeamContactCommentResponse, DeleteTeamData, DeleteTeamError, DeleteTeamMemberData, DeleteTeamMemberError, DeleteTeamMemberResponse, DeleteUserV2Data, DeleteUserV2Error, DeleteUserV2Response, FindIdentityData, FindIdentityError, FindIdentityResponse, GetAllEventGuestsData, GetAllEventGuestsError, GetAllEventGuestsResponse, GetAutotagPreviewStatusData, GetAutotagPreviewStatusError, GetAutotagPreviewStatusResponse, GetCandidateActivityLogsData, GetCandidateActivityLogsError, GetCandidateActivityLogsResponse, GetCandidateActivityLogsSearchData, GetCandidateActivityLogsSearchError, GetCandidateActivityLogsSearchResponse, GetCandidateCommentaryData, GetCandidateCommentaryError, GetCandidateCommentaryResponse, GetCandidateCompanyMetadataData, GetCandidateCompanyMetadataError, GetCandidateCompanyMetadataResponse, GetCandidateGoalsData, GetCandidateGoalsError, GetCandidateGoalsResponse, GetCandidateGoalsWithActivitiesData, GetCandidateGoalsWithActivitiesError, GetCandidateGoalsWithActivitiesResponse, GetCandidateGoalV2Data, GetCandidateGoalV2Error, GetCandidateGoalV2Response, GetCandidateImageData, GetCandidateImageError, GetCandidateIntroductionsTeamHistoryData, GetCandidateIntroductionsTeamHistoryError, GetCandidateIntroductionsTeamHistoryResponse, GetCandidateIntroductionTemplatesData, GetCandidateIntroductionTemplatesError, GetCandidateIntroductionTemplatesResponse, GetCandidateOffLimitsCompaniesData, GetCandidateOffLimitsCompaniesError, GetCandidateOffLimitsCompaniesResponse, GetCandidateOffLimitsIdentitiesData, GetCandidateOffLimitsIdentitiesError, GetCandidateOffLimitsIdentitiesResponse, GetCandidatePathwayActivityTargetsData, GetCandidatePathwayActivityTargetsError, GetCandidatePathwayActivityTargetsResponse, GetCandidateRecommendationsCompareBackgroundData, GetCandidateRecommendationsCompareBackgroundError, GetCandidateRecommendationsCompareBackgroundResponse, GetCandidateRecommendationsComparePerformanceData, GetCandidateRecommendationsComparePerformanceError, GetCandidateRecommendationsComparePerformanceResponse, GetCandidateRecommendationsComparePipelinesData, GetCandidateRecommendationsComparePipelinesError, GetCandidateRecommendationsComparePipelinesResponse, GetCandidateRecommendationsCompareRecommendationsData, GetCandidateRecommendationsCompareRecommendationsError, GetCandidateRecommendationsCompareRecommendationsResponse, GetCandidateRecommendationsData, GetCandidateRecommendationsError, GetCandidateRecommendationsResponse, GetCandidateResumeData, GetCandidateResumeError, GetCandidateResumeResponse, GetCandidatesFindData, GetCandidatesFindError, GetCandidatesFindResponse, GetCandidateStatsData, GetCandidateStatsError, GetCandidateStatsResponse, GetCandidateTasksOnboardingData, GetCandidateTasksOnboardingError, GetCandidateTasksOnboardingResponse, GetCandidateV2Data, GetCandidateV2Error, GetCandidateV2Response, GetCompaniesData, GetCompaniesError, GetCompaniesFindData, GetCompaniesFindError, GetCompaniesFindResponse, GetCompaniesResponse, GetCompaniesSectorsData, GetCompaniesSectorsError, GetCompaniesSectorsResponse, GetCompanyByNameData, GetCompanyByNameError, GetCompanyByNameResponse, GetCompanyData, GetCompanyError, GetCompanyMembersData, GetCompanyMembersError, GetCompanyMembersResponse, GetCompanyResponse, GetContactsFindData, GetContactsFindError, GetContactsFindResponse, GetCountriesData, GetCountriesResponse, GetEmailPreviewData, GetEmailPreviewError, GetEmailPreviewResponse, GetEmailTemplateData, GetEmailTemplateError, GetEmailTemplateResponse, GetEsIndexData, GetEsIndexError, GetEsIndexResponse, GetEventData, GetEventEmailBatchesData, GetEventEmailBatchesError, GetEventEmailBatchesResponse, GetEventEmailEventsData, GetEventEmailEventsError, GetEventEmailEventsResponse, GetEventError, GetEventGuestsData, GetEventGuestsError, GetEventGuestsResponse, GetEventLandingImagePublicData, GetEventLandingImagePublicError, GetEventResponse, GetEventRsvpLandingData, GetEventRsvpLandingError, GetEventRsvpLandingImageData, GetEventRsvpLandingImageError, GetEventRsvpLandingResponse, GetEventRsvpPreviewData, GetEventRsvpPreviewError, GetEventRsvpPreviewResponse, GetEventsData, GetEventsError, GetEventsResponse, GetExecutiveClientCandidateData, GetExecutiveClientCandidateError, GetExecutiveClientCandidateResponse, GetExecutiveClientContactData, GetExecutiveClientContactError, GetExecutiveClientContactResponse, GetExecutiveClientEventData, GetExecutiveClientEventError, GetExecutiveClientEventResponse, GetExecutiveClientPersonDetailData, GetExecutiveClientPersonDetailError, GetExecutiveClientPersonDetailResponse, GetExecutiveClientSettingsData, GetExecutiveClientSettingsError, GetExecutiveClientSettingsResponse, GetExecutiveClientTeamData, GetExecutiveClientTeamError, GetExecutiveClientTeamResponse, GetExecutiveClientTrendingData, GetExecutiveClientTrendingError, GetExecutiveClientTrendingRecommendationData, GetExecutiveClientTrendingRecommendationError, GetExecutiveClientTrendingRecommendationResponse, GetExecutiveClientTrendingResponse, GetExecutiveData, GetExecutiveError, GetExecutiveResponse, GetExecutivesData, GetExecutivesResponse, GetFilesImageData, GetFilesImageError, GetFindData, GetFindError, GetFindResponse, GetHomeActivityLogsData, GetHomeActivityLogsError, GetHomeActivityLogsResponse, GetHomeAllIntrosData, GetHomeAllIntrosError, GetHomeAllIntrosResponse, GetHomeCandidatesDownvotesData, GetHomeTeamActivityData, GetHomeTeamActivityError, GetHomeTeamActivityResponse, GetHomeTeamCandidatesData, GetHomeTeamCandidatesError, GetHomeTeamCandidatesResponse, GetHomeTeamStatsData, GetHomeTeamStatsError, GetHomeTeamStatsResponse, GetIdentityData, GetIdentityEmailEventsData, GetIdentityEmailEventsError, GetIdentityEmailEventsResponse, GetIdentityError, GetIdentityResponse, GetJobsAutoIntroductionsData, GetJobsAutoIntroductionsResponse, GetJobsDraftStatusChangeEmailsData, GetJobsDraftStatusChangeEmailsError, GetJobsDraftStatusChangeEmailsResponse, GetJobsFacilitatedIntroReminderData, GetJobsFacilitatedIntroReminderError, GetJobsHubspotFieldSyncData, GetJobsHubspotFieldSyncError, GetJobsHubspotFieldSyncResponse, GetJobsLinkedinBatchSyncData, GetJobsLinkedinBatchSyncError, GetJobsLinkedinBatchSyncResponse, GetJobsMarketSearchClassificationCatchupData, GetJobsMarketSearchClassificationCatchupError, GetJobsMarketSearchClassificationCatchupResponse, GetJobsMarketSearchClosureVerificationData, GetJobsMarketSearchClosureVerificationError, GetJobsMarketSearchClosureVerificationResponse, GetJobsMarketSearchResolveSweepData, GetJobsMarketSearchResolveSweepError, GetJobsMarketSearchResolveSweepResponse, GetJobsRefreshTeamInsightsData, GetJobsRefreshTeamInsightsError, GetJobsRefreshTeamInsightsResponse, GetJobsResendinviteData, GetJobsResendinviteError, GetJobsScheduledIntrosData, GetJobsScheduledIntrosError, GetJobsScheduledIntrosResponse, GetJobsScheduledP2pIntrosData, GetJobsScheduledP2pIntrosError, GetJobsScheduledP2pIntrosResponse, GetMarketSearchContactOptionsData, GetMarketSearchContactOptionsError, GetMarketSearchContactOptionsResponse, GetMarketSearchData, GetMarketSearchError, GetMarketSearchPipelineOptionsData, GetMarketSearchPipelineOptionsError, GetMarketSearchPipelineOptionsResponse, GetMarketSearchResponse, GetMarketSearchTeamOptionsData, GetMarketSearchTeamOptionsError, GetMarketSearchTeamOptionsResponse, GetNewCandidatesData, GetNewCandidatesError, GetNewCandidatesResponse, GetPathwayActivityDefaultsData, GetPathwayActivityDefaultsResponse, GetPeerActivityData, GetPeerActivityError, GetPeerActivityResponse, GetPeerData, GetPeerError, GetPeerResponse, GetPeopleAdvisorsData, GetPeopleAdvisorsError, GetPeopleAdvisorsResponse, GetPeopleCurrentData, GetPeopleCurrentResponse, GetPeopleCurrentTeamsData, GetPeopleCurrentTeamsResponse, GetPeopleFindData, GetPeopleFindError, GetPeopleFindResponse, GetPeopleInternalData, GetPeopleInternalResponse, GetPersonImageData, GetPersonImageError, GetPipelinesFindData, GetPipelinesFindError, GetPipelinesFindResponse, GetRecommendationData, GetRecommendationError, GetRecommendationResponse, GetRecommendationsFindData, GetRecommendationsFindError, GetRecommendationsFindResponse, GetRecsysAssigneesData, GetRecsysAssigneesResponse, GetRecsysCandidateOpportunitiesData, GetRecsysCandidateOpportunitiesError, GetRecsysCandidateOpportunitiesResponse, GetRecsysOpportunityRationaleData, GetRecsysOpportunityRationaleError, GetRecsysOpportunityRationaleResponse, GetRecsysPipelineRecommendationsData, GetRecsysPipelineRecommendationsError, GetRecsysPipelineRecommendationsResponse, GetReindexStatusData, GetReindexStatusError, GetReindexStatusResponse, GetSubmissionData, GetSubmissionError, GetSubmissionResponse, GetTailoredHighlightsStatusData, GetTailoredHighlightsStatusError, GetTailoredHighlightsStatusResponse, GetTaskData, GetTaskError, GetTaskModuleData, GetTaskModuleError, GetTaskModuleResponse, GetTaskResponse, GetTeamCandidateActivityData, GetTeamCandidateActivityError, GetTeamCandidateActivityResponse, GetTeamCandidateData, GetTeamCandidateError, GetTeamCandidateRecommendationsData, GetTeamCandidateRecommendationsError, GetTeamCandidateRecommendationsResponse, GetTeamCandidateResponse, GetTeamContactCommentsData, GetTeamContactCommentsError, GetTeamContactCommentsResponse, GetTeamData, GetTeamError, GetTeamIntroInsightData, GetTeamIntroInsightError, GetTeamIntroInsightResponse, GetTeamMembersData, GetTeamMembersError, GetTeamMembersResponse, GetTeamPipelineCandidatesData, GetTeamPipelineCandidatesError, GetTeamPipelineCandidatesOffLimitsData, GetTeamPipelineCandidatesOffLimitsError, GetTeamPipelineCandidatesOffLimitsResponse, GetTeamPipelineCandidatesResponse, GetTeamPipelineData, GetTeamPipelineError, GetTeamPipelineRecommendationBioData, GetTeamPipelineRecommendationBioError, GetTeamPipelineRecommendationBioResponse, GetTeamPipelineRecommendationChecksSharedData, GetTeamPipelineRecommendationChecksSharedError, GetTeamPipelineRecommendationChecksSharedResponse, GetTeamPipelineRecommendationData, GetTeamPipelineRecommendationError, GetTeamPipelineRecommendationInternalCommentsData, GetTeamPipelineRecommendationInternalCommentsError, GetTeamPipelineRecommendationInternalCommentsResponse, GetTeamPipelineRecommendationIntroductionData, GetTeamPipelineRecommendationIntroductionError, GetTeamPipelineRecommendationIntroductionResponse, GetTeamPipelineRecommendationResponse, GetTeamPipelineResponse, GetTeamPipelinesData, GetTeamPipelinesError, GetTeamPipelinesResponse, GetTeamRecommendationBioData, GetTeamRecommendationBioError, GetTeamRecommendationBioResponse, GetTeamRecommendationIntroductionData, GetTeamRecommendationIntroductionError, GetTeamRecommendationIntroductionResponse, GetTeamResponse, GetTeamsFindData, GetTeamsFindError, GetTeamsFindResponse, GetTeamTrendingData, GetTeamTrendingError, GetTeamTrendingRecommendationActivityData, GetTeamTrendingRecommendationActivityError, GetTeamTrendingRecommendationActivityResponse, GetTeamTrendingRecommendationCommentsData, GetTeamTrendingRecommendationCommentsError, GetTeamTrendingRecommendationCommentsResponse, GetTeamTrendingRecommendationData, GetTeamTrendingRecommendationError, GetTeamTrendingRecommendationResponse, GetTeamTrendingResponse, GetTrendingMessageKeysData, GetTrendingMessageKeysResponse, GetTrendingMessagesData, GetTrendingMessagesError, GetTrendingMessagesResponse, GetUserEventsData, GetUserEventsError, GetUserEventsResponse, GetUserV2Data, GetUserV2Error, GetUserV2Response, GetV1RecommendationData, GetV1RecommendationError, GetV1RecommendationPreviewData, GetV1RecommendationPreviewError, GetV1RecommendationPreviewResponse, GetV1RecommendationResponse, GetVerifyEmailOneTimeCodeData, GetVerifyEmailOneTimeCodeError, GetVerifyEmailOneTimeCodeResponse, HealthCheckData, ImportCandidateCompanyMetadataData, ImportCandidateCompanyMetadataError, ImportCandidateCompanyMetadataResponse, LinkMarketSearchData, LinkMarketSearchError, LinkMarketSearchResponse, ListCandidateCompanyMetadataData, ListCandidateCompanyMetadataError, ListCandidateCompanyMetadataResponse, ListCompanyContactTagsData, ListCompanyContactTagsError, ListCompanyContactTagsResponse, ListEmailTemplateDefaultsData, ListEmailTemplateDefaultsError, ListEmailTemplateDefaultsResponse, ListEmailTemplatesData, ListEmailTemplatesError, ListEmailTemplatesResponse, ListEmailTypesData, ListEmailTypesResponse, ListEventEmailTemplatesData, ListEventEmailTemplatesError, ListEventEmailTemplatesResponse, ListExecutiveClientEventsData, ListExecutiveClientEventsError, ListExecutiveClientEventsResponse, ListPersonContactTagsData, ListPersonContactTagsError, ListPersonContactTagsResponse, PatchAliasToEsIndexData, PatchAliasToEsIndexError, PatchAliasToEsIndexResponse, PatchCandidateData, PatchCandidateError, PatchCandidateGoalsData, PatchCandidateGoalsError, PatchCandidateGoalsResponse, PatchCandidateGoalV2Data, PatchCandidateGoalV2Error, PatchCandidateGoalV2Response, PatchCandidateV2Data, PatchCandidateV2Error, PatchCandidateV2Response, PatchCompanyData, PatchCompanyError, PatchCompanyResponse, PatchEventData, PatchEventError, PatchEventGuestData, PatchEventGuestError, PatchEventGuestResponse, PatchEventGuestsData, PatchEventGuestsError, PatchEventGuestsResponse, PatchEventResponse, PatchEventRsvpData, PatchEventRsvpError, PatchEventRsvpResponse, PatchExecutiveClientSettingsData, PatchExecutiveClientSettingsError, PatchExecutiveClientSettingsResponse, PatchExecutiveSettingsData, PatchExecutiveSettingsError, PatchExecutiveSettingsResponse, PatchPeopleCurrentData, PatchPeopleCurrentError, PatchPeopleCurrentResponse, PatchPersonContactTagDefinitionData, PatchPersonContactTagDefinitionError, PatchPersonContactTagDefinitionResponse, PatchPersonData, PatchPersonEmailNotificationsData, PatchPersonEmailNotificationsError, PatchPersonEmailNotificationsResponse, PatchPersonError, PatchPersonResponse, PatchTeamData, PatchTeamError, PatchTeamPipelineData, PatchTeamPipelineError, PatchTeamPipelineResponse, PatchTeamResponse, PatchUserData, PatchUserError, PatchUserResponse, PatchUserRoleRemoveCompanyData, PatchUserRoleRemoveCompanyError, PatchUserRoleRemoveCompanyResponse, PostActivateExecutiveData, PostActivateExecutiveError, PostActivateExecutiveResponse, PostAdminExecutiveClientActivityData, PostAdminExecutiveClientActivityError, PostAdminExecutiveClientActivityResponse, PostAdminPeersCandidatesFilterData, PostAdminPeersCandidatesFilterError, PostAdminPeersCandidatesFilterResponse, PostAdminPeersFilterData, PostAdminPeersFilterError, PostAdminPeersFilterResponse, PostAdminPeersMatchesData, PostAdminPeersMatchesError, PostAdminPeersMatchesResponse, PostAdminPeersPublishData, PostAdminPeersPublishError, PostAdminPeersPublishResponse, PostAdminPipelineCandidatesFilterData, PostAdminPipelineCandidatesFilterError, PostAdminPipelineCandidatesFilterResponse, PostAutotagPreviewData, PostAutotagPreviewError, PostAutotagPreviewResponse, PostBulkActivateExecutivesData, PostBulkActivateExecutivesError, PostBulkActivateExecutivesResponse, PostCandidateActivityLogData, PostCandidateActivityLogError, PostCandidateActivityLogResponse, PostCandidateCompareAboutData, PostCandidateCompareAboutError, PostCandidateCompareAboutResponse, PostCandidateCompareGoalsData, PostCandidateCompareGoalsError, PostCandidateCompareGoalsResponse, PostCandidateCompareP2pData, PostCandidateCompareP2pError, PostCandidateCompareP2pResponse, PostCandidateFavoriteData, PostCandidateFavoriteError, PostCandidateFavoriteResponse, PostCandidateFeedbackFilterData, PostCandidateFeedbackFilterError, PostCandidateFeedbackFilterResponse, PostCandidateFeedbackV2Data, PostCandidateFeedbackV2Error, PostCandidateFeedbackV2Response, PostCandidateGoalActivityData, PostCandidateGoalActivityError, PostCandidateGoalActivityResponse, PostCandidateGoalTasksData, PostCandidateGoalTasksError, PostCandidateGoalTasksResponse, PostCandidateHighlightsData, PostCandidateHighlightsError, PostCandidateHighlightsResponse, PostCandidateHighlightsV2Data, PostCandidateHighlightsV2Error, PostCandidateHighlightsV2Response, PostCandidateIntroTemplatesData, PostCandidateIntroTemplatesError, PostCandidateIntroTemplatesResponse, PostCandidateMergeData, PostCandidateMergeError, PostCandidateMergeResponse, PostCandidateRecommendationsFilterData, PostCandidateRecommendationsFilterError, PostCandidateRecommendationsFilterResponse, PostCandidatesData, PostCandidatesError, PostCandidatesExportFailedData, PostCandidatesExportFailedError, PostCandidatesFilterData, PostCandidatesFilterError, PostCandidatesFilterResponse, PostCandidatesGoalsV2Data, PostCandidatesGoalsV2Error, PostCandidatesGoalsV2Response, PostCandidateShowOnboardingSectionData, PostCandidateShowOnboardingSectionError, PostCandidatesImportFromCsvData, PostCandidatesImportFromCsvError, PostCandidatesImportFromCsvResponse, PostCandidatesPerformanceFilterData, PostCandidatesPerformanceFilterError, PostCandidatesPerformanceFilterResponse, PostCandidatesPerformanceInRedData, PostCandidatesPerformanceInRedError, PostCandidatesPerformanceInRedResponse, PostCandidatesResponse, PostCandidatesTrendingFilterData, PostCandidatesTrendingFilterError, PostCandidatesTrendingFilterResponse, PostCandidateTasksFilterData, PostCandidateTasksFilterError, PostCandidateTasksFilterResponse, PostClerkWebhookData, PostClerkWebhookResponse, PostCompaniesData, PostCompaniesError, PostCompaniesResponse, PostCompaniesSearchV2Data, PostCompaniesSearchV2Error, PostCompaniesSearchV2Response, PostCompanyPeopleFilterData, PostCompanyPeopleFilterError, PostCompanyPeopleFilterResponse, PostCompanyTeamsData, PostCompanyTeamsError, PostCompanyTeamsResponse, PostContactListsData, PostContactListsError, PostContactListsResponse, PostEmailResponseFeedbackData, PostEmailResponseFeedbackError, PostEmailResponseFeedbackResponse, PostEsReindexData, PostEsReindexError, PostEsReindexResponse, PostEventAnnouncementSendData, PostEventAnnouncementSendError, PostEventAnnouncementSendResponse, PostEventData, PostEventError, PostEventGuestsData, PostEventGuestsError, PostEventGuestsResponse, PostEventGuestsSelectionData, PostEventGuestsSelectionError, PostEventGuestsSelectionResponse, PostEventInvitePreviewData, PostEventInvitePreviewError, PostEventInvitePreviewResponse, PostEventInviteSendData, PostEventInviteSendError, PostEventInviteSendResponse, PostEventLandingImageData, PostEventLandingImageError, PostEventLandingImageResponse, PostEventReminderPreviewData, PostEventReminderPreviewError, PostEventReminderPreviewResponse, PostEventReminderSendData, PostEventReminderSendError, PostEventReminderSendResponse, PostEventResponse, PostEventRsvpPreviewData, PostEventRsvpPreviewError, PostEventRsvpPreviewResponse, PostExecutiveClientActivityData, PostExecutiveClientActivityError, PostExecutiveClientActivityResponse, PostExecutiveClientContactPipelinesData, PostExecutiveClientContactPipelinesError, PostExecutiveClientContactPipelinesResponse, PostExecutiveClientPeopleSearchData, PostExecutiveClientPeopleSearchError, PostExecutiveClientPeopleSearchResponse, PostFilesImageData, PostFilesImageError, PostFilesImageResponse, PostFilesLinkedinResumeData, PostFilesLinkedinResumeError, PostFilesLinkedinResumeResponse, PosthogJsData, PosthogJsError, PosthogProxyData, PosthogProxyError, PostHomeCandidatesData, PostHomepageCandidatesData, PostHomeTeamCandidateFeedbackData, PostHomeTeamCandidateFeedbackError, PostHomeTeamViewsData, PostHomeTeamViewsError, PostIdentityData, PostIdentityError, PostIdentityLoginData, PostIdentityLoginError, PostIdentityLoginResponse, PostIdentityMergeData, PostIdentityMergeError, PostIdentityMergeResponse, PostIdentityPersonData, PostIdentityPersonError, PostIdentityPersonResponse, PostIdentityResponse, PostLinkedinPreviewData, PostLinkedinPreviewError, PostLinkedinPreviewResponse, PostLinkedinSyncCandidateData, PostLinkedinSyncCandidateError, PostLinkedinSyncCandidateResponse, PostPeerCommentData, PostPeerCommentError, PostPeerCommentResponse, PostPeopleV2Data, PostPeopleV2Error, PostPeopleV2Response, PostPersonClerkUserData, PostPersonClerkUserError, PostPersonClerkUserResponse2, PostPersonContactFavoriteData, PostPersonContactFavoriteError, PostPersonContactFavoriteResponse, PostPersonImageData, PostPersonImageError, PostPersonImageResponse, PostPipelineCandidatesData, PostPipelineCandidatesError, PostPipelineCandidatesResponse, PostPipelinesFilterData, PostPipelinesFilterError, PostPipelinesFilterResponse, PostPipelineTransferToTeamData, PostPipelineTransferToTeamError, PostPipelineTransferToTeamResponse, PostPotentialGuestsData, PostPotentialGuestsError, PostPotentialGuestsResponse, PostPotentialGuestsSelectionData, PostPotentialGuestsSelectionError, PostPotentialGuestsSelectionResponse, PostRecommendationOffLimitsData, PostRecommendationOffLimitsError, PostRecommendationOffLimitsResponse, PostRecsysCandidateContextData, PostRecsysCandidateContextError, PostRecsysCandidateContextResponse, PostRecsysOpportunityBadMatchData, PostRecsysOpportunityBadMatchError, PostRecsysOpportunityBadMatchResponse, PostRecsysOpportunityReviewedData, PostRecsysOpportunityReviewedError, PostRecsysOpportunityReviewedResponse, PostRecsysRecommendationFeedbackData, PostRecsysRecommendationFeedbackError, PostRecsysRecommendationsData, PostRecsysRecommendationsError, PostRecsysRecommendationsResponse, PostSendExecutiveInvitationData, PostSendExecutiveInvitationError, PostSendExecutiveInvitationResponse, PostShareRecommendationsData, PostShareRecommendationsError, PostShareRecommendationsResponse, PostSubmissionCancelRecommendationsData, PostSubmissionCancelRecommendationsError, PostSubmissionCancelRecommendationsResponse, PostSubmissionEmailPreviewData, PostSubmissionEmailPreviewError, PostSubmissionEmailPreviewResponse, PostSubmissionFilterData, PostSubmissionFilterError, PostSubmissionFilterResponse, PostSubmissionsData, PostSubmissionsError, PostSubmissionsFilterData, PostSubmissionsFilterError, PostSubmissionsFilterResponse, PostSubmissionsResponse, PostTailoredHighlightsData, PostTailoredHighlightsError, PostTailoredHighlightsResponse, PostTaskModulesData, PostTaskModulesError, PostTaskModulesResponse, PostTasksData, PostTasksError, PostTasksFilterData, PostTasksFilterError, PostTasksFilterResponse, PostTasksResponse, PostTeamCandidateFavoriteData, PostTeamCandidateFavoriteError, PostTeamCandidateFavoriteResponse, PostTeamCandidatePipelinesData, PostTeamCandidatePipelinesError, PostTeamCandidatePipelinesResponse, PostTeamCandidatesFilterV3Data, PostTeamCandidatesFilterV3Error, PostTeamCandidatesFilterV3Response, PostTeamCandidateStatusData, PostTeamCandidateStatusError, PostTeamCandidateStatusResponse, PostTeamCandidateViewsData, PostTeamCandidateViewsError, PostTeamContactCommentData, PostTeamContactCommentError, PostTeamContactCommentResponse, PostTeamMembersBulkV2Data, PostTeamMembersBulkV2Error, PostTeamMembersV2Data, PostTeamMembersV2Error, PostTeamMergeData, PostTeamMergeError, PostTeamMergeResponse, PostTeamPipelineRecommendationCommentsData, PostTeamPipelineRecommendationCommentsError, PostTeamPipelineRecommendationCommentsResponse, PostTeamPipelineRecommendationDislikeData, PostTeamPipelineRecommendationDislikeError, PostTeamPipelineRecommendationDislikeResponse, PostTeamPipelineRecommendationFavoriteData, PostTeamPipelineRecommendationFavoriteError, PostTeamPipelineRecommendationFavoriteResponse, PostTeamPipelineRecommendationInternalCommentsData, PostTeamPipelineRecommendationInternalCommentsError, PostTeamPipelineRecommendationInternalCommentsResponse, PostTeamPipelineRecommendationIntroductionData, PostTeamPipelineRecommendationIntroductionError, PostTeamPipelineRecommendationViewsData, PostTeamPipelineRecommendationViewsError, PostTeamPipelinesData, PostTeamPipelinesError, PostTeamPipelinesResponse, PostTeamPipelineSubmissionData, PostTeamPipelineSubmissionError, PostTeamPipelineSubmissionResponse, PostTeamPipelineViewsData, PostTeamPipelineViewsError, PostTeamRecommendationIntroductionData, PostTeamRecommendationIntroductionError, PostTeamsData, PostTeamsError, PostTeamsFilterData, PostTeamsFilterError, PostTeamsFilterResponse, PostTeamsResponse, PostTeamsSuggestedData, PostTeamsSuggestedError, PostTeamsSuggestedResponse, PostTeamsV2Data, PostTeamsV2Error, PostTeamsV2Response, PostTeamTeamsData, PostTeamTeamsError, PostTeamTeamsResponse, PostTeamTransferToCompanyData, PostTeamTransferToCompanyError, PostTeamTransferToCompanyResponse, PostTeamTrendingRecommendationCommentsData, PostTeamTrendingRecommendationCommentsError, PostTeamTrendingRecommendationCommentsResponse, PostTeamTrendingRecommendationDislikeData, PostTeamTrendingRecommendationDislikeError, PostTeamTrendingRecommendationDislikeResponse, PostTeamTrendingRecommendationFavoriteData, PostTeamTrendingRecommendationFavoriteError, PostTeamTrendingRecommendationFavoriteResponse, PostTeamTrendingRecommendationViewsData, PostTeamTrendingRecommendationViewsError, PostTokenData, PostTokenError, PostTokenResponse, PostTrendingScheduleData, PostTrendingScheduleError, PostTrendingScheduleResponse, PostUserCompanyData, PostUserCompanyError, PostUserCompanyResponse, PostUsersBulkDeleteV2Data, PostUsersBulkDeleteV2Error, PostUsersBulkDeleteV2Response, PostUsersSearchV2Data, PostUsersSearchV2Error, PostUsersSearchV2Response, PostUserTeamData, PostUserTeamError, PostUserTeamResponse, PostUtilsMailSendData, PostUtilsMailSendError, PostUtilsMailSendResponse, PostWebhooksEsEventsData, PostWebhooksEsEventsError, PreviewEventEmailData, PreviewEventEmailError, PreviewEventEmailResponse, PutCandidateCommentaryData, PutCandidateCommentaryError, PutCandidateCommentaryResponse, PutCandidateData, PutCandidateError, PutCandidateFeedbackData, PutCandidateFeedbackError, PutCandidateFeedbackResponse, PutCandidateOffLimitsCompaniesData, PutCandidateOffLimitsCompaniesError, PutCandidateOffLimitsCompaniesResponse, PutCandidateOffLimitsIdentitiesData, PutCandidateOffLimitsIdentitiesError, PutCandidateOffLimitsIdentitiesResponse, PutCandidatePathwayActivityTargetsData, PutCandidatePathwayActivityTargetsError, PutCandidatePathwayActivityTargetsResponse, PutCandidateReferrerData, PutCandidateReferrerError, PutCandidateReferrerResponse, PutCandidateResponse, PutCommentData, PutCommentError, PutCommentResponse, PutCompaniesData, PutCompaniesError, PutCompaniesResponse, PutEmailTemplateDefaultData, PutEmailTemplateDefaultError, PutEmailTemplateDefaultResponse, PutEvaluationHistoryIntroductionData, PutEvaluationHistoryIntroductionError, PutEvaluationHistoryIntroductionResponse, PutHighlightData, PutHighlightError, PutHighlightResponse2, PutIdentityCandidateData, PutIdentityCandidateError, PutIdentityCandidateResponse, PutInternalCommentData, PutInternalCommentError, PutInternalCommentResponse, PutIntroductionTemplateData, PutIntroductionTemplateError, PutIntroductionTemplateResponse, PutMultipleRecommendationDraftsData, PutMultipleRecommendationDraftsError, PutMultipleRecommendationDraftsResponse, PutPathwayActivityDefaultsData, PutPathwayActivityDefaultsError, PutPathwayActivityDefaultsResponse, PutPeerAssigneesData, PutPeerAssigneesError, PutPeerAssigneesResponse, PutPeerIntroductionData, PutPeerIntroductionError, PutPeerIntroductionResponse, PutPeerStatusData, PutPeerStatusError, PutPeerStatusResponse, PutPeopleCurrentPasswordData, PutPeopleCurrentPasswordError, PutPeopleCurrentPasswordResponse, PutPersonPasswordData, PutPersonPasswordError, PutPersonPasswordResponse, PutRecommendationCommentaryData, PutRecommendationCommentaryError, PutRecommendationCommentaryResponse, PutRecommendationStatusData, PutRecommendationStatusError, PutRecommendationStatusV2Data, PutRecommendationStatusV2Error, PutRecommendationStatusV2Response, PutSubmissionData, PutSubmissionError, PutSubmissionResponse, PutSubmissionStatusData, PutSubmissionStatusError, PutSubmissionStatusResponse, PutTaskData, PutTaskError, PutTaskModuleData, PutTaskModuleError, PutTaskModuleResponse, PutTaskModuleStatusData, PutTaskModuleStatusError, PutTaskModuleStatusResponse, PutTaskResponse, PutTaskStatusData, PutTaskStatusError, PutTaskStatusResponse, PutTeamCandidateStatusData, PutTeamCandidateStatusError, PutTeamCandidateStatusResponse, PutTeamContactCommentData, PutTeamContactCommentError, PutTeamContactCommentResponse, PutTeamData, PutTeamError, PutTeamPipelineData, PutTeamPipelineError, PutTeamPipelineRecommendationIntroEmailTypeData, PutTeamPipelineRecommendationIntroEmailTypeError, PutTeamPipelineRecommendationIntroEmailTypeResponse, PutTeamPipelineResponse, PutTeamResponse, RemoveCompanyContactTagData, RemoveCompanyContactTagError, RemoveCompanyContactTagResponse, RemovePersonContactTagData, RemovePersonContactTagError, RemovePersonContactTagResponse, ResolvePersonCandidateByEmailData, ResolvePersonCandidateByEmailError, ResolvePersonCandidateByEmailResponse2, RevertEvaluationHistoryData, RevertEvaluationHistoryError, RevertEvaluationHistoryResponse, SearchMarketSearchesData, SearchMarketSearchesError, SearchMarketSearchesResponse, UpdateEmailTemplateData, UpdateEmailTemplateError, UpdateEmailTemplateResponse, UpdateEventEmailTemplateData, UpdateEventEmailTemplateError, UpdateEventEmailTemplateResponse, UpdateExecutiveClientEventRsvpData, UpdateExecutiveClientEventRsvpError, UpdateExecutiveClientEventRsvpResponse, UpdateMarketSearchData, UpdateMarketSearchError, UpdateMarketSearchResponse, UpdatePersonMetadataV2Data, UpdatePersonMetadataV2Error, UpdatePersonMetadataV2Response, UpsertCandidateCompanyMetadataData, UpsertCandidateCompanyMetadataError, UpsertCandidateCompanyMetadataResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseURL' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseURL: options?.baseURL || (options?.client ?? client).getConfig().baseURL } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const appVersionQueryKey = (options?: Options<AppVersionData>) => createQueryKey('appVersion', options);

/**
 * App Version
 *
 * GET /
 */
export const appVersionOptions = (options?: Options<AppVersionData>) => queryOptions<unknown, AxiosError<DefaultError>, unknown, ReturnType<typeof appVersionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await appVersion({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: appVersionQueryKey(options)
});

export const healthCheckQueryKey = (options?: Options<HealthCheckData>) => createQueryKey('healthCheck', options);

/**
 * Health Check
 *
 * GET /health
 */
export const healthCheckOptions = (options?: Options<HealthCheckData>) => queryOptions<unknown, AxiosError<DefaultError>, unknown, ReturnType<typeof healthCheckQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await healthCheck({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: healthCheckQueryKey(options)
});

export const getVerifyEmailOneTimeCodeQueryKey = (options: Options<GetVerifyEmailOneTimeCodeData>) => createQueryKey('getVerifyEmailOneTimeCode', options);

/**
 * Get Verify Email One Time Code
 *
 * GET /api/email-response
 */
export const getVerifyEmailOneTimeCodeOptions = (options: Options<GetVerifyEmailOneTimeCodeData>) => queryOptions<GetVerifyEmailOneTimeCodeResponse, AxiosError<GetVerifyEmailOneTimeCodeError>, GetVerifyEmailOneTimeCodeResponse, ReturnType<typeof getVerifyEmailOneTimeCodeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getVerifyEmailOneTimeCode({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getVerifyEmailOneTimeCodeQueryKey(options)
});

export const postEmailResponseFeedbackQueryKey = (options: Options<PostEmailResponseFeedbackData>) => createQueryKey('postEmailResponseFeedback', options);

/**
 * Post Email Response Feedback
 *
 * POST /api/email-response/feedback
 *
 * Check the email code and find appropriate recommendation for the user associated with the email
 * code. Mark the introduction as not facilitated and add evaluation history event.
 */
export const postEmailResponseFeedbackOptions = (options: Options<PostEmailResponseFeedbackData>) => queryOptions<PostEmailResponseFeedbackResponse, AxiosError<PostEmailResponseFeedbackError>, PostEmailResponseFeedbackResponse, ReturnType<typeof postEmailResponseFeedbackQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postEmailResponseFeedback({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postEmailResponseFeedbackQueryKey(options)
});

/**
 * Post Email Response Feedback
 *
 * POST /api/email-response/feedback
 *
 * Check the email code and find appropriate recommendation for the user associated with the email
 * code. Mark the introduction as not facilitated and add evaluation history event.
 */
export const postEmailResponseFeedbackMutation = (options?: Partial<Options<PostEmailResponseFeedbackData>>): UseMutationOptions<PostEmailResponseFeedbackResponse, AxiosError<PostEmailResponseFeedbackError>, Options<PostEmailResponseFeedbackData>> => {
    const mutationOptions: UseMutationOptions<PostEmailResponseFeedbackResponse, AxiosError<PostEmailResponseFeedbackError>, Options<PostEmailResponseFeedbackData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postEmailResponseFeedback({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCountriesQueryKey = (options?: Options<GetCountriesData>) => createQueryKey('getCountries', options);

/**
 * Get Countries
 *
 * GET /api/v1/countries
 */
export const getCountriesOptions = (options?: Options<GetCountriesData>) => queryOptions<GetCountriesResponse, AxiosError<DefaultError>, GetCountriesResponse, ReturnType<typeof getCountriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCountries({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCountriesQueryKey(options)
});

export const postTokenQueryKey = (options: Options<PostTokenData>) => createQueryKey('postToken', options);

/**
 * Post Token
 *
 * POST /api/v1/token
 */
export const postTokenOptions = (options: Options<PostTokenData>) => queryOptions<PostTokenResponse, AxiosError<PostTokenError>, PostTokenResponse, ReturnType<typeof postTokenQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postToken({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postTokenQueryKey(options)
});

/**
 * Post Token
 *
 * POST /api/v1/token
 */
export const postTokenMutation = (options?: Partial<Options<PostTokenData>>): UseMutationOptions<PostTokenResponse, AxiosError<PostTokenError>, Options<PostTokenData>> => {
    const mutationOptions: UseMutationOptions<PostTokenResponse, AxiosError<PostTokenError>, Options<PostTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const posthogProxyQueryKey = (options: Options<PosthogProxyData>) => createQueryKey('posthogProxy', options);

/**
 * Posthog Proxy
 *
 * POST /api/v1/ingest/{path}/
 *
 * This is a proxy endpoint for PostHog event ingestion, to avoid browser blocking
 * of product metrics tracking.
 *
 * It's labeled 'ingest' instead of 'posthog' or 'analytics' to avoid term-based blocking.
 */
export const posthogProxyOptions = (options: Options<PosthogProxyData>) => queryOptions<unknown, AxiosError<PosthogProxyError>, unknown, ReturnType<typeof posthogProxyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await posthogProxy({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: posthogProxyQueryKey(options)
});

/**
 * Posthog Proxy
 *
 * POST /api/v1/ingest/{path}/
 *
 * This is a proxy endpoint for PostHog event ingestion, to avoid browser blocking
 * of product metrics tracking.
 *
 * It's labeled 'ingest' instead of 'posthog' or 'analytics' to avoid term-based blocking.
 */
export const posthogProxyMutation = (options?: Partial<Options<PosthogProxyData>>): UseMutationOptions<unknown, AxiosError<PosthogProxyError>, Options<PosthogProxyData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PosthogProxyError>, Options<PosthogProxyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await posthogProxy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const posthogJsQueryKey = (options: Options<PosthogJsData>) => createQueryKey('posthogJs', options);

/**
 * Posthog Js
 *
 * GET /api/v1/ingest/status/{filename:path}
 *
 * This endpoint, an extension of the one above, serves static files from PostHog
 */
export const posthogJsOptions = (options: Options<PosthogJsData>) => queryOptions<unknown, AxiosError<PosthogJsError>, unknown, ReturnType<typeof posthogJsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await posthogJs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: posthogJsQueryKey(options)
});

export const postCandidatesFilterQueryKey = (options: Options<PostCandidatesFilterData>) => createQueryKey('postCandidatesFilter', options);

/**
 * Post Candidates Filter
 *
 * POST /api/v1/candidates/filter
 */
export const postCandidatesFilterOptions = (options: Options<PostCandidatesFilterData>) => queryOptions<PostCandidatesFilterResponse, AxiosError<PostCandidatesFilterError>, PostCandidatesFilterResponse, ReturnType<typeof postCandidatesFilterQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postCandidatesFilter({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postCandidatesFilterQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const postCandidatesFilterInfiniteQueryKey = (options: Options<PostCandidatesFilterData>): QueryKey<Options<PostCandidatesFilterData>> => createQueryKey('postCandidatesFilter', options, true);

/**
 * Post Candidates Filter
 *
 * POST /api/v1/candidates/filter
 */
export const postCandidatesFilterInfiniteOptions = (options: Options<PostCandidatesFilterData>) => {
    const opts = infiniteQueryOptions<PostCandidatesFilterResponse, AxiosError<PostCandidatesFilterError>, InfiniteData<PostCandidatesFilterResponse>, QueryKey<Options<PostCandidatesFilterData>>, number | Pick<QueryKey<Options<PostCandidatesFilterData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PostCandidatesFilterData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                body: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await postCandidatesFilter({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postCandidatesFilterInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Post Candidates Filter
 *
 * POST /api/v1/candidates/filter
 */
export const postCandidatesFilterMutation = (options?: Partial<Options<PostCandidatesFilterData>>): UseMutationOptions<PostCandidatesFilterResponse, AxiosError<PostCandidatesFilterError>, Options<PostCandidatesFilterData>> => {
    const mutationOptions: UseMutationOptions<PostCandidatesFilterResponse, AxiosError<PostCandidatesFilterError>, Options<PostCandidatesFilterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCandidatesFilter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCandidatesFindQueryKey = (options?: Options<GetCandidatesFindData>) => createQueryKey('getCandidatesFind', options);

/**
 * Get Candidates Find
 *
 * GET /api/v1/candidates/find
 */
export const getCandidatesFindOptions = (options?: Options<GetCandidatesFindData>) => queryOptions<GetCandidatesFindResponse, AxiosError<GetCandidatesFindError>, GetCandidatesFindResponse, ReturnType<typeof getCandidatesFindQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCandidatesFind({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCandidatesFindQueryKey(options)
});

export const getCandidatesFindInfiniteQueryKey = (options?: Options<GetCandidatesFindData>): QueryKey<Options<GetCandidatesFindData>> => createQueryKey('getCandidatesFind', options, true);

/**
 * Get Candidates Find
 *
 * GET /api/v1/candidates/find
 */
export const getCandidatesFindInfiniteOptions = (options?: Options<GetCandidatesFindData>) => {
    const opts = infiniteQueryOptions<GetCandidatesFindResponse, AxiosError<GetCandidatesFindError>, InfiniteData<GetCandidatesFindResponse>, QueryKey<Options<GetCandidatesFindData>>, number | Pick<QueryKey<Options<GetCandidatesFindData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetCandidatesFindData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getCandidatesFind({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCandidatesFindInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const postCandidatesPerformanceInRedQueryKey = (options: Options<PostCandidatesPerformanceInRedData>) => createQueryKey('postCandidatesPerformanceInRed', options);

/**
 * Post Candidates Performance In Red
 *
 * POST /api/v1/candidates/performance/in-red
 */
export const postCandidatesPerformanceInRedOptions = (options: Options<PostCandidatesPerformanceInRedData>) => queryOptions<PostCandidatesPerformanceInRedResponse, AxiosError<PostCandidatesPerformanceInRedError>, PostCandidatesPerformanceInRedResponse, ReturnType<typeof postCandidatesPerformanceInRedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postCandidatesPerformanceInRed({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postCandidatesPerformanceInRedQueryKey(options)
});

export const postCandidatesPerformanceInRedInfiniteQueryKey = (options: Options<PostCandidatesPerformanceInRedData>): QueryKey<Options<PostCandidatesPerformanceInRedData>> => createQueryKey('postCandidatesPerformanceInRed', options, true);

/**
 * Post Candidates Performance In Red
 *
 * POST /api/v1/candidates/performance/in-red
 */
export const postCandidatesPerformanceInRedInfiniteOptions = (options: Options<PostCandidatesPerformanceInRedData>) => {
    const opts = infiniteQueryOptions<PostCandidatesPerformanceInRedResponse, AxiosError<PostCandidatesPerformanceInRedError>, InfiniteData<PostCandidatesPerformanceInRedResponse>, QueryKey<Options<PostCandidatesPerformanceInRedData>>, number | Pick<QueryKey<Options<PostCandidatesPerformanceInRedData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PostCandidatesPerformanceInRedData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                body: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await postCandidatesPerformanceInRed({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postCandidatesPerformanceInRedInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Post Candidates Performance In Red
 *
 * POST /api/v1/candidates/performance/in-red
 */
export const postCandidatesPerformanceInRedMutation = (options?: Partial<Options<PostCandidatesPerformanceInRedData>>): UseMutationOptions<PostCandidatesPerformanceInRedResponse, AxiosError<PostCandidatesPerformanceInRedError>, Options<PostCandidatesPerformanceInRedData>> => {
    const mutationOptions: UseMutationOptions<PostCandidatesPerformanceInRedResponse, AxiosError<PostCandidatesPerformanceInRedError>, Options<PostCandidatesPerformanceInRedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCandidatesPerformanceInRed({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postCandidatesPerformanceFilterQueryKey = (options: Options<PostCandidatesPerformanceFilterData>) => createQueryKey('postCandidatesPerformanceFilter', options);

/**
 * Post Candidates Performance Filter
 *
 * POST /api/v1/candidates/performance/filter
 */
export const postCandidatesPerformanceFilterOptions = (options: Options<PostCandidatesPerformanceFilterData>) => queryOptions<PostCandidatesPerformanceFilterResponse, AxiosError<PostCandidatesPerformanceFilterError>, PostCandidatesPerformanceFilterResponse, ReturnType<typeof postCandidatesPerformanceFilterQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postCandidatesPerformanceFilter({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postCandidatesPerformanceFilterQueryKey(options)
});

export const postCandidatesPerformanceFilterInfiniteQueryKey = (options: Options<PostCandidatesPerformanceFilterData>): QueryKey<Options<PostCandidatesPerformanceFilterData>> => createQueryKey('postCandidatesPerformanceFilter', options, true);

/**
 * Post Candidates Performance Filter
 *
 * POST /api/v1/candidates/performance/filter
 */
export const postCandidatesPerformanceFilterInfiniteOptions = (options: Options<PostCandidatesPerformanceFilterData>) => {
    const opts = infiniteQueryOptions<PostCandidatesPerformanceFilterResponse, AxiosError<PostCandidatesPerformanceFilterError>, InfiniteData<PostCandidatesPerformanceFilterResponse>, QueryKey<Options<PostCandidatesPerformanceFilterData>>, number | Pick<QueryKey<Options<PostCandidatesPerformanceFilterData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PostCandidatesPerformanceFilterData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                body: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await postCandidatesPerformanceFilter({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postCandidatesPerformanceFilterInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Post Candidates Performance Filter
 *
 * POST /api/v1/candidates/performance/filter
 */
export const postCandidatesPerformanceFilterMutation = (options?: Partial<Options<PostCandidatesPerformanceFilterData>>): UseMutationOptions<PostCandidatesPerformanceFilterResponse, AxiosError<PostCandidatesPerformanceFilterError>, Options<PostCandidatesPerformanceFilterData>> => {
    const mutationOptions: UseMutationOptions<PostCandidatesPerformanceFilterResponse, AxiosError<PostCandidatesPerformanceFilterError>, Options<PostCandidatesPerformanceFilterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCandidatesPerformanceFilter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCandidateCommentaryQueryKey = (options: Options<GetCandidateCommentaryData>) => createQueryKey('getCandidateCommentary', options);

/**
 * Get Candidate Commentary
 *
 * GET /api/v1/candidates/{candidate_uuid}/commentary
 */
export const getCandidateCommentaryOptions = (options: Options<GetCandidateCommentaryData>) => queryOptions<GetCandidateCommentaryResponse, AxiosError<GetCandidateCommentaryError>, GetCandidateCommentaryResponse, ReturnType<typeof getCandidateCommentaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCandidateCommentary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCandidateCommentaryQueryKey(options)
});

/**
 * Put Candidate Commentary
 *
 * PUT /api/v1/candidates/{candidate_uuid}/commentary
 *
 * @deprecated
 */
export const putCandidateCommentaryMutation = (options?: Partial<Options<PutCandidateCommentaryData>>): UseMutationOptions<PutCandidateCommentaryResponse, AxiosError<PutCandidateCommentaryError>, Options<PutCandidateCommentaryData>> => {
    const mutationOptions: UseMutationOptions<PutCandidateCommentaryResponse, AxiosError<PutCandidateCommentaryError>, Options<PutCandidateCommentaryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putCandidateCommentary({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postCandidateHighlightsQueryKey = (options: Options<PostCandidateHighlightsData>) => createQueryKey('postCandidateHighlights', options);

/**
 * Post Candidate Highlights
 *
 * POST /api/v1/candidates/{candidate_uuid}/highlights
 */
export const postCandidateHighlightsOptions = (options: Options<PostCandidateHighlightsData>) => queryOptions<PostCandidateHighlightsResponse, AxiosError<PostCandidateHighlightsError>, PostCandidateHighlightsResponse, ReturnType<typeof postCandidateHighlightsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postCandidateHighlights({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postCandidateHighlightsQueryKey(options)
});

/**
 * Post Candidate Highlights
 *
 * POST /api/v1/candidates/{candidate_uuid}/highlights
 */
export const postCandidateHighlightsMutation = (options?: Partial<Options<PostCandidateHighlightsData>>): UseMutationOptions<PostCandidateHighlightsResponse, AxiosError<PostCandidateHighlightsError>, Options<PostCandidateHighlightsData>> => {
    const mutationOptions: UseMutationOptions<PostCandidateHighlightsResponse, AxiosError<PostCandidateHighlightsError>, Options<PostCandidateHighlightsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCandidateHighlights({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCandidateImageQueryKey = (options: Options<GetCandidateImageData>) => createQueryKey('getCandidateImage', options);

/**
 * Get Candidate Image
 */
export const getCandidateImageOptions = (options: Options<GetCandidateImageData>) => queryOptions<unknown, AxiosError<GetCandidateImageError>, unknown, ReturnType<typeof getCandidateImageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCandidateImage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCandidateImageQueryKey(options)
});

export const getCandidateIntroductionsTeamHistoryQueryKey = (options: Options<GetCandidateIntroductionsTeamHistoryData>) => createQueryKey('getCandidateIntroductionsTeamHistory', options);

/**
 * Get Candidate Introductions Team History
 *
 * GET /candidates/{candidate_uuid}/introductions/{team_slug}/history
 */
export const getCandidateIntroductionsTeamHistoryOptions = (options: Options<GetCandidateIntroductionsTeamHistoryData>) => queryOptions<GetCandidateIntroductionsTeamHistoryResponse, AxiosError<GetCandidateIntroductionsTeamHistoryError>, GetCandidateIntroductionsTeamHistoryResponse, ReturnType<typeof getCandidateIntroductionsTeamHistoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCandidateIntroductionsTeamHistory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCandidateIntroductionsTeamHistoryQueryKey(options)
});

export const getCandidateIntroductionTemplatesQueryKey = (options: Options<GetCandidateIntroductionTemplatesData>) => createQueryKey('getCandidateIntroductionTemplates', options);

/**
 * Get Candidate Introduction Templates
 *
 * GET /candidates/{candidate_uuid}/introduction_templates
 */
export const getCandidateIntroductionTemplatesOptions = (options: Options<GetCandidateIntroductionTemplatesData>) => queryOptions<GetCandidateIntroductionTemplatesResponse, AxiosError<GetCandidateIntroductionTemplatesError>, GetCandidateIntroductionTemplatesResponse, ReturnType<typeof getCandidateIntroductionTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCandidateIntroductionTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCandidateIntroductionTemplatesQueryKey(options)
});

export const getCandidateOffLimitsCompaniesQueryKey = (options: Options<GetCandidateOffLimitsCompaniesData>) => createQueryKey('getCandidateOffLimitsCompanies', options);

/**
 * Get Candidate Off Limits Companies
 *
 * GET /candidates/{candidate_uuid}/off_limits/companies
 *
 * The companies this candidate's human must not be shown to.
 */
export const getCandidateOffLimitsCompaniesOptions = (options: Options<GetCandidateOffLimitsCompaniesData>) => queryOptions<GetCandidateOffLimitsCompaniesResponse, AxiosError<GetCandidateOffLimitsCompaniesError>, GetCandidateOffLimitsCompaniesResponse, ReturnType<typeof getCandidateOffLimitsCompaniesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCandidateOffLimitsCompanies({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCandidateOffLimitsCompaniesQueryKey(options)
});

/**
 * Put Candidate Off Limits Companies
 *
 * PUT /candidates/{candidate_uuid}/off_limits/companies
 *
 * Replaces the whole list. The same company listed twice keeps its first
 * reason.
 */
export const putCandidateOffLimitsCompaniesMutation = (options?: Partial<Options<PutCandidateOffLimitsCompaniesData>>): UseMutationOptions<PutCandidateOffLimitsCompaniesResponse, AxiosError<PutCandidateOffLimitsCompaniesError>, Options<PutCandidateOffLimitsCompaniesData>> => {
    const mutationOptions: UseMutationOptions<PutCandidateOffLimitsCompaniesResponse, AxiosError<PutCandidateOffLimitsCompaniesError>, Options<PutCandidateOffLimitsCompaniesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putCandidateOffLimitsCompanies({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCandidateOffLimitsIdentitiesQueryKey = (options: Options<GetCandidateOffLimitsIdentitiesData>) => createQueryKey('getCandidateOffLimitsIdentities', options);

/**
 * Get Candidate Off Limits Identities
 *
 * GET /candidates/{candidate_uuid}/off_limits/identities
 *
 * The humans this candidate's human is off-limits to.
 */
export const getCandidateOffLimitsIdentitiesOptions = (options: Options<GetCandidateOffLimitsIdentitiesData>) => queryOptions<GetCandidateOffLimitsIdentitiesResponse, AxiosError<GetCandidateOffLimitsIdentitiesError>, GetCandidateOffLimitsIdentitiesResponse, ReturnType<typeof getCandidateOffLimitsIdentitiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCandidateOffLimitsIdentities({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCandidateOffLimitsIdentitiesQueryKey(options)
});

/**
 * Put Candidate Off Limits Identities
 *
 * PUT /candidates/{candidate_uuid}/off_limits/identities
 *
 * Replaces the whole list. The same identity listed twice keeps its first
 * reason. Unknown identities are a 404.
 */
export const putCandidateOffLimitsIdentitiesMutation = (options?: Partial<Options<PutCandidateOffLimitsIdentitiesData>>): UseMutationOptions<PutCandidateOffLimitsIdentitiesResponse, AxiosError<PutCandidateOffLimitsIdentitiesError>, Options<PutCandidateOffLimitsIdentitiesData>> => {
    const mutationOptions: UseMutationOptions<PutCandidateOffLimitsIdentitiesResponse, AxiosError<PutCandidateOffLimitsIdentitiesError>, Options<PutCandidateOffLimitsIdentitiesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putCandidateOffLimitsIdentities({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCandidateRecommendationsQueryKey = (options: Options<GetCandidateRecommendationsData>) => createQueryKey('getCandidateRecommendations', options);

/**
 * Get Candidate Recommendations
 *
 * GET /api/v1/candidates/{candidate_uuid}/recommendations
 */
export const getCandidateRecommendationsOptions = (options: Options<GetCandidateRecommendationsData>) => queryOptions<GetCandidateRecommendationsResponse, AxiosError<GetCandidateRecommendationsError>, GetCandidateRecommendationsResponse, ReturnType<typeof getCandidateRecommendationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCandidateRecommendations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCandidateRecommendationsQueryKey(options)
});

export const getCandidateRecommendationsInfiniteQueryKey = (options: Options<GetCandidateRecommendationsData>): QueryKey<Options<GetCandidateRecommendationsData>> => createQueryKey('getCandidateRecommendations', options, true);

/**
 * Get Candidate Recommendations
 *
 * GET /api/v1/candidates/{candidate_uuid}/recommendations
 */
export const getCandidateRecommendationsInfiniteOptions = (options: Options<GetCandidateRecommendationsData>) => {
    const opts = infiniteQueryOptions<GetCandidateRecommendationsResponse, AxiosError<GetCandidateRecommendationsError>, InfiniteData<GetCandidateRecommendationsResponse>, QueryKey<Options<GetCandidateRecommendationsData>>, number | Pick<QueryKey<Options<GetCandidateRecommendationsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetCandidateRecommendationsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getCandidateRecommendations({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCandidateRecommendationsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getCandidateRecommendationsCompareBackgroundQueryKey = (options: Options<GetCandidateRecommendationsCompareBackgroundData>) => createQueryKey('getCandidateRecommendationsCompareBackground', options);

/**
 * Get Candidate Recommendations Compare Background
 *
 * GET /api/v1/candidates/{candidate_uuid}/recommendations/compare/background?peer_uuid={peer_uuid}
 */
export const getCandidateRecommendationsCompareBackgroundOptions = (options: Options<GetCandidateRecommendationsCompareBackgroundData>) => queryOptions<GetCandidateRecommendationsCompareBackgroundResponse, AxiosError<GetCandidateRecommendationsCompareBackgroundError>, GetCandidateRecommendationsCompareBackgroundResponse, ReturnType<typeof getCandidateRecommendationsCompareBackgroundQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCandidateRecommendationsCompareBackground({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCandidateRecommendationsCompareBackgroundQueryKey(options)
});

export const getCandidateRecommendationsComparePerformanceQueryKey = (options: Options<GetCandidateRecommendationsComparePerformanceData>) => createQueryKey('getCandidateRecommendationsComparePerformance', options);

/**
 * Get Candidate Recommendations Compare Performance
 *
 * GET /api/v1/candidates/{candidate_uuid}/recommendations/    compare/performance?peer={peer_uuid}
 */
export const getCandidateRecommendationsComparePerformanceOptions = (options: Options<GetCandidateRecommendationsComparePerformanceData>) => queryOptions<GetCandidateRecommendationsComparePerformanceResponse, AxiosError<GetCandidateRecommendationsComparePerformanceError>, GetCandidateRecommendationsComparePerformanceResponse, ReturnType<typeof getCandidateRecommendationsComparePerformanceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCandidateRecommendationsComparePerformance({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCandidateRecommendationsComparePerformanceQueryKey(options)
});

export const getCandidateRecommendationsCompareRecommendationsQueryKey = (options: Options<GetCandidateRecommendationsCompareRecommendationsData>) => createQueryKey('getCandidateRecommendationsCompareRecommendations', options);

/**
 * Get Candidate Recommendations Compare Recommendations
 *
 * GET /api/v1/candidates/{candidate_uuid}/recommendations/    compare/recommendations?peer={peer_uuid}
 */
export const getCandidateRecommendationsCompareRecommendationsOptions = (options: Options<GetCandidateRecommendationsCompareRecommendationsData>) => queryOptions<GetCandidateRecommendationsCompareRecommendationsResponse, AxiosError<GetCandidateRecommendationsCompareRecommendationsError>, GetCandidateRecommendationsCompareRecommendationsResponse, ReturnType<typeof getCandidateRecommendationsCompareRecommendationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCandidateRecommendationsCompareRecommendations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCandidateRecommendationsCompareRecommendationsQueryKey(options)
});

export const getCandidateRecommendationsComparePipelinesQueryKey = (options: Options<GetCandidateRecommendationsComparePipelinesData>) => createQueryKey('getCandidateRecommendationsComparePipelines', options);

/**
 * Get Candidate Recommendations Compare Pipelines
 */
export const getCandidateRecommendationsComparePipelinesOptions = (options: Options<GetCandidateRecommendationsComparePipelinesData>) => queryOptions<GetCandidateRecommendationsComparePipelinesResponse, AxiosError<GetCandidateRecommendationsComparePipelinesError>, GetCandidateRecommendationsComparePipelinesResponse, ReturnType<typeof getCandidateRecommendationsComparePipelinesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCandidateRecommendationsComparePipelines({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCandidateRecommendationsComparePipelinesQueryKey(options)
});

export const getCandidateResumeQueryKey = (options: Options<GetCandidateResumeData>) => createQueryKey('getCandidateResume', options);

/**
 * Get Candidate Resume
 *
 * GET /api/v1/candidates/{candidate_uuid}/resume
 */
export const getCandidateResumeOptions = (options: Options<GetCandidateResumeData>) => queryOptions<GetCandidateResumeResponse, AxiosError<GetCandidateResumeError>, GetCandidateResumeResponse, ReturnType<typeof getCandidateResumeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCandidateResume({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCandidateResumeQueryKey(options)
});

/**
 * Patch Candidate
 *
 * PATCH /api/v1/candidates/{candidate_uuid}
 *
 * @deprecated
 */
export const patchCandidateMutation = (options?: Partial<Options<PatchCandidateData>>): UseMutationOptions<unknown, AxiosError<PatchCandidateError>, Options<PatchCandidateData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PatchCandidateError>, Options<PatchCandidateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchCandidate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCompaniesQueryKey = (options?: Options<GetCompaniesData>) => createQueryKey('getCompanies', options);

/**
 * Get Companies
 *
 * GET /api/v1/companies
 */
export const getCompaniesOptions = (options?: Options<GetCompaniesData>) => queryOptions<GetCompaniesResponse, AxiosError<GetCompaniesError>, GetCompaniesResponse, ReturnType<typeof getCompaniesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCompanies({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCompaniesQueryKey(options)
});

export const getCompaniesInfiniteQueryKey = (options?: Options<GetCompaniesData>): QueryKey<Options<GetCompaniesData>> => createQueryKey('getCompanies', options, true);

/**
 * Get Companies
 *
 * GET /api/v1/companies
 */
export const getCompaniesInfiniteOptions = (options?: Options<GetCompaniesData>) => {
    const opts = infiniteQueryOptions<GetCompaniesResponse, AxiosError<GetCompaniesError>, InfiniteData<GetCompaniesResponse>, QueryKey<Options<GetCompaniesData>>, number | Pick<QueryKey<Options<GetCompaniesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetCompaniesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getCompanies({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCompaniesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const postCompaniesQueryKey = (options: Options<PostCompaniesData>) => createQueryKey('postCompanies', options);

/**
 * Post Companies
 *
 * POST /api/v1/companies
 *
 * Create a new company. Name, type, slug, and payment_status can be set.
 * Also reachable by the Contender Actions connector (service key + acting
 * user).
 */
export const postCompaniesOptions = (options: Options<PostCompaniesData>) => queryOptions<PostCompaniesResponse, AxiosError<PostCompaniesError>, PostCompaniesResponse, ReturnType<typeof postCompaniesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postCompanies({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postCompaniesQueryKey(options)
});

/**
 * Post Companies
 *
 * POST /api/v1/companies
 *
 * Create a new company. Name, type, slug, and payment_status can be set.
 * Also reachable by the Contender Actions connector (service key + acting
 * user).
 */
export const postCompaniesMutation = (options?: Partial<Options<PostCompaniesData>>): UseMutationOptions<PostCompaniesResponse, AxiosError<PostCompaniesError>, Options<PostCompaniesData>> => {
    const mutationOptions: UseMutationOptions<PostCompaniesResponse, AxiosError<PostCompaniesError>, Options<PostCompaniesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCompanies({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Put Companies
 *
 * PUT /api/v1/companies
 */
export const putCompaniesMutation = (options?: Partial<Options<PutCompaniesData>>): UseMutationOptions<PutCompaniesResponse, AxiosError<PutCompaniesError>, Options<PutCompaniesData>> => {
    const mutationOptions: UseMutationOptions<PutCompaniesResponse, AxiosError<PutCompaniesError>, Options<PutCompaniesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putCompanies({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCompanyByNameQueryKey = (options: Options<GetCompanyByNameData>) => createQueryKey('getCompanyByName', options);

/**
 * Get Company By Name
 *
 * GET /api/v1/companies/by-name?name={company_name}&case_insensitive={boolean}
 */
export const getCompanyByNameOptions = (options: Options<GetCompanyByNameData>) => queryOptions<GetCompanyByNameResponse, AxiosError<GetCompanyByNameError>, GetCompanyByNameResponse, ReturnType<typeof getCompanyByNameQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCompanyByName({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCompanyByNameQueryKey(options)
});

export const getCompaniesFindQueryKey = (options?: Options<GetCompaniesFindData>) => createQueryKey('getCompaniesFind', options);

/**
 * Get Companies Find
 *
 * GET /api/v1/companies/find
 */
export const getCompaniesFindOptions = (options?: Options<GetCompaniesFindData>) => queryOptions<GetCompaniesFindResponse, AxiosError<GetCompaniesFindError>, GetCompaniesFindResponse, ReturnType<typeof getCompaniesFindQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCompaniesFind({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCompaniesFindQueryKey(options)
});

export const getCompaniesFindInfiniteQueryKey = (options?: Options<GetCompaniesFindData>): QueryKey<Options<GetCompaniesFindData>> => createQueryKey('getCompaniesFind', options, true);

/**
 * Get Companies Find
 *
 * GET /api/v1/companies/find
 */
export const getCompaniesFindInfiniteOptions = (options?: Options<GetCompaniesFindData>) => {
    const opts = infiniteQueryOptions<GetCompaniesFindResponse, AxiosError<GetCompaniesFindError>, InfiniteData<GetCompaniesFindResponse>, QueryKey<Options<GetCompaniesFindData>>, number | Pick<QueryKey<Options<GetCompaniesFindData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetCompaniesFindData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getCompaniesFind({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCompaniesFindInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getCompaniesSectorsQueryKey = (options: Options<GetCompaniesSectorsData>) => createQueryKey('getCompaniesSectors', options);

/**
 * Get Companies Sectors
 *
 * GET /api/v1/companies/sectors
 */
export const getCompaniesSectorsOptions = (options: Options<GetCompaniesSectorsData>) => queryOptions<GetCompaniesSectorsResponse, AxiosError<GetCompaniesSectorsError>, GetCompaniesSectorsResponse, ReturnType<typeof getCompaniesSectorsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCompaniesSectors({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCompaniesSectorsQueryKey(options)
});

/**
 * Delete Company
 *
 * DELETE /api/v1/companies/{company_slug}
 */
export const deleteCompanyMutation = (options?: Partial<Options<DeleteCompanyData>>): UseMutationOptions<DeleteCompanyResponse, AxiosError<DeleteCompanyError>, Options<DeleteCompanyData>> => {
    const mutationOptions: UseMutationOptions<DeleteCompanyResponse, AxiosError<DeleteCompanyError>, Options<DeleteCompanyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteCompany({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCompanyQueryKey = (options: Options<GetCompanyData>) => createQueryKey('getCompany', options);

/**
 * Get Company
 *
 * GET /api/v1/companies/{company_slug}
 */
export const getCompanyOptions = (options: Options<GetCompanyData>) => queryOptions<GetCompanyResponse, AxiosError<GetCompanyError>, GetCompanyResponse, ReturnType<typeof getCompanyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCompany({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCompanyQueryKey(options)
});

/**
 * Patch Company
 *
 * PATCH /api/v1/companies/{company_slug}
 */
export const patchCompanyMutation = (options?: Partial<Options<PatchCompanyData>>): UseMutationOptions<PatchCompanyResponse, AxiosError<PatchCompanyError>, Options<PatchCompanyData>> => {
    const mutationOptions: UseMutationOptions<PatchCompanyResponse, AxiosError<PatchCompanyError>, Options<PatchCompanyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchCompany({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCompanyMembersQueryKey = (options: Options<GetCompanyMembersData>) => createQueryKey('getCompanyMembers', options);

/**
 * Get Company Members
 *
 * GET /api/v1/companies/{company_slug}/members
 */
export const getCompanyMembersOptions = (options: Options<GetCompanyMembersData>) => queryOptions<GetCompanyMembersResponse, AxiosError<GetCompanyMembersError>, GetCompanyMembersResponse, ReturnType<typeof getCompanyMembersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCompanyMembers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCompanyMembersQueryKey(options)
});

export const getContactsFindQueryKey = (options?: Options<GetContactsFindData>) => createQueryKey('getContactsFind', options);

/**
 * Get Contacts Find
 *
 * GET /api/v1/contacts/find
 *
 * Merged person+candidate typeahead search. With a phrase, sorted by best
 * match (ES relevance) so an exactly-typed name surfaces first (BAN-5912);
 * without one, sorted alphabetically by full name. One row per human:
 * when a linked candidate and its person both match, the candidate row
 * wins. Each row carries only the identity it stands for.
 */
export const getContactsFindOptions = (options?: Options<GetContactsFindData>) => queryOptions<GetContactsFindResponse, AxiosError<GetContactsFindError>, GetContactsFindResponse, ReturnType<typeof getContactsFindQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getContactsFind({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getContactsFindQueryKey(options)
});

export const getContactsFindInfiniteQueryKey = (options?: Options<GetContactsFindData>): QueryKey<Options<GetContactsFindData>> => createQueryKey('getContactsFind', options, true);

/**
 * Get Contacts Find
 *
 * GET /api/v1/contacts/find
 *
 * Merged person+candidate typeahead search. With a phrase, sorted by best
 * match (ES relevance) so an exactly-typed name surfaces first (BAN-5912);
 * without one, sorted alphabetically by full name. One row per human:
 * when a linked candidate and its person both match, the candidate row
 * wins. Each row carries only the identity it stands for.
 */
export const getContactsFindInfiniteOptions = (options?: Options<GetContactsFindData>) => {
    const opts = infiniteQueryOptions<GetContactsFindResponse, AxiosError<GetContactsFindError>, InfiniteData<GetContactsFindResponse>, QueryKey<Options<GetContactsFindData>>, number | Pick<QueryKey<Options<GetContactsFindData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetContactsFindData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getContactsFind({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getContactsFindInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getFilesImageQueryKey = (options: Options<GetFilesImageData>) => createQueryKey('getFilesImage', options);

/**
 * Get Files Image
 *
 * GET /api/v1/files/image
 */
export const getFilesImageOptions = (options: Options<GetFilesImageData>) => queryOptions<unknown, AxiosError<GetFilesImageError>, unknown, ReturnType<typeof getFilesImageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFilesImage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFilesImageQueryKey(options)
});

export const postFilesImageQueryKey = (options: Options<PostFilesImageData>) => createQueryKey('postFilesImage', options);

/**
 * Post Files Image
 *
 * POST /api/v1/files/image
 */
export const postFilesImageOptions = (options: Options<PostFilesImageData>) => queryOptions<PostFilesImageResponse, AxiosError<PostFilesImageError>, PostFilesImageResponse, ReturnType<typeof postFilesImageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postFilesImage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postFilesImageQueryKey(options)
});

/**
 * Post Files Image
 *
 * POST /api/v1/files/image
 */
export const postFilesImageMutation = (options?: Partial<Options<PostFilesImageData>>): UseMutationOptions<PostFilesImageResponse, AxiosError<PostFilesImageError>, Options<PostFilesImageData>> => {
    const mutationOptions: UseMutationOptions<PostFilesImageResponse, AxiosError<PostFilesImageError>, Options<PostFilesImageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postFilesImage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postFilesLinkedinResumeQueryKey = (options: Options<PostFilesLinkedinResumeData>) => createQueryKey('postFilesLinkedinResume', options);

/**
 * Post Files Linkedin Resume
 *
 * POST /api/v1/files/linkedin_resume
 */
export const postFilesLinkedinResumeOptions = (options: Options<PostFilesLinkedinResumeData>) => queryOptions<PostFilesLinkedinResumeResponse, AxiosError<PostFilesLinkedinResumeError>, PostFilesLinkedinResumeResponse, ReturnType<typeof postFilesLinkedinResumeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postFilesLinkedinResume({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postFilesLinkedinResumeQueryKey(options)
});

/**
 * Post Files Linkedin Resume
 *
 * POST /api/v1/files/linkedin_resume
 */
export const postFilesLinkedinResumeMutation = (options?: Partial<Options<PostFilesLinkedinResumeData>>): UseMutationOptions<PostFilesLinkedinResumeResponse, AxiosError<PostFilesLinkedinResumeError>, Options<PostFilesLinkedinResumeData>> => {
    const mutationOptions: UseMutationOptions<PostFilesLinkedinResumeResponse, AxiosError<PostFilesLinkedinResumeError>, Options<PostFilesLinkedinResumeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postFilesLinkedinResume({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getFindQueryKey = (options?: Options<GetFindData>) => createQueryKey('getFind', options);

/**
 * Get Find
 *
 * POST /find
 */
export const getFindOptions = (options?: Options<GetFindData>) => queryOptions<GetFindResponse, AxiosError<GetFindError>, GetFindResponse, ReturnType<typeof getFindQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFind({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFindQueryKey(options)
});

export const getFindInfiniteQueryKey = (options?: Options<GetFindData>): QueryKey<Options<GetFindData>> => createQueryKey('getFind', options, true);

/**
 * Get Find
 *
 * POST /find
 */
export const getFindInfiniteOptions = (options?: Options<GetFindData>) => {
    const opts = infiniteQueryOptions<GetFindResponse, AxiosError<GetFindError>, InfiniteData<GetFindResponse>, QueryKey<Options<GetFindData>>, number | Pick<QueryKey<Options<GetFindData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetFindData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getFind({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getFindInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Get Find
 *
 * POST /find
 */
export const getFindMutation = (options?: Partial<Options<GetFindData>>): UseMutationOptions<GetFindResponse, AxiosError<GetFindError>, Options<GetFindData>> => {
    const mutationOptions: UseMutationOptions<GetFindResponse, AxiosError<GetFindError>, Options<GetFindData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await getFind({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getHomeTeamActivityQueryKey = (options: Options<GetHomeTeamActivityData>) => createQueryKey('getHomeTeamActivity', options);

/**
 * Get Home Team Activity
 *
 * GET /api/v1/home/teams/{team_uuid}/activity
 */
export const getHomeTeamActivityOptions = (options: Options<GetHomeTeamActivityData>) => queryOptions<GetHomeTeamActivityResponse, AxiosError<GetHomeTeamActivityError>, GetHomeTeamActivityResponse, ReturnType<typeof getHomeTeamActivityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeTeamActivity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeTeamActivityQueryKey(options)
});

export const getHomeTeamActivityInfiniteQueryKey = (options: Options<GetHomeTeamActivityData>): QueryKey<Options<GetHomeTeamActivityData>> => createQueryKey('getHomeTeamActivity', options, true);

/**
 * Get Home Team Activity
 *
 * GET /api/v1/home/teams/{team_uuid}/activity
 */
export const getHomeTeamActivityInfiniteOptions = (options: Options<GetHomeTeamActivityData>) => {
    const opts = infiniteQueryOptions<GetHomeTeamActivityResponse, AxiosError<GetHomeTeamActivityError>, InfiniteData<GetHomeTeamActivityResponse>, QueryKey<Options<GetHomeTeamActivityData>>, number | Pick<QueryKey<Options<GetHomeTeamActivityData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetHomeTeamActivityData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getHomeTeamActivity({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getHomeTeamActivityInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getHomeTeamCandidatesQueryKey = (options: Options<GetHomeTeamCandidatesData>) => createQueryKey('getHomeTeamCandidates', options);

/**
 * Get Home Team Candidates
 *
 * GET /api/v1/home/teams/{team_uuid}/candidates
 */
export const getHomeTeamCandidatesOptions = (options: Options<GetHomeTeamCandidatesData>) => queryOptions<GetHomeTeamCandidatesResponse, AxiosError<GetHomeTeamCandidatesError>, GetHomeTeamCandidatesResponse, ReturnType<typeof getHomeTeamCandidatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeTeamCandidates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeTeamCandidatesQueryKey(options)
});

export const postHomeCandidatesQueryKey = (options?: Options<PostHomeCandidatesData>) => createQueryKey('postHomeCandidates', options);

/**
 * Post Home Candidates
 *
 * POST /api/v1/home/candidates
 */
export const postHomeCandidatesOptions = (options?: Options<PostHomeCandidatesData>) => queryOptions<unknown, AxiosError<DefaultError>, unknown, ReturnType<typeof postHomeCandidatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postHomeCandidates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postHomeCandidatesQueryKey(options)
});

/**
 * Post Home Candidates
 *
 * POST /api/v1/home/candidates
 */
export const postHomeCandidatesMutation = (options?: Partial<Options<PostHomeCandidatesData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<PostHomeCandidatesData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<PostHomeCandidatesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postHomeCandidates({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getHomeCandidatesDownvotesQueryKey = (options?: Options<GetHomeCandidatesDownvotesData>) => createQueryKey('getHomeCandidatesDownvotes', options);

/**
 * Get Home Candidates Downvotes
 *
 * GET /api/v1/home/candidates/downvotes
 */
export const getHomeCandidatesDownvotesOptions = (options?: Options<GetHomeCandidatesDownvotesData>) => queryOptions<unknown, AxiosError<DefaultError>, unknown, ReturnType<typeof getHomeCandidatesDownvotesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeCandidatesDownvotes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeCandidatesDownvotesQueryKey(options)
});

export const postHomeTeamCandidateFeedbackQueryKey = (options: Options<PostHomeTeamCandidateFeedbackData>) => createQueryKey('postHomeTeamCandidateFeedback', options);

/**
 * Post Home Team Candidate Feedback
 *
 * POST /api/v1/home/teams/{team_uuid}/candidates/{candidate_uuid}/feedback
 */
export const postHomeTeamCandidateFeedbackOptions = (options: Options<PostHomeTeamCandidateFeedbackData>) => queryOptions<unknown, AxiosError<PostHomeTeamCandidateFeedbackError>, unknown, ReturnType<typeof postHomeTeamCandidateFeedbackQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postHomeTeamCandidateFeedback({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postHomeTeamCandidateFeedbackQueryKey(options)
});

/**
 * Post Home Team Candidate Feedback
 *
 * POST /api/v1/home/teams/{team_uuid}/candidates/{candidate_uuid}/feedback
 */
export const postHomeTeamCandidateFeedbackMutation = (options?: Partial<Options<PostHomeTeamCandidateFeedbackData>>): UseMutationOptions<unknown, AxiosError<PostHomeTeamCandidateFeedbackError>, Options<PostHomeTeamCandidateFeedbackData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostHomeTeamCandidateFeedbackError>, Options<PostHomeTeamCandidateFeedbackData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postHomeTeamCandidateFeedback({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getHomeTeamStatsQueryKey = (options: Options<GetHomeTeamStatsData>) => createQueryKey('getHomeTeamStats', options);

/**
 * Get Home Team Stats
 *
 * GET /api/v1/home/teams/{team_uuid}/stats
 */
export const getHomeTeamStatsOptions = (options: Options<GetHomeTeamStatsData>) => queryOptions<GetHomeTeamStatsResponse, AxiosError<GetHomeTeamStatsError>, GetHomeTeamStatsResponse, ReturnType<typeof getHomeTeamStatsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeTeamStats({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeTeamStatsQueryKey(options)
});

export const postHomeTeamViewsQueryKey = (options: Options<PostHomeTeamViewsData>) => createQueryKey('postHomeTeamViews', options);

/**
 * Post Home Team Views
 *
 * POST /api/v1/home/teams/{team_uuid}/views
 */
export const postHomeTeamViewsOptions = (options: Options<PostHomeTeamViewsData>) => queryOptions<unknown, AxiosError<PostHomeTeamViewsError>, unknown, ReturnType<typeof postHomeTeamViewsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postHomeTeamViews({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postHomeTeamViewsQueryKey(options)
});

/**
 * Post Home Team Views
 *
 * POST /api/v1/home/teams/{team_uuid}/views
 */
export const postHomeTeamViewsMutation = (options?: Partial<Options<PostHomeTeamViewsData>>): UseMutationOptions<unknown, AxiosError<PostHomeTeamViewsError>, Options<PostHomeTeamViewsData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostHomeTeamViewsError>, Options<PostHomeTeamViewsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postHomeTeamViews({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getJobsFacilitatedIntroReminderQueryKey = (options?: Options<GetJobsFacilitatedIntroReminderData>) => createQueryKey('getJobsFacilitatedIntroReminder', options);

/**
 * Get Jobs Facilitated Intro Reminder
 *
 * GET /api/v1/jobs/facilitated_intro_reminder
 */
export const getJobsFacilitatedIntroReminderOptions = (options?: Options<GetJobsFacilitatedIntroReminderData>) => queryOptions<unknown, AxiosError<GetJobsFacilitatedIntroReminderError>, unknown, ReturnType<typeof getJobsFacilitatedIntroReminderQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getJobsFacilitatedIntroReminder({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getJobsFacilitatedIntroReminderQueryKey(options)
});

export const getJobsResendinviteQueryKey = (options?: Options<GetJobsResendinviteData>) => createQueryKey('getJobsResendinvite', options);

/**
 * Get Jobs Resendinvite
 *
 * GET /api/v1/jobs/resendinvite
 */
export const getJobsResendinviteOptions = (options?: Options<GetJobsResendinviteData>) => queryOptions<unknown, AxiosError<GetJobsResendinviteError>, unknown, ReturnType<typeof getJobsResendinviteQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getJobsResendinvite({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getJobsResendinviteQueryKey(options)
});

export const getJobsScheduledIntrosQueryKey = (options?: Options<GetJobsScheduledIntrosData>) => createQueryKey('getJobsScheduledIntros', options);

/**
 * Get Jobs Scheduled Intros
 *
 * GET /api/v1/jobs/scheduled_intros
 */
export const getJobsScheduledIntrosOptions = (options?: Options<GetJobsScheduledIntrosData>) => queryOptions<GetJobsScheduledIntrosResponse, AxiosError<GetJobsScheduledIntrosError>, GetJobsScheduledIntrosResponse, ReturnType<typeof getJobsScheduledIntrosQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getJobsScheduledIntros({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getJobsScheduledIntrosQueryKey(options)
});

export const postHomepageCandidatesQueryKey = (options?: Options<PostHomepageCandidatesData>) => createQueryKey('postHomepageCandidates', options);

/**
 * Post Homepage Candidates
 *
 * POST /api/v1/jobs/homepage-candidates
 */
export const postHomepageCandidatesOptions = (options?: Options<PostHomepageCandidatesData>) => queryOptions<unknown, AxiosError<DefaultError>, unknown, ReturnType<typeof postHomepageCandidatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postHomepageCandidates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postHomepageCandidatesQueryKey(options)
});

/**
 * Post Homepage Candidates
 *
 * POST /api/v1/jobs/homepage-candidates
 */
export const postHomepageCandidatesMutation = (options?: Partial<Options<PostHomepageCandidatesData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<PostHomepageCandidatesData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<PostHomepageCandidatesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postHomepageCandidates({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getJobsScheduledP2pIntrosQueryKey = (options?: Options<GetJobsScheduledP2pIntrosData>) => createQueryKey('getJobsScheduledP2pIntros', options);

/**
 * Get Jobs Scheduled P2P Intros
 *
 * GET /api/v1/jobs/scheduled_p2p_intros
 */
export const getJobsScheduledP2pIntrosOptions = (options?: Options<GetJobsScheduledP2pIntrosData>) => queryOptions<GetJobsScheduledP2pIntrosResponse, AxiosError<GetJobsScheduledP2pIntrosError>, GetJobsScheduledP2pIntrosResponse, ReturnType<typeof getJobsScheduledP2pIntrosQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getJobsScheduledP2pIntros({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getJobsScheduledP2pIntrosQueryKey(options)
});

export const getJobsAutoIntroductionsQueryKey = (options?: Options<GetJobsAutoIntroductionsData>) => createQueryKey('getJobsAutoIntroductions', options);

/**
 * Get Jobs Auto Introductions
 *
 * Auto introduction emails have been disabled; keep endpoint for backwards compatibility.
 */
export const getJobsAutoIntroductionsOptions = (options?: Options<GetJobsAutoIntroductionsData>) => queryOptions<GetJobsAutoIntroductionsResponse, AxiosError<DefaultError>, GetJobsAutoIntroductionsResponse, ReturnType<typeof getJobsAutoIntroductionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getJobsAutoIntroductions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getJobsAutoIntroductionsQueryKey(options)
});

export const getJobsDraftStatusChangeEmailsQueryKey = (options?: Options<GetJobsDraftStatusChangeEmailsData>) => createQueryKey('getJobsDraftStatusChangeEmails', options);

/**
 * Get Jobs Draft Status Change Emails
 *
 * GET /api/v1/jobs/draft_status_change_emails
 *
 * Send batched draft status change email notifications including assignee changes.
 *
 * Processes:
 * 1. Draft status changes from EvaluationHistory (last N minutes)
 * 2. Assignee changes from Redis queue
 *
 * Runs every 30 minutes via CRON scheduler.
 */
export const getJobsDraftStatusChangeEmailsOptions = (options?: Options<GetJobsDraftStatusChangeEmailsData>) => queryOptions<GetJobsDraftStatusChangeEmailsResponse, AxiosError<GetJobsDraftStatusChangeEmailsError>, GetJobsDraftStatusChangeEmailsResponse, ReturnType<typeof getJobsDraftStatusChangeEmailsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getJobsDraftStatusChangeEmails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getJobsDraftStatusChangeEmailsQueryKey(options)
});

export const getJobsLinkedinBatchSyncQueryKey = (options?: Options<GetJobsLinkedinBatchSyncData>) => createQueryKey('getJobsLinkedinBatchSync', options);

/**
 * Get Jobs Linkedin Batch Sync
 *
 * GET /api/v1/jobs/linkedin_batch_sync
 *
 * Monthly LinkedIn profile batch sync for:
 * - Tier 3 (advisor_network) candidates not updated in >6 months
 * - Tier 1b (former_executive_client) candidates not updated in >6 months
 *
 * Query params:
 * dry_run: If true, returns candidate count without syncing
 * batch_size: Number of candidates to sync (default: all, minimum: 1)
 *
 * Returns:
 * {
 * "candidates_found": int,
 * "sync_started": bool,
 * "dry_run": bool,
 * "estimated_credits": int,
 * "errors": list[dict]
 * }
 */
export const getJobsLinkedinBatchSyncOptions = (options?: Options<GetJobsLinkedinBatchSyncData>) => queryOptions<GetJobsLinkedinBatchSyncResponse, AxiosError<GetJobsLinkedinBatchSyncError>, GetJobsLinkedinBatchSyncResponse, ReturnType<typeof getJobsLinkedinBatchSyncQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getJobsLinkedinBatchSync({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getJobsLinkedinBatchSyncQueryKey(options)
});

export const getJobsHubspotFieldSyncQueryKey = (options?: Options<GetJobsHubspotFieldSyncData>) => createQueryKey('getJobsHubspotFieldSync', options);

/**
 * Get Jobs Hubspot Field Sync
 *
 * GET /api/v1/jobs/hubspot_field_sync
 *
 * Reconcile the HubSpot `invoice_status` contact property onto tier 1
 * (executive_client) and tier 1b (former_executive_client) candidates.
 *
 * Idempotent: the first run backfills `hubspot_id` links (matching HubSpot
 * contacts by email); every run refreshes `invoice_status`, writing only when
 * the value changed. Unmatched emails are retried next run; emails matching
 * multiple HubSpot contacts are skipped for human resolution (never guessed).
 *
 * Cadence: intended to run hourly via the Heroku Advanced Scheduler (the
 * interval lives in the scheduler, not the repo). Start hourly; tune later.
 *
 * Query params:
 * dry_run: If true, runs the reconcile in dry mode (calls HubSpot, writes
 * nothing) and reports would-link / would-update / ambiguous / unmatched
 * counts. Combine with `batch_size` to bound the HubSpot calls.
 * batch_size: Cap the number of candidates reconciled (default: all).
 *
 * Returns:
 * HubSpotFieldSyncResponse
 */
export const getJobsHubspotFieldSyncOptions = (options?: Options<GetJobsHubspotFieldSyncData>) => queryOptions<GetJobsHubspotFieldSyncResponse, AxiosError<GetJobsHubspotFieldSyncError>, GetJobsHubspotFieldSyncResponse, ReturnType<typeof getJobsHubspotFieldSyncQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getJobsHubspotFieldSync({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getJobsHubspotFieldSyncQueryKey(options)
});

export const getJobsMarketSearchResolveSweepQueryKey = (options?: Options<GetJobsMarketSearchResolveSweepData>) => createQueryKey('getJobsMarketSearchResolveSweep', options);

/**
 * Get Jobs Market Search Resolve Sweep
 *
 * GET /api/v1/jobs/market_search_resolve_sweep
 *
 * Retry the references a market search was logged without. Daily.
 *
 * A search is captured from a note, so the company it names may not be in
 * Contender yet and the client may be spelled a little differently. Those
 * columns are left NULL rather than guessed, and this is what revisits them.
 * Every row it examines is stamped `last_resolved_at`, so a name that will
 * never resolve is looked at once instead of leading the queue forever.
 */
export const getJobsMarketSearchResolveSweepOptions = (options?: Options<GetJobsMarketSearchResolveSweepData>) => queryOptions<GetJobsMarketSearchResolveSweepResponse, AxiosError<GetJobsMarketSearchResolveSweepError>, GetJobsMarketSearchResolveSweepResponse, ReturnType<typeof getJobsMarketSearchResolveSweepQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getJobsMarketSearchResolveSweep({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getJobsMarketSearchResolveSweepQueryKey(options)
});

export const getJobsMarketSearchClosureVerificationQueryKey = (options?: Options<GetJobsMarketSearchClosureVerificationData>) => createQueryKey('getJobsMarketSearchClosureVerification', options);

/**
 * Get Jobs Market Search Closure Verification
 *
 * GET /api/v1/jobs/market_search_closure_verification
 *
 * Close searches a finished Banff pipeline proves are over. Weekly.
 *
 * Nobody tells us a search ended, so the evidence has to be found. A closed
 * pipeline at the same company for the same role is that evidence; the same
 * company for a *different* role is not, which is why linking and closing sit
 * at different similarity thresholds and a conflicting function vetoes both.
 */
export const getJobsMarketSearchClosureVerificationOptions = (options?: Options<GetJobsMarketSearchClosureVerificationData>) => queryOptions<GetJobsMarketSearchClosureVerificationResponse, AxiosError<GetJobsMarketSearchClosureVerificationError>, GetJobsMarketSearchClosureVerificationResponse, ReturnType<typeof getJobsMarketSearchClosureVerificationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getJobsMarketSearchClosureVerification({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getJobsMarketSearchClosureVerificationQueryKey(options)
});

export const getJobsMarketSearchClassificationCatchupQueryKey = (options?: Options<GetJobsMarketSearchClassificationCatchupData>) => createQueryKey('getJobsMarketSearchClassificationCatchup', options);

/**
 * Get Jobs Market Search Classification Catchup
 *
 * GET /api/v1/jobs/market_search_classification_catchup
 *
 * Classify market searches still missing a role type or seniority. Hourly.
 *
 * The capture path already asks the model, under a five-second cap; this
 * picks up whatever that cap or an outage left behind, plus the backfilled
 * rows nobody ever asked about. Cheapest source first — dictionary, then
 * titles already decided on other rows, then the model in batches on distinct
 * titles only.
 */
export const getJobsMarketSearchClassificationCatchupOptions = (options?: Options<GetJobsMarketSearchClassificationCatchupData>) => queryOptions<GetJobsMarketSearchClassificationCatchupResponse, AxiosError<GetJobsMarketSearchClassificationCatchupError>, GetJobsMarketSearchClassificationCatchupResponse, ReturnType<typeof getJobsMarketSearchClassificationCatchupQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getJobsMarketSearchClassificationCatchup({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getJobsMarketSearchClassificationCatchupQueryKey(options)
});

export const getJobsRefreshTeamInsightsQueryKey = (options?: Options<GetJobsRefreshTeamInsightsData>) => createQueryKey('getJobsRefreshTeamInsights', options);

/**
 * Get Jobs Refresh Team Insights
 *
 * GET /api/v1/jobs/refresh_team_insights
 *
 * Recompute the AI intro-request summaries (the "Recent Intro Requests" pane +
 * trending search) for teams whose request set has gone stale. Nightly.
 *
 * Queues the work on the worker rather than running it in-request: the sweep
 * makes an LLM call per stale team, which does not belong in a scheduler's HTTP
 * call. Only stale/cold teams are recomputed, so a nightly run is cheap; the
 * one-time backfill stays a manual `tasks/refresh_team_insights.py` run.
 */
export const getJobsRefreshTeamInsightsOptions = (options?: Options<GetJobsRefreshTeamInsightsData>) => queryOptions<GetJobsRefreshTeamInsightsResponse, AxiosError<GetJobsRefreshTeamInsightsError>, GetJobsRefreshTeamInsightsResponse, ReturnType<typeof getJobsRefreshTeamInsightsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getJobsRefreshTeamInsights({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getJobsRefreshTeamInsightsQueryKey(options)
});

export const postUtilsMailSendQueryKey = (options: Options<PostUtilsMailSendData>) => createQueryKey('postUtilsMailSend', options);

/**
 * Post Utils Mail Send
 *
 * Send a SendGrid dynamic-template email with optional attachments to recipients.
 * The `recipients` form field must be a JSON array of objects:
 * [{"email": "...", "first_name": "...", "last_name": "..."}]
 */
export const postUtilsMailSendOptions = (options: Options<PostUtilsMailSendData>) => queryOptions<PostUtilsMailSendResponse, AxiosError<PostUtilsMailSendError>, PostUtilsMailSendResponse, ReturnType<typeof postUtilsMailSendQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postUtilsMailSend({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postUtilsMailSendQueryKey(options)
});

/**
 * Post Utils Mail Send
 *
 * Send a SendGrid dynamic-template email with optional attachments to recipients.
 * The `recipients` form field must be a JSON array of objects:
 * [{"email": "...", "first_name": "...", "last_name": "..."}]
 */
export const postUtilsMailSendMutation = (options?: Partial<Options<PostUtilsMailSendData>>): UseMutationOptions<PostUtilsMailSendResponse, AxiosError<PostUtilsMailSendError>, Options<PostUtilsMailSendData>> => {
    const mutationOptions: UseMutationOptions<PostUtilsMailSendResponse, AxiosError<PostUtilsMailSendError>, Options<PostUtilsMailSendData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postUtilsMailSend({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPeopleAdvisorsQueryKey = (options?: Options<GetPeopleAdvisorsData>) => createQueryKey('getPeopleAdvisors', options);

/**
 * Get People Advisors
 *
 * GET /api/v1/people/advisors
 *
 * Also open to the Contender Actions connector (``X-MCP-API-Key`` +
 * ``X-Acting-User-Email``, see ``app.api.deps.auth.agent``).
 */
export const getPeopleAdvisorsOptions = (options?: Options<GetPeopleAdvisorsData>) => queryOptions<GetPeopleAdvisorsResponse, AxiosError<GetPeopleAdvisorsError>, GetPeopleAdvisorsResponse, ReturnType<typeof getPeopleAdvisorsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPeopleAdvisors({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPeopleAdvisorsQueryKey(options)
});

export const getPeopleAdvisorsInfiniteQueryKey = (options?: Options<GetPeopleAdvisorsData>): QueryKey<Options<GetPeopleAdvisorsData>> => createQueryKey('getPeopleAdvisors', options, true);

/**
 * Get People Advisors
 *
 * GET /api/v1/people/advisors
 *
 * Also open to the Contender Actions connector (``X-MCP-API-Key`` +
 * ``X-Acting-User-Email``, see ``app.api.deps.auth.agent``).
 */
export const getPeopleAdvisorsInfiniteOptions = (options?: Options<GetPeopleAdvisorsData>) => {
    const opts = infiniteQueryOptions<GetPeopleAdvisorsResponse, AxiosError<GetPeopleAdvisorsError>, InfiniteData<GetPeopleAdvisorsResponse>, QueryKey<Options<GetPeopleAdvisorsData>>, number | Pick<QueryKey<Options<GetPeopleAdvisorsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetPeopleAdvisorsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getPeopleAdvisors({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPeopleAdvisorsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getPeopleCurrentQueryKey = (options?: Options<GetPeopleCurrentData>) => createQueryKey('getPeopleCurrent', options);

/**
 * Get People Current
 *
 * GET /api/v1/people/current
 *
 * Current user profile for the app (legacy ``Person`` shape).
 */
export const getPeopleCurrentOptions = (options?: Options<GetPeopleCurrentData>) => queryOptions<GetPeopleCurrentResponse, AxiosError<DefaultError>, GetPeopleCurrentResponse, ReturnType<typeof getPeopleCurrentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPeopleCurrent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPeopleCurrentQueryKey(options)
});

export const getPeopleCurrentTeamsQueryKey = (options?: Options<GetPeopleCurrentTeamsData>) => createQueryKey('getPeopleCurrentTeams', options);

/**
 * Get People Current Teams
 *
 * GET /api/v1/people/current/teams
 */
export const getPeopleCurrentTeamsOptions = (options?: Options<GetPeopleCurrentTeamsData>) => queryOptions<GetPeopleCurrentTeamsResponse, AxiosError<DefaultError>, GetPeopleCurrentTeamsResponse, ReturnType<typeof getPeopleCurrentTeamsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPeopleCurrentTeams({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPeopleCurrentTeamsQueryKey(options)
});

export const getPeopleFindQueryKey = (options?: Options<GetPeopleFindData>) => createQueryKey('getPeopleFind', options);

/**
 * Get People Find
 *
 * GET /api/v1/people/find
 */
export const getPeopleFindOptions = (options?: Options<GetPeopleFindData>) => queryOptions<GetPeopleFindResponse, AxiosError<GetPeopleFindError>, GetPeopleFindResponse, ReturnType<typeof getPeopleFindQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPeopleFind({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPeopleFindQueryKey(options)
});

export const getPeopleFindInfiniteQueryKey = (options?: Options<GetPeopleFindData>): QueryKey<Options<GetPeopleFindData>> => createQueryKey('getPeopleFind', options, true);

/**
 * Get People Find
 *
 * GET /api/v1/people/find
 */
export const getPeopleFindInfiniteOptions = (options?: Options<GetPeopleFindData>) => {
    const opts = infiniteQueryOptions<GetPeopleFindResponse, AxiosError<GetPeopleFindError>, InfiniteData<GetPeopleFindResponse>, QueryKey<Options<GetPeopleFindData>>, number | Pick<QueryKey<Options<GetPeopleFindData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetPeopleFindData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getPeopleFind({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPeopleFindInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Delete Person Image
 *
 * DELETE /api/v1/people/{person_uuid}/image
 */
export const deletePersonImageMutation = (options?: Partial<Options<DeletePersonImageData>>): UseMutationOptions<unknown, AxiosError<DeletePersonImageError>, Options<DeletePersonImageData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DeletePersonImageError>, Options<DeletePersonImageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deletePersonImage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPersonImageQueryKey = (options: Options<GetPersonImageData>) => createQueryKey('getPersonImage', options);

/**
 * Get Person Image
 *
 * GET /api/v1/people/{person_uuid}/image
 */
export const getPersonImageOptions = (options: Options<GetPersonImageData>) => queryOptions<unknown, AxiosError<GetPersonImageError>, unknown, ReturnType<typeof getPersonImageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPersonImage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPersonImageQueryKey(options)
});

export const postPersonImageQueryKey = (options: Options<PostPersonImageData>) => createQueryKey('postPersonImage', options);

/**
 * Post Person Image
 *
 * POST /api/v1/people/{person_uuid}/image
 */
export const postPersonImageOptions = (options: Options<PostPersonImageData>) => queryOptions<PostPersonImageResponse, AxiosError<PostPersonImageError>, PostPersonImageResponse, ReturnType<typeof postPersonImageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postPersonImage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postPersonImageQueryKey(options)
});

/**
 * Post Person Image
 *
 * POST /api/v1/people/{person_uuid}/image
 */
export const postPersonImageMutation = (options?: Partial<Options<PostPersonImageData>>): UseMutationOptions<PostPersonImageResponse, AxiosError<PostPersonImageError>, Options<PostPersonImageData>> => {
    const mutationOptions: UseMutationOptions<PostPersonImageResponse, AxiosError<PostPersonImageError>, Options<PostPersonImageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postPersonImage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Put Person Password
 *
 * PUT /api/v1/people/{person_uuid}/password
 */
export const putPersonPasswordMutation = (options?: Partial<Options<PutPersonPasswordData>>): UseMutationOptions<PutPersonPasswordResponse, AxiosError<PutPersonPasswordError>, Options<PutPersonPasswordData>> => {
    const mutationOptions: UseMutationOptions<PutPersonPasswordResponse, AxiosError<PutPersonPasswordError>, Options<PutPersonPasswordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putPersonPassword({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPipelinesFindQueryKey = (options?: Options<GetPipelinesFindData>) => createQueryKey('getPipelinesFind', options);

/**
 * Get Pipelines Find
 *
 * GET /api/v1/pipelines/find
 */
export const getPipelinesFindOptions = (options?: Options<GetPipelinesFindData>) => queryOptions<GetPipelinesFindResponse, AxiosError<GetPipelinesFindError>, GetPipelinesFindResponse, ReturnType<typeof getPipelinesFindQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPipelinesFind({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPipelinesFindQueryKey(options)
});

export const getPipelinesFindInfiniteQueryKey = (options?: Options<GetPipelinesFindData>): QueryKey<Options<GetPipelinesFindData>> => createQueryKey('getPipelinesFind', options, true);

/**
 * Get Pipelines Find
 *
 * GET /api/v1/pipelines/find
 */
export const getPipelinesFindInfiniteOptions = (options?: Options<GetPipelinesFindData>) => {
    const opts = infiniteQueryOptions<GetPipelinesFindResponse, AxiosError<GetPipelinesFindError>, InfiniteData<GetPipelinesFindResponse>, QueryKey<Options<GetPipelinesFindData>>, number | Pick<QueryKey<Options<GetPipelinesFindData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetPipelinesFindData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getPipelinesFind({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPipelinesFindInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Delete A Pipeline
 *
 * DELETE /api/v1/pipelines/{pipeline_slug}
 */
export const deleteAPipelineMutation = (options?: Partial<Options<DeleteAPipelineData>>): UseMutationOptions<DeleteAPipelineResponse, AxiosError<DeleteAPipelineError>, Options<DeleteAPipelineData>> => {
    const mutationOptions: UseMutationOptions<DeleteAPipelineResponse, AxiosError<DeleteAPipelineError>, Options<DeleteAPipelineData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteAPipeline({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getRecommendationsFindQueryKey = (options: Options<GetRecommendationsFindData>) => createQueryKey('getRecommendationsFind', options);

/**
 * Get Recommendations Find
 *
 * GET /api/v1/recommendations/find
 */
export const getRecommendationsFindOptions = (options: Options<GetRecommendationsFindData>) => queryOptions<GetRecommendationsFindResponse, AxiosError<GetRecommendationsFindError>, GetRecommendationsFindResponse, ReturnType<typeof getRecommendationsFindQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRecommendationsFind({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRecommendationsFindQueryKey(options)
});

export const getRecommendationsFindInfiniteQueryKey = (options: Options<GetRecommendationsFindData>): QueryKey<Options<GetRecommendationsFindData>> => createQueryKey('getRecommendationsFind', options, true);

/**
 * Get Recommendations Find
 *
 * GET /api/v1/recommendations/find
 */
export const getRecommendationsFindInfiniteOptions = (options: Options<GetRecommendationsFindData>) => {
    const opts = infiniteQueryOptions<GetRecommendationsFindResponse, AxiosError<GetRecommendationsFindError>, InfiniteData<GetRecommendationsFindResponse>, QueryKey<Options<GetRecommendationsFindData>>, number | Pick<QueryKey<Options<GetRecommendationsFindData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetRecommendationsFindData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getRecommendationsFind({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getRecommendationsFindInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getV1RecommendationQueryKey = (options: Options<GetV1RecommendationData>) => createQueryKey('getV1Recommendation', options);

/**
 * Get V1 Recommendation
 *
 * GET /api/v1/recommendations/{recommendation_uuid}
 */
export const getV1RecommendationOptions = (options: Options<GetV1RecommendationData>) => queryOptions<GetV1RecommendationResponse, AxiosError<GetV1RecommendationError>, GetV1RecommendationResponse, ReturnType<typeof getV1RecommendationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1Recommendation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1RecommendationQueryKey(options)
});

export const getV1RecommendationPreviewQueryKey = (options: Options<GetV1RecommendationPreviewData>) => createQueryKey('getV1RecommendationPreview', options);

/**
 * Get V1 Recommendation Preview
 *
 * GET /api/v1/recommendations/{recommendation_uuid}/preview
 *
 * Guest/preview endpoint for accessing a recommendation via signed token.
 * Returns limited fields suitable for unauthenticated users.
 *
 * The token should be generated using generate_preview_token() and included
 * in the email link as a query parameter.
 */
export const getV1RecommendationPreviewOptions = (options: Options<GetV1RecommendationPreviewData>) => queryOptions<GetV1RecommendationPreviewResponse, AxiosError<GetV1RecommendationPreviewError>, GetV1RecommendationPreviewResponse, ReturnType<typeof getV1RecommendationPreviewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1RecommendationPreview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1RecommendationPreviewQueryKey(options)
});

export const postRecommendationOffLimitsQueryKey = (options: Options<PostRecommendationOffLimitsData>) => createQueryKey('postRecommendationOffLimits', options);

/**
 * Post Recommendation Off Limits
 *
 * POST /api/v1/recommendations/{candidate_uuid}/off_limits
 */
export const postRecommendationOffLimitsOptions = (options: Options<PostRecommendationOffLimitsData>) => queryOptions<PostRecommendationOffLimitsResponse, AxiosError<PostRecommendationOffLimitsError>, PostRecommendationOffLimitsResponse, ReturnType<typeof postRecommendationOffLimitsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postRecommendationOffLimits({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postRecommendationOffLimitsQueryKey(options)
});

/**
 * Post Recommendation Off Limits
 *
 * POST /api/v1/recommendations/{candidate_uuid}/off_limits
 */
export const postRecommendationOffLimitsMutation = (options?: Partial<Options<PostRecommendationOffLimitsData>>): UseMutationOptions<PostRecommendationOffLimitsResponse, AxiosError<PostRecommendationOffLimitsError>, Options<PostRecommendationOffLimitsData>> => {
    const mutationOptions: UseMutationOptions<PostRecommendationOffLimitsResponse, AxiosError<PostRecommendationOffLimitsError>, Options<PostRecommendationOffLimitsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postRecommendationOffLimits({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Put Recommendation Status
 *
 * PUT /api/v1/recommendations/{submission_candidate_uuid}/status
 */
export const putRecommendationStatusMutation = (options?: Partial<Options<PutRecommendationStatusData>>): UseMutationOptions<unknown, AxiosError<PutRecommendationStatusError>, Options<PutRecommendationStatusData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PutRecommendationStatusError>, Options<PutRecommendationStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putRecommendationStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postShareRecommendationsQueryKey = (options: Options<PostShareRecommendationsData>) => createQueryKey('postShareRecommendations', options);

/**
 * Post Share Recommendations
 *
 * POST /api/v1/share/recommendations
 */
export const postShareRecommendationsOptions = (options: Options<PostShareRecommendationsData>) => queryOptions<PostShareRecommendationsResponse, AxiosError<PostShareRecommendationsError>, PostShareRecommendationsResponse, ReturnType<typeof postShareRecommendationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postShareRecommendations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postShareRecommendationsQueryKey(options)
});

/**
 * Post Share Recommendations
 *
 * POST /api/v1/share/recommendations
 */
export const postShareRecommendationsMutation = (options?: Partial<Options<PostShareRecommendationsData>>): UseMutationOptions<PostShareRecommendationsResponse, AxiosError<PostShareRecommendationsError>, Options<PostShareRecommendationsData>> => {
    const mutationOptions: UseMutationOptions<PostShareRecommendationsResponse, AxiosError<PostShareRecommendationsError>, Options<PostShareRecommendationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postShareRecommendations({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postTeamsQueryKey = (options: Options<PostTeamsData>) => createQueryKey('postTeams', options);

/**
 * Post Teams
 *
 * POST /api/v1/teams
 *
 * @deprecated
 */
export const postTeamsOptions = (options: Options<PostTeamsData>) => queryOptions<PostTeamsResponse, AxiosError<PostTeamsError>, PostTeamsResponse, ReturnType<typeof postTeamsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postTeams({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postTeamsQueryKey(options)
});

/**
 * Post Teams
 *
 * POST /api/v1/teams
 *
 * @deprecated
 */
export const postTeamsMutation = (options?: Partial<Options<PostTeamsData>>): UseMutationOptions<PostTeamsResponse, AxiosError<PostTeamsError>, Options<PostTeamsData>> => {
    const mutationOptions: UseMutationOptions<PostTeamsResponse, AxiosError<PostTeamsError>, Options<PostTeamsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTeams({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTeamsFindQueryKey = (options?: Options<GetTeamsFindData>) => createQueryKey('getTeamsFind', options);

/**
 * Get Teams Find
 *
 * GET /api/v1/teams/find
 */
export const getTeamsFindOptions = (options?: Options<GetTeamsFindData>) => queryOptions<GetTeamsFindResponse, AxiosError<GetTeamsFindError>, GetTeamsFindResponse, ReturnType<typeof getTeamsFindQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTeamsFind({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTeamsFindQueryKey(options)
});

export const getTeamsFindInfiniteQueryKey = (options?: Options<GetTeamsFindData>): QueryKey<Options<GetTeamsFindData>> => createQueryKey('getTeamsFind', options, true);

/**
 * Get Teams Find
 *
 * GET /api/v1/teams/find
 */
export const getTeamsFindInfiniteOptions = (options?: Options<GetTeamsFindData>) => {
    const opts = infiniteQueryOptions<GetTeamsFindResponse, AxiosError<GetTeamsFindError>, InfiniteData<GetTeamsFindResponse>, QueryKey<Options<GetTeamsFindData>>, number | Pick<QueryKey<Options<GetTeamsFindData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetTeamsFindData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getTeamsFind({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getTeamsFindInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Delete Team
 *
 * DELETE /api/v1/teams/{team_slug}
 */
export const deleteTeamMutation = (options?: Partial<Options<DeleteTeamData>>): UseMutationOptions<unknown, AxiosError<DeleteTeamError>, Options<DeleteTeamData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DeleteTeamError>, Options<DeleteTeamData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteTeam({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTeamQueryKey = (options: Options<GetTeamData>) => createQueryKey('getTeam', options);

/**
 * Get Team
 *
 * GET /api/v1/teams/{team_slug}
 */
export const getTeamOptions = (options: Options<GetTeamData>) => queryOptions<GetTeamResponse, AxiosError<GetTeamError>, GetTeamResponse, ReturnType<typeof getTeamQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTeam({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTeamQueryKey(options)
});

/**
 * Patch Team
 *
 * PATCH /api/v1/teams/{team_slug}
 *
 * `active` is admin-only (BAN-6000): team leads can edit their team but not
 * archive it.
 */
export const patchTeamMutation = (options?: Partial<Options<PatchTeamData>>): UseMutationOptions<PatchTeamResponse, AxiosError<PatchTeamError>, Options<PatchTeamData>> => {
    const mutationOptions: UseMutationOptions<PatchTeamResponse, AxiosError<PatchTeamError>, Options<PatchTeamData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchTeam({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTeamMembersQueryKey = (options: Options<GetTeamMembersData>) => createQueryKey('getTeamMembers', options);

/**
 * Get Team Members
 *
 * GET /api/v1/teams/{team_slug}/members
 */
export const getTeamMembersOptions = (options: Options<GetTeamMembersData>) => queryOptions<GetTeamMembersResponse, AxiosError<GetTeamMembersError>, GetTeamMembersResponse, ReturnType<typeof getTeamMembersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTeamMembers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTeamMembersQueryKey(options)
});

/**
 * Delete Team Member
 *
 * DELETE /api/v1/teams/{team_slug}/members/{person_uuid}
 */
export const deleteTeamMemberMutation = (options?: Partial<Options<DeleteTeamMemberData>>): UseMutationOptions<DeleteTeamMemberResponse, AxiosError<DeleteTeamMemberError>, Options<DeleteTeamMemberData>> => {
    const mutationOptions: UseMutationOptions<DeleteTeamMemberResponse, AxiosError<DeleteTeamMemberError>, Options<DeleteTeamMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTeamPipelinesQueryKey = (options: Options<GetTeamPipelinesData>) => createQueryKey('getTeamPipelines', options);

/**
 * Get Team Pipelines
 *
 * GET /api/v1/teams/{team_slug}/pipelines
 */
export const getTeamPipelinesOptions = (options: Options<GetTeamPipelinesData>) => queryOptions<GetTeamPipelinesResponse, AxiosError<GetTeamPipelinesError>, GetTeamPipelinesResponse, ReturnType<typeof getTeamPipelinesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTeamPipelines({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTeamPipelinesQueryKey(options)
});

export const getTeamPipelinesInfiniteQueryKey = (options: Options<GetTeamPipelinesData>): QueryKey<Options<GetTeamPipelinesData>> => createQueryKey('getTeamPipelines', options, true);

/**
 * Get Team Pipelines
 *
 * GET /api/v1/teams/{team_slug}/pipelines
 */
export const getTeamPipelinesInfiniteOptions = (options: Options<GetTeamPipelinesData>) => {
    const opts = infiniteQueryOptions<GetTeamPipelinesResponse, AxiosError<GetTeamPipelinesError>, InfiniteData<GetTeamPipelinesResponse>, QueryKey<Options<GetTeamPipelinesData>>, number | Pick<QueryKey<Options<GetTeamPipelinesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetTeamPipelinesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getTeamPipelines({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getTeamPipelinesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Patch Team Pipeline
 *
 * PATCH /api/v1/teams/{team_slug}/pipelines/{pipeline_slug}
 */
export const patchTeamPipelineMutation = (options?: Partial<Options<PatchTeamPipelineData>>): UseMutationOptions<PatchTeamPipelineResponse, AxiosError<PatchTeamPipelineError>, Options<PatchTeamPipelineData>> => {
    const mutationOptions: UseMutationOptions<PatchTeamPipelineResponse, AxiosError<PatchTeamPipelineError>, Options<PatchTeamPipelineData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchTeamPipeline({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTeamPipelineRecommendationBioQueryKey = (options: Options<GetTeamPipelineRecommendationBioData>) => createQueryKey('getTeamPipelineRecommendationBio', options);

/**
 * Get Team Pipeline Recommendation Bio
 *
 * GET /api/v1/api/v1/teams/{team_slug}/pipelines/{pipeline_slug}/recommendations/{candidate_uuid}/bio
 */
export const getTeamPipelineRecommendationBioOptions = (options: Options<GetTeamPipelineRecommendationBioData>) => queryOptions<GetTeamPipelineRecommendationBioResponse, AxiosError<GetTeamPipelineRecommendationBioError>, GetTeamPipelineRecommendationBioResponse, ReturnType<typeof getTeamPipelineRecommendationBioQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTeamPipelineRecommendationBio({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTeamPipelineRecommendationBioQueryKey(options)
});

export const getTeamPipelineRecommendationChecksSharedQueryKey = (options: Options<GetTeamPipelineRecommendationChecksSharedData>) => createQueryKey('getTeamPipelineRecommendationChecksShared', options);

/**
 * Get Team Pipeline Recommendation Checks Shared
 *
 * GET /api/v1/teams/{team_slug}/pipelines/{pipeline_slug}/recommendations/{candidate_uuid}/checks/shared
 */
export const getTeamPipelineRecommendationChecksSharedOptions = (options: Options<GetTeamPipelineRecommendationChecksSharedData>) => queryOptions<GetTeamPipelineRecommendationChecksSharedResponse, AxiosError<GetTeamPipelineRecommendationChecksSharedError>, GetTeamPipelineRecommendationChecksSharedResponse, ReturnType<typeof getTeamPipelineRecommendationChecksSharedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTeamPipelineRecommendationChecksShared({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTeamPipelineRecommendationChecksSharedQueryKey(options)
});

export const getTeamPipelineRecommendationIntroductionQueryKey = (options: Options<GetTeamPipelineRecommendationIntroductionData>) => createQueryKey('getTeamPipelineRecommendationIntroduction', options);

/**
 * Get Team Pipeline Recommendation Introduction
 *
 * GET /api/v1/teams/{team_slug}/pipelines/{pipeline_slug}/recommendations/{candidate_uuid}/introduction
 */
export const getTeamPipelineRecommendationIntroductionOptions = (options: Options<GetTeamPipelineRecommendationIntroductionData>) => queryOptions<GetTeamPipelineRecommendationIntroductionResponse, AxiosError<GetTeamPipelineRecommendationIntroductionError>, GetTeamPipelineRecommendationIntroductionResponse, ReturnType<typeof getTeamPipelineRecommendationIntroductionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTeamPipelineRecommendationIntroduction({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTeamPipelineRecommendationIntroductionQueryKey(options)
});

export const postTeamPipelineRecommendationIntroductionQueryKey = (options: Options<PostTeamPipelineRecommendationIntroductionData>) => createQueryKey('postTeamPipelineRecommendationIntroduction', options);

/**
 * Post Team Pipeline Recommendation Introduction
 *
 * POST /api/v1/teams/{team_slug}/pipelines/{pipeline_slug}/recommendations/{candidate_uuid}/introduction
 */
export const postTeamPipelineRecommendationIntroductionOptions = (options: Options<PostTeamPipelineRecommendationIntroductionData>) => queryOptions<unknown, AxiosError<PostTeamPipelineRecommendationIntroductionError>, unknown, ReturnType<typeof postTeamPipelineRecommendationIntroductionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postTeamPipelineRecommendationIntroduction({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postTeamPipelineRecommendationIntroductionQueryKey(options)
});

/**
 * Post Team Pipeline Recommendation Introduction
 *
 * POST /api/v1/teams/{team_slug}/pipelines/{pipeline_slug}/recommendations/{candidate_uuid}/introduction
 */
export const postTeamPipelineRecommendationIntroductionMutation = (options?: Partial<Options<PostTeamPipelineRecommendationIntroductionData>>): UseMutationOptions<unknown, AxiosError<PostTeamPipelineRecommendationIntroductionError>, Options<PostTeamPipelineRecommendationIntroductionData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostTeamPipelineRecommendationIntroductionError>, Options<PostTeamPipelineRecommendationIntroductionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTeamPipelineRecommendationIntroduction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTeamRecommendationBioQueryKey = (options: Options<GetTeamRecommendationBioData>) => createQueryKey('getTeamRecommendationBio', options);

/**
 * Get Team Recommendation Bio
 *
 * GET /api/v1/teams/{team_slug}/recommendations/{candidate_uuid}/bio
 */
export const getTeamRecommendationBioOptions = (options: Options<GetTeamRecommendationBioData>) => queryOptions<GetTeamRecommendationBioResponse, AxiosError<GetTeamRecommendationBioError>, GetTeamRecommendationBioResponse, ReturnType<typeof getTeamRecommendationBioQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTeamRecommendationBio({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTeamRecommendationBioQueryKey(options)
});

export const getTeamRecommendationIntroductionQueryKey = (options: Options<GetTeamRecommendationIntroductionData>) => createQueryKey('getTeamRecommendationIntroduction', options);

/**
 * Get Team Recommendation Introduction
 *
 * GET /api/v1/teams/{team_slug}/recommendations/{candidate_uuid}/introduction
 */
export const getTeamRecommendationIntroductionOptions = (options: Options<GetTeamRecommendationIntroductionData>) => queryOptions<GetTeamRecommendationIntroductionResponse, AxiosError<GetTeamRecommendationIntroductionError>, GetTeamRecommendationIntroductionResponse, ReturnType<typeof getTeamRecommendationIntroductionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTeamRecommendationIntroduction({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTeamRecommendationIntroductionQueryKey(options)
});

export const postTeamRecommendationIntroductionQueryKey = (options: Options<PostTeamRecommendationIntroductionData>) => createQueryKey('postTeamRecommendationIntroduction', options);

/**
 * Post Team Recommendation Introduction
 *
 * POST /api/v1/teams/{team_slug}/recommendations/{candidate_uuid}/introduction
 */
export const postTeamRecommendationIntroductionOptions = (options: Options<PostTeamRecommendationIntroductionData>) => queryOptions<unknown, AxiosError<PostTeamRecommendationIntroductionError>, unknown, ReturnType<typeof postTeamRecommendationIntroductionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postTeamRecommendationIntroduction({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postTeamRecommendationIntroductionQueryKey(options)
});

/**
 * Post Team Recommendation Introduction
 *
 * POST /api/v1/teams/{team_slug}/recommendations/{candidate_uuid}/introduction
 */
export const postTeamRecommendationIntroductionMutation = (options?: Partial<Options<PostTeamRecommendationIntroductionData>>): UseMutationOptions<unknown, AxiosError<PostTeamRecommendationIntroductionError>, Options<PostTeamRecommendationIntroductionData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostTeamRecommendationIntroductionError>, Options<PostTeamRecommendationIntroductionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTeamRecommendationIntroduction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postTrendingScheduleQueryKey = (options: Options<PostTrendingScheduleData>) => createQueryKey('postTrendingSchedule', options);

/**
 * Post Trending Schedule
 *
 * POST /api/v1/trending_schedule
 *
 * Also open to the Contender Actions connector (``X-MCP-API-Key`` +
 * ``X-Acting-User-Email``, see ``app.api.deps.auth.agent``).
 */
export const postTrendingScheduleOptions = (options: Options<PostTrendingScheduleData>) => queryOptions<PostTrendingScheduleResponse, AxiosError<PostTrendingScheduleError>, PostTrendingScheduleResponse, ReturnType<typeof postTrendingScheduleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postTrendingSchedule({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postTrendingScheduleQueryKey(options)
});

/**
 * Post Trending Schedule
 *
 * POST /api/v1/trending_schedule
 *
 * Also open to the Contender Actions connector (``X-MCP-API-Key`` +
 * ``X-Acting-User-Email``, see ``app.api.deps.auth.agent``).
 */
export const postTrendingScheduleMutation = (options?: Partial<Options<PostTrendingScheduleData>>): UseMutationOptions<PostTrendingScheduleResponse, AxiosError<PostTrendingScheduleError>, Options<PostTrendingScheduleData>> => {
    const mutationOptions: UseMutationOptions<PostTrendingScheduleResponse, AxiosError<PostTrendingScheduleError>, Options<PostTrendingScheduleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTrendingSchedule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postClerkWebhookQueryKey = (options?: Options<PostClerkWebhookData>) => createQueryKey('postClerkWebhook', options);

/**
 * Post Clerk Webhook
 *
 * POST /api/v1/webhooks/clerk
 */
export const postClerkWebhookOptions = (options?: Options<PostClerkWebhookData>) => queryOptions<PostClerkWebhookResponse, AxiosError<DefaultError>, PostClerkWebhookResponse, ReturnType<typeof postClerkWebhookQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postClerkWebhook({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postClerkWebhookQueryKey(options)
});

/**
 * Post Clerk Webhook
 *
 * POST /api/v1/webhooks/clerk
 */
export const postClerkWebhookMutation = (options?: Partial<Options<PostClerkWebhookData>>): UseMutationOptions<PostClerkWebhookResponse, AxiosError<DefaultError>, Options<PostClerkWebhookData>> => {
    const mutationOptions: UseMutationOptions<PostClerkWebhookResponse, AxiosError<DefaultError>, Options<PostClerkWebhookData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postClerkWebhook({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postWebhooksEsEventsQueryKey = (options: Options<PostWebhooksEsEventsData>) => createQueryKey('postWebhooksEsEvents', options);

/**
 * Post Webhooks Es Events
 *
 * POST /api/v1/webhooks/es_events
 */
export const postWebhooksEsEventsOptions = (options: Options<PostWebhooksEsEventsData>) => queryOptions<unknown, AxiosError<PostWebhooksEsEventsError>, unknown, ReturnType<typeof postWebhooksEsEventsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postWebhooksEsEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postWebhooksEsEventsQueryKey(options)
});

/**
 * Post Webhooks Es Events
 *
 * POST /api/v1/webhooks/es_events
 */
export const postWebhooksEsEventsMutation = (options?: Partial<Options<PostWebhooksEsEventsData>>): UseMutationOptions<unknown, AxiosError<PostWebhooksEsEventsError>, Options<PostWebhooksEsEventsData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostWebhooksEsEventsError>, Options<PostWebhooksEsEventsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postWebhooksEsEvents({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postCandidatesImportFromCsvQueryKey = (options?: Options<PostCandidatesImportFromCsvData>) => createQueryKey('postCandidatesImportFromCsv', options);

/**
 * Post Candidates Import From Csv
 *
 * POST /api/v1/candidates/import
 * Import candidates from a CSV file.
 */
export const postCandidatesImportFromCsvOptions = (options?: Options<PostCandidatesImportFromCsvData>) => queryOptions<PostCandidatesImportFromCsvResponse, AxiosError<PostCandidatesImportFromCsvError>, PostCandidatesImportFromCsvResponse, ReturnType<typeof postCandidatesImportFromCsvQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postCandidatesImportFromCsv({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postCandidatesImportFromCsvQueryKey(options)
});

/**
 * Post Candidates Import From Csv
 *
 * POST /api/v1/candidates/import
 * Import candidates from a CSV file.
 */
export const postCandidatesImportFromCsvMutation = (options?: Partial<Options<PostCandidatesImportFromCsvData>>): UseMutationOptions<PostCandidatesImportFromCsvResponse, AxiosError<PostCandidatesImportFromCsvError>, Options<PostCandidatesImportFromCsvData>> => {
    const mutationOptions: UseMutationOptions<PostCandidatesImportFromCsvResponse, AxiosError<PostCandidatesImportFromCsvError>, Options<PostCandidatesImportFromCsvData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCandidatesImportFromCsv({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postCandidatesExportFailedQueryKey = (options: Options<PostCandidatesExportFailedData>) => createQueryKey('postCandidatesExportFailed', options);

/**
 * Post Candidates Export Failed
 *
 * POST /api/v1/candidates/export-failed
 * Export failed candidate imports to a CSV file.
 *
 * This endpoint accepts a list of failed candidate rows and returns a downloadable CSV file
 * containing the import errors.
 */
export const postCandidatesExportFailedOptions = (options: Options<PostCandidatesExportFailedData>) => queryOptions<unknown, AxiosError<PostCandidatesExportFailedError>, unknown, ReturnType<typeof postCandidatesExportFailedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postCandidatesExportFailed({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postCandidatesExportFailedQueryKey(options)
});

/**
 * Post Candidates Export Failed
 *
 * POST /api/v1/candidates/export-failed
 * Export failed candidate imports to a CSV file.
 *
 * This endpoint accepts a list of failed candidate rows and returns a downloadable CSV file
 * containing the import errors.
 */
export const postCandidatesExportFailedMutation = (options?: Partial<Options<PostCandidatesExportFailedData>>): UseMutationOptions<unknown, AxiosError<PostCandidatesExportFailedError>, Options<PostCandidatesExportFailedData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostCandidatesExportFailedError>, Options<PostCandidatesExportFailedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCandidatesExportFailed({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postEsReindexQueryKey = (options: Options<PostEsReindexData>) => createQueryKey('postEsReindex', options);

/**
 * Post Es Reindex
 *
 * POST /api/v2/es-reindex
 *
 * Enqueues a Celery task to reindex the specified Elasticsearch index asynchronously.
 * All indices are reindexed asynchronously to prevent API timeouts and enable
 * progress monitoring via Flower dashboard.
 *
 * Returns 202 Accepted with task_id to poll for status and results.
 */
export const postEsReindexOptions = (options: Options<PostEsReindexData>) => queryOptions<PostEsReindexResponse, AxiosError<PostEsReindexError>, PostEsReindexResponse, ReturnType<typeof postEsReindexQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postEsReindex({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postEsReindexQueryKey(options)
});

/**
 * Post Es Reindex
 *
 * POST /api/v2/es-reindex
 *
 * Enqueues a Celery task to reindex the specified Elasticsearch index asynchronously.
 * All indices are reindexed asynchronously to prevent API timeouts and enable
 * progress monitoring via Flower dashboard.
 *
 * Returns 202 Accepted with task_id to poll for status and results.
 */
export const postEsReindexMutation = (options?: Partial<Options<PostEsReindexData>>): UseMutationOptions<PostEsReindexResponse, AxiosError<PostEsReindexError>, Options<PostEsReindexData>> => {
    const mutationOptions: UseMutationOptions<PostEsReindexResponse, AxiosError<PostEsReindexError>, Options<PostEsReindexData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postEsReindex({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getReindexStatusQueryKey = (options: Options<GetReindexStatusData>) => createQueryKey('getReindexStatus', options);

/**
 * Get Reindex Status
 *
 * GET /api/v2/es-reindex/status/{task_id}
 *
 * Check the status of a reindex task by its task_id.
 *
 * Returns current state, progress information, and final results when complete.
 * Task states: PENDING, PROGRESS, SUCCESS, FAILURE, RETRY
 */
export const getReindexStatusOptions = (options: Options<GetReindexStatusData>) => queryOptions<GetReindexStatusResponse, AxiosError<GetReindexStatusError>, GetReindexStatusResponse, ReturnType<typeof getReindexStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getReindexStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getReindexStatusQueryKey(options)
});

export const getEsIndexQueryKey = (options: Options<GetEsIndexData>) => createQueryKey('getEsIndex', options);

/**
 * Get Es Index
 *
 * GET /api/v2/current-es-index
 */
export const getEsIndexOptions = (options: Options<GetEsIndexData>) => queryOptions<GetEsIndexResponse, AxiosError<GetEsIndexError>, GetEsIndexResponse, ReturnType<typeof getEsIndexQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEsIndex({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEsIndexQueryKey(options)
});

/**
 * Patch Alias To Es Index
 *
 * PATCH /api/v2/current-es-index
 */
export const patchAliasToEsIndexMutation = (options?: Partial<Options<PatchAliasToEsIndexData>>): UseMutationOptions<PatchAliasToEsIndexResponse, AxiosError<PatchAliasToEsIndexError>, Options<PatchAliasToEsIndexData>> => {
    const mutationOptions: UseMutationOptions<PatchAliasToEsIndexResponse, AxiosError<PatchAliasToEsIndexError>, Options<PatchAliasToEsIndexData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchAliasToEsIndex({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createMarketSearchQueryKey = (options: Options<CreateMarketSearchData>) => createQueryKey('createMarketSearch', options);

/**
 * Create Market Search
 *
 * POST /api/v2/market-searches — log one observation of a search in the market.
 *
 * Normalizes the strings, fills classification the caller left blank, resolves
 * target company / search firm / client to Contender rows where an exact match
 * exists, then applies the same-search rules: an ingestion double returns the
 * existing row (200), a confident match is linked to its search, and anything
 * fuzzier becomes its own search with the candidates returned for a person
 * to confirm via ``/link``.
 */
export const createMarketSearchOptions = (options: Options<CreateMarketSearchData>) => queryOptions<CreateMarketSearchResponse, AxiosError<CreateMarketSearchError>, CreateMarketSearchResponse, ReturnType<typeof createMarketSearchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await createMarketSearch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: createMarketSearchQueryKey(options)
});

/**
 * Create Market Search
 *
 * POST /api/v2/market-searches — log one observation of a search in the market.
 *
 * Normalizes the strings, fills classification the caller left blank, resolves
 * target company / search firm / client to Contender rows where an exact match
 * exists, then applies the same-search rules: an ingestion double returns the
 * existing row (200), a confident match is linked to its search, and anything
 * fuzzier becomes its own search with the candidates returned for a person
 * to confirm via ``/link``.
 */
export const createMarketSearchMutation = (options?: Partial<Options<CreateMarketSearchData>>): UseMutationOptions<CreateMarketSearchResponse, AxiosError<CreateMarketSearchError>, Options<CreateMarketSearchData>> => {
    const mutationOptions: UseMutationOptions<CreateMarketSearchResponse, AxiosError<CreateMarketSearchError>, Options<CreateMarketSearchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createMarketSearch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const linkMarketSearchQueryKey = (options: Options<LinkMarketSearchData>) => createQueryKey('linkMarketSearch', options);

/**
 * Link Market Search
 *
 * POST /api/v2/market-searches/{market_search_uuid}/link — confirm a same-search match.
 *
 * Attaches the observation (and any observations already grouped under it) to
 * the given hub. The hub must itself be a hub — a star, never a chain.
 */
export const linkMarketSearchOptions = (options: Options<LinkMarketSearchData>) => queryOptions<LinkMarketSearchResponse, AxiosError<LinkMarketSearchError>, LinkMarketSearchResponse, ReturnType<typeof linkMarketSearchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await linkMarketSearch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: linkMarketSearchQueryKey(options)
});

/**
 * Link Market Search
 *
 * POST /api/v2/market-searches/{market_search_uuid}/link — confirm a same-search match.
 *
 * Attaches the observation (and any observations already grouped under it) to
 * the given hub. The hub must itself be a hub — a star, never a chain.
 */
export const linkMarketSearchMutation = (options?: Partial<Options<LinkMarketSearchData>>): UseMutationOptions<LinkMarketSearchResponse, AxiosError<LinkMarketSearchError>, Options<LinkMarketSearchData>> => {
    const mutationOptions: UseMutationOptions<LinkMarketSearchResponse, AxiosError<LinkMarketSearchError>, Options<LinkMarketSearchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await linkMarketSearch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const closeMarketSearchQueryKey = (options: Options<CloseMarketSearchData>) => createQueryKey('closeMarketSearch', options);

/**
 * Close Market Search
 *
 * POST /api/v2/market-searches/{market_search_uuid}/close — close the whole search.
 *
 * Writes ``status``, ``closed_at`` and ``closed_evidence`` onto every observation
 * that shares this row's ``search_uuid``.
 */
export const closeMarketSearchOptions = (options: Options<CloseMarketSearchData>) => queryOptions<CloseMarketSearchResponse, AxiosError<CloseMarketSearchError>, CloseMarketSearchResponse, ReturnType<typeof closeMarketSearchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await closeMarketSearch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: closeMarketSearchQueryKey(options)
});

/**
 * Close Market Search
 *
 * POST /api/v2/market-searches/{market_search_uuid}/close — close the whole search.
 *
 * Writes ``status``, ``closed_at`` and ``closed_evidence`` onto every observation
 * that shares this row's ``search_uuid``.
 */
export const closeMarketSearchMutation = (options?: Partial<Options<CloseMarketSearchData>>): UseMutationOptions<CloseMarketSearchResponse, AxiosError<CloseMarketSearchError>, Options<CloseMarketSearchData>> => {
    const mutationOptions: UseMutationOptions<CloseMarketSearchResponse, AxiosError<CloseMarketSearchError>, Options<CloseMarketSearchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await closeMarketSearch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const searchMarketSearchesQueryKey = (options: Options<SearchMarketSearchesData>) => createQueryKey('searchMarketSearches', options);

/**
 * Search Market Searches
 *
 * POST /api/v2/market-searches/search — the market-search table.
 *
 * One row per observation, with the size of its search and the linked
 * records it needs for display. Every word of ``phrase`` must match the row's
 * title, target company, firm, contact, client or closing note, or the current name
 * of a record it links to — so a row written "H&S" is found by "Heidrick"
 * once linked. Filters combine with AND; values inside one filter with OR.
 * Newest heard first unless ``sort_rules`` say otherwise.
 */
export const searchMarketSearchesOptions = (options: Options<SearchMarketSearchesData>) => queryOptions<SearchMarketSearchesResponse, AxiosError<SearchMarketSearchesError>, SearchMarketSearchesResponse, ReturnType<typeof searchMarketSearchesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchMarketSearches({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchMarketSearchesQueryKey(options)
});

export const searchMarketSearchesInfiniteQueryKey = (options: Options<SearchMarketSearchesData>): QueryKey<Options<SearchMarketSearchesData>> => createQueryKey('searchMarketSearches', options, true);

/**
 * Search Market Searches
 *
 * POST /api/v2/market-searches/search — the market-search table.
 *
 * One row per observation, with the size of its search and the linked
 * records it needs for display. Every word of ``phrase`` must match the row's
 * title, target company, firm, contact, client or closing note, or the current name
 * of a record it links to — so a row written "H&S" is found by "Heidrick"
 * once linked. Filters combine with AND; values inside one filter with OR.
 * Newest heard first unless ``sort_rules`` say otherwise.
 */
export const searchMarketSearchesInfiniteOptions = (options: Options<SearchMarketSearchesData>) => {
    const opts = infiniteQueryOptions<SearchMarketSearchesResponse, AxiosError<SearchMarketSearchesError>, InfiniteData<SearchMarketSearchesResponse>, QueryKey<Options<SearchMarketSearchesData>>, number | Pick<QueryKey<Options<SearchMarketSearchesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<SearchMarketSearchesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                body: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await searchMarketSearches({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: searchMarketSearchesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Search Market Searches
 *
 * POST /api/v2/market-searches/search — the market-search table.
 *
 * One row per observation, with the size of its search and the linked
 * records it needs for display. Every word of ``phrase`` must match the row's
 * title, target company, firm, contact, client or closing note, or the current name
 * of a record it links to — so a row written "H&S" is found by "Heidrick"
 * once linked. Filters combine with AND; values inside one filter with OR.
 * Newest heard first unless ``sort_rules`` say otherwise.
 */
export const searchMarketSearchesMutation = (options?: Partial<Options<SearchMarketSearchesData>>): UseMutationOptions<SearchMarketSearchesResponse, AxiosError<SearchMarketSearchesError>, Options<SearchMarketSearchesData>> => {
    const mutationOptions: UseMutationOptions<SearchMarketSearchesResponse, AxiosError<SearchMarketSearchesError>, Options<SearchMarketSearchesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await searchMarketSearches({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMarketSearchContactOptionsQueryKey = (options?: Options<GetMarketSearchContactOptionsData>) => createQueryKey('getMarketSearchContactOptions', options);

/**
 * Get Market Search Contact Options
 *
 * GET /api/v2/market-searches/contact-options — people to link as a search's contact.
 *
 * One option per human: people on an active team of a search firm, investor
 * or company — at the given firm or team when narrowed — never Banff staff.
 * Each comes with the teams they sit on, so choosing one can fill in the team
 * and the firm. Declared before ``/{market_search_uuid}``, which would
 * otherwise claim the path.
 */
export const getMarketSearchContactOptionsOptions = (options?: Options<GetMarketSearchContactOptionsData>) => queryOptions<GetMarketSearchContactOptionsResponse, AxiosError<GetMarketSearchContactOptionsError>, GetMarketSearchContactOptionsResponse, ReturnType<typeof getMarketSearchContactOptionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMarketSearchContactOptions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMarketSearchContactOptionsQueryKey(options)
});

export const getMarketSearchTeamOptionsQueryKey = (options?: Options<GetMarketSearchTeamOptionsData>) => createQueryKey('getMarketSearchTeamOptions', options);

/**
 * Get Market Search Team Options
 *
 * GET /api/v2/market-searches/team-options — active teams to link a search to.
 *
 * Narrowed to the search's firm when given. Declared before
 * ``/{market_search_uuid}``, which would otherwise claim the path.
 */
export const getMarketSearchTeamOptionsOptions = (options?: Options<GetMarketSearchTeamOptionsData>) => queryOptions<GetMarketSearchTeamOptionsResponse, AxiosError<GetMarketSearchTeamOptionsError>, GetMarketSearchTeamOptionsResponse, ReturnType<typeof getMarketSearchTeamOptionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMarketSearchTeamOptions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMarketSearchTeamOptionsQueryKey(options)
});

export const getMarketSearchPipelineOptionsQueryKey = (options?: Options<GetMarketSearchPipelineOptionsData>) => createQueryKey('getMarketSearchPipelineOptions', options);

/**
 * Get Market Search Pipeline Options
 *
 * GET /api/v2/market-searches/pipeline-options — pipelines to link a search to.
 *
 * Active pipelines first, then the newest. Declared before
 * ``/{market_search_uuid}``, which would otherwise claim the path.
 */
export const getMarketSearchPipelineOptionsOptions = (options?: Options<GetMarketSearchPipelineOptionsData>) => queryOptions<GetMarketSearchPipelineOptionsResponse, AxiosError<GetMarketSearchPipelineOptionsError>, GetMarketSearchPipelineOptionsResponse, ReturnType<typeof getMarketSearchPipelineOptionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMarketSearchPipelineOptions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMarketSearchPipelineOptionsQueryKey(options)
});

/**
 * Delete Market Search
 *
 * DELETE /api/v2/market-searches/{market_search_uuid} — remove one observation.
 *
 * Only this report goes: the search's other reports stay, and when this one
 * was the search's hub the oldest of them takes over. The row is kept as
 * deleted rather than erased, so it drops out of every listing and job but
 * an imported row can never be imported again.
 */
export const deleteMarketSearchMutation = (options?: Partial<Options<DeleteMarketSearchData>>): UseMutationOptions<DeleteMarketSearchResponse, AxiosError<DeleteMarketSearchError>, Options<DeleteMarketSearchData>> => {
    const mutationOptions: UseMutationOptions<DeleteMarketSearchResponse, AxiosError<DeleteMarketSearchError>, Options<DeleteMarketSearchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteMarketSearch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMarketSearchQueryKey = (options: Options<GetMarketSearchData>) => createQueryKey('getMarketSearch', options);

/**
 * Get Market Search
 *
 * GET /api/v2/market-searches/{market_search_uuid} — one observation, in full.
 *
 * Everything the row holds, the records it links to, and the other
 * observations of its search.
 */
export const getMarketSearchOptions = (options: Options<GetMarketSearchData>) => queryOptions<GetMarketSearchResponse, AxiosError<GetMarketSearchError>, GetMarketSearchResponse, ReturnType<typeof getMarketSearchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMarketSearch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMarketSearchQueryKey(options)
});

/**
 * Update Market Search
 *
 * PATCH /api/v2/market-searches/{market_search_uuid} — correct what was recorded.
 *
 * Only the fields sent change. Classification, the target company, status
 * and pipeline describe the search and are written to all of its
 * observations (``rows_updated`` says how many); the rest stay on this one.
 * Picking a record by id sets its name too; a new name without an id is
 * looked up again by exact match; an id sent as null unlinks and keeps the
 * name. 422 when a value cannot be stored — a record that does not exist, a
 * team at another firm, a contact not on the firm's teams. Open to the
 * Contender Actions connector, acting for the named team member.
 */
export const updateMarketSearchMutation = (options?: Partial<Options<UpdateMarketSearchData>>): UseMutationOptions<UpdateMarketSearchResponse, AxiosError<UpdateMarketSearchError>, Options<UpdateMarketSearchData>> => {
    const mutationOptions: UseMutationOptions<UpdateMarketSearchResponse, AxiosError<UpdateMarketSearchError>, Options<UpdateMarketSearchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateMarketSearch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postCandidatesQueryKey = (options: Options<PostCandidatesData>) => createQueryKey('postCandidates', options);

/**
 * Post Candidates
 *
 * POST /api/v2/candidates
 *
 * Rejects the create when a candidate with the same email already exists, so
 * a re-submitted form or a retried request cannot fork a second record for
 * the same executive.
 */
export const postCandidatesOptions = (options: Options<PostCandidatesData>) => queryOptions<PostCandidatesResponse, AxiosError<PostCandidatesError>, PostCandidatesResponse, ReturnType<typeof postCandidatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postCandidates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postCandidatesQueryKey(options)
});

/**
 * Post Candidates
 *
 * POST /api/v2/candidates
 *
 * Rejects the create when a candidate with the same email already exists, so
 * a re-submitted form or a retried request cannot fork a second record for
 * the same executive.
 */
export const postCandidatesMutation = (options?: Partial<Options<PostCandidatesData>>): UseMutationOptions<PostCandidatesResponse, AxiosError<PostCandidatesError>, Options<PostCandidatesData>> => {
    const mutationOptions: UseMutationOptions<PostCandidatesResponse, AxiosError<PostCandidatesError>, Options<PostCandidatesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCandidates({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCandidateV2QueryKey = (options: Options<GetCandidateV2Data>) => createQueryKey('getCandidateV2', options);

/**
 * Get Candidate V2
 *
 * GET /api/v2/candidates/{candidate_uuid}
 *
 * Also answers the Contender Actions connector, which reads a profile back
 * after changing it (a LinkedIn sync, for whether a photo was set).
 */
export const getCandidateV2Options = (options: Options<GetCandidateV2Data>) => queryOptions<GetCandidateV2Response, AxiosError<GetCandidateV2Error>, GetCandidateV2Response, ReturnType<typeof getCandidateV2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCandidateV2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCandidateV2QueryKey(options)
});

/**
 * Patch Candidate V2
 *
 * PATCH /api/v2/candidates/{candidate_uuid}
 *
 * A JSON merge patch: only the fields in the body are written, ``null``
 * clears a field. Referrers and blackout periods are not accepted here;
 * referrers have their own endpoints.
 *
 * Unlike ``PUT``, a pathway change keeps the candidate's
 * ``candidate_pathway_targets`` overrides.
 */
export const patchCandidateV2Mutation = (options?: Partial<Options<PatchCandidateV2Data>>): UseMutationOptions<PatchCandidateV2Response, AxiosError<PatchCandidateV2Error>, Options<PatchCandidateV2Data>> => {
    const mutationOptions: UseMutationOptions<PatchCandidateV2Response, AxiosError<PatchCandidateV2Error>, Options<PatchCandidateV2Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchCandidateV2({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Put Candidate
 *
 * PUT /api/v2/candidates/{candidate_uuid}
 *
 * The payload is dumped without ``exclude_unset``, so ``email`` is rewritten on
 * every save; guard it so an edit cannot move a candidate onto an email another
 * candidate already uses.
 */
export const putCandidateMutation = (options?: Partial<Options<PutCandidateData>>): UseMutationOptions<PutCandidateResponse, AxiosError<PutCandidateError>, Options<PutCandidateData>> => {
    const mutationOptions: UseMutationOptions<PutCandidateResponse, AxiosError<PutCandidateError>, Options<PutCandidateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putCandidate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Candidate Referrer
 *
 * DELETE /api/v2/candidates/{candidate_uuid}/referrers/{identity_uuid}
 *
 * Remove every row recording that ``identity_uuid`` referred this candidate;
 * the table has no unique constraint on the pair, so there can be more than
 * one. 404 when there is none. Other referral rows are not touched.
 */
export const deleteCandidateReferrerMutation = (options?: Partial<Options<DeleteCandidateReferrerData>>): UseMutationOptions<DeleteCandidateReferrerResponse, AxiosError<DeleteCandidateReferrerError>, Options<DeleteCandidateReferrerData>> => {
    const mutationOptions: UseMutationOptions<DeleteCandidateReferrerResponse, AxiosError<DeleteCandidateReferrerError>, Options<DeleteCandidateReferrerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteCandidateReferrer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Put Candidate Referrer
 *
 * PUT /api/v2/candidates/{candidate_uuid}/referrers/{identity_uuid}
 *
 * Record that ``identity_uuid`` referred this candidate: 201 with the new
 * referral, or 200 with the existing one when it is already recorded, so no
 * second row is added. The candidate's other referral rows are not touched.
 */
export const putCandidateReferrerMutation = (options?: Partial<Options<PutCandidateReferrerData>>): UseMutationOptions<PutCandidateReferrerResponse, AxiosError<PutCandidateReferrerError>, Options<PutCandidateReferrerData>> => {
    const mutationOptions: UseMutationOptions<PutCandidateReferrerResponse, AxiosError<PutCandidateReferrerError>, Options<PutCandidateReferrerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putCandidateReferrer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Candidate Favorite
 *
 * DELETE /api/v2/candidates/{candidate_uuid}/favorite
 *
 * @deprecated
 */
export const deleteCandidateFavoriteMutation = (options?: Partial<Options<DeleteCandidateFavoriteData>>): UseMutationOptions<DeleteCandidateFavoriteResponse, AxiosError<DeleteCandidateFavoriteError>, Options<DeleteCandidateFavoriteData>> => {
    const mutationOptions: UseMutationOptions<DeleteCandidateFavoriteResponse, AxiosError<DeleteCandidateFavoriteError>, Options<DeleteCandidateFavoriteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteCandidateFavorite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postCandidateFavoriteQueryKey = (options: Options<PostCandidateFavoriteData>) => createQueryKey('postCandidateFavorite', options);

/**
 * Post Candidate Favorite
 *
 * POST /api/v2/candidates/{candidate_uuid}/favorite
 *
 * @deprecated
 */
export const postCandidateFavoriteOptions = (options: Options<PostCandidateFavoriteData>) => queryOptions<PostCandidateFavoriteResponse, AxiosError<PostCandidateFavoriteError>, PostCandidateFavoriteResponse, ReturnType<typeof postCandidateFavoriteQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postCandidateFavorite({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postCandidateFavoriteQueryKey(options)
});

/**
 * Post Candidate Favorite
 *
 * POST /api/v2/candidates/{candidate_uuid}/favorite
 *
 * @deprecated
 */
export const postCandidateFavoriteMutation = (options?: Partial<Options<PostCandidateFavoriteData>>): UseMutationOptions<PostCandidateFavoriteResponse, AxiosError<PostCandidateFavoriteError>, Options<PostCandidateFavoriteData>> => {
    const mutationOptions: UseMutationOptions<PostCandidateFavoriteResponse, AxiosError<PostCandidateFavoriteError>, Options<PostCandidateFavoriteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCandidateFavorite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCandidateGoalsQueryKey = (options: Options<GetCandidateGoalsData>) => createQueryKey('getCandidateGoals', options);

/**
 * Get Candidate Goals
 *
 * GET /api/v2/candidates/{candidate_uuid}/goals
 *
 * @deprecated
 */
export const getCandidateGoalsOptions = (options: Options<GetCandidateGoalsData>) => queryOptions<GetCandidateGoalsResponse, AxiosError<GetCandidateGoalsError>, GetCandidateGoalsResponse, ReturnType<typeof getCandidateGoalsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCandidateGoals({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCandidateGoalsQueryKey(options)
});

/**
 * Patch Candidate Goals
 *
 * PATCH /api/v2/candidates/{candidate_uuid}/goals
 *
 * @deprecated
 */
export const patchCandidateGoalsMutation = (options?: Partial<Options<PatchCandidateGoalsData>>): UseMutationOptions<PatchCandidateGoalsResponse, AxiosError<PatchCandidateGoalsError>, Options<PatchCandidateGoalsData>> => {
    const mutationOptions: UseMutationOptions<PatchCandidateGoalsResponse, AxiosError<PatchCandidateGoalsError>, Options<PatchCandidateGoalsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchCandidateGoals({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCandidateGoalsWithActivitiesQueryKey = (options: Options<GetCandidateGoalsWithActivitiesData>) => createQueryKey('getCandidateGoalsWithActivities', options);

/**
 * Get Candidate Goals With Activities
 *
 * GET /api/v2/candidates/{candidate_uuid}/goals-activities
 */
export const getCandidateGoalsWithActivitiesOptions = (options: Options<GetCandidateGoalsWithActivitiesData>) => queryOptions<GetCandidateGoalsWithActivitiesResponse, AxiosError<GetCandidateGoalsWithActivitiesError>, GetCandidateGoalsWithActivitiesResponse, ReturnType<typeof getCandidateGoalsWithActivitiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCandidateGoalsWithActivities({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCandidateGoalsWithActivitiesQueryKey(options)
});

export const postCandidatesGoalsV2QueryKey = (options: Options<PostCandidatesGoalsV2Data>) => createQueryKey('postCandidatesGoalsV2', options);

/**
 * Post Candidates Goals V2
 *
 * POST /api/v2/candidates/{candidate_uuid}/goals-activities
 */
export const postCandidatesGoalsV2Options = (options: Options<PostCandidatesGoalsV2Data>) => queryOptions<PostCandidatesGoalsV2Response, AxiosError<PostCandidatesGoalsV2Error>, PostCandidatesGoalsV2Response, ReturnType<typeof postCandidatesGoalsV2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postCandidatesGoalsV2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postCandidatesGoalsV2QueryKey(options)
});

/**
 * Post Candidates Goals V2
 *
 * POST /api/v2/candidates/{candidate_uuid}/goals-activities
 */
export const postCandidatesGoalsV2Mutation = (options?: Partial<Options<PostCandidatesGoalsV2Data>>): UseMutationOptions<PostCandidatesGoalsV2Response, AxiosError<PostCandidatesGoalsV2Error>, Options<PostCandidatesGoalsV2Data>> => {
    const mutationOptions: UseMutationOptions<PostCandidatesGoalsV2Response, AxiosError<PostCandidatesGoalsV2Error>, Options<PostCandidatesGoalsV2Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCandidatesGoalsV2({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postCandidateShowOnboardingSectionQueryKey = (options: Options<PostCandidateShowOnboardingSectionData>) => createQueryKey('postCandidateShowOnboardingSection', options);

/**
 * Post Candidate Show Onboarding Section
 *
 * POST /api/v2/candidates/{candidate_uuid}/show-onboarding-section
 */
export const postCandidateShowOnboardingSectionOptions = (options: Options<PostCandidateShowOnboardingSectionData>) => queryOptions<unknown, AxiosError<PostCandidateShowOnboardingSectionError>, unknown, ReturnType<typeof postCandidateShowOnboardingSectionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postCandidateShowOnboardingSection({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postCandidateShowOnboardingSectionQueryKey(options)
});

/**
 * Post Candidate Show Onboarding Section
 *
 * POST /api/v2/candidates/{candidate_uuid}/show-onboarding-section
 */
export const postCandidateShowOnboardingSectionMutation = (options?: Partial<Options<PostCandidateShowOnboardingSectionData>>): UseMutationOptions<unknown, AxiosError<PostCandidateShowOnboardingSectionError>, Options<PostCandidateShowOnboardingSectionData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostCandidateShowOnboardingSectionError>, Options<PostCandidateShowOnboardingSectionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCandidateShowOnboardingSection({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postCandidateFeedbackV2QueryKey = (options: Options<PostCandidateFeedbackV2Data>) => createQueryKey('postCandidateFeedbackV2', options);

/**
 * Post Candidate Feedback V2
 *
 * POST /api/v2/candidates/{candidate_uuid}/feedback
 */
export const postCandidateFeedbackV2Options = (options: Options<PostCandidateFeedbackV2Data>) => queryOptions<PostCandidateFeedbackV2Response, AxiosError<PostCandidateFeedbackV2Error>, PostCandidateFeedbackV2Response, ReturnType<typeof postCandidateFeedbackV2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postCandidateFeedbackV2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postCandidateFeedbackV2QueryKey(options)
});

/**
 * Post Candidate Feedback V2
 *
 * POST /api/v2/candidates/{candidate_uuid}/feedback
 */
export const postCandidateFeedbackV2Mutation = (options?: Partial<Options<PostCandidateFeedbackV2Data>>): UseMutationOptions<PostCandidateFeedbackV2Response, AxiosError<PostCandidateFeedbackV2Error>, Options<PostCandidateFeedbackV2Data>> => {
    const mutationOptions: UseMutationOptions<PostCandidateFeedbackV2Response, AxiosError<PostCandidateFeedbackV2Error>, Options<PostCandidateFeedbackV2Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCandidateFeedbackV2({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postCandidateFeedbackFilterQueryKey = (options: Options<PostCandidateFeedbackFilterData>) => createQueryKey('postCandidateFeedbackFilter', options);

/**
 * Post Candidate Feedback Filter
 *
 * POST /api/v2/candidates/{candidate_uuid}/feedback/filter
 */
export const postCandidateFeedbackFilterOptions = (options: Options<PostCandidateFeedbackFilterData>) => queryOptions<PostCandidateFeedbackFilterResponse, AxiosError<PostCandidateFeedbackFilterError>, PostCandidateFeedbackFilterResponse, ReturnType<typeof postCandidateFeedbackFilterQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postCandidateFeedbackFilter({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postCandidateFeedbackFilterQueryKey(options)
});

export const postCandidateFeedbackFilterInfiniteQueryKey = (options: Options<PostCandidateFeedbackFilterData>): QueryKey<Options<PostCandidateFeedbackFilterData>> => createQueryKey('postCandidateFeedbackFilter', options, true);

/**
 * Post Candidate Feedback Filter
 *
 * POST /api/v2/candidates/{candidate_uuid}/feedback/filter
 */
export const postCandidateFeedbackFilterInfiniteOptions = (options: Options<PostCandidateFeedbackFilterData>) => {
    const opts = infiniteQueryOptions<PostCandidateFeedbackFilterResponse, AxiosError<PostCandidateFeedbackFilterError>, InfiniteData<PostCandidateFeedbackFilterResponse>, QueryKey<Options<PostCandidateFeedbackFilterData>>, number | Pick<QueryKey<Options<PostCandidateFeedbackFilterData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PostCandidateFeedbackFilterData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                body: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await postCandidateFeedbackFilter({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postCandidateFeedbackFilterInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Post Candidate Feedback Filter
 *
 * POST /api/v2/candidates/{candidate_uuid}/feedback/filter
 */
export const postCandidateFeedbackFilterMutation = (options?: Partial<Options<PostCandidateFeedbackFilterData>>): UseMutationOptions<PostCandidateFeedbackFilterResponse, AxiosError<PostCandidateFeedbackFilterError>, Options<PostCandidateFeedbackFilterData>> => {
    const mutationOptions: UseMutationOptions<PostCandidateFeedbackFilterResponse, AxiosError<PostCandidateFeedbackFilterError>, Options<PostCandidateFeedbackFilterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCandidateFeedbackFilter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Candidate Feedback
 *
 * DELETE /api/v2/candidates/{candidate_uuid}/feedback/{feedback_uuid}
 */
export const deleteCandidateFeedbackMutation = (options?: Partial<Options<DeleteCandidateFeedbackData>>): UseMutationOptions<DeleteCandidateFeedbackResponse, AxiosError<DeleteCandidateFeedbackError>, Options<DeleteCandidateFeedbackData>> => {
    const mutationOptions: UseMutationOptions<DeleteCandidateFeedbackResponse, AxiosError<DeleteCandidateFeedbackError>, Options<DeleteCandidateFeedbackData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteCandidateFeedback({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Put Candidate Feedback
 *
 * PUT /api/v2/candidates/{candidate_uuid}/feedback/{feedback_uuid}
 */
export const putCandidateFeedbackMutation = (options?: Partial<Options<PutCandidateFeedbackData>>): UseMutationOptions<PutCandidateFeedbackResponse, AxiosError<PutCandidateFeedbackError>, Options<PutCandidateFeedbackData>> => {
    const mutationOptions: UseMutationOptions<PutCandidateFeedbackResponse, AxiosError<PutCandidateFeedbackError>, Options<PutCandidateFeedbackData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putCandidateFeedback({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Candidate Goal
 *
 * DELETE /api/v2/candidates/{candidate_uuid}/goals/{goal_id}
 */
export const deleteCandidateGoalMutation = (options?: Partial<Options<DeleteCandidateGoalData>>): UseMutationOptions<DeleteCandidateGoalResponse, AxiosError<DeleteCandidateGoalError>, Options<DeleteCandidateGoalData>> => {
    const mutationOptions: UseMutationOptions<DeleteCandidateGoalResponse, AxiosError<DeleteCandidateGoalError>, Options<DeleteCandidateGoalData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteCandidateGoal({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCandidateGoalV2QueryKey = (options: Options<GetCandidateGoalV2Data>) => createQueryKey('getCandidateGoalV2', options);

/**
 * Get Candidate Goal V2
 *
 * GET /api/v2/candidates/{candidate_uuid}/goals/{goal_id}
 */
export const getCandidateGoalV2Options = (options: Options<GetCandidateGoalV2Data>) => queryOptions<GetCandidateGoalV2Response, AxiosError<GetCandidateGoalV2Error>, GetCandidateGoalV2Response, ReturnType<typeof getCandidateGoalV2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCandidateGoalV2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCandidateGoalV2QueryKey(options)
});

/**
 * Patch Candidate Goal V2
 *
 * PATCH /api/v2/candidates/{candidate_uuid}/goals/{goal_id}
 */
export const patchCandidateGoalV2Mutation = (options?: Partial<Options<PatchCandidateGoalV2Data>>): UseMutationOptions<PatchCandidateGoalV2Response, AxiosError<PatchCandidateGoalV2Error>, Options<PatchCandidateGoalV2Data>> => {
    const mutationOptions: UseMutationOptions<PatchCandidateGoalV2Response, AxiosError<PatchCandidateGoalV2Error>, Options<PatchCandidateGoalV2Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchCandidateGoalV2({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Candidate Goal Activity
 *
 * DELETE /api/v2/candidates/{candidate_uuid}/goals/{goal_id}/activity
 */
export const deleteCandidateGoalActivityMutation = (options?: Partial<Options<DeleteCandidateGoalActivityData>>): UseMutationOptions<DeleteCandidateGoalActivityResponse, AxiosError<DeleteCandidateGoalActivityError>, Options<DeleteCandidateGoalActivityData>> => {
    const mutationOptions: UseMutationOptions<DeleteCandidateGoalActivityResponse, AxiosError<DeleteCandidateGoalActivityError>, Options<DeleteCandidateGoalActivityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteCandidateGoalActivity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postCandidateGoalActivityQueryKey = (options: Options<PostCandidateGoalActivityData>) => createQueryKey('postCandidateGoalActivity', options);

/**
 * Post Candidate Goal Activity
 *
 * POST /api/v2/candidates/{candidate_uuid}/goals/{goal_id}/activity
 */
export const postCandidateGoalActivityOptions = (options: Options<PostCandidateGoalActivityData>) => queryOptions<PostCandidateGoalActivityResponse, AxiosError<PostCandidateGoalActivityError>, PostCandidateGoalActivityResponse, ReturnType<typeof postCandidateGoalActivityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postCandidateGoalActivity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postCandidateGoalActivityQueryKey(options)
});

/**
 * Post Candidate Goal Activity
 *
 * POST /api/v2/candidates/{candidate_uuid}/goals/{goal_id}/activity
 */
export const postCandidateGoalActivityMutation = (options?: Partial<Options<PostCandidateGoalActivityData>>): UseMutationOptions<PostCandidateGoalActivityResponse, AxiosError<PostCandidateGoalActivityError>, Options<PostCandidateGoalActivityData>> => {
    const mutationOptions: UseMutationOptions<PostCandidateGoalActivityResponse, AxiosError<PostCandidateGoalActivityError>, Options<PostCandidateGoalActivityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCandidateGoalActivity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postCandidateGoalTasksQueryKey = (options: Options<PostCandidateGoalTasksData>) => createQueryKey('postCandidateGoalTasks', options);

/**
 * Post Candidate Goal Tasks
 *
 * POST /api/v2/candidates/{candidate_uuid}/goals/{goal_id}/tasks
 */
export const postCandidateGoalTasksOptions = (options: Options<PostCandidateGoalTasksData>) => queryOptions<PostCandidateGoalTasksResponse, AxiosError<PostCandidateGoalTasksError>, PostCandidateGoalTasksResponse, ReturnType<typeof postCandidateGoalTasksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postCandidateGoalTasks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postCandidateGoalTasksQueryKey(options)
});

/**
 * Post Candidate Goal Tasks
 *
 * POST /api/v2/candidates/{candidate_uuid}/goals/{goal_id}/tasks
 */
export const postCandidateGoalTasksMutation = (options?: Partial<Options<PostCandidateGoalTasksData>>): UseMutationOptions<PostCandidateGoalTasksResponse, AxiosError<PostCandidateGoalTasksError>, Options<PostCandidateGoalTasksData>> => {
    const mutationOptions: UseMutationOptions<PostCandidateGoalTasksResponse, AxiosError<PostCandidateGoalTasksError>, Options<PostCandidateGoalTasksData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCandidateGoalTasks({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postCandidateRecommendationsFilterQueryKey = (options: Options<PostCandidateRecommendationsFilterData>) => createQueryKey('postCandidateRecommendationsFilter', options);

/**
 * Post Candidate Recommendations Filter
 *
 * POST /api/v2/candidates/{candidate_uuid}/recommendations/filter
 */
export const postCandidateRecommendationsFilterOptions = (options: Options<PostCandidateRecommendationsFilterData>) => queryOptions<PostCandidateRecommendationsFilterResponse, AxiosError<PostCandidateRecommendationsFilterError>, PostCandidateRecommendationsFilterResponse, ReturnType<typeof postCandidateRecommendationsFilterQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postCandidateRecommendationsFilter({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postCandidateRecommendationsFilterQueryKey(options)
});

export const postCandidateRecommendationsFilterInfiniteQueryKey = (options: Options<PostCandidateRecommendationsFilterData>): QueryKey<Options<PostCandidateRecommendationsFilterData>> => createQueryKey('postCandidateRecommendationsFilter', options, true);

/**
 * Post Candidate Recommendations Filter
 *
 * POST /api/v2/candidates/{candidate_uuid}/recommendations/filter
 */
export const postCandidateRecommendationsFilterInfiniteOptions = (options: Options<PostCandidateRecommendationsFilterData>) => {
    const opts = infiniteQueryOptions<PostCandidateRecommendationsFilterResponse, AxiosError<PostCandidateRecommendationsFilterError>, InfiniteData<PostCandidateRecommendationsFilterResponse>, QueryKey<Options<PostCandidateRecommendationsFilterData>>, number | Pick<QueryKey<Options<PostCandidateRecommendationsFilterData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PostCandidateRecommendationsFilterData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                body: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await postCandidateRecommendationsFilter({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postCandidateRecommendationsFilterInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Post Candidate Recommendations Filter
 *
 * POST /api/v2/candidates/{candidate_uuid}/recommendations/filter
 */
export const postCandidateRecommendationsFilterMutation = (options?: Partial<Options<PostCandidateRecommendationsFilterData>>): UseMutationOptions<PostCandidateRecommendationsFilterResponse, AxiosError<PostCandidateRecommendationsFilterError>, Options<PostCandidateRecommendationsFilterData>> => {
    const mutationOptions: UseMutationOptions<PostCandidateRecommendationsFilterResponse, AxiosError<PostCandidateRecommendationsFilterError>, Options<PostCandidateRecommendationsFilterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCandidateRecommendationsFilter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postCandidateIntroTemplatesQueryKey = (options: Options<PostCandidateIntroTemplatesData>) => createQueryKey('postCandidateIntroTemplates', options);

/**
 * Post Candidate Intro Templates
 *
 * Create a new introduction template for a candidate
 */
export const postCandidateIntroTemplatesOptions = (options: Options<PostCandidateIntroTemplatesData>) => queryOptions<PostCandidateIntroTemplatesResponse, AxiosError<PostCandidateIntroTemplatesError>, PostCandidateIntroTemplatesResponse, ReturnType<typeof postCandidateIntroTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postCandidateIntroTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postCandidateIntroTemplatesQueryKey(options)
});

/**
 * Post Candidate Intro Templates
 *
 * Create a new introduction template for a candidate
 */
export const postCandidateIntroTemplatesMutation = (options?: Partial<Options<PostCandidateIntroTemplatesData>>): UseMutationOptions<PostCandidateIntroTemplatesResponse, AxiosError<PostCandidateIntroTemplatesError>, Options<PostCandidateIntroTemplatesData>> => {
    const mutationOptions: UseMutationOptions<PostCandidateIntroTemplatesResponse, AxiosError<PostCandidateIntroTemplatesError>, Options<PostCandidateIntroTemplatesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCandidateIntroTemplates({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postCandidateHighlightsV2QueryKey = (options: Options<PostCandidateHighlightsV2Data>) => createQueryKey('postCandidateHighlightsV2', options);

/**
 * Post Candidate Highlights V2
 *
 * Create a new highlight for a candidate
 */
export const postCandidateHighlightsV2Options = (options: Options<PostCandidateHighlightsV2Data>) => queryOptions<PostCandidateHighlightsV2Response, AxiosError<PostCandidateHighlightsV2Error>, PostCandidateHighlightsV2Response, ReturnType<typeof postCandidateHighlightsV2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postCandidateHighlightsV2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postCandidateHighlightsV2QueryKey(options)
});

/**
 * Post Candidate Highlights V2
 *
 * Create a new highlight for a candidate
 */
export const postCandidateHighlightsV2Mutation = (options?: Partial<Options<PostCandidateHighlightsV2Data>>): UseMutationOptions<PostCandidateHighlightsV2Response, AxiosError<PostCandidateHighlightsV2Error>, Options<PostCandidateHighlightsV2Data>> => {
    const mutationOptions: UseMutationOptions<PostCandidateHighlightsV2Response, AxiosError<PostCandidateHighlightsV2Error>, Options<PostCandidateHighlightsV2Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCandidateHighlightsV2({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCandidateStatsQueryKey = (options: Options<GetCandidateStatsData>) => createQueryKey('getCandidateStats', options);

/**
 * Get Candidate Stats
 *
 * GET /api/v2/candidates/{candidate_uuid}/stats
 */
export const getCandidateStatsOptions = (options: Options<GetCandidateStatsData>) => queryOptions<GetCandidateStatsResponse, AxiosError<GetCandidateStatsError>, GetCandidateStatsResponse, ReturnType<typeof getCandidateStatsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCandidateStats({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCandidateStatsQueryKey(options)
});

export const getRecsysCandidateOpportunitiesQueryKey = (options: Options<GetRecsysCandidateOpportunitiesData>) => createQueryKey('getRecsysCandidateOpportunities', options);

/**
 * Get Recsys Candidate Opportunities
 *
 * GET /api/v2/candidates/{candidate_uuid}/recsys-opportunities
 *
 * Fetch this exec's RecSys opportunity queue — the open pipelines RecSys rates them a good
 * fit for, best fit first — and hydrate each into Contender pipeline data. Read-through:
 * nothing is stored on the Contender side. `already_recommended` flags pipelines the exec is
 * already on (so the UI can disable quick add). Empty when RecSys's sweep hasn't reached this
 * exec yet; a 502/503 when the RecSys service is unavailable or unconfigured.
 *
 * Paging happens HERE, not in RecSys: rows whose pipeline is closed or unknown to
 * Contender are dropped, and paging RecSys-side would make `total` count rows that never
 * render and leave pages short. The queue is small by construction (top-of-ranking pairs,
 * well under the bridge's 100 cap), so we read it whole, filter, then slice.
 */
export const getRecsysCandidateOpportunitiesOptions = (options: Options<GetRecsysCandidateOpportunitiesData>) => queryOptions<GetRecsysCandidateOpportunitiesResponse, AxiosError<GetRecsysCandidateOpportunitiesError>, GetRecsysCandidateOpportunitiesResponse, ReturnType<typeof getRecsysCandidateOpportunitiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRecsysCandidateOpportunities({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRecsysCandidateOpportunitiesQueryKey(options)
});

export const getRecsysCandidateOpportunitiesInfiniteQueryKey = (options: Options<GetRecsysCandidateOpportunitiesData>): QueryKey<Options<GetRecsysCandidateOpportunitiesData>> => createQueryKey('getRecsysCandidateOpportunities', options, true);

/**
 * Get Recsys Candidate Opportunities
 *
 * GET /api/v2/candidates/{candidate_uuid}/recsys-opportunities
 *
 * Fetch this exec's RecSys opportunity queue — the open pipelines RecSys rates them a good
 * fit for, best fit first — and hydrate each into Contender pipeline data. Read-through:
 * nothing is stored on the Contender side. `already_recommended` flags pipelines the exec is
 * already on (so the UI can disable quick add). Empty when RecSys's sweep hasn't reached this
 * exec yet; a 502/503 when the RecSys service is unavailable or unconfigured.
 *
 * Paging happens HERE, not in RecSys: rows whose pipeline is closed or unknown to
 * Contender are dropped, and paging RecSys-side would make `total` count rows that never
 * render and leave pages short. The queue is small by construction (top-of-ranking pairs,
 * well under the bridge's 100 cap), so we read it whole, filter, then slice.
 */
export const getRecsysCandidateOpportunitiesInfiniteOptions = (options: Options<GetRecsysCandidateOpportunitiesData>) => {
    const opts = infiniteQueryOptions<GetRecsysCandidateOpportunitiesResponse, AxiosError<GetRecsysCandidateOpportunitiesError>, InfiniteData<GetRecsysCandidateOpportunitiesResponse>, QueryKey<Options<GetRecsysCandidateOpportunitiesData>>, number | Pick<QueryKey<Options<GetRecsysCandidateOpportunitiesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetRecsysCandidateOpportunitiesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getRecsysCandidateOpportunities({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getRecsysCandidateOpportunitiesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getRecsysOpportunityRationaleQueryKey = (options: Options<GetRecsysOpportunityRationaleData>) => createQueryKey('getRecsysOpportunityRationale', options);

/**
 * Get Recsys Opportunity Rationale
 *
 * GET /api/v2/candidates/{candidate_uuid}/recsys-opportunities/{pipeline_uuid}/rationale
 *
 * Why RecSys thinks this exec fits this search. RecSys writes it on first ask and caches it,
 * so a pair whose `has_rationale` is false costs a model call — fetch this when a row is
 * expanded, never for a whole page.
 */
export const getRecsysOpportunityRationaleOptions = (options: Options<GetRecsysOpportunityRationaleData>) => queryOptions<GetRecsysOpportunityRationaleResponse, AxiosError<GetRecsysOpportunityRationaleError>, GetRecsysOpportunityRationaleResponse, ReturnType<typeof getRecsysOpportunityRationaleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRecsysOpportunityRationale({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRecsysOpportunityRationaleQueryKey(options)
});

export const postRecsysOpportunityReviewedQueryKey = (options: Options<PostRecsysOpportunityReviewedData>) => createQueryKey('postRecsysOpportunityReviewed', options);

/**
 * Post Recsys Opportunity Reviewed
 *
 * POST /api/v2/candidates/{candidate_uuid}/recsys-opportunities/{pipeline_uuid}/reviewed
 *
 * Mark this opportunity reviewed, or clear it. The state lives in RecSys and is keyed on the
 * (candidate, pipeline) pair, so a row an advisor works here stops being offered in the RecSys
 * app too. Clearing fully resets the pair — any bad-match verdict goes with it.
 */
export const postRecsysOpportunityReviewedOptions = (options: Options<PostRecsysOpportunityReviewedData>) => queryOptions<PostRecsysOpportunityReviewedResponse, AxiosError<PostRecsysOpportunityReviewedError>, PostRecsysOpportunityReviewedResponse, ReturnType<typeof postRecsysOpportunityReviewedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postRecsysOpportunityReviewed({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postRecsysOpportunityReviewedQueryKey(options)
});

/**
 * Post Recsys Opportunity Reviewed
 *
 * POST /api/v2/candidates/{candidate_uuid}/recsys-opportunities/{pipeline_uuid}/reviewed
 *
 * Mark this opportunity reviewed, or clear it. The state lives in RecSys and is keyed on the
 * (candidate, pipeline) pair, so a row an advisor works here stops being offered in the RecSys
 * app too. Clearing fully resets the pair — any bad-match verdict goes with it.
 */
export const postRecsysOpportunityReviewedMutation = (options?: Partial<Options<PostRecsysOpportunityReviewedData>>): UseMutationOptions<PostRecsysOpportunityReviewedResponse, AxiosError<PostRecsysOpportunityReviewedError>, Options<PostRecsysOpportunityReviewedData>> => {
    const mutationOptions: UseMutationOptions<PostRecsysOpportunityReviewedResponse, AxiosError<PostRecsysOpportunityReviewedError>, Options<PostRecsysOpportunityReviewedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postRecsysOpportunityReviewed({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postRecsysOpportunityBadMatchQueryKey = (options: Options<PostRecsysOpportunityBadMatchData>) => createQueryKey('postRecsysOpportunityBadMatch', options);

/**
 * Post Recsys Opportunity Bad Match
 *
 * POST /api/v2/candidates/{candidate_uuid}/recsys-opportunities/{pipeline_uuid}/bad
 *
 * Record that this pipeline is a bad fit for the exec, with an optional reason. Stored in
 * RecSys against the pair and used to steer future suggestions; it deliberately does not
 * touch the pipeline's own recommendation feedback, so a candidate-side verdict never
 * re-ranks somebody else's search.
 */
export const postRecsysOpportunityBadMatchOptions = (options: Options<PostRecsysOpportunityBadMatchData>) => queryOptions<PostRecsysOpportunityBadMatchResponse, AxiosError<PostRecsysOpportunityBadMatchError>, PostRecsysOpportunityBadMatchResponse, ReturnType<typeof postRecsysOpportunityBadMatchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postRecsysOpportunityBadMatch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postRecsysOpportunityBadMatchQueryKey(options)
});

/**
 * Post Recsys Opportunity Bad Match
 *
 * POST /api/v2/candidates/{candidate_uuid}/recsys-opportunities/{pipeline_uuid}/bad
 *
 * Record that this pipeline is a bad fit for the exec, with an optional reason. Stored in
 * RecSys against the pair and used to steer future suggestions; it deliberately does not
 * touch the pipeline's own recommendation feedback, so a candidate-side verdict never
 * re-ranks somebody else's search.
 */
export const postRecsysOpportunityBadMatchMutation = (options?: Partial<Options<PostRecsysOpportunityBadMatchData>>): UseMutationOptions<PostRecsysOpportunityBadMatchResponse, AxiosError<PostRecsysOpportunityBadMatchError>, Options<PostRecsysOpportunityBadMatchData>> => {
    const mutationOptions: UseMutationOptions<PostRecsysOpportunityBadMatchResponse, AxiosError<PostRecsysOpportunityBadMatchError>, Options<PostRecsysOpportunityBadMatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postRecsysOpportunityBadMatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postCandidatesTrendingFilterQueryKey = (options: Options<PostCandidatesTrendingFilterData>) => createQueryKey('postCandidatesTrendingFilter', options);

/**
 * Post Candidates Trending Filter
 *
 * POST /api/v2/candidates/trending/filter
 */
export const postCandidatesTrendingFilterOptions = (options: Options<PostCandidatesTrendingFilterData>) => queryOptions<PostCandidatesTrendingFilterResponse, AxiosError<PostCandidatesTrendingFilterError>, PostCandidatesTrendingFilterResponse, ReturnType<typeof postCandidatesTrendingFilterQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postCandidatesTrendingFilter({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postCandidatesTrendingFilterQueryKey(options)
});

export const postCandidatesTrendingFilterInfiniteQueryKey = (options: Options<PostCandidatesTrendingFilterData>): QueryKey<Options<PostCandidatesTrendingFilterData>> => createQueryKey('postCandidatesTrendingFilter', options, true);

/**
 * Post Candidates Trending Filter
 *
 * POST /api/v2/candidates/trending/filter
 */
export const postCandidatesTrendingFilterInfiniteOptions = (options: Options<PostCandidatesTrendingFilterData>) => {
    const opts = infiniteQueryOptions<PostCandidatesTrendingFilterResponse, AxiosError<PostCandidatesTrendingFilterError>, InfiniteData<PostCandidatesTrendingFilterResponse>, QueryKey<Options<PostCandidatesTrendingFilterData>>, number | Pick<QueryKey<Options<PostCandidatesTrendingFilterData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PostCandidatesTrendingFilterData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                body: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await postCandidatesTrendingFilter({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postCandidatesTrendingFilterInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Post Candidates Trending Filter
 *
 * POST /api/v2/candidates/trending/filter
 */
export const postCandidatesTrendingFilterMutation = (options?: Partial<Options<PostCandidatesTrendingFilterData>>): UseMutationOptions<PostCandidatesTrendingFilterResponse, AxiosError<PostCandidatesTrendingFilterError>, Options<PostCandidatesTrendingFilterData>> => {
    const mutationOptions: UseMutationOptions<PostCandidatesTrendingFilterResponse, AxiosError<PostCandidatesTrendingFilterError>, Options<PostCandidatesTrendingFilterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCandidatesTrendingFilter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postCompaniesSearchV2QueryKey = (options?: Options<PostCompaniesSearchV2Data>) => createQueryKey('postCompaniesSearchV2', options);

/**
 * Post Companies Search V2
 *
 * POST /api/v2/companies/search
 *
 * Returns a list of companies with their teams and users.
 * Supports filtering by payment_status, type, has_members and active.
 * Supports sorting by name, payment_status, type, users_count, teams_count.
 * Supports searching by phrase (case-insensitive match on name or industry_keywords).
 */
export const postCompaniesSearchV2Options = (options?: Options<PostCompaniesSearchV2Data>) => queryOptions<PostCompaniesSearchV2Response, AxiosError<PostCompaniesSearchV2Error>, PostCompaniesSearchV2Response, ReturnType<typeof postCompaniesSearchV2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postCompaniesSearchV2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postCompaniesSearchV2QueryKey(options)
});

export const postCompaniesSearchV2InfiniteQueryKey = (options?: Options<PostCompaniesSearchV2Data>): QueryKey<Options<PostCompaniesSearchV2Data>> => createQueryKey('postCompaniesSearchV2', options, true);

/**
 * Post Companies Search V2
 *
 * POST /api/v2/companies/search
 *
 * Returns a list of companies with their teams and users.
 * Supports filtering by payment_status, type, has_members and active.
 * Supports sorting by name, payment_status, type, users_count, teams_count.
 * Supports searching by phrase (case-insensitive match on name or industry_keywords).
 */
export const postCompaniesSearchV2InfiniteOptions = (options?: Options<PostCompaniesSearchV2Data>) => {
    const opts = infiniteQueryOptions<PostCompaniesSearchV2Response, AxiosError<PostCompaniesSearchV2Error>, InfiniteData<PostCompaniesSearchV2Response>, QueryKey<Options<PostCompaniesSearchV2Data>>, number | Pick<QueryKey<Options<PostCompaniesSearchV2Data>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PostCompaniesSearchV2Data>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                body: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await postCompaniesSearchV2({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postCompaniesSearchV2InfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Post Companies Search V2
 *
 * POST /api/v2/companies/search
 *
 * Returns a list of companies with their teams and users.
 * Supports filtering by payment_status, type, has_members and active.
 * Supports sorting by name, payment_status, type, users_count, teams_count.
 * Supports searching by phrase (case-insensitive match on name or industry_keywords).
 */
export const postCompaniesSearchV2Mutation = (options?: Partial<Options<PostCompaniesSearchV2Data>>): UseMutationOptions<PostCompaniesSearchV2Response, AxiosError<PostCompaniesSearchV2Error>, Options<PostCompaniesSearchV2Data>> => {
    const mutationOptions: UseMutationOptions<PostCompaniesSearchV2Response, AxiosError<PostCompaniesSearchV2Error>, Options<PostCompaniesSearchV2Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCompaniesSearchV2({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postCompanyTeamsQueryKey = (options: Options<PostCompanyTeamsData>) => createQueryKey('postCompanyTeams', options);

/**
 * Post Company Teams
 *
 * POST /api/v2/companies/{company_slug}/teams
 *
 * Also reachable by the Contender Actions connector (service key + acting
 * user), which may only add a team: the ``company`` block, which overwrites
 * the company's name, type and payment status, is refused on that path.
 */
export const postCompanyTeamsOptions = (options: Options<PostCompanyTeamsData>) => queryOptions<PostCompanyTeamsResponse, AxiosError<PostCompanyTeamsError>, PostCompanyTeamsResponse, ReturnType<typeof postCompanyTeamsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postCompanyTeams({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postCompanyTeamsQueryKey(options)
});

/**
 * Post Company Teams
 *
 * POST /api/v2/companies/{company_slug}/teams
 *
 * Also reachable by the Contender Actions connector (service key + acting
 * user), which may only add a team: the ``company`` block, which overwrites
 * the company's name, type and payment status, is refused on that path.
 */
export const postCompanyTeamsMutation = (options?: Partial<Options<PostCompanyTeamsData>>): UseMutationOptions<PostCompanyTeamsResponse, AxiosError<PostCompanyTeamsError>, Options<PostCompanyTeamsData>> => {
    const mutationOptions: UseMutationOptions<PostCompanyTeamsResponse, AxiosError<PostCompanyTeamsError>, Options<PostCompanyTeamsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCompanyTeams({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Comment
 *
 * DELETE /api/v2/comments/{comment_uuid}
 *
 * Soft delete (sets ``deleted_at``); author-only.
 */
export const deleteCommentMutation = (options?: Partial<Options<DeleteCommentData>>): UseMutationOptions<DeleteCommentResponse, AxiosError<DeleteCommentError>, Options<DeleteCommentData>> => {
    const mutationOptions: UseMutationOptions<DeleteCommentResponse, AxiosError<DeleteCommentError>, Options<DeleteCommentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteComment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Put Comment
 *
 * PUT /api/v2/comments/{comment_uuid}
 */
export const putCommentMutation = (options?: Partial<Options<PutCommentData>>): UseMutationOptions<PutCommentResponse, AxiosError<PutCommentError>, Options<PutCommentData>> => {
    const mutationOptions: UseMutationOptions<PutCommentResponse, AxiosError<PutCommentError>, Options<PutCommentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putComment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Internal Comment
 *
 * DELETE /api/v2/internal-comments/{comment_uuid}
 */
export const deleteInternalCommentMutation = (options?: Partial<Options<DeleteInternalCommentData>>): UseMutationOptions<DeleteInternalCommentResponse, AxiosError<DeleteInternalCommentError>, Options<DeleteInternalCommentData>> => {
    const mutationOptions: UseMutationOptions<DeleteInternalCommentResponse, AxiosError<DeleteInternalCommentError>, Options<DeleteInternalCommentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteInternalComment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Put Internal Comment
 *
 * PUT /api/v2/internal-comments/{comment_uuid}
 */
export const putInternalCommentMutation = (options?: Partial<Options<PutInternalCommentData>>): UseMutationOptions<PutInternalCommentResponse, AxiosError<PutInternalCommentError>, Options<PutInternalCommentData>> => {
    const mutationOptions: UseMutationOptions<PutInternalCommentResponse, AxiosError<PutInternalCommentError>, Options<PutInternalCommentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putInternalComment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Put Evaluation History Introduction
 *
 * Edit who an existing intro request is for, in place.
 *
 * The subject — an external person or a platform user the request was made
 * on behalf of — is stored in the COMPLETED entry's context and snapshotted
 * into any FACILITATED / INTRODUCTION_NOT_FACILITATED entries of the same
 * request cycle and into every paired candidate_activity_log message, so all
 * of them are rewritten together. Timestamps are never touched: this is the
 * supported way to backfill or correct an introduction without rewriting
 * feed history (unlike revert + re-request, which stamps new dates).
 *
 * The entry's person_id (and the logs' actor_id) is a logging value: it
 * becomes the new on-behalf person, or the acting admin for an external
 * subject — matching what creating the request that way would have recorded.
 *
 * Recommendation-level fields (requested_on_behalf_id, requested_intro)
 * describe the latest request, so they are only rewritten when the edited
 * entry is the latest COMPLETED entry in its scope.
 */
export const putEvaluationHistoryIntroductionMutation = (options?: Partial<Options<PutEvaluationHistoryIntroductionData>>): UseMutationOptions<PutEvaluationHistoryIntroductionResponse, AxiosError<PutEvaluationHistoryIntroductionError>, Options<PutEvaluationHistoryIntroductionData>> => {
    const mutationOptions: UseMutationOptions<PutEvaluationHistoryIntroductionResponse, AxiosError<PutEvaluationHistoryIntroductionError>, Options<PutEvaluationHistoryIntroductionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putEvaluationHistoryIntroduction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const revertEvaluationHistoryQueryKey = (options: Options<RevertEvaluationHistoryData>) => createQueryKey('revertEvaluationHistory', options);

/**
 * Revert Evaluation History
 *
 * Revert a specific evaluation history entry and recalculate recommendation state.
 *
 * Supports:
 * - NOT_LIKED and NOT_LIKED_UNDO actions: Recalculates recommendation's is_liked state
 * - COMPLETED (intro request): Removes intro request and resets submission_candidate fields
 * - FACILITATED (intro facilitated): Removes facilitated status
 * - INTRODUCTION_NOT_FACILITATED (intro unavailable): Removes unavailable status
 *
 * For pipeline intro requests (with recommendation_uuid):
 * - Only ONE intro request (COMPLETED) is allowed per recommendation
 * - Lifecycle: COMPLETED -> FACILITATED or INTRODUCTION_NOT_FACILITATED (one cycle)
 * - Resets submission_candidate fields only if all intro-related entries are removed
 *
 * For global intro requests (without recommendation_uuid):
 * - Multiple cycles are allowed: COMPLETED -> FACILITATED -> COMPLETED (new cycle) -> ...
 * - Only one pending (COMPLETED) request at a time
 * - Only deletes evaluation_history and candidate_activity_log entries (no field resets)
 *
 * Deletes all associated candidate_activity_log entries.
 */
export const revertEvaluationHistoryOptions = (options: Options<RevertEvaluationHistoryData>) => queryOptions<RevertEvaluationHistoryResponse, AxiosError<RevertEvaluationHistoryError>, RevertEvaluationHistoryResponse, ReturnType<typeof revertEvaluationHistoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await revertEvaluationHistory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: revertEvaluationHistoryQueryKey(options)
});

/**
 * Revert Evaluation History
 *
 * Revert a specific evaluation history entry and recalculate recommendation state.
 *
 * Supports:
 * - NOT_LIKED and NOT_LIKED_UNDO actions: Recalculates recommendation's is_liked state
 * - COMPLETED (intro request): Removes intro request and resets submission_candidate fields
 * - FACILITATED (intro facilitated): Removes facilitated status
 * - INTRODUCTION_NOT_FACILITATED (intro unavailable): Removes unavailable status
 *
 * For pipeline intro requests (with recommendation_uuid):
 * - Only ONE intro request (COMPLETED) is allowed per recommendation
 * - Lifecycle: COMPLETED -> FACILITATED or INTRODUCTION_NOT_FACILITATED (one cycle)
 * - Resets submission_candidate fields only if all intro-related entries are removed
 *
 * For global intro requests (without recommendation_uuid):
 * - Multiple cycles are allowed: COMPLETED -> FACILITATED -> COMPLETED (new cycle) -> ...
 * - Only one pending (COMPLETED) request at a time
 * - Only deletes evaluation_history and candidate_activity_log entries (no field resets)
 *
 * Deletes all associated candidate_activity_log entries.
 */
export const revertEvaluationHistoryMutation = (options?: Partial<Options<RevertEvaluationHistoryData>>): UseMutationOptions<RevertEvaluationHistoryResponse, AxiosError<RevertEvaluationHistoryError>, Options<RevertEvaluationHistoryData>> => {
    const mutationOptions: UseMutationOptions<RevertEvaluationHistoryResponse, AxiosError<RevertEvaluationHistoryError>, Options<RevertEvaluationHistoryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await revertEvaluationHistory({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Highlight
 *
 * DELETE /api/v2/highlights/{highlight_uuid}
 */
export const deleteHighlightMutation = (options?: Partial<Options<DeleteHighlightData>>): UseMutationOptions<DeleteHighlightResponse2, AxiosError<DeleteHighlightError>, Options<DeleteHighlightData>> => {
    const mutationOptions: UseMutationOptions<DeleteHighlightResponse2, AxiosError<DeleteHighlightError>, Options<DeleteHighlightData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteHighlight({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Put Highlight
 *
 * PUT /api/v2/highlights/{highlight_uuid}
 */
export const putHighlightMutation = (options?: Partial<Options<PutHighlightData>>): UseMutationOptions<PutHighlightResponse2, AxiosError<PutHighlightError>, Options<PutHighlightData>> => {
    const mutationOptions: UseMutationOptions<PutHighlightResponse2, AxiosError<PutHighlightError>, Options<PutHighlightData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putHighlight({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Introduction Template
 *
 * DELETE /api/v2/introduction-templates/{template_uuid}
 */
export const deleteIntroductionTemplateMutation = (options?: Partial<Options<DeleteIntroductionTemplateData>>): UseMutationOptions<DeleteIntroductionTemplateResponse, AxiosError<DeleteIntroductionTemplateError>, Options<DeleteIntroductionTemplateData>> => {
    const mutationOptions: UseMutationOptions<DeleteIntroductionTemplateResponse, AxiosError<DeleteIntroductionTemplateError>, Options<DeleteIntroductionTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteIntroductionTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Put Introduction Template
 *
 * PUT /api/v2/introduction-templates/{template_uuid}
 */
export const putIntroductionTemplateMutation = (options?: Partial<Options<PutIntroductionTemplateData>>): UseMutationOptions<PutIntroductionTemplateResponse, AxiosError<PutIntroductionTemplateError>, Options<PutIntroductionTemplateData>> => {
    const mutationOptions: UseMutationOptions<PutIntroductionTemplateResponse, AxiosError<PutIntroductionTemplateError>, Options<PutIntroductionTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putIntroductionTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postLinkedinSyncCandidateQueryKey = (options: Options<PostLinkedinSyncCandidateData>) => createQueryKey('postLinkedinSyncCandidate', options);

/**
 * Post Linkedin Sync Candidate
 *
 * POST /api/v2/linkedin_sync/candidates/{candidate_id}
 *
 * Pull the candidate's LinkedIn profile into their resume, headline and photo.
 * The photo is filled in when the candidate has none; with `replace_photo` it
 * replaces the current one. A profile fetched within the last hour (by a
 * preview, typically) is used instead of fetching it again. Otherwise the
 * provider serves its stored copy, however old, unless `fresh` asks it to
 * re-read one it last saw over a month ago (about one credit more). The body
 * is optional: without one, both options are off. 204 means LinkedIn had
 * nothing new for the resume; the headline and photo may still have changed.
 * 404 means LinkedIn has no profile at the candidate's link, and 503 without
 * Retry-After that lookups are out of credits. 503 with Retry-After means
 * LinkedIn is slow: the sync finishes in the background, and syncing again a
 * minute later uses what it fetched.
 */
export const postLinkedinSyncCandidateOptions = (options: Options<PostLinkedinSyncCandidateData>) => queryOptions<PostLinkedinSyncCandidateResponse, AxiosError<PostLinkedinSyncCandidateError>, PostLinkedinSyncCandidateResponse, ReturnType<typeof postLinkedinSyncCandidateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postLinkedinSyncCandidate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postLinkedinSyncCandidateQueryKey(options)
});

/**
 * Post Linkedin Sync Candidate
 *
 * POST /api/v2/linkedin_sync/candidates/{candidate_id}
 *
 * Pull the candidate's LinkedIn profile into their resume, headline and photo.
 * The photo is filled in when the candidate has none; with `replace_photo` it
 * replaces the current one. A profile fetched within the last hour (by a
 * preview, typically) is used instead of fetching it again. Otherwise the
 * provider serves its stored copy, however old, unless `fresh` asks it to
 * re-read one it last saw over a month ago (about one credit more). The body
 * is optional: without one, both options are off. 204 means LinkedIn had
 * nothing new for the resume; the headline and photo may still have changed.
 * 404 means LinkedIn has no profile at the candidate's link, and 503 without
 * Retry-After that lookups are out of credits. 503 with Retry-After means
 * LinkedIn is slow: the sync finishes in the background, and syncing again a
 * minute later uses what it fetched.
 */
export const postLinkedinSyncCandidateMutation = (options?: Partial<Options<PostLinkedinSyncCandidateData>>): UseMutationOptions<PostLinkedinSyncCandidateResponse, AxiosError<PostLinkedinSyncCandidateError>, Options<PostLinkedinSyncCandidateData>> => {
    const mutationOptions: UseMutationOptions<PostLinkedinSyncCandidateResponse, AxiosError<PostLinkedinSyncCandidateError>, Options<PostLinkedinSyncCandidateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postLinkedinSyncCandidate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postLinkedinPreviewQueryKey = (options: Options<PostLinkedinPreviewData>) => createQueryKey('postLinkedinPreview', options);

/**
 * Post Linkedin Preview
 *
 * POST /api/v2/linkedin_sync/preview
 *
 * Show a LinkedIn profile before anyone syncs it onto a candidate: by its URL,
 * or found by name and company. Writes nothing to any candidate. The fetch is
 * kept as a profile-cache entry, so syncing the same profile straight after
 * costs no second lookup. 503 with Retry-After means LinkedIn is slow: the
 * fetch finishes in the background and previewing again uses what it stored.
 */
export const postLinkedinPreviewOptions = (options: Options<PostLinkedinPreviewData>) => queryOptions<PostLinkedinPreviewResponse, AxiosError<PostLinkedinPreviewError>, PostLinkedinPreviewResponse, ReturnType<typeof postLinkedinPreviewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postLinkedinPreview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postLinkedinPreviewQueryKey(options)
});

/**
 * Post Linkedin Preview
 *
 * POST /api/v2/linkedin_sync/preview
 *
 * Show a LinkedIn profile before anyone syncs it onto a candidate: by its URL,
 * or found by name and company. Writes nothing to any candidate. The fetch is
 * kept as a profile-cache entry, so syncing the same profile straight after
 * costs no second lookup. 503 with Retry-After means LinkedIn is slow: the
 * fetch finishes in the background and previewing again uses what it stored.
 */
export const postLinkedinPreviewMutation = (options?: Partial<Options<PostLinkedinPreviewData>>): UseMutationOptions<PostLinkedinPreviewResponse, AxiosError<PostLinkedinPreviewError>, Options<PostLinkedinPreviewData>> => {
    const mutationOptions: UseMutationOptions<PostLinkedinPreviewResponse, AxiosError<PostLinkedinPreviewError>, Options<PostLinkedinPreviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postLinkedinPreview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postAutotagPreviewQueryKey = (options: Options<PostAutotagPreviewData>) => createQueryKey('postAutotagPreview', options);

/**
 * Post Autotag Preview
 *
 * POST /api/v2/candidates/autotag/preview
 *
 * Enqueue async tagging of the call notes (+ optional identity), or of a Notion
 * meeting-note row when `notion_page_id` is given (notes + identity read from Notion).
 * Writes nothing; returns a task_id to poll for the proposal.
 */
export const postAutotagPreviewOptions = (options: Options<PostAutotagPreviewData>) => queryOptions<PostAutotagPreviewResponse, AxiosError<PostAutotagPreviewError>, PostAutotagPreviewResponse, ReturnType<typeof postAutotagPreviewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postAutotagPreview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postAutotagPreviewQueryKey(options)
});

/**
 * Post Autotag Preview
 *
 * POST /api/v2/candidates/autotag/preview
 *
 * Enqueue async tagging of the call notes (+ optional identity), or of a Notion
 * meeting-note row when `notion_page_id` is given (notes + identity read from Notion).
 * Writes nothing; returns a task_id to poll for the proposal.
 */
export const postAutotagPreviewMutation = (options?: Partial<Options<PostAutotagPreviewData>>): UseMutationOptions<PostAutotagPreviewResponse, AxiosError<PostAutotagPreviewError>, Options<PostAutotagPreviewData>> => {
    const mutationOptions: UseMutationOptions<PostAutotagPreviewResponse, AxiosError<PostAutotagPreviewError>, Options<PostAutotagPreviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postAutotagPreview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAutotagPreviewStatusQueryKey = (options: Options<GetAutotagPreviewStatusData>) => createQueryKey('getAutotagPreviewStatus', options);

/**
 * Get Autotag Preview Status
 *
 * GET /api/v2/candidates/autotag/preview/status/{task_id}
 *
 * Return the TagProposal once the task completes.
 * Task states: PENDING, SUCCESS, FAILURE.
 */
export const getAutotagPreviewStatusOptions = (options: Options<GetAutotagPreviewStatusData>) => queryOptions<GetAutotagPreviewStatusResponse, AxiosError<GetAutotagPreviewStatusError>, GetAutotagPreviewStatusResponse, ReturnType<typeof getAutotagPreviewStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAutotagPreviewStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAutotagPreviewStatusQueryKey(options)
});

export const postPipelinesFilterQueryKey = (options: Options<PostPipelinesFilterData>) => createQueryKey('postPipelinesFilter', options);

/**
 * Post Pipelines Filter
 *
 * POST /api/v2/pipelines/filter
 */
export const postPipelinesFilterOptions = (options: Options<PostPipelinesFilterData>) => queryOptions<PostPipelinesFilterResponse, AxiosError<PostPipelinesFilterError>, PostPipelinesFilterResponse, ReturnType<typeof postPipelinesFilterQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postPipelinesFilter({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postPipelinesFilterQueryKey(options)
});

export const postPipelinesFilterInfiniteQueryKey = (options: Options<PostPipelinesFilterData>): QueryKey<Options<PostPipelinesFilterData>> => createQueryKey('postPipelinesFilter', options, true);

/**
 * Post Pipelines Filter
 *
 * POST /api/v2/pipelines/filter
 */
export const postPipelinesFilterInfiniteOptions = (options: Options<PostPipelinesFilterData>) => {
    const opts = infiniteQueryOptions<PostPipelinesFilterResponse, AxiosError<PostPipelinesFilterError>, InfiniteData<PostPipelinesFilterResponse>, QueryKey<Options<PostPipelinesFilterData>>, number | Pick<QueryKey<Options<PostPipelinesFilterData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PostPipelinesFilterData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                body: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await postPipelinesFilter({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postPipelinesFilterInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Post Pipelines Filter
 *
 * POST /api/v2/pipelines/filter
 */
export const postPipelinesFilterMutation = (options?: Partial<Options<PostPipelinesFilterData>>): UseMutationOptions<PostPipelinesFilterResponse, AxiosError<PostPipelinesFilterError>, Options<PostPipelinesFilterData>> => {
    const mutationOptions: UseMutationOptions<PostPipelinesFilterResponse, AxiosError<PostPipelinesFilterError>, Options<PostPipelinesFilterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postPipelinesFilter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Put Multiple Recommendation Drafts
 *
 * PUT /api/v2/recommendations/drafts
 */
export const putMultipleRecommendationDraftsMutation = (options?: Partial<Options<PutMultipleRecommendationDraftsData>>): UseMutationOptions<PutMultipleRecommendationDraftsResponse, AxiosError<PutMultipleRecommendationDraftsError>, Options<PutMultipleRecommendationDraftsData>> => {
    const mutationOptions: UseMutationOptions<PutMultipleRecommendationDraftsResponse, AxiosError<PutMultipleRecommendationDraftsError>, Options<PutMultipleRecommendationDraftsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putMultipleRecommendationDrafts({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Recommendation
 *
 * DELETE /api/v2/recommendations/{recommendation_uuid}
 */
export const deleteRecommendationMutation = (options?: Partial<Options<DeleteRecommendationData>>): UseMutationOptions<DeleteRecommendationResponse, AxiosError<DeleteRecommendationError>, Options<DeleteRecommendationData>> => {
    const mutationOptions: UseMutationOptions<DeleteRecommendationResponse, AxiosError<DeleteRecommendationError>, Options<DeleteRecommendationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteRecommendation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getRecommendationQueryKey = (options: Options<GetRecommendationData>) => createQueryKey('getRecommendation', options);

/**
 * Get Recommendation
 *
 * GET /api/v2/recommendations/{recommendation_uuid}
 */
export const getRecommendationOptions = (options: Options<GetRecommendationData>) => queryOptions<GetRecommendationResponse, AxiosError<GetRecommendationError>, GetRecommendationResponse, ReturnType<typeof getRecommendationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRecommendation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRecommendationQueryKey(options)
});

/**
 * Put Recommendation Commentary
 *
 * PUT /api/v2/recommendations/{recommendation_uuid}/commentary
 */
export const putRecommendationCommentaryMutation = (options?: Partial<Options<PutRecommendationCommentaryData>>): UseMutationOptions<PutRecommendationCommentaryResponse, AxiosError<PutRecommendationCommentaryError>, Options<PutRecommendationCommentaryData>> => {
    const mutationOptions: UseMutationOptions<PutRecommendationCommentaryResponse, AxiosError<PutRecommendationCommentaryError>, Options<PutRecommendationCommentaryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putRecommendationCommentary({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Put Recommendation Status V2
 *
 * PUT /api/v2/recommendations/{recommendation_uuid}/status
 */
export const putRecommendationStatusV2Mutation = (options?: Partial<Options<PutRecommendationStatusV2Data>>): UseMutationOptions<PutRecommendationStatusV2Response, AxiosError<PutRecommendationStatusV2Error>, Options<PutRecommendationStatusV2Data>> => {
    const mutationOptions: UseMutationOptions<PutRecommendationStatusV2Response, AxiosError<PutRecommendationStatusV2Error>, Options<PutRecommendationStatusV2Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putRecommendationStatusV2({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Recommendation Assignee
 *
 * DELETE /api/v2/recommendations/{recommendation_uuid}/assignee
 */
export const deleteRecommendationAssigneeMutation = (options?: Partial<Options<DeleteRecommendationAssigneeData>>): UseMutationOptions<DeleteRecommendationAssigneeResponse, AxiosError<DeleteRecommendationAssigneeError>, Options<DeleteRecommendationAssigneeData>> => {
    const mutationOptions: UseMutationOptions<DeleteRecommendationAssigneeResponse, AxiosError<DeleteRecommendationAssigneeError>, Options<DeleteRecommendationAssigneeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteRecommendationAssignee({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postRecsysRecommendationsQueryKey = (options: Options<PostRecsysRecommendationsData>) => createQueryKey('postRecsysRecommendations', options);

/**
 * Post Recsys Recommendations
 *
 * POST /api/v2/integrations/recsys/recommendations
 *
 * Receive candidate suggestions from the RecSys (Brief Match) app and add them
 * to a pipeline's internal view as `suggested` draft recommendations. The
 * sending advisor (`author_person_uuid`) is recorded as the actor for the
 * submission, recommendation, evaluation history and internal comment. Each
 * candidate may carry its own `assignee_person_uuid` (the advisor the draft is
 * assigned to); it defaults to the author when omitted. The call is idempotent:
 * candidates already on the pipeline are skipped. Candidates off-limits to the
 * pipeline's search team are never added; they come back in `off_limits`.
 */
export const postRecsysRecommendationsOptions = (options: Options<PostRecsysRecommendationsData>) => queryOptions<PostRecsysRecommendationsResponse, AxiosError<PostRecsysRecommendationsError>, PostRecsysRecommendationsResponse, ReturnType<typeof postRecsysRecommendationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postRecsysRecommendations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postRecsysRecommendationsQueryKey(options)
});

/**
 * Post Recsys Recommendations
 *
 * POST /api/v2/integrations/recsys/recommendations
 *
 * Receive candidate suggestions from the RecSys (Brief Match) app and add them
 * to a pipeline's internal view as `suggested` draft recommendations. The
 * sending advisor (`author_person_uuid`) is recorded as the actor for the
 * submission, recommendation, evaluation history and internal comment. Each
 * candidate may carry its own `assignee_person_uuid` (the advisor the draft is
 * assigned to); it defaults to the author when omitted. The call is idempotent:
 * candidates already on the pipeline are skipped. Candidates off-limits to the
 * pipeline's search team are never added; they come back in `off_limits`.
 */
export const postRecsysRecommendationsMutation = (options?: Partial<Options<PostRecsysRecommendationsData>>): UseMutationOptions<PostRecsysRecommendationsResponse, AxiosError<PostRecsysRecommendationsError>, Options<PostRecsysRecommendationsData>> => {
    const mutationOptions: UseMutationOptions<PostRecsysRecommendationsResponse, AxiosError<PostRecsysRecommendationsError>, Options<PostRecsysRecommendationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postRecsysRecommendations({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postRecsysCandidateContextQueryKey = (options: Options<PostRecsysCandidateContextData>) => createQueryKey('postRecsysCandidateContext', options);

/**
 * Post Recsys Candidate Context
 *
 * POST /api/v2/integrations/recsys/candidate-team-context
 *
 * Team-relationship context for a batch of (candidate, pipeline) pairs: a `warm`
 * flag, the most significant `last_action` between the candidate and the pipeline's
 * search team (a facilitated introduction, else being added to a recommendation),
 * and candidate-level referrers.
 *
 * Read-only sibling of the recsys write bridge (`.../recommendations`,
 * `.../assignees`), authenticated by the same `X-RecSys-API-Key` service key so the
 * RecSys (Brief Match) app can surface this context alongside its recommendations
 * without a team-scoped user session.
 *
 * Pairs let one request cover every RecSys surface: a pipeline's candidate slate
 * (one pipeline, many candidates), a candidate's opportunity queue / pipeline
 * targets (one candidate, many pipelines), or an arbitrary mix. Warmth and
 * last-action mirror the warm_case + priority logic of the internal
 * POST /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/candidates view — computed
 * set-based here (see _batch_team_context) so the batch resolves in a few queries
 * regardless of team count, rather than one per team. The exec-only intro paths still
 * reuse that view's shared helper. Net: the numbers match what advisors see in Contender.
 */
export const postRecsysCandidateContextOptions = (options: Options<PostRecsysCandidateContextData>) => queryOptions<PostRecsysCandidateContextResponse, AxiosError<PostRecsysCandidateContextError>, PostRecsysCandidateContextResponse, ReturnType<typeof postRecsysCandidateContextQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postRecsysCandidateContext({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postRecsysCandidateContextQueryKey(options)
});

/**
 * Post Recsys Candidate Context
 *
 * POST /api/v2/integrations/recsys/candidate-team-context
 *
 * Team-relationship context for a batch of (candidate, pipeline) pairs: a `warm`
 * flag, the most significant `last_action` between the candidate and the pipeline's
 * search team (a facilitated introduction, else being added to a recommendation),
 * and candidate-level referrers.
 *
 * Read-only sibling of the recsys write bridge (`.../recommendations`,
 * `.../assignees`), authenticated by the same `X-RecSys-API-Key` service key so the
 * RecSys (Brief Match) app can surface this context alongside its recommendations
 * without a team-scoped user session.
 *
 * Pairs let one request cover every RecSys surface: a pipeline's candidate slate
 * (one pipeline, many candidates), a candidate's opportunity queue / pipeline
 * targets (one candidate, many pipelines), or an arbitrary mix. Warmth and
 * last-action mirror the warm_case + priority logic of the internal
 * POST /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/candidates view — computed
 * set-based here (see _batch_team_context) so the batch resolves in a few queries
 * regardless of team count, rather than one per team. The exec-only intro paths still
 * reuse that view's shared helper. Net: the numbers match what advisors see in Contender.
 */
export const postRecsysCandidateContextMutation = (options?: Partial<Options<PostRecsysCandidateContextData>>): UseMutationOptions<PostRecsysCandidateContextResponse, AxiosError<PostRecsysCandidateContextError>, Options<PostRecsysCandidateContextData>> => {
    const mutationOptions: UseMutationOptions<PostRecsysCandidateContextResponse, AxiosError<PostRecsysCandidateContextError>, Options<PostRecsysCandidateContextData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postRecsysCandidateContext({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getRecsysAssigneesQueryKey = (options?: Options<GetRecsysAssigneesData>) => createQueryKey('getRecsysAssignees', options);

/**
 * Get Recsys Assignees
 *
 * GET /api/v2/integrations/recsys/assignees
 *
 * The advisors a RecSys suggestion can be assigned to — the internal
 * customer-success team, i.e. the same set the webapp's assignee picker and
 * `GET /api/v2/people/internal/customer_success` return. Exposed under the RecSys
 * service key so Brief Match can fetch valid options for whichever environment it
 * is sending to.
 */
export const getRecsysAssigneesOptions = (options?: Options<GetRecsysAssigneesData>) => queryOptions<GetRecsysAssigneesResponse, AxiosError<DefaultError>, GetRecsysAssigneesResponse, ReturnType<typeof getRecsysAssigneesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRecsysAssignees({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRecsysAssigneesQueryKey(options)
});

export const postSubmissionsFilterQueryKey = (options: Options<PostSubmissionsFilterData>) => createQueryKey('postSubmissionsFilter', options);

/**
 * Post Submissions Filter
 *
 * POST /api/v2/submissions/filter
 *
 * Also open to the Contender Actions connector (``X-MCP-API-Key`` +
 * ``X-Acting-User-Email``, see ``app.api.deps.auth.agent``).
 */
export const postSubmissionsFilterOptions = (options: Options<PostSubmissionsFilterData>) => queryOptions<PostSubmissionsFilterResponse, AxiosError<PostSubmissionsFilterError>, PostSubmissionsFilterResponse, ReturnType<typeof postSubmissionsFilterQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postSubmissionsFilter({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postSubmissionsFilterQueryKey(options)
});

export const postSubmissionsFilterInfiniteQueryKey = (options: Options<PostSubmissionsFilterData>): QueryKey<Options<PostSubmissionsFilterData>> => createQueryKey('postSubmissionsFilter', options, true);

/**
 * Post Submissions Filter
 *
 * POST /api/v2/submissions/filter
 *
 * Also open to the Contender Actions connector (``X-MCP-API-Key`` +
 * ``X-Acting-User-Email``, see ``app.api.deps.auth.agent``).
 */
export const postSubmissionsFilterInfiniteOptions = (options: Options<PostSubmissionsFilterData>) => {
    const opts = infiniteQueryOptions<PostSubmissionsFilterResponse, AxiosError<PostSubmissionsFilterError>, InfiniteData<PostSubmissionsFilterResponse>, QueryKey<Options<PostSubmissionsFilterData>>, number | Pick<QueryKey<Options<PostSubmissionsFilterData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PostSubmissionsFilterData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                body: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await postSubmissionsFilter({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postSubmissionsFilterInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Post Submissions Filter
 *
 * POST /api/v2/submissions/filter
 *
 * Also open to the Contender Actions connector (``X-MCP-API-Key`` +
 * ``X-Acting-User-Email``, see ``app.api.deps.auth.agent``).
 */
export const postSubmissionsFilterMutation = (options?: Partial<Options<PostSubmissionsFilterData>>): UseMutationOptions<PostSubmissionsFilterResponse, AxiosError<PostSubmissionsFilterError>, Options<PostSubmissionsFilterData>> => {
    const mutationOptions: UseMutationOptions<PostSubmissionsFilterResponse, AxiosError<PostSubmissionsFilterError>, Options<PostSubmissionsFilterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postSubmissionsFilter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postSubmissionFilterQueryKey = (options: Options<PostSubmissionFilterData>) => createQueryKey('postSubmissionFilter', options);

/**
 * Post Submission Filter
 *
 * POST /api/v2/submissions/{submission_uuid}/filter
 */
export const postSubmissionFilterOptions = (options: Options<PostSubmissionFilterData>) => queryOptions<PostSubmissionFilterResponse, AxiosError<PostSubmissionFilterError>, PostSubmissionFilterResponse, ReturnType<typeof postSubmissionFilterQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postSubmissionFilter({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postSubmissionFilterQueryKey(options)
});

export const postSubmissionFilterInfiniteQueryKey = (options: Options<PostSubmissionFilterData>): QueryKey<Options<PostSubmissionFilterData>> => createQueryKey('postSubmissionFilter', options, true);

/**
 * Post Submission Filter
 *
 * POST /api/v2/submissions/{submission_uuid}/filter
 */
export const postSubmissionFilterInfiniteOptions = (options: Options<PostSubmissionFilterData>) => {
    const opts = infiniteQueryOptions<PostSubmissionFilterResponse, AxiosError<PostSubmissionFilterError>, InfiniteData<PostSubmissionFilterResponse>, QueryKey<Options<PostSubmissionFilterData>>, number | Pick<QueryKey<Options<PostSubmissionFilterData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PostSubmissionFilterData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                body: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await postSubmissionFilter({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postSubmissionFilterInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Post Submission Filter
 *
 * POST /api/v2/submissions/{submission_uuid}/filter
 */
export const postSubmissionFilterMutation = (options?: Partial<Options<PostSubmissionFilterData>>): UseMutationOptions<PostSubmissionFilterResponse, AxiosError<PostSubmissionFilterError>, Options<PostSubmissionFilterData>> => {
    const mutationOptions: UseMutationOptions<PostSubmissionFilterResponse, AxiosError<PostSubmissionFilterError>, Options<PostSubmissionFilterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postSubmissionFilter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postTeamsV2QueryKey = (options: Options<PostTeamsV2Data>) => createQueryKey('postTeamsV2', options);

/**
 * Post Teams V2
 *
 * POST /api/v2/teams
 */
export const postTeamsV2Options = (options: Options<PostTeamsV2Data>) => queryOptions<PostTeamsV2Response, AxiosError<PostTeamsV2Error>, PostTeamsV2Response, ReturnType<typeof postTeamsV2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postTeamsV2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postTeamsV2QueryKey(options)
});

/**
 * Post Teams V2
 *
 * POST /api/v2/teams
 */
export const postTeamsV2Mutation = (options?: Partial<Options<PostTeamsV2Data>>): UseMutationOptions<PostTeamsV2Response, AxiosError<PostTeamsV2Error>, Options<PostTeamsV2Data>> => {
    const mutationOptions: UseMutationOptions<PostTeamsV2Response, AxiosError<PostTeamsV2Error>, Options<PostTeamsV2Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTeamsV2({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Put Team
 *
 * PUT /api/v2/teams/{team_slug}
 */
export const putTeamMutation = (options?: Partial<Options<PutTeamData>>): UseMutationOptions<PutTeamResponse, AxiosError<PutTeamError>, Options<PutTeamData>> => {
    const mutationOptions: UseMutationOptions<PutTeamResponse, AxiosError<PutTeamError>, Options<PutTeamData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putTeam({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postTeamsFilterQueryKey = (options: Options<PostTeamsFilterData>) => createQueryKey('postTeamsFilter', options);

/**
 * Post Teams Filter
 *
 * POST /api/v2/teams/filter
 *
 * Also open to the Contender Actions connector (``X-MCP-API-Key`` +
 * ``X-Acting-User-Email``, see ``app.api.deps.auth.agent``).
 */
export const postTeamsFilterOptions = (options: Options<PostTeamsFilterData>) => queryOptions<PostTeamsFilterResponse, AxiosError<PostTeamsFilterError>, PostTeamsFilterResponse, ReturnType<typeof postTeamsFilterQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postTeamsFilter({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postTeamsFilterQueryKey(options)
});

export const postTeamsFilterInfiniteQueryKey = (options: Options<PostTeamsFilterData>): QueryKey<Options<PostTeamsFilterData>> => createQueryKey('postTeamsFilter', options, true);

/**
 * Post Teams Filter
 *
 * POST /api/v2/teams/filter
 *
 * Also open to the Contender Actions connector (``X-MCP-API-Key`` +
 * ``X-Acting-User-Email``, see ``app.api.deps.auth.agent``).
 */
export const postTeamsFilterInfiniteOptions = (options: Options<PostTeamsFilterData>) => {
    const opts = infiniteQueryOptions<PostTeamsFilterResponse, AxiosError<PostTeamsFilterError>, InfiniteData<PostTeamsFilterResponse>, QueryKey<Options<PostTeamsFilterData>>, number | Pick<QueryKey<Options<PostTeamsFilterData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PostTeamsFilterData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                body: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await postTeamsFilter({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postTeamsFilterInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Post Teams Filter
 *
 * POST /api/v2/teams/filter
 *
 * Also open to the Contender Actions connector (``X-MCP-API-Key`` +
 * ``X-Acting-User-Email``, see ``app.api.deps.auth.agent``).
 */
export const postTeamsFilterMutation = (options?: Partial<Options<PostTeamsFilterData>>): UseMutationOptions<PostTeamsFilterResponse, AxiosError<PostTeamsFilterError>, Options<PostTeamsFilterData>> => {
    const mutationOptions: UseMutationOptions<PostTeamsFilterResponse, AxiosError<PostTeamsFilterError>, Options<PostTeamsFilterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTeamsFilter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postTeamsSuggestedQueryKey = (options: Options<PostTeamsSuggestedData>) => createQueryKey('postTeamsSuggested', options);

/**
 * Post Teams Suggested
 *
 * POST /api/v2/teams/suggested
 *
 * The top of the ranked team-suggestion pool for a trending campaign for one
 * candidate: the trending hygiene exclusions (empty / inactive / basic-investor
 * teams, illegal trending teams, off-limits, teams that declined this
 * candidate, teams already trended to) followed by the backtested hybrid
 * scorer (see app/helpers/team_suggestions.py). Serves the compact "don't miss
 * these teams" module; the wizard's browsable list uses the same ranking
 * through POST /api/v2/teams/filter `suggested`, which pages the whole pool and
 * composes it with phrase and filters.
 *
 * Also open to the Contender Actions connector (``X-MCP-API-Key`` +
 * ``X-Acting-User-Email``, see ``app.api.deps.auth.agent``).
 */
export const postTeamsSuggestedOptions = (options: Options<PostTeamsSuggestedData>) => queryOptions<PostTeamsSuggestedResponse, AxiosError<PostTeamsSuggestedError>, PostTeamsSuggestedResponse, ReturnType<typeof postTeamsSuggestedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postTeamsSuggested({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postTeamsSuggestedQueryKey(options)
});

/**
 * Post Teams Suggested
 *
 * POST /api/v2/teams/suggested
 *
 * The top of the ranked team-suggestion pool for a trending campaign for one
 * candidate: the trending hygiene exclusions (empty / inactive / basic-investor
 * teams, illegal trending teams, off-limits, teams that declined this
 * candidate, teams already trended to) followed by the backtested hybrid
 * scorer (see app/helpers/team_suggestions.py). Serves the compact "don't miss
 * these teams" module; the wizard's browsable list uses the same ranking
 * through POST /api/v2/teams/filter `suggested`, which pages the whole pool and
 * composes it with phrase and filters.
 *
 * Also open to the Contender Actions connector (``X-MCP-API-Key`` +
 * ``X-Acting-User-Email``, see ``app.api.deps.auth.agent``).
 */
export const postTeamsSuggestedMutation = (options?: Partial<Options<PostTeamsSuggestedData>>): UseMutationOptions<PostTeamsSuggestedResponse, AxiosError<PostTeamsSuggestedError>, Options<PostTeamsSuggestedData>> => {
    const mutationOptions: UseMutationOptions<PostTeamsSuggestedResponse, AxiosError<PostTeamsSuggestedError>, Options<PostTeamsSuggestedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTeamsSuggested({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postTeamTeamsQueryKey = (options: Options<PostTeamTeamsData>) => createQueryKey('postTeamTeams', options);

/**
 * Post Team Teams
 *
 * POST /api/v2/teams/{team_uuid}/teams
 */
export const postTeamTeamsOptions = (options: Options<PostTeamTeamsData>) => queryOptions<PostTeamTeamsResponse, AxiosError<PostTeamTeamsError>, PostTeamTeamsResponse, ReturnType<typeof postTeamTeamsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postTeamTeams({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postTeamTeamsQueryKey(options)
});

/**
 * Post Team Teams
 *
 * POST /api/v2/teams/{team_uuid}/teams
 */
export const postTeamTeamsMutation = (options?: Partial<Options<PostTeamTeamsData>>): UseMutationOptions<PostTeamTeamsResponse, AxiosError<PostTeamTeamsError>, Options<PostTeamTeamsData>> => {
    const mutationOptions: UseMutationOptions<PostTeamTeamsResponse, AxiosError<PostTeamTeamsError>, Options<PostTeamTeamsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTeamTeams({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTeamCandidateQueryKey = (options: Options<GetTeamCandidateData>) => createQueryKey('getTeamCandidate', options);

/**
 * Get Team Candidate
 *
 * GET /api/v2/teams/{team_uuid}/candidates/{candidate_uuid}
 */
export const getTeamCandidateOptions = (options: Options<GetTeamCandidateData>) => queryOptions<GetTeamCandidateResponse, AxiosError<GetTeamCandidateError>, GetTeamCandidateResponse, ReturnType<typeof getTeamCandidateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTeamCandidate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTeamCandidateQueryKey(options)
});

export const getTeamCandidateActivityQueryKey = (options: Options<GetTeamCandidateActivityData>) => createQueryKey('getTeamCandidateActivity', options);

/**
 * Get Team Candidate Activity
 *
 * GET /api/v2/teams/{team_uuid}/candidates/{candidate_uuid}/activity
 */
export const getTeamCandidateActivityOptions = (options: Options<GetTeamCandidateActivityData>) => queryOptions<GetTeamCandidateActivityResponse, AxiosError<GetTeamCandidateActivityError>, GetTeamCandidateActivityResponse, ReturnType<typeof getTeamCandidateActivityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTeamCandidateActivity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTeamCandidateActivityQueryKey(options)
});

export const getTeamCandidateActivityInfiniteQueryKey = (options: Options<GetTeamCandidateActivityData>): QueryKey<Options<GetTeamCandidateActivityData>> => createQueryKey('getTeamCandidateActivity', options, true);

/**
 * Get Team Candidate Activity
 *
 * GET /api/v2/teams/{team_uuid}/candidates/{candidate_uuid}/activity
 */
export const getTeamCandidateActivityInfiniteOptions = (options: Options<GetTeamCandidateActivityData>) => {
    const opts = infiniteQueryOptions<GetTeamCandidateActivityResponse, AxiosError<GetTeamCandidateActivityError>, InfiniteData<GetTeamCandidateActivityResponse>, QueryKey<Options<GetTeamCandidateActivityData>>, number | Pick<QueryKey<Options<GetTeamCandidateActivityData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetTeamCandidateActivityData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getTeamCandidateActivity({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getTeamCandidateActivityInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const postTeamCandidateFavoriteQueryKey = (options: Options<PostTeamCandidateFavoriteData>) => createQueryKey('postTeamCandidateFavorite', options);

/**
 * Post Team Candidate Favorite
 *
 * POST /api/v2/teams/{team_uuid}/candidates/{candidate_uuid}/favorite
 */
export const postTeamCandidateFavoriteOptions = (options: Options<PostTeamCandidateFavoriteData>) => queryOptions<PostTeamCandidateFavoriteResponse, AxiosError<PostTeamCandidateFavoriteError>, PostTeamCandidateFavoriteResponse, ReturnType<typeof postTeamCandidateFavoriteQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postTeamCandidateFavorite({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postTeamCandidateFavoriteQueryKey(options)
});

/**
 * Post Team Candidate Favorite
 *
 * POST /api/v2/teams/{team_uuid}/candidates/{candidate_uuid}/favorite
 */
export const postTeamCandidateFavoriteMutation = (options?: Partial<Options<PostTeamCandidateFavoriteData>>): UseMutationOptions<PostTeamCandidateFavoriteResponse, AxiosError<PostTeamCandidateFavoriteError>, Options<PostTeamCandidateFavoriteData>> => {
    const mutationOptions: UseMutationOptions<PostTeamCandidateFavoriteResponse, AxiosError<PostTeamCandidateFavoriteError>, Options<PostTeamCandidateFavoriteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTeamCandidateFavorite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postTeamCandidatePipelinesQueryKey = (options: Options<PostTeamCandidatePipelinesData>) => createQueryKey('postTeamCandidatePipelines', options);

/**
 * Post Team Candidate Pipelines
 *
 * POST /api/v2/teams/{team_uuid}/candidates/{candidate_uuid}/pipelines
 */
export const postTeamCandidatePipelinesOptions = (options: Options<PostTeamCandidatePipelinesData>) => queryOptions<PostTeamCandidatePipelinesResponse, AxiosError<PostTeamCandidatePipelinesError>, PostTeamCandidatePipelinesResponse, ReturnType<typeof postTeamCandidatePipelinesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postTeamCandidatePipelines({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postTeamCandidatePipelinesQueryKey(options)
});

/**
 * Post Team Candidate Pipelines
 *
 * POST /api/v2/teams/{team_uuid}/candidates/{candidate_uuid}/pipelines
 */
export const postTeamCandidatePipelinesMutation = (options?: Partial<Options<PostTeamCandidatePipelinesData>>): UseMutationOptions<PostTeamCandidatePipelinesResponse, AxiosError<PostTeamCandidatePipelinesError>, Options<PostTeamCandidatePipelinesData>> => {
    const mutationOptions: UseMutationOptions<PostTeamCandidatePipelinesResponse, AxiosError<PostTeamCandidatePipelinesError>, Options<PostTeamCandidatePipelinesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTeamCandidatePipelines({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTeamCandidateRecommendationsQueryKey = (options: Options<GetTeamCandidateRecommendationsData>) => createQueryKey('getTeamCandidateRecommendations', options);

/**
 * Get Team Candidate Recommendations
 *
 * GET /api/v2/teams/{team_uuid}/candidates/{candidate_uuid}/recommendations
 */
export const getTeamCandidateRecommendationsOptions = (options: Options<GetTeamCandidateRecommendationsData>) => queryOptions<GetTeamCandidateRecommendationsResponse, AxiosError<GetTeamCandidateRecommendationsError>, GetTeamCandidateRecommendationsResponse, ReturnType<typeof getTeamCandidateRecommendationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTeamCandidateRecommendations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTeamCandidateRecommendationsQueryKey(options)
});

export const postTeamCandidateStatusQueryKey = (options: Options<PostTeamCandidateStatusData>) => createQueryKey('postTeamCandidateStatus', options);

/**
 * Post Team Candidate Status
 *
 * POST /api/v2/teams/{team_uuid}/candidates/{candidate_uuid}/status
 */
export const postTeamCandidateStatusOptions = (options: Options<PostTeamCandidateStatusData>) => queryOptions<PostTeamCandidateStatusResponse, AxiosError<PostTeamCandidateStatusError>, PostTeamCandidateStatusResponse, ReturnType<typeof postTeamCandidateStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postTeamCandidateStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postTeamCandidateStatusQueryKey(options)
});

/**
 * Post Team Candidate Status
 *
 * POST /api/v2/teams/{team_uuid}/candidates/{candidate_uuid}/status
 */
export const postTeamCandidateStatusMutation = (options?: Partial<Options<PostTeamCandidateStatusData>>): UseMutationOptions<PostTeamCandidateStatusResponse, AxiosError<PostTeamCandidateStatusError>, Options<PostTeamCandidateStatusData>> => {
    const mutationOptions: UseMutationOptions<PostTeamCandidateStatusResponse, AxiosError<PostTeamCandidateStatusError>, Options<PostTeamCandidateStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTeamCandidateStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Put Team Candidate Status
 *
 * PUT /api/v2/teams/{team_uuid}/candidates/{candidate_uuid}/status
 */
export const putTeamCandidateStatusMutation = (options?: Partial<Options<PutTeamCandidateStatusData>>): UseMutationOptions<PutTeamCandidateStatusResponse, AxiosError<PutTeamCandidateStatusError>, Options<PutTeamCandidateStatusData>> => {
    const mutationOptions: UseMutationOptions<PutTeamCandidateStatusResponse, AxiosError<PutTeamCandidateStatusError>, Options<PutTeamCandidateStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putTeamCandidateStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postTeamCandidateViewsQueryKey = (options: Options<PostTeamCandidateViewsData>) => createQueryKey('postTeamCandidateViews', options);

/**
 * Post Team Candidate Views
 *
 * POST /api/v2/teams/{team_uuid}/candidates/{candidate_uuid}/views
 */
export const postTeamCandidateViewsOptions = (options: Options<PostTeamCandidateViewsData>) => queryOptions<unknown, AxiosError<PostTeamCandidateViewsError>, unknown, ReturnType<typeof postTeamCandidateViewsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postTeamCandidateViews({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postTeamCandidateViewsQueryKey(options)
});

/**
 * Post Team Candidate Views
 *
 * POST /api/v2/teams/{team_uuid}/candidates/{candidate_uuid}/views
 */
export const postTeamCandidateViewsMutation = (options?: Partial<Options<PostTeamCandidateViewsData>>): UseMutationOptions<unknown, AxiosError<PostTeamCandidateViewsError>, Options<PostTeamCandidateViewsData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostTeamCandidateViewsError>, Options<PostTeamCandidateViewsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTeamCandidateViews({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTeamContactCommentsQueryKey = (options: Options<GetTeamContactCommentsData>) => createQueryKey('getTeamContactComments', options);

/**
 * Get Team Contact Comments
 *
 * GET /api/v2/teams/{team_uuid}/contacts/{identity_uuid}/comments
 *
 * Every live comment this team has on this contact, newest first.
 */
export const getTeamContactCommentsOptions = (options: Options<GetTeamContactCommentsData>) => queryOptions<GetTeamContactCommentsResponse, AxiosError<GetTeamContactCommentsError>, GetTeamContactCommentsResponse, ReturnType<typeof getTeamContactCommentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTeamContactComments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTeamContactCommentsQueryKey(options)
});

export const postTeamContactCommentQueryKey = (options: Options<PostTeamContactCommentData>) => createQueryKey('postTeamContactComment', options);

/**
 * Post Team Contact Comment
 *
 * POST /api/v2/teams/{team_uuid}/contacts/{identity_uuid}/comments
 */
export const postTeamContactCommentOptions = (options: Options<PostTeamContactCommentData>) => queryOptions<PostTeamContactCommentResponse, AxiosError<PostTeamContactCommentError>, PostTeamContactCommentResponse, ReturnType<typeof postTeamContactCommentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postTeamContactComment({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postTeamContactCommentQueryKey(options)
});

/**
 * Post Team Contact Comment
 *
 * POST /api/v2/teams/{team_uuid}/contacts/{identity_uuid}/comments
 */
export const postTeamContactCommentMutation = (options?: Partial<Options<PostTeamContactCommentData>>): UseMutationOptions<PostTeamContactCommentResponse, AxiosError<PostTeamContactCommentError>, Options<PostTeamContactCommentData>> => {
    const mutationOptions: UseMutationOptions<PostTeamContactCommentResponse, AxiosError<PostTeamContactCommentError>, Options<PostTeamContactCommentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTeamContactComment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Team Contact Comment
 *
 * DELETE /api/v2/teams/{team_uuid}/contacts/{identity_uuid}/comments/{comment_uuid}
 *
 * Soft delete (sets ``deleted_at``); author-only.
 */
export const deleteTeamContactCommentMutation = (options?: Partial<Options<DeleteTeamContactCommentData>>): UseMutationOptions<DeleteTeamContactCommentResponse, AxiosError<DeleteTeamContactCommentError>, Options<DeleteTeamContactCommentData>> => {
    const mutationOptions: UseMutationOptions<DeleteTeamContactCommentResponse, AxiosError<DeleteTeamContactCommentError>, Options<DeleteTeamContactCommentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteTeamContactComment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Put Team Contact Comment
 *
 * PUT /api/v2/teams/{team_uuid}/contacts/{identity_uuid}/comments/{comment_uuid}
 */
export const putTeamContactCommentMutation = (options?: Partial<Options<PutTeamContactCommentData>>): UseMutationOptions<PutTeamContactCommentResponse, AxiosError<PutTeamContactCommentError>, Options<PutTeamContactCommentData>> => {
    const mutationOptions: UseMutationOptions<PutTeamContactCommentResponse, AxiosError<PutTeamContactCommentError>, Options<PutTeamContactCommentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putTeamContactComment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listCompanyContactTagsQueryKey = (options: Options<ListCompanyContactTagsData>) => createQueryKey('listCompanyContactTags', options);

/**
 * List Company Contact Tags
 *
 * GET /api/v2/companies/{company_id}/contacts/tags — list company tag vocabulary.
 */
export const listCompanyContactTagsOptions = (options: Options<ListCompanyContactTagsData>) => queryOptions<ListCompanyContactTagsResponse, AxiosError<ListCompanyContactTagsError>, ListCompanyContactTagsResponse, ReturnType<typeof listCompanyContactTagsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listCompanyContactTags({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listCompanyContactTagsQueryKey(options)
});

export const addCompanyContactTagQueryKey = (options: Options<AddCompanyContactTagData>) => createQueryKey('addCompanyContactTag', options);

/**
 * Add Company Contact Tag
 *
 * POST .../contacts/{candidate_uuid}/tags — link one tag to a candidate.
 */
export const addCompanyContactTagOptions = (options: Options<AddCompanyContactTagData>) => queryOptions<AddCompanyContactTagResponse, AxiosError<AddCompanyContactTagError>, AddCompanyContactTagResponse, ReturnType<typeof addCompanyContactTagQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await addCompanyContactTag({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: addCompanyContactTagQueryKey(options)
});

/**
 * Add Company Contact Tag
 *
 * POST .../contacts/{candidate_uuid}/tags — link one tag to a candidate.
 */
export const addCompanyContactTagMutation = (options?: Partial<Options<AddCompanyContactTagData>>): UseMutationOptions<AddCompanyContactTagResponse, AxiosError<AddCompanyContactTagError>, Options<AddCompanyContactTagData>> => {
    const mutationOptions: UseMutationOptions<AddCompanyContactTagResponse, AxiosError<AddCompanyContactTagError>, Options<AddCompanyContactTagData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addCompanyContactTag({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Company Contact Tag
 *
 * DELETE .../contacts/{candidate_uuid}/tags/{tag_definition_uuid}.
 */
export const removeCompanyContactTagMutation = (options?: Partial<Options<RemoveCompanyContactTagData>>): UseMutationOptions<RemoveCompanyContactTagResponse, AxiosError<RemoveCompanyContactTagError>, Options<RemoveCompanyContactTagData>> => {
    const mutationOptions: UseMutationOptions<RemoveCompanyContactTagResponse, AxiosError<RemoveCompanyContactTagError>, Options<RemoveCompanyContactTagData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeCompanyContactTag({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postTeamPipelinesQueryKey = (options: Options<PostTeamPipelinesData>) => createQueryKey('postTeamPipelines', options);

/**
 * Post Team Pipelines
 *
 * POST /api/v2/teams/{team_uuid}/pipelines
 *
 * Also reachable by the Contender Actions connector (service key + acting
 * user), which always sends ``is_notification_enabled: false``.
 */
export const postTeamPipelinesOptions = (options: Options<PostTeamPipelinesData>) => queryOptions<PostTeamPipelinesResponse, AxiosError<PostTeamPipelinesError>, PostTeamPipelinesResponse, ReturnType<typeof postTeamPipelinesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postTeamPipelines({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postTeamPipelinesQueryKey(options)
});

/**
 * Post Team Pipelines
 *
 * POST /api/v2/teams/{team_uuid}/pipelines
 *
 * Also reachable by the Contender Actions connector (service key + acting
 * user), which always sends ``is_notification_enabled: false``.
 */
export const postTeamPipelinesMutation = (options?: Partial<Options<PostTeamPipelinesData>>): UseMutationOptions<PostTeamPipelinesResponse, AxiosError<PostTeamPipelinesError>, Options<PostTeamPipelinesData>> => {
    const mutationOptions: UseMutationOptions<PostTeamPipelinesResponse, AxiosError<PostTeamPipelinesError>, Options<PostTeamPipelinesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTeamPipelines({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTeamPipelineQueryKey = (options: Options<GetTeamPipelineData>) => createQueryKey('getTeamPipeline', options);

/**
 * Get Team Pipeline
 *
 * GET /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}
 */
export const getTeamPipelineOptions = (options: Options<GetTeamPipelineData>) => queryOptions<GetTeamPipelineResponse, AxiosError<GetTeamPipelineError>, GetTeamPipelineResponse, ReturnType<typeof getTeamPipelineQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTeamPipeline({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTeamPipelineQueryKey(options)
});

/**
 * Put Team Pipeline
 *
 * PUT /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}
 */
export const putTeamPipelineMutation = (options?: Partial<Options<PutTeamPipelineData>>): UseMutationOptions<PutTeamPipelineResponse, AxiosError<PutTeamPipelineError>, Options<PutTeamPipelineData>> => {
    const mutationOptions: UseMutationOptions<PutTeamPipelineResponse, AxiosError<PutTeamPipelineError>, Options<PutTeamPipelineData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putTeamPipeline({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postTeamPipelineViewsQueryKey = (options: Options<PostTeamPipelineViewsData>) => createQueryKey('postTeamPipelineViews', options);

/**
 * Post Team Pipeline Views
 *
 * POST /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/views
 */
export const postTeamPipelineViewsOptions = (options: Options<PostTeamPipelineViewsData>) => queryOptions<unknown, AxiosError<PostTeamPipelineViewsError>, unknown, ReturnType<typeof postTeamPipelineViewsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postTeamPipelineViews({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postTeamPipelineViewsQueryKey(options)
});

/**
 * Post Team Pipeline Views
 *
 * POST /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/views
 */
export const postTeamPipelineViewsMutation = (options?: Partial<Options<PostTeamPipelineViewsData>>): UseMutationOptions<unknown, AxiosError<PostTeamPipelineViewsError>, Options<PostTeamPipelineViewsData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostTeamPipelineViewsError>, Options<PostTeamPipelineViewsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTeamPipelineViews({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTeamPipelineCandidatesQueryKey = (options: Options<GetTeamPipelineCandidatesData>) => createQueryKey('getTeamPipelineCandidates', options);

/**
 * Get Team Pipeline Candidates
 *
 * GET /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/candidates
 */
export const getTeamPipelineCandidatesOptions = (options: Options<GetTeamPipelineCandidatesData>) => queryOptions<GetTeamPipelineCandidatesResponse, AxiosError<GetTeamPipelineCandidatesError>, GetTeamPipelineCandidatesResponse, ReturnType<typeof getTeamPipelineCandidatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTeamPipelineCandidates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTeamPipelineCandidatesQueryKey(options)
});

export const postPipelineCandidatesQueryKey = (options: Options<PostPipelineCandidatesData>) => createQueryKey('postPipelineCandidates', options);

/**
 * Post Pipeline Candidates
 *
 * POST /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/candidates
 */
export const postPipelineCandidatesOptions = (options: Options<PostPipelineCandidatesData>) => queryOptions<PostPipelineCandidatesResponse, AxiosError<PostPipelineCandidatesError>, PostPipelineCandidatesResponse, ReturnType<typeof postPipelineCandidatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postPipelineCandidates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postPipelineCandidatesQueryKey(options)
});

export const postPipelineCandidatesInfiniteQueryKey = (options: Options<PostPipelineCandidatesData>): QueryKey<Options<PostPipelineCandidatesData>> => createQueryKey('postPipelineCandidates', options, true);

/**
 * Post Pipeline Candidates
 *
 * POST /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/candidates
 */
export const postPipelineCandidatesInfiniteOptions = (options: Options<PostPipelineCandidatesData>) => {
    const opts = infiniteQueryOptions<PostPipelineCandidatesResponse, AxiosError<PostPipelineCandidatesError>, InfiniteData<PostPipelineCandidatesResponse>, QueryKey<Options<PostPipelineCandidatesData>>, number | Pick<QueryKey<Options<PostPipelineCandidatesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PostPipelineCandidatesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                body: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await postPipelineCandidates({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postPipelineCandidatesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Post Pipeline Candidates
 *
 * POST /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/candidates
 */
export const postPipelineCandidatesMutation = (options?: Partial<Options<PostPipelineCandidatesData>>): UseMutationOptions<PostPipelineCandidatesResponse, AxiosError<PostPipelineCandidatesError>, Options<PostPipelineCandidatesData>> => {
    const mutationOptions: UseMutationOptions<PostPipelineCandidatesResponse, AxiosError<PostPipelineCandidatesError>, Options<PostPipelineCandidatesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postPipelineCandidates({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTeamPipelineCandidatesOffLimitsQueryKey = (options: Options<GetTeamPipelineCandidatesOffLimitsData>) => createQueryKey('getTeamPipelineCandidatesOffLimits', options);

/**
 * Get Team Pipeline Candidates Off Limits
 *
 * GET /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/candidates/off_limits
 */
export const getTeamPipelineCandidatesOffLimitsOptions = (options: Options<GetTeamPipelineCandidatesOffLimitsData>) => queryOptions<GetTeamPipelineCandidatesOffLimitsResponse, AxiosError<GetTeamPipelineCandidatesOffLimitsError>, GetTeamPipelineCandidatesOffLimitsResponse, ReturnType<typeof getTeamPipelineCandidatesOffLimitsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTeamPipelineCandidatesOffLimits({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTeamPipelineCandidatesOffLimitsQueryKey(options)
});

export const postTeamPipelineSubmissionQueryKey = (options: Options<PostTeamPipelineSubmissionData>) => createQueryKey('postTeamPipelineSubmission', options);

/**
 * Post Team Pipeline Submission
 *
 * POST /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/submissions
 */
export const postTeamPipelineSubmissionOptions = (options: Options<PostTeamPipelineSubmissionData>) => queryOptions<PostTeamPipelineSubmissionResponse, AxiosError<PostTeamPipelineSubmissionError>, PostTeamPipelineSubmissionResponse, ReturnType<typeof postTeamPipelineSubmissionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postTeamPipelineSubmission({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postTeamPipelineSubmissionQueryKey(options)
});

/**
 * Post Team Pipeline Submission
 *
 * POST /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/submissions
 */
export const postTeamPipelineSubmissionMutation = (options?: Partial<Options<PostTeamPipelineSubmissionData>>): UseMutationOptions<PostTeamPipelineSubmissionResponse, AxiosError<PostTeamPipelineSubmissionError>, Options<PostTeamPipelineSubmissionData>> => {
    const mutationOptions: UseMutationOptions<PostTeamPipelineSubmissionResponse, AxiosError<PostTeamPipelineSubmissionError>, Options<PostTeamPipelineSubmissionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTeamPipelineSubmission({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postTailoredHighlightsQueryKey = (options: Options<PostTailoredHighlightsData>) => createQueryKey('postTailoredHighlights', options);

/**
 * Post Tailored Highlights
 *
 * POST /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/tailored-highlights
 *
 * Queue AI-drafted highlights for one candidate, written for this pipeline from
 * its details, the candidate's LinkedIn resume and their advisor-written
 * highlights and Abouts. Poll `status_url`.
 */
export const postTailoredHighlightsOptions = (options: Options<PostTailoredHighlightsData>) => queryOptions<PostTailoredHighlightsResponse, AxiosError<PostTailoredHighlightsError>, PostTailoredHighlightsResponse, ReturnType<typeof postTailoredHighlightsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postTailoredHighlights({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postTailoredHighlightsQueryKey(options)
});

/**
 * Post Tailored Highlights
 *
 * POST /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/tailored-highlights
 *
 * Queue AI-drafted highlights for one candidate, written for this pipeline from
 * its details, the candidate's LinkedIn resume and their advisor-written
 * highlights and Abouts. Poll `status_url`.
 */
export const postTailoredHighlightsMutation = (options?: Partial<Options<PostTailoredHighlightsData>>): UseMutationOptions<PostTailoredHighlightsResponse, AxiosError<PostTailoredHighlightsError>, Options<PostTailoredHighlightsData>> => {
    const mutationOptions: UseMutationOptions<PostTailoredHighlightsResponse, AxiosError<PostTailoredHighlightsError>, Options<PostTailoredHighlightsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTailoredHighlights({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTailoredHighlightsStatusQueryKey = (options: Options<GetTailoredHighlightsStatusData>) => createQueryKey('getTailoredHighlightsStatus', options);

/**
 * Get Tailored Highlights Status
 *
 * GET /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/tailored-highlights/status/{task_id}
 *
 * The drafts once the task has finished. States: PENDING, SUCCESS, FAILURE.
 */
export const getTailoredHighlightsStatusOptions = (options: Options<GetTailoredHighlightsStatusData>) => queryOptions<GetTailoredHighlightsStatusResponse, AxiosError<GetTailoredHighlightsStatusError>, GetTailoredHighlightsStatusResponse, ReturnType<typeof getTailoredHighlightsStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTailoredHighlightsStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTailoredHighlightsStatusQueryKey(options)
});

export const getTeamPipelineRecommendationQueryKey = (options: Options<GetTeamPipelineRecommendationData>) => createQueryKey('getTeamPipelineRecommendation', options);

/**
 * Get Team Pipeline Recommendation
 *
 * GET /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/recommendations/{recommendation_uuid}
 */
export const getTeamPipelineRecommendationOptions = (options: Options<GetTeamPipelineRecommendationData>) => queryOptions<GetTeamPipelineRecommendationResponse, AxiosError<GetTeamPipelineRecommendationError>, GetTeamPipelineRecommendationResponse, ReturnType<typeof getTeamPipelineRecommendationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTeamPipelineRecommendation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTeamPipelineRecommendationQueryKey(options)
});

/**
 * Put Team Pipeline Recommendation Intro Email Type
 *
 * PUT /api/v2/teams/{team_slug}/pipelines/{pipeline_uuid}/recommendations/{recommendation_uuid}
 */
export const putTeamPipelineRecommendationIntroEmailTypeMutation = (options?: Partial<Options<PutTeamPipelineRecommendationIntroEmailTypeData>>): UseMutationOptions<PutTeamPipelineRecommendationIntroEmailTypeResponse, AxiosError<PutTeamPipelineRecommendationIntroEmailTypeError>, Options<PutTeamPipelineRecommendationIntroEmailTypeData>> => {
    const mutationOptions: UseMutationOptions<PutTeamPipelineRecommendationIntroEmailTypeResponse, AxiosError<PutTeamPipelineRecommendationIntroEmailTypeError>, Options<PutTeamPipelineRecommendationIntroEmailTypeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putTeamPipelineRecommendationIntroEmailType({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postTeamPipelineRecommendationCommentsQueryKey = (options: Options<PostTeamPipelineRecommendationCommentsData>) => createQueryKey('postTeamPipelineRecommendationComments', options);

/**
 * Post Team Pipeline Recommendation Comments
 *
 * POST /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/recommendations/{recommendation_uuid}/comments
 */
export const postTeamPipelineRecommendationCommentsOptions = (options: Options<PostTeamPipelineRecommendationCommentsData>) => queryOptions<PostTeamPipelineRecommendationCommentsResponse, AxiosError<PostTeamPipelineRecommendationCommentsError>, PostTeamPipelineRecommendationCommentsResponse, ReturnType<typeof postTeamPipelineRecommendationCommentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postTeamPipelineRecommendationComments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postTeamPipelineRecommendationCommentsQueryKey(options)
});

/**
 * Post Team Pipeline Recommendation Comments
 *
 * POST /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/recommendations/{recommendation_uuid}/comments
 */
export const postTeamPipelineRecommendationCommentsMutation = (options?: Partial<Options<PostTeamPipelineRecommendationCommentsData>>): UseMutationOptions<PostTeamPipelineRecommendationCommentsResponse, AxiosError<PostTeamPipelineRecommendationCommentsError>, Options<PostTeamPipelineRecommendationCommentsData>> => {
    const mutationOptions: UseMutationOptions<PostTeamPipelineRecommendationCommentsResponse, AxiosError<PostTeamPipelineRecommendationCommentsError>, Options<PostTeamPipelineRecommendationCommentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTeamPipelineRecommendationComments({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postTeamPipelineRecommendationDislikeQueryKey = (options: Options<PostTeamPipelineRecommendationDislikeData>) => createQueryKey('postTeamPipelineRecommendationDislike', options);

/**
 * Post Team Pipeline Recommendation Dislike
 *
 * POST /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/recommendations/{recommendation_uuid}/dislike
 */
export const postTeamPipelineRecommendationDislikeOptions = (options: Options<PostTeamPipelineRecommendationDislikeData>) => queryOptions<PostTeamPipelineRecommendationDislikeResponse, AxiosError<PostTeamPipelineRecommendationDislikeError>, PostTeamPipelineRecommendationDislikeResponse, ReturnType<typeof postTeamPipelineRecommendationDislikeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postTeamPipelineRecommendationDislike({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postTeamPipelineRecommendationDislikeQueryKey(options)
});

/**
 * Post Team Pipeline Recommendation Dislike
 *
 * POST /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/recommendations/{recommendation_uuid}/dislike
 */
export const postTeamPipelineRecommendationDislikeMutation = (options?: Partial<Options<PostTeamPipelineRecommendationDislikeData>>): UseMutationOptions<PostTeamPipelineRecommendationDislikeResponse, AxiosError<PostTeamPipelineRecommendationDislikeError>, Options<PostTeamPipelineRecommendationDislikeData>> => {
    const mutationOptions: UseMutationOptions<PostTeamPipelineRecommendationDislikeResponse, AxiosError<PostTeamPipelineRecommendationDislikeError>, Options<PostTeamPipelineRecommendationDislikeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTeamPipelineRecommendationDislike({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postTeamPipelineRecommendationFavoriteQueryKey = (options: Options<PostTeamPipelineRecommendationFavoriteData>) => createQueryKey('postTeamPipelineRecommendationFavorite', options);

/**
 * Post Team Pipeline Recommendation Favorite
 *
 * POST /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/recommendations/{recommendation_uuid}/favorite
 */
export const postTeamPipelineRecommendationFavoriteOptions = (options: Options<PostTeamPipelineRecommendationFavoriteData>) => queryOptions<PostTeamPipelineRecommendationFavoriteResponse, AxiosError<PostTeamPipelineRecommendationFavoriteError>, PostTeamPipelineRecommendationFavoriteResponse, ReturnType<typeof postTeamPipelineRecommendationFavoriteQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postTeamPipelineRecommendationFavorite({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postTeamPipelineRecommendationFavoriteQueryKey(options)
});

/**
 * Post Team Pipeline Recommendation Favorite
 *
 * POST /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/recommendations/{recommendation_uuid}/favorite
 */
export const postTeamPipelineRecommendationFavoriteMutation = (options?: Partial<Options<PostTeamPipelineRecommendationFavoriteData>>): UseMutationOptions<PostTeamPipelineRecommendationFavoriteResponse, AxiosError<PostTeamPipelineRecommendationFavoriteError>, Options<PostTeamPipelineRecommendationFavoriteData>> => {
    const mutationOptions: UseMutationOptions<PostTeamPipelineRecommendationFavoriteResponse, AxiosError<PostTeamPipelineRecommendationFavoriteError>, Options<PostTeamPipelineRecommendationFavoriteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTeamPipelineRecommendationFavorite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postTeamPipelineRecommendationViewsQueryKey = (options: Options<PostTeamPipelineRecommendationViewsData>) => createQueryKey('postTeamPipelineRecommendationViews', options);

/**
 * Post Team Pipeline Recommendation Views
 *
 * POST /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/recommendations/{recommendation_uuid}/views
 */
export const postTeamPipelineRecommendationViewsOptions = (options: Options<PostTeamPipelineRecommendationViewsData>) => queryOptions<unknown, AxiosError<PostTeamPipelineRecommendationViewsError>, unknown, ReturnType<typeof postTeamPipelineRecommendationViewsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postTeamPipelineRecommendationViews({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postTeamPipelineRecommendationViewsQueryKey(options)
});

/**
 * Post Team Pipeline Recommendation Views
 *
 * POST /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/recommendations/{recommendation_uuid}/views
 */
export const postTeamPipelineRecommendationViewsMutation = (options?: Partial<Options<PostTeamPipelineRecommendationViewsData>>): UseMutationOptions<unknown, AxiosError<PostTeamPipelineRecommendationViewsError>, Options<PostTeamPipelineRecommendationViewsData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostTeamPipelineRecommendationViewsError>, Options<PostTeamPipelineRecommendationViewsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTeamPipelineRecommendationViews({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTeamPipelineRecommendationInternalCommentsQueryKey = (options: Options<GetTeamPipelineRecommendationInternalCommentsData>) => createQueryKey('getTeamPipelineRecommendationInternalComments', options);

/**
 * Get Team Pipeline Recommendation Internal Comments
 *
 * GET /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/recommendations/{recommendation_uuid}/internal-comments
 */
export const getTeamPipelineRecommendationInternalCommentsOptions = (options: Options<GetTeamPipelineRecommendationInternalCommentsData>) => queryOptions<GetTeamPipelineRecommendationInternalCommentsResponse, AxiosError<GetTeamPipelineRecommendationInternalCommentsError>, GetTeamPipelineRecommendationInternalCommentsResponse, ReturnType<typeof getTeamPipelineRecommendationInternalCommentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTeamPipelineRecommendationInternalComments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTeamPipelineRecommendationInternalCommentsQueryKey(options)
});

export const getTeamPipelineRecommendationInternalCommentsInfiniteQueryKey = (options: Options<GetTeamPipelineRecommendationInternalCommentsData>): QueryKey<Options<GetTeamPipelineRecommendationInternalCommentsData>> => createQueryKey('getTeamPipelineRecommendationInternalComments', options, true);

/**
 * Get Team Pipeline Recommendation Internal Comments
 *
 * GET /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/recommendations/{recommendation_uuid}/internal-comments
 */
export const getTeamPipelineRecommendationInternalCommentsInfiniteOptions = (options: Options<GetTeamPipelineRecommendationInternalCommentsData>) => {
    const opts = infiniteQueryOptions<GetTeamPipelineRecommendationInternalCommentsResponse, AxiosError<GetTeamPipelineRecommendationInternalCommentsError>, InfiniteData<GetTeamPipelineRecommendationInternalCommentsResponse>, QueryKey<Options<GetTeamPipelineRecommendationInternalCommentsData>>, number | Pick<QueryKey<Options<GetTeamPipelineRecommendationInternalCommentsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetTeamPipelineRecommendationInternalCommentsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getTeamPipelineRecommendationInternalComments({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getTeamPipelineRecommendationInternalCommentsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const postTeamPipelineRecommendationInternalCommentsQueryKey = (options: Options<PostTeamPipelineRecommendationInternalCommentsData>) => createQueryKey('postTeamPipelineRecommendationInternalComments', options);

/**
 * Post Team Pipeline Recommendation Internal Comments
 *
 * POST /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/recommendations/{recommendation_uuid}/internal-comments
 */
export const postTeamPipelineRecommendationInternalCommentsOptions = (options: Options<PostTeamPipelineRecommendationInternalCommentsData>) => queryOptions<PostTeamPipelineRecommendationInternalCommentsResponse, AxiosError<PostTeamPipelineRecommendationInternalCommentsError>, PostTeamPipelineRecommendationInternalCommentsResponse, ReturnType<typeof postTeamPipelineRecommendationInternalCommentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postTeamPipelineRecommendationInternalComments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postTeamPipelineRecommendationInternalCommentsQueryKey(options)
});

/**
 * Post Team Pipeline Recommendation Internal Comments
 *
 * POST /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/recommendations/{recommendation_uuid}/internal-comments
 */
export const postTeamPipelineRecommendationInternalCommentsMutation = (options?: Partial<Options<PostTeamPipelineRecommendationInternalCommentsData>>): UseMutationOptions<PostTeamPipelineRecommendationInternalCommentsResponse, AxiosError<PostTeamPipelineRecommendationInternalCommentsError>, Options<PostTeamPipelineRecommendationInternalCommentsData>> => {
    const mutationOptions: UseMutationOptions<PostTeamPipelineRecommendationInternalCommentsResponse, AxiosError<PostTeamPipelineRecommendationInternalCommentsError>, Options<PostTeamPipelineRecommendationInternalCommentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTeamPipelineRecommendationInternalComments({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getRecsysPipelineRecommendationsQueryKey = (options: Options<GetRecsysPipelineRecommendationsData>) => createQueryKey('getRecsysPipelineRecommendations', options);

/**
 * Get Recsys Pipeline Recommendations
 *
 * GET /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/recsys-recommendations
 *
 * Fetch the RecSys (Brief Match) scheduler-computed recommendations for this pipeline and
 * hydrate each into Contender candidate data. Read-through: nothing is stored on the Contender
 * side. `already_on_pipeline` flags candidates already recommended on this pipeline (so the UI
 * can disable "Add as draft"). Empty when RecSys has no run for the pipeline yet; a 502/503 when
 * the RecSys service is unavailable or unconfigured.
 */
export const getRecsysPipelineRecommendationsOptions = (options: Options<GetRecsysPipelineRecommendationsData>) => queryOptions<GetRecsysPipelineRecommendationsResponse, AxiosError<GetRecsysPipelineRecommendationsError>, GetRecsysPipelineRecommendationsResponse, ReturnType<typeof getRecsysPipelineRecommendationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRecsysPipelineRecommendations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRecsysPipelineRecommendationsQueryKey(options)
});

export const getRecsysPipelineRecommendationsInfiniteQueryKey = (options: Options<GetRecsysPipelineRecommendationsData>): QueryKey<Options<GetRecsysPipelineRecommendationsData>> => createQueryKey('getRecsysPipelineRecommendations', options, true);

/**
 * Get Recsys Pipeline Recommendations
 *
 * GET /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/recsys-recommendations
 *
 * Fetch the RecSys (Brief Match) scheduler-computed recommendations for this pipeline and
 * hydrate each into Contender candidate data. Read-through: nothing is stored on the Contender
 * side. `already_on_pipeline` flags candidates already recommended on this pipeline (so the UI
 * can disable "Add as draft"). Empty when RecSys has no run for the pipeline yet; a 502/503 when
 * the RecSys service is unavailable or unconfigured.
 */
export const getRecsysPipelineRecommendationsInfiniteOptions = (options: Options<GetRecsysPipelineRecommendationsData>) => {
    const opts = infiniteQueryOptions<GetRecsysPipelineRecommendationsResponse, AxiosError<GetRecsysPipelineRecommendationsError>, InfiniteData<GetRecsysPipelineRecommendationsResponse>, QueryKey<Options<GetRecsysPipelineRecommendationsData>>, number | Pick<QueryKey<Options<GetRecsysPipelineRecommendationsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetRecsysPipelineRecommendationsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getRecsysPipelineRecommendations({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getRecsysPipelineRecommendationsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const postRecsysRecommendationFeedbackQueryKey = (options: Options<PostRecsysRecommendationFeedbackData>) => createQueryKey('postRecsysRecommendationFeedback', options);

/**
 * Post Recsys Recommendation Feedback
 *
 * POST .../pipelines/{pipeline_uuid}/recsys-recommendations/{recommendation_id}/feedback
 *
 * Record Good/Bad feedback on a RecSys recommendation, proxied to the RecSys feedback routine
 * (persists there and steers future runs). `recommendation_id` is the id returned by the fetch
 * endpoint. Read-through: nothing is stored on the Contender side.
 */
export const postRecsysRecommendationFeedbackOptions = (options: Options<PostRecsysRecommendationFeedbackData>) => queryOptions<unknown, AxiosError<PostRecsysRecommendationFeedbackError>, unknown, ReturnType<typeof postRecsysRecommendationFeedbackQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postRecsysRecommendationFeedback({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postRecsysRecommendationFeedbackQueryKey(options)
});

/**
 * Post Recsys Recommendation Feedback
 *
 * POST .../pipelines/{pipeline_uuid}/recsys-recommendations/{recommendation_id}/feedback
 *
 * Record Good/Bad feedback on a RecSys recommendation, proxied to the RecSys feedback routine
 * (persists there and steers future runs). `recommendation_id` is the id returned by the fetch
 * endpoint. Read-through: nothing is stored on the Contender side.
 */
export const postRecsysRecommendationFeedbackMutation = (options?: Partial<Options<PostRecsysRecommendationFeedbackData>>): UseMutationOptions<unknown, AxiosError<PostRecsysRecommendationFeedbackError>, Options<PostRecsysRecommendationFeedbackData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostRecsysRecommendationFeedbackError>, Options<PostRecsysRecommendationFeedbackData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postRecsysRecommendationFeedback({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTeamTrendingQueryKey = (options: Options<GetTeamTrendingData>) => createQueryKey('getTeamTrending', options);

/**
 * Get Team Trending
 *
 * GET /api/v2/teams/{team_uuid}/trending
 */
export const getTeamTrendingOptions = (options: Options<GetTeamTrendingData>) => queryOptions<GetTeamTrendingResponse, AxiosError<GetTeamTrendingError>, GetTeamTrendingResponse, ReturnType<typeof getTeamTrendingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTeamTrending({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTeamTrendingQueryKey(options)
});

export const getTeamTrendingRecommendationQueryKey = (options: Options<GetTeamTrendingRecommendationData>) => createQueryKey('getTeamTrendingRecommendation', options);

/**
 * Get Team Trending Recommendation
 *
 * GET /api/v2/teams/{team_uuid}/trending/{recommendation_uuid}
 */
export const getTeamTrendingRecommendationOptions = (options: Options<GetTeamTrendingRecommendationData>) => queryOptions<GetTeamTrendingRecommendationResponse, AxiosError<GetTeamTrendingRecommendationError>, GetTeamTrendingRecommendationResponse, ReturnType<typeof getTeamTrendingRecommendationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTeamTrendingRecommendation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTeamTrendingRecommendationQueryKey(options)
});

export const getTeamTrendingRecommendationActivityQueryKey = (options: Options<GetTeamTrendingRecommendationActivityData>) => createQueryKey('getTeamTrendingRecommendationActivity', options);

/**
 * Get Team Trending Recommendation Activity
 *
 * GET /api/v2/teams/{team_uuid}/trending/{recommendation_uuid}/activity
 */
export const getTeamTrendingRecommendationActivityOptions = (options: Options<GetTeamTrendingRecommendationActivityData>) => queryOptions<GetTeamTrendingRecommendationActivityResponse, AxiosError<GetTeamTrendingRecommendationActivityError>, GetTeamTrendingRecommendationActivityResponse, ReturnType<typeof getTeamTrendingRecommendationActivityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTeamTrendingRecommendationActivity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTeamTrendingRecommendationActivityQueryKey(options)
});

export const getTeamTrendingRecommendationActivityInfiniteQueryKey = (options: Options<GetTeamTrendingRecommendationActivityData>): QueryKey<Options<GetTeamTrendingRecommendationActivityData>> => createQueryKey('getTeamTrendingRecommendationActivity', options, true);

/**
 * Get Team Trending Recommendation Activity
 *
 * GET /api/v2/teams/{team_uuid}/trending/{recommendation_uuid}/activity
 */
export const getTeamTrendingRecommendationActivityInfiniteOptions = (options: Options<GetTeamTrendingRecommendationActivityData>) => {
    const opts = infiniteQueryOptions<GetTeamTrendingRecommendationActivityResponse, AxiosError<GetTeamTrendingRecommendationActivityError>, InfiniteData<GetTeamTrendingRecommendationActivityResponse>, QueryKey<Options<GetTeamTrendingRecommendationActivityData>>, number | Pick<QueryKey<Options<GetTeamTrendingRecommendationActivityData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetTeamTrendingRecommendationActivityData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getTeamTrendingRecommendationActivity({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getTeamTrendingRecommendationActivityInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getTeamTrendingRecommendationCommentsQueryKey = (options: Options<GetTeamTrendingRecommendationCommentsData>) => createQueryKey('getTeamTrendingRecommendationComments', options);

/**
 * Get Team Trending Recommendation Comments
 *
 * GET /api/v2/teams/{team_uuid}/trending/{recommendation_uuid}/comments
 */
export const getTeamTrendingRecommendationCommentsOptions = (options: Options<GetTeamTrendingRecommendationCommentsData>) => queryOptions<GetTeamTrendingRecommendationCommentsResponse, AxiosError<GetTeamTrendingRecommendationCommentsError>, GetTeamTrendingRecommendationCommentsResponse, ReturnType<typeof getTeamTrendingRecommendationCommentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTeamTrendingRecommendationComments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTeamTrendingRecommendationCommentsQueryKey(options)
});

export const getTeamTrendingRecommendationCommentsInfiniteQueryKey = (options: Options<GetTeamTrendingRecommendationCommentsData>): QueryKey<Options<GetTeamTrendingRecommendationCommentsData>> => createQueryKey('getTeamTrendingRecommendationComments', options, true);

/**
 * Get Team Trending Recommendation Comments
 *
 * GET /api/v2/teams/{team_uuid}/trending/{recommendation_uuid}/comments
 */
export const getTeamTrendingRecommendationCommentsInfiniteOptions = (options: Options<GetTeamTrendingRecommendationCommentsData>) => {
    const opts = infiniteQueryOptions<GetTeamTrendingRecommendationCommentsResponse, AxiosError<GetTeamTrendingRecommendationCommentsError>, InfiniteData<GetTeamTrendingRecommendationCommentsResponse>, QueryKey<Options<GetTeamTrendingRecommendationCommentsData>>, number | Pick<QueryKey<Options<GetTeamTrendingRecommendationCommentsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetTeamTrendingRecommendationCommentsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getTeamTrendingRecommendationComments({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getTeamTrendingRecommendationCommentsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const postTeamTrendingRecommendationCommentsQueryKey = (options: Options<PostTeamTrendingRecommendationCommentsData>) => createQueryKey('postTeamTrendingRecommendationComments', options);

/**
 * Post Team Trending Recommendation Comments
 *
 * POST /api/v2/teams/{team_uuid}/trending/{recommendation_uuid}/comments
 */
export const postTeamTrendingRecommendationCommentsOptions = (options: Options<PostTeamTrendingRecommendationCommentsData>) => queryOptions<PostTeamTrendingRecommendationCommentsResponse, AxiosError<PostTeamTrendingRecommendationCommentsError>, PostTeamTrendingRecommendationCommentsResponse, ReturnType<typeof postTeamTrendingRecommendationCommentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postTeamTrendingRecommendationComments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postTeamTrendingRecommendationCommentsQueryKey(options)
});

/**
 * Post Team Trending Recommendation Comments
 *
 * POST /api/v2/teams/{team_uuid}/trending/{recommendation_uuid}/comments
 */
export const postTeamTrendingRecommendationCommentsMutation = (options?: Partial<Options<PostTeamTrendingRecommendationCommentsData>>): UseMutationOptions<PostTeamTrendingRecommendationCommentsResponse, AxiosError<PostTeamTrendingRecommendationCommentsError>, Options<PostTeamTrendingRecommendationCommentsData>> => {
    const mutationOptions: UseMutationOptions<PostTeamTrendingRecommendationCommentsResponse, AxiosError<PostTeamTrendingRecommendationCommentsError>, Options<PostTeamTrendingRecommendationCommentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTeamTrendingRecommendationComments({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postTeamTrendingRecommendationDislikeQueryKey = (options: Options<PostTeamTrendingRecommendationDislikeData>) => createQueryKey('postTeamTrendingRecommendationDislike', options);

/**
 * Post Team Trending Recommendation Dislike
 *
 * POST /api/v2/teams/{team_uuid}/trending/{recommendation_uuid}/dislike
 */
export const postTeamTrendingRecommendationDislikeOptions = (options: Options<PostTeamTrendingRecommendationDislikeData>) => queryOptions<PostTeamTrendingRecommendationDislikeResponse, AxiosError<PostTeamTrendingRecommendationDislikeError>, PostTeamTrendingRecommendationDislikeResponse, ReturnType<typeof postTeamTrendingRecommendationDislikeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postTeamTrendingRecommendationDislike({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postTeamTrendingRecommendationDislikeQueryKey(options)
});

/**
 * Post Team Trending Recommendation Dislike
 *
 * POST /api/v2/teams/{team_uuid}/trending/{recommendation_uuid}/dislike
 */
export const postTeamTrendingRecommendationDislikeMutation = (options?: Partial<Options<PostTeamTrendingRecommendationDislikeData>>): UseMutationOptions<PostTeamTrendingRecommendationDislikeResponse, AxiosError<PostTeamTrendingRecommendationDislikeError>, Options<PostTeamTrendingRecommendationDislikeData>> => {
    const mutationOptions: UseMutationOptions<PostTeamTrendingRecommendationDislikeResponse, AxiosError<PostTeamTrendingRecommendationDislikeError>, Options<PostTeamTrendingRecommendationDislikeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTeamTrendingRecommendationDislike({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postTeamTrendingRecommendationFavoriteQueryKey = (options: Options<PostTeamTrendingRecommendationFavoriteData>) => createQueryKey('postTeamTrendingRecommendationFavorite', options);

/**
 * Post Team Trending Recommendation Favorite
 *
 * POST /api/v2/teams/{team_uuid}/trending/{recommendation_uuid}/favorite
 */
export const postTeamTrendingRecommendationFavoriteOptions = (options: Options<PostTeamTrendingRecommendationFavoriteData>) => queryOptions<PostTeamTrendingRecommendationFavoriteResponse, AxiosError<PostTeamTrendingRecommendationFavoriteError>, PostTeamTrendingRecommendationFavoriteResponse, ReturnType<typeof postTeamTrendingRecommendationFavoriteQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postTeamTrendingRecommendationFavorite({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postTeamTrendingRecommendationFavoriteQueryKey(options)
});

/**
 * Post Team Trending Recommendation Favorite
 *
 * POST /api/v2/teams/{team_uuid}/trending/{recommendation_uuid}/favorite
 */
export const postTeamTrendingRecommendationFavoriteMutation = (options?: Partial<Options<PostTeamTrendingRecommendationFavoriteData>>): UseMutationOptions<PostTeamTrendingRecommendationFavoriteResponse, AxiosError<PostTeamTrendingRecommendationFavoriteError>, Options<PostTeamTrendingRecommendationFavoriteData>> => {
    const mutationOptions: UseMutationOptions<PostTeamTrendingRecommendationFavoriteResponse, AxiosError<PostTeamTrendingRecommendationFavoriteError>, Options<PostTeamTrendingRecommendationFavoriteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTeamTrendingRecommendationFavorite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postTeamTrendingRecommendationViewsQueryKey = (options: Options<PostTeamTrendingRecommendationViewsData>) => createQueryKey('postTeamTrendingRecommendationViews', options);

/**
 * Post Team Trending Recommendation Views
 *
 * POST /api/v2/teams/{team_uuid}/trending/{recommendation_uuid}/views
 */
export const postTeamTrendingRecommendationViewsOptions = (options: Options<PostTeamTrendingRecommendationViewsData>) => queryOptions<unknown, AxiosError<PostTeamTrendingRecommendationViewsError>, unknown, ReturnType<typeof postTeamTrendingRecommendationViewsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postTeamTrendingRecommendationViews({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postTeamTrendingRecommendationViewsQueryKey(options)
});

/**
 * Post Team Trending Recommendation Views
 *
 * POST /api/v2/teams/{team_uuid}/trending/{recommendation_uuid}/views
 */
export const postTeamTrendingRecommendationViewsMutation = (options?: Partial<Options<PostTeamTrendingRecommendationViewsData>>): UseMutationOptions<unknown, AxiosError<PostTeamTrendingRecommendationViewsError>, Options<PostTeamTrendingRecommendationViewsData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostTeamTrendingRecommendationViewsError>, Options<PostTeamTrendingRecommendationViewsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTeamTrendingRecommendationViews({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postCandidateMergeQueryKey = (options: Options<PostCandidateMergeData>) => createQueryKey('postCandidateMerge', options);

/**
 * Post Candidate Merge
 *
 * POST /api/v2/admin/candidates/{candidate_uuid}/merge
 *
 * Merge another candidate record (``source_candidate_uuid``) into this one:
 * recommendations, highlights, activity and every other row that points at
 * the source move here; the source's identity is folded into this record's
 * identity (logins, referrals, feedback, email events, with a log row and a
 * signpost); the source is deactivated, its email released, and it points at
 * this record through ``merged_into_uuid``. Not undoable.
 *
 * ``dry_run`` reports counts per table and blockers and writes nothing. A
 * real merge with a blocker is a 409 with the same body. Merging a record
 * into itself is a 422. Reachable by the webapp and by the Contender Actions
 * connector acting for a named advisor.
 */
export const postCandidateMergeOptions = (options: Options<PostCandidateMergeData>) => queryOptions<PostCandidateMergeResponse, AxiosError<PostCandidateMergeError>, PostCandidateMergeResponse, ReturnType<typeof postCandidateMergeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postCandidateMerge({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postCandidateMergeQueryKey(options)
});

/**
 * Post Candidate Merge
 *
 * POST /api/v2/admin/candidates/{candidate_uuid}/merge
 *
 * Merge another candidate record (``source_candidate_uuid``) into this one:
 * recommendations, highlights, activity and every other row that points at
 * the source move here; the source's identity is folded into this record's
 * identity (logins, referrals, feedback, email events, with a log row and a
 * signpost); the source is deactivated, its email released, and it points at
 * this record through ``merged_into_uuid``. Not undoable.
 *
 * ``dry_run`` reports counts per table and blockers and writes nothing. A
 * real merge with a blocker is a 409 with the same body. Merging a record
 * into itself is a 422. Reachable by the webapp and by the Contender Actions
 * connector acting for a named advisor.
 */
export const postCandidateMergeMutation = (options?: Partial<Options<PostCandidateMergeData>>): UseMutationOptions<PostCandidateMergeResponse, AxiosError<PostCandidateMergeError>, Options<PostCandidateMergeData>> => {
    const mutationOptions: UseMutationOptions<PostCandidateMergeResponse, AxiosError<PostCandidateMergeError>, Options<PostCandidateMergeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCandidateMerge({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getNewCandidatesQueryKey = (options?: Options<GetNewCandidatesData>) => createQueryKey('getNewCandidates', options);

/**
 * Get New Candidates
 *
 * GET /api/v2/admin/candidates/new
 */
export const getNewCandidatesOptions = (options?: Options<GetNewCandidatesData>) => queryOptions<GetNewCandidatesResponse, AxiosError<GetNewCandidatesError>, GetNewCandidatesResponse, ReturnType<typeof getNewCandidatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getNewCandidates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getNewCandidatesQueryKey(options)
});

export const getNewCandidatesInfiniteQueryKey = (options?: Options<GetNewCandidatesData>): QueryKey<Options<GetNewCandidatesData>> => createQueryKey('getNewCandidates', options, true);

/**
 * Get New Candidates
 *
 * GET /api/v2/admin/candidates/new
 */
export const getNewCandidatesInfiniteOptions = (options?: Options<GetNewCandidatesData>) => {
    const opts = infiniteQueryOptions<GetNewCandidatesResponse, AxiosError<GetNewCandidatesError>, InfiniteData<GetNewCandidatesResponse>, QueryKey<Options<GetNewCandidatesData>>, number | Pick<QueryKey<Options<GetNewCandidatesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetNewCandidatesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getNewCandidates({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getNewCandidatesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const findIdentityQueryKey = (options?: Options<FindIdentityData>) => createQueryKey('findIdentity', options);

/**
 * Find Identity
 *
 * GET /api/v2/admin/identities?person_uuid=… | ?candidate_uuid=…
 *
 * The identity a login or a candidate belongs to. Pass exactly one of the
 * two; passing both or neither is a 422.
 */
export const findIdentityOptions = (options?: Options<FindIdentityData>) => queryOptions<FindIdentityResponse, AxiosError<FindIdentityError>, FindIdentityResponse, ReturnType<typeof findIdentityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findIdentity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findIdentityQueryKey(options)
});

export const postIdentityQueryKey = (options: Options<PostIdentityData>) => createQueryKey('postIdentity', options);

/**
 * Post Identity
 *
 * POST /api/v2/admin/identities
 *
 * A new human with its first login: an executive (activated, with no
 * candidate profile; one can be attached later), an enterprise user (on the
 * team given, or none yet) or an admin. Refused (409) when the email is
 * already a login, or is on a candidate profile (the login belongs to that
 * person), with that identity in the detail.
 */
export const postIdentityOptions = (options: Options<PostIdentityData>) => queryOptions<PostIdentityResponse, AxiosError<PostIdentityError>, PostIdentityResponse, ReturnType<typeof postIdentityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postIdentity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postIdentityQueryKey(options)
});

/**
 * Post Identity
 *
 * POST /api/v2/admin/identities
 *
 * A new human with its first login: an executive (activated, with no
 * candidate profile; one can be attached later), an enterprise user (on the
 * team given, or none yet) or an admin. Refused (409) when the email is
 * already a login, or is on a candidate profile (the login belongs to that
 * person), with that identity in the detail.
 */
export const postIdentityMutation = (options?: Partial<Options<PostIdentityData>>): UseMutationOptions<PostIdentityResponse, AxiosError<PostIdentityError>, Options<PostIdentityData>> => {
    const mutationOptions: UseMutationOptions<PostIdentityResponse, AxiosError<PostIdentityError>, Options<PostIdentityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postIdentity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getIdentityQueryKey = (options: Options<GetIdentityData>) => createQueryKey('getIdentity', options);

/**
 * Get Identity
 *
 * GET /api/v2/admin/identities/{identity_uuid}
 *
 * Every login in the identity, the activated executive first, plus the one
 * candidate it holds, if any.
 */
export const getIdentityOptions = (options: Options<GetIdentityData>) => queryOptions<GetIdentityResponse, AxiosError<GetIdentityError>, GetIdentityResponse, ReturnType<typeof getIdentityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getIdentity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getIdentityQueryKey(options)
});

export const getIdentityEmailEventsQueryKey = (options: Options<GetIdentityEmailEventsData>) => createQueryKey('getIdentityEmailEvents', options);

/**
 * Get Identity Email Events
 *
 * GET /api/v2/admin/identities/{identity_uuid}/email-events
 *
 * Every email sent to this human, one item per email with its lifecycle
 * (delivered, opened, clicked, bounced or dropped). Newest send first.
 *
 * An email belongs to the identity stamped on it at send time, so the emails
 * sent to each of the human's logins, at whatever address, are all here.
 * Pass `batch_uuid` to keep one send run, `event_uuid` to keep the emails
 * about one event, `email_event_type` to keep some kinds of email (summaries,
 * invites), `sendgrid_event` to keep only the emails delivered, opened,
 * bounced and so on.
 */
export const getIdentityEmailEventsOptions = (options: Options<GetIdentityEmailEventsData>) => queryOptions<GetIdentityEmailEventsResponse, AxiosError<GetIdentityEmailEventsError>, GetIdentityEmailEventsResponse, ReturnType<typeof getIdentityEmailEventsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getIdentityEmailEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getIdentityEmailEventsQueryKey(options)
});

export const getIdentityEmailEventsInfiniteQueryKey = (options: Options<GetIdentityEmailEventsData>): QueryKey<Options<GetIdentityEmailEventsData>> => createQueryKey('getIdentityEmailEvents', options, true);

/**
 * Get Identity Email Events
 *
 * GET /api/v2/admin/identities/{identity_uuid}/email-events
 *
 * Every email sent to this human, one item per email with its lifecycle
 * (delivered, opened, clicked, bounced or dropped). Newest send first.
 *
 * An email belongs to the identity stamped on it at send time, so the emails
 * sent to each of the human's logins, at whatever address, are all here.
 * Pass `batch_uuid` to keep one send run, `event_uuid` to keep the emails
 * about one event, `email_event_type` to keep some kinds of email (summaries,
 * invites), `sendgrid_event` to keep only the emails delivered, opened,
 * bounced and so on.
 */
export const getIdentityEmailEventsInfiniteOptions = (options: Options<GetIdentityEmailEventsData>) => {
    const opts = infiniteQueryOptions<GetIdentityEmailEventsResponse, AxiosError<GetIdentityEmailEventsError>, InfiniteData<GetIdentityEmailEventsResponse>, QueryKey<Options<GetIdentityEmailEventsData>>, number | Pick<QueryKey<Options<GetIdentityEmailEventsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetIdentityEmailEventsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getIdentityEmailEvents({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getIdentityEmailEventsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const postIdentityPersonQueryKey = (options: Options<PostIdentityPersonData>) => createQueryKey('postIdentityPerson', options);

/**
 * Post Identity Person
 *
 * POST /api/v2/admin/identities/{identity_uuid}/persons
 *
 * Move a login into this identity. Membership only: a login becomes the
 * candidate's executive by being activated, not by being added. 409 when the
 * login already shares a different candidate or a second activated executive
 * would result.
 */
export const postIdentityPersonOptions = (options: Options<PostIdentityPersonData>) => queryOptions<PostIdentityPersonResponse, AxiosError<PostIdentityPersonError>, PostIdentityPersonResponse, ReturnType<typeof postIdentityPersonQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postIdentityPerson({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postIdentityPersonQueryKey(options)
});

/**
 * Post Identity Person
 *
 * POST /api/v2/admin/identities/{identity_uuid}/persons
 *
 * Move a login into this identity. Membership only: a login becomes the
 * candidate's executive by being activated, not by being added. 409 when the
 * login already shares a different candidate or a second activated executive
 * would result.
 */
export const postIdentityPersonMutation = (options?: Partial<Options<PostIdentityPersonData>>): UseMutationOptions<PostIdentityPersonResponse, AxiosError<PostIdentityPersonError>, Options<PostIdentityPersonData>> => {
    const mutationOptions: UseMutationOptions<PostIdentityPersonResponse, AxiosError<PostIdentityPersonError>, Options<PostIdentityPersonData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postIdentityPerson({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Identity Person
 *
 * DELETE /api/v2/admin/identities/{identity_uuid}/persons/{person_uuid}
 *
 * Move a login out of this identity into a fresh, empty one. 409 for an
 * activated executive (undo the activation first) or a login that is not a
 * member.
 */
export const deleteIdentityPersonMutation = (options?: Partial<Options<DeleteIdentityPersonData>>): UseMutationOptions<DeleteIdentityPersonResponse, AxiosError<DeleteIdentityPersonError>, Options<DeleteIdentityPersonData>> => {
    const mutationOptions: UseMutationOptions<DeleteIdentityPersonResponse, AxiosError<DeleteIdentityPersonError>, Options<DeleteIdentityPersonData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteIdentityPerson({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Identity Candidate
 *
 * DELETE /api/v2/admin/identities/{identity_uuid}/candidate
 *
 * Take the candidate out of this identity; it gets a fresh identity of its
 * own. 409 when the identity has no candidate, or has an activated executive
 * (undo the activation first).
 */
export const deleteIdentityCandidateMutation = (options?: Partial<Options<DeleteIdentityCandidateData>>): UseMutationOptions<DeleteIdentityCandidateResponse, AxiosError<DeleteIdentityCandidateError>, Options<DeleteIdentityCandidateData>> => {
    const mutationOptions: UseMutationOptions<DeleteIdentityCandidateResponse, AxiosError<DeleteIdentityCandidateError>, Options<DeleteIdentityCandidateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteIdentityCandidate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Put Identity Candidate
 *
 * PUT /api/v2/admin/identities/{identity_uuid}/candidate
 *
 * Make this candidate the one candidate of the identity. The candidate's old
 * identity is left behind, empty. 409 when the identity already holds a
 * different candidate (merge the candidates first).
 */
export const putIdentityCandidateMutation = (options?: Partial<Options<PutIdentityCandidateData>>): UseMutationOptions<PutIdentityCandidateResponse, AxiosError<PutIdentityCandidateError>, Options<PutIdentityCandidateData>> => {
    const mutationOptions: UseMutationOptions<PutIdentityCandidateResponse, AxiosError<PutIdentityCandidateError>, Options<PutIdentityCandidateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putIdentityCandidate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postIdentityMergeQueryKey = (options: Options<PostIdentityMergeData>) => createQueryKey('postIdentityMerge', options);

/**
 * Post Identity Merge
 *
 * POST /api/v2/admin/identities/{identity_uuid}/merge
 *
 * Merge another identity (``from_identity_uuid``) into this one: every login,
 * the candidate if this identity has none, and every pointer (referrals,
 * feedback, email events) move here; the other identity stays behind as an
 * empty signpost. ``dry_run`` reports what would move and writes nothing.
 *
 * Only the uncomplicated case: at most one candidate and one activated
 * executive between the two. Otherwise 409, with the same body and
 * ``blockers`` saying why. Merging an identity into itself is a 422.
 */
export const postIdentityMergeOptions = (options: Options<PostIdentityMergeData>) => queryOptions<PostIdentityMergeResponse, AxiosError<PostIdentityMergeError>, PostIdentityMergeResponse, ReturnType<typeof postIdentityMergeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postIdentityMerge({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postIdentityMergeQueryKey(options)
});

/**
 * Post Identity Merge
 *
 * POST /api/v2/admin/identities/{identity_uuid}/merge
 *
 * Merge another identity (``from_identity_uuid``) into this one: every login,
 * the candidate if this identity has none, and every pointer (referrals,
 * feedback, email events) move here; the other identity stays behind as an
 * empty signpost. ``dry_run`` reports what would move and writes nothing.
 *
 * Only the uncomplicated case: at most one candidate and one activated
 * executive between the two. Otherwise 409, with the same body and
 * ``blockers`` saying why. Merging an identity into itself is a 422.
 */
export const postIdentityMergeMutation = (options?: Partial<Options<PostIdentityMergeData>>): UseMutationOptions<PostIdentityMergeResponse, AxiosError<PostIdentityMergeError>, Options<PostIdentityMergeData>> => {
    const mutationOptions: UseMutationOptions<PostIdentityMergeResponse, AxiosError<PostIdentityMergeError>, Options<PostIdentityMergeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postIdentityMerge({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postIdentityLoginQueryKey = (options: Options<PostIdentityLoginData>) => createQueryKey('postIdentityLogin', options);

/**
 * Post Identity Login
 *
 * POST /api/v2/admin/identities/{identity_uuid}/logins
 *
 * A new login for this human, created in its identity: an executive
 * (activated; refused when the identity already has one), an enterprise
 * user (on the team given, or none yet) or an admin. Refused (409) when the
 * email is already a login, here or on someone else, or is on another
 * person's candidate profile, with that identity in the detail.
 */
export const postIdentityLoginOptions = (options: Options<PostIdentityLoginData>) => queryOptions<PostIdentityLoginResponse, AxiosError<PostIdentityLoginError>, PostIdentityLoginResponse, ReturnType<typeof postIdentityLoginQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postIdentityLogin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postIdentityLoginQueryKey(options)
});

/**
 * Post Identity Login
 *
 * POST /api/v2/admin/identities/{identity_uuid}/logins
 *
 * A new login for this human, created in its identity: an executive
 * (activated; refused when the identity already has one), an enterprise
 * user (on the team given, or none yet) or an admin. Refused (409) when the
 * email is already a login, here or on someone else, or is on another
 * person's candidate profile, with that identity in the detail.
 */
export const postIdentityLoginMutation = (options?: Partial<Options<PostIdentityLoginData>>): UseMutationOptions<PostIdentityLoginResponse, AxiosError<PostIdentityLoginError>, Options<PostIdentityLoginData>> => {
    const mutationOptions: UseMutationOptions<PostIdentityLoginResponse, AxiosError<PostIdentityLoginError>, Options<PostIdentityLoginData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postIdentityLogin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postContactListsQueryKey = (options?: Options<PostContactListsData>) => createQueryKey('postContactLists', options);

/**
 * Post Contact Lists
 *
 * POST /api/v2/admin/contact-lists — create the dated Internal and External SendGrid lists.
 *
 * Also open to the Contender Actions connector (``X-MCP-API-Key`` +
 * ``X-Acting-User-Email``, see ``app.api.deps.auth.agent``).
 */
export const postContactListsOptions = (options?: Options<PostContactListsData>) => queryOptions<PostContactListsResponse, AxiosError<PostContactListsError>, PostContactListsResponse, ReturnType<typeof postContactListsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postContactLists({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postContactListsQueryKey(options)
});

/**
 * Post Contact Lists
 *
 * POST /api/v2/admin/contact-lists — create the dated Internal and External SendGrid lists.
 *
 * Also open to the Contender Actions connector (``X-MCP-API-Key`` +
 * ``X-Acting-User-Email``, see ``app.api.deps.auth.agent``).
 */
export const postContactListsMutation = (options?: Partial<Options<PostContactListsData>>): UseMutationOptions<PostContactListsResponse, AxiosError<PostContactListsError>, Options<PostContactListsData>> => {
    const mutationOptions: UseMutationOptions<PostContactListsResponse, AxiosError<PostContactListsError>, Options<PostContactListsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postContactLists({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPathwayActivityDefaultsQueryKey = (options?: Options<GetPathwayActivityDefaultsData>) => createQueryKey('getPathwayActivityDefaults', options);

/**
 * Get Pathway Activity Defaults
 *
 * GET /api/v2/admin/pathway-activity-defaults
 */
export const getPathwayActivityDefaultsOptions = (options?: Options<GetPathwayActivityDefaultsData>) => queryOptions<GetPathwayActivityDefaultsResponse, AxiosError<DefaultError>, GetPathwayActivityDefaultsResponse, ReturnType<typeof getPathwayActivityDefaultsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPathwayActivityDefaults({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPathwayActivityDefaultsQueryKey(options)
});

/**
 * Put Pathway Activity Defaults
 *
 * PUT /api/v2/admin/pathway-activity-defaults — upsert rows by pathway + activity_type.
 */
export const putPathwayActivityDefaultsMutation = (options?: Partial<Options<PutPathwayActivityDefaultsData>>): UseMutationOptions<PutPathwayActivityDefaultsResponse, AxiosError<PutPathwayActivityDefaultsError>, Options<PutPathwayActivityDefaultsData>> => {
    const mutationOptions: UseMutationOptions<PutPathwayActivityDefaultsResponse, AxiosError<PutPathwayActivityDefaultsError>, Options<PutPathwayActivityDefaultsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putPathwayActivityDefaults({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCandidateActivityLogsQueryKey = (options: Options<GetCandidateActivityLogsData>) => createQueryKey('getCandidateActivityLogs', options);

/**
 * Get Candidate Activity Logs
 *
 * GET /api/v2/admin/candidates/{candidate_uuid}/logs
 */
export const getCandidateActivityLogsOptions = (options: Options<GetCandidateActivityLogsData>) => queryOptions<GetCandidateActivityLogsResponse, AxiosError<GetCandidateActivityLogsError>, GetCandidateActivityLogsResponse, ReturnType<typeof getCandidateActivityLogsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCandidateActivityLogs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCandidateActivityLogsQueryKey(options)
});

export const getCandidateActivityLogsInfiniteQueryKey = (options: Options<GetCandidateActivityLogsData>): QueryKey<Options<GetCandidateActivityLogsData>> => createQueryKey('getCandidateActivityLogs', options, true);

/**
 * Get Candidate Activity Logs
 *
 * GET /api/v2/admin/candidates/{candidate_uuid}/logs
 */
export const getCandidateActivityLogsInfiniteOptions = (options: Options<GetCandidateActivityLogsData>) => {
    const opts = infiniteQueryOptions<GetCandidateActivityLogsResponse, AxiosError<GetCandidateActivityLogsError>, InfiniteData<GetCandidateActivityLogsResponse>, QueryKey<Options<GetCandidateActivityLogsData>>, number | Pick<QueryKey<Options<GetCandidateActivityLogsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetCandidateActivityLogsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getCandidateActivityLogs({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCandidateActivityLogsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const postCandidateActivityLogQueryKey = (options: Options<PostCandidateActivityLogData>) => createQueryKey('postCandidateActivityLog', options);

/**
 * Post Candidate Activity Log
 *
 * POST /api/v2/admin/candidates/{candidate_uuid}/logs
 */
export const postCandidateActivityLogOptions = (options: Options<PostCandidateActivityLogData>) => queryOptions<PostCandidateActivityLogResponse, AxiosError<PostCandidateActivityLogError>, PostCandidateActivityLogResponse, ReturnType<typeof postCandidateActivityLogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postCandidateActivityLog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postCandidateActivityLogQueryKey(options)
});

/**
 * Post Candidate Activity Log
 *
 * POST /api/v2/admin/candidates/{candidate_uuid}/logs
 */
export const postCandidateActivityLogMutation = (options?: Partial<Options<PostCandidateActivityLogData>>): UseMutationOptions<PostCandidateActivityLogResponse, AxiosError<PostCandidateActivityLogError>, Options<PostCandidateActivityLogData>> => {
    const mutationOptions: UseMutationOptions<PostCandidateActivityLogResponse, AxiosError<PostCandidateActivityLogError>, Options<PostCandidateActivityLogData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCandidateActivityLog({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCandidateActivityLogsSearchQueryKey = (options: Options<GetCandidateActivityLogsSearchData>) => createQueryKey('getCandidateActivityLogsSearch', options);

/**
 * Get Candidate Activity Logs Search
 *
 * GET /api/v2/admin/candidates/{candidate_uuid}/logs/search
 */
export const getCandidateActivityLogsSearchOptions = (options: Options<GetCandidateActivityLogsSearchData>) => queryOptions<GetCandidateActivityLogsSearchResponse, AxiosError<GetCandidateActivityLogsSearchError>, GetCandidateActivityLogsSearchResponse, ReturnType<typeof getCandidateActivityLogsSearchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCandidateActivityLogsSearch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCandidateActivityLogsSearchQueryKey(options)
});

export const postCandidateTasksFilterQueryKey = (options: Options<PostCandidateTasksFilterData>) => createQueryKey('postCandidateTasksFilter', options);

/**
 * Post Candidate Tasks Filter
 *
 * POST /api/v2/admin/candidates/{candidate_uuid}/tasks/filter
 */
export const postCandidateTasksFilterOptions = (options: Options<PostCandidateTasksFilterData>) => queryOptions<PostCandidateTasksFilterResponse, AxiosError<PostCandidateTasksFilterError>, PostCandidateTasksFilterResponse, ReturnType<typeof postCandidateTasksFilterQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postCandidateTasksFilter({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postCandidateTasksFilterQueryKey(options)
});

export const postCandidateTasksFilterInfiniteQueryKey = (options: Options<PostCandidateTasksFilterData>): QueryKey<Options<PostCandidateTasksFilterData>> => createQueryKey('postCandidateTasksFilter', options, true);

/**
 * Post Candidate Tasks Filter
 *
 * POST /api/v2/admin/candidates/{candidate_uuid}/tasks/filter
 */
export const postCandidateTasksFilterInfiniteOptions = (options: Options<PostCandidateTasksFilterData>) => {
    const opts = infiniteQueryOptions<PostCandidateTasksFilterResponse, AxiosError<PostCandidateTasksFilterError>, InfiniteData<PostCandidateTasksFilterResponse>, QueryKey<Options<PostCandidateTasksFilterData>>, number | Pick<QueryKey<Options<PostCandidateTasksFilterData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PostCandidateTasksFilterData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                body: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await postCandidateTasksFilter({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postCandidateTasksFilterInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Post Candidate Tasks Filter
 *
 * POST /api/v2/admin/candidates/{candidate_uuid}/tasks/filter
 */
export const postCandidateTasksFilterMutation = (options?: Partial<Options<PostCandidateTasksFilterData>>): UseMutationOptions<PostCandidateTasksFilterResponse, AxiosError<PostCandidateTasksFilterError>, Options<PostCandidateTasksFilterData>> => {
    const mutationOptions: UseMutationOptions<PostCandidateTasksFilterResponse, AxiosError<PostCandidateTasksFilterError>, Options<PostCandidateTasksFilterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCandidateTasksFilter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCandidateTasksOnboardingQueryKey = (options: Options<GetCandidateTasksOnboardingData>) => createQueryKey('getCandidateTasksOnboarding', options);

/**
 * Get Candidate Tasks Onboarding
 *
 * GET /api/v2/admin/candidates/{candidate_uuid}/tasks/onboarding-status
 */
export const getCandidateTasksOnboardingOptions = (options: Options<GetCandidateTasksOnboardingData>) => queryOptions<GetCandidateTasksOnboardingResponse, AxiosError<GetCandidateTasksOnboardingError>, GetCandidateTasksOnboardingResponse, ReturnType<typeof getCandidateTasksOnboardingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCandidateTasksOnboarding({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCandidateTasksOnboardingQueryKey(options)
});

/**
 * Delete All Candidate Pathway Activity Targets
 *
 * DELETE …/pathway-activity-targets — remove all overrides (revert to pathway defaults).
 */
export const deleteAllCandidatePathwayActivityTargetsMutation = (options?: Partial<Options<DeleteAllCandidatePathwayActivityTargetsData>>): UseMutationOptions<DeleteAllCandidatePathwayActivityTargetsResponse, AxiosError<DeleteAllCandidatePathwayActivityTargetsError>, Options<DeleteAllCandidatePathwayActivityTargetsData>> => {
    const mutationOptions: UseMutationOptions<DeleteAllCandidatePathwayActivityTargetsResponse, AxiosError<DeleteAllCandidatePathwayActivityTargetsError>, Options<DeleteAllCandidatePathwayActivityTargetsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteAllCandidatePathwayActivityTargets({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCandidatePathwayActivityTargetsQueryKey = (options: Options<GetCandidatePathwayActivityTargetsData>) => createQueryKey('getCandidatePathwayActivityTargets', options);

/**
 * Get Candidate Pathway Activity Targets
 *
 * GET /api/v2/admin/candidates/{candidate_uuid}/pathway-activity-targets
 */
export const getCandidatePathwayActivityTargetsOptions = (options: Options<GetCandidatePathwayActivityTargetsData>) => queryOptions<GetCandidatePathwayActivityTargetsResponse, AxiosError<GetCandidatePathwayActivityTargetsError>, GetCandidatePathwayActivityTargetsResponse, ReturnType<typeof getCandidatePathwayActivityTargetsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCandidatePathwayActivityTargets({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCandidatePathwayActivityTargetsQueryKey(options)
});

/**
 * Put Candidate Pathway Activity Targets
 *
 * PUT /api/v2/admin/candidates/{candidate_uuid}/pathway-activity-targets — upsert overrides.
 */
export const putCandidatePathwayActivityTargetsMutation = (options?: Partial<Options<PutCandidatePathwayActivityTargetsData>>): UseMutationOptions<PutCandidatePathwayActivityTargetsResponse, AxiosError<PutCandidatePathwayActivityTargetsError>, Options<PutCandidatePathwayActivityTargetsData>> => {
    const mutationOptions: UseMutationOptions<PutCandidatePathwayActivityTargetsResponse, AxiosError<PutCandidatePathwayActivityTargetsError>, Options<PutCandidatePathwayActivityTargetsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putCandidatePathwayActivityTargets({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Candidate Pathway Activity Target
 *
 * DELETE …/pathway-activity-targets/{activity_type} — remove one override.
 */
export const deleteCandidatePathwayActivityTargetMutation = (options?: Partial<Options<DeleteCandidatePathwayActivityTargetData>>): UseMutationOptions<DeleteCandidatePathwayActivityTargetResponse, AxiosError<DeleteCandidatePathwayActivityTargetError>, Options<DeleteCandidatePathwayActivityTargetData>> => {
    const mutationOptions: UseMutationOptions<DeleteCandidatePathwayActivityTargetResponse, AxiosError<DeleteCandidatePathwayActivityTargetError>, Options<DeleteCandidatePathwayActivityTargetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteCandidatePathwayActivityTarget({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getHomeActivityLogsQueryKey = (options?: Options<GetHomeActivityLogsData>) => createQueryKey('getHomeActivityLogs', options);

/**
 * Get Home Activity Logs
 *
 * GET /api/v2/admin/home/logs
 */
export const getHomeActivityLogsOptions = (options?: Options<GetHomeActivityLogsData>) => queryOptions<GetHomeActivityLogsResponse, AxiosError<GetHomeActivityLogsError>, GetHomeActivityLogsResponse, ReturnType<typeof getHomeActivityLogsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeActivityLogs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeActivityLogsQueryKey(options)
});

export const getHomeActivityLogsInfiniteQueryKey = (options?: Options<GetHomeActivityLogsData>): QueryKey<Options<GetHomeActivityLogsData>> => createQueryKey('getHomeActivityLogs', options, true);

/**
 * Get Home Activity Logs
 *
 * GET /api/v2/admin/home/logs
 */
export const getHomeActivityLogsInfiniteOptions = (options?: Options<GetHomeActivityLogsData>) => {
    const opts = infiniteQueryOptions<GetHomeActivityLogsResponse, AxiosError<GetHomeActivityLogsError>, InfiniteData<GetHomeActivityLogsResponse>, QueryKey<Options<GetHomeActivityLogsData>>, number | Pick<QueryKey<Options<GetHomeActivityLogsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetHomeActivityLogsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getHomeActivityLogs({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getHomeActivityLogsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getHomeAllIntrosQueryKey = (options?: Options<GetHomeAllIntrosData>) => createQueryKey('getHomeAllIntros', options);

/**
 * Get Home All Intros
 *
 * GET /api/v2/admin/home/intros
 */
export const getHomeAllIntrosOptions = (options?: Options<GetHomeAllIntrosData>) => queryOptions<GetHomeAllIntrosResponse, AxiosError<GetHomeAllIntrosError>, GetHomeAllIntrosResponse, ReturnType<typeof getHomeAllIntrosQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeAllIntros({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeAllIntrosQueryKey(options)
});

export const getHomeAllIntrosInfiniteQueryKey = (options?: Options<GetHomeAllIntrosData>): QueryKey<Options<GetHomeAllIntrosData>> => createQueryKey('getHomeAllIntros', options, true);

/**
 * Get Home All Intros
 *
 * GET /api/v2/admin/home/intros
 */
export const getHomeAllIntrosInfiniteOptions = (options?: Options<GetHomeAllIntrosData>) => {
    const opts = infiniteQueryOptions<GetHomeAllIntrosResponse, AxiosError<GetHomeAllIntrosError>, InfiniteData<GetHomeAllIntrosResponse>, QueryKey<Options<GetHomeAllIntrosData>>, number | Pick<QueryKey<Options<GetHomeAllIntrosData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetHomeAllIntrosData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getHomeAllIntros({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getHomeAllIntrosInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const postAdminPeersFilterQueryKey = (options: Options<PostAdminPeersFilterData>) => createQueryKey('postAdminPeersFilter', options);

/**
 * Post Admin Peers Filter
 *
 * POST /api/v2/admin/peers/filter
 */
export const postAdminPeersFilterOptions = (options: Options<PostAdminPeersFilterData>) => queryOptions<PostAdminPeersFilterResponse, AxiosError<PostAdminPeersFilterError>, PostAdminPeersFilterResponse, ReturnType<typeof postAdminPeersFilterQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postAdminPeersFilter({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postAdminPeersFilterQueryKey(options)
});

export const postAdminPeersFilterInfiniteQueryKey = (options: Options<PostAdminPeersFilterData>): QueryKey<Options<PostAdminPeersFilterData>> => createQueryKey('postAdminPeersFilter', options, true);

/**
 * Post Admin Peers Filter
 *
 * POST /api/v2/admin/peers/filter
 */
export const postAdminPeersFilterInfiniteOptions = (options: Options<PostAdminPeersFilterData>) => {
    const opts = infiniteQueryOptions<PostAdminPeersFilterResponse, AxiosError<PostAdminPeersFilterError>, InfiniteData<PostAdminPeersFilterResponse>, QueryKey<Options<PostAdminPeersFilterData>>, number | Pick<QueryKey<Options<PostAdminPeersFilterData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PostAdminPeersFilterData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                body: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await postAdminPeersFilter({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postAdminPeersFilterInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Post Admin Peers Filter
 *
 * POST /api/v2/admin/peers/filter
 */
export const postAdminPeersFilterMutation = (options?: Partial<Options<PostAdminPeersFilterData>>): UseMutationOptions<PostAdminPeersFilterResponse, AxiosError<PostAdminPeersFilterError>, Options<PostAdminPeersFilterData>> => {
    const mutationOptions: UseMutationOptions<PostAdminPeersFilterResponse, AxiosError<PostAdminPeersFilterError>, Options<PostAdminPeersFilterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postAdminPeersFilter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postCandidateCompareAboutQueryKey = (options: Options<PostCandidateCompareAboutData>) => createQueryKey('postCandidateCompareAbout', options);

/**
 * Post Candidate Compare About
 *
 * POST /api/v2/admin/peers/compare/about
 */
export const postCandidateCompareAboutOptions = (options: Options<PostCandidateCompareAboutData>) => queryOptions<PostCandidateCompareAboutResponse, AxiosError<PostCandidateCompareAboutError>, PostCandidateCompareAboutResponse, ReturnType<typeof postCandidateCompareAboutQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postCandidateCompareAbout({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postCandidateCompareAboutQueryKey(options)
});

/**
 * Post Candidate Compare About
 *
 * POST /api/v2/admin/peers/compare/about
 */
export const postCandidateCompareAboutMutation = (options?: Partial<Options<PostCandidateCompareAboutData>>): UseMutationOptions<PostCandidateCompareAboutResponse, AxiosError<PostCandidateCompareAboutError>, Options<PostCandidateCompareAboutData>> => {
    const mutationOptions: UseMutationOptions<PostCandidateCompareAboutResponse, AxiosError<PostCandidateCompareAboutError>, Options<PostCandidateCompareAboutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCandidateCompareAbout({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postCandidateCompareGoalsQueryKey = (options: Options<PostCandidateCompareGoalsData>) => createQueryKey('postCandidateCompareGoals', options);

/**
 * Post Candidate Compare Goals
 *
 * POST /api/v2/admin/peers/compare/goals
 *
 * Goals of every compared candidate, in the order the candidates were
 * requested. Active goals come first, completed ones last, newest first
 * within each group - the same ordering the candidate's own goals page uses.
 */
export const postCandidateCompareGoalsOptions = (options: Options<PostCandidateCompareGoalsData>) => queryOptions<PostCandidateCompareGoalsResponse, AxiosError<PostCandidateCompareGoalsError>, PostCandidateCompareGoalsResponse, ReturnType<typeof postCandidateCompareGoalsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postCandidateCompareGoals({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postCandidateCompareGoalsQueryKey(options)
});

/**
 * Post Candidate Compare Goals
 *
 * POST /api/v2/admin/peers/compare/goals
 *
 * Goals of every compared candidate, in the order the candidates were
 * requested. Active goals come first, completed ones last, newest first
 * within each group - the same ordering the candidate's own goals page uses.
 */
export const postCandidateCompareGoalsMutation = (options?: Partial<Options<PostCandidateCompareGoalsData>>): UseMutationOptions<PostCandidateCompareGoalsResponse, AxiosError<PostCandidateCompareGoalsError>, Options<PostCandidateCompareGoalsData>> => {
    const mutationOptions: UseMutationOptions<PostCandidateCompareGoalsResponse, AxiosError<PostCandidateCompareGoalsError>, Options<PostCandidateCompareGoalsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCandidateCompareGoals({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postCandidateCompareP2pQueryKey = (options: Options<PostCandidateCompareP2pData>) => createQueryKey('postCandidateCompareP2P', options);

/**
 * Post Candidate Compare P2P
 *
 * POST /api/v2/admin/peers/compare/p2p
 */
export const postCandidateCompareP2pOptions = (options: Options<PostCandidateCompareP2pData>) => queryOptions<PostCandidateCompareP2pResponse, AxiosError<PostCandidateCompareP2pError>, PostCandidateCompareP2pResponse, ReturnType<typeof postCandidateCompareP2pQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postCandidateCompareP2P({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postCandidateCompareP2pQueryKey(options)
});

/**
 * Post Candidate Compare P2P
 *
 * POST /api/v2/admin/peers/compare/p2p
 */
export const postCandidateCompareP2pMutation = (options?: Partial<Options<PostCandidateCompareP2pData>>): UseMutationOptions<PostCandidateCompareP2pResponse, AxiosError<PostCandidateCompareP2pError>, Options<PostCandidateCompareP2pData>> => {
    const mutationOptions: UseMutationOptions<PostCandidateCompareP2pResponse, AxiosError<PostCandidateCompareP2pError>, Options<PostCandidateCompareP2pData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCandidateCompareP2P({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postAdminPeersMatchesQueryKey = (options: Options<PostAdminPeersMatchesData>) => createQueryKey('postAdminPeersMatches', options);

/**
 * Post Admin Peers Matches
 *
 * POST /api/v2/admin/peers/{candidate_uuid}/matches
 */
export const postAdminPeersMatchesOptions = (options: Options<PostAdminPeersMatchesData>) => queryOptions<PostAdminPeersMatchesResponse, AxiosError<PostAdminPeersMatchesError>, PostAdminPeersMatchesResponse, ReturnType<typeof postAdminPeersMatchesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postAdminPeersMatches({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postAdminPeersMatchesQueryKey(options)
});

export const postAdminPeersMatchesInfiniteQueryKey = (options: Options<PostAdminPeersMatchesData>): QueryKey<Options<PostAdminPeersMatchesData>> => createQueryKey('postAdminPeersMatches', options, true);

/**
 * Post Admin Peers Matches
 *
 * POST /api/v2/admin/peers/{candidate_uuid}/matches
 */
export const postAdminPeersMatchesInfiniteOptions = (options: Options<PostAdminPeersMatchesData>) => {
    const opts = infiniteQueryOptions<PostAdminPeersMatchesResponse, AxiosError<PostAdminPeersMatchesError>, InfiniteData<PostAdminPeersMatchesResponse>, QueryKey<Options<PostAdminPeersMatchesData>>, number | Pick<QueryKey<Options<PostAdminPeersMatchesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PostAdminPeersMatchesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                body: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await postAdminPeersMatches({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postAdminPeersMatchesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Post Admin Peers Matches
 *
 * POST /api/v2/admin/peers/{candidate_uuid}/matches
 */
export const postAdminPeersMatchesMutation = (options?: Partial<Options<PostAdminPeersMatchesData>>): UseMutationOptions<PostAdminPeersMatchesResponse, AxiosError<PostAdminPeersMatchesError>, Options<PostAdminPeersMatchesData>> => {
    const mutationOptions: UseMutationOptions<PostAdminPeersMatchesResponse, AxiosError<PostAdminPeersMatchesError>, Options<PostAdminPeersMatchesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postAdminPeersMatches({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postAdminPeersCandidatesFilterQueryKey = (options: Options<PostAdminPeersCandidatesFilterData>) => createQueryKey('postAdminPeersCandidatesFilter', options);

/**
 * Post Admin Peers Candidates Filter
 *
 * POST /api/v2/admin/peers/{candidate_uuid}/candidates/filter
 */
export const postAdminPeersCandidatesFilterOptions = (options: Options<PostAdminPeersCandidatesFilterData>) => queryOptions<PostAdminPeersCandidatesFilterResponse, AxiosError<PostAdminPeersCandidatesFilterError>, PostAdminPeersCandidatesFilterResponse, ReturnType<typeof postAdminPeersCandidatesFilterQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postAdminPeersCandidatesFilter({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postAdminPeersCandidatesFilterQueryKey(options)
});

export const postAdminPeersCandidatesFilterInfiniteQueryKey = (options: Options<PostAdminPeersCandidatesFilterData>): QueryKey<Options<PostAdminPeersCandidatesFilterData>> => createQueryKey('postAdminPeersCandidatesFilter', options, true);

/**
 * Post Admin Peers Candidates Filter
 *
 * POST /api/v2/admin/peers/{candidate_uuid}/candidates/filter
 */
export const postAdminPeersCandidatesFilterInfiniteOptions = (options: Options<PostAdminPeersCandidatesFilterData>) => {
    const opts = infiniteQueryOptions<PostAdminPeersCandidatesFilterResponse, AxiosError<PostAdminPeersCandidatesFilterError>, InfiniteData<PostAdminPeersCandidatesFilterResponse>, QueryKey<Options<PostAdminPeersCandidatesFilterData>>, number | Pick<QueryKey<Options<PostAdminPeersCandidatesFilterData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PostAdminPeersCandidatesFilterData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                body: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await postAdminPeersCandidatesFilter({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postAdminPeersCandidatesFilterInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Post Admin Peers Candidates Filter
 *
 * POST /api/v2/admin/peers/{candidate_uuid}/candidates/filter
 */
export const postAdminPeersCandidatesFilterMutation = (options?: Partial<Options<PostAdminPeersCandidatesFilterData>>): UseMutationOptions<PostAdminPeersCandidatesFilterResponse, AxiosError<PostAdminPeersCandidatesFilterError>, Options<PostAdminPeersCandidatesFilterData>> => {
    const mutationOptions: UseMutationOptions<PostAdminPeersCandidatesFilterResponse, AxiosError<PostAdminPeersCandidatesFilterError>, Options<PostAdminPeersCandidatesFilterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postAdminPeersCandidatesFilter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postAdminPeersPublishQueryKey = (options: Options<PostAdminPeersPublishData>) => createQueryKey('postAdminPeersPublish', options);

/**
 * Post Admin Peers Publish
 *
 * POST /api/v2/admin/peers/{candidate_uuid}
 */
export const postAdminPeersPublishOptions = (options: Options<PostAdminPeersPublishData>) => queryOptions<PostAdminPeersPublishResponse, AxiosError<PostAdminPeersPublishError>, PostAdminPeersPublishResponse, ReturnType<typeof postAdminPeersPublishQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postAdminPeersPublish({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postAdminPeersPublishQueryKey(options)
});

/**
 * Post Admin Peers Publish
 *
 * POST /api/v2/admin/peers/{candidate_uuid}
 */
export const postAdminPeersPublishMutation = (options?: Partial<Options<PostAdminPeersPublishData>>): UseMutationOptions<PostAdminPeersPublishResponse, AxiosError<PostAdminPeersPublishError>, Options<PostAdminPeersPublishData>> => {
    const mutationOptions: UseMutationOptions<PostAdminPeersPublishResponse, AxiosError<PostAdminPeersPublishError>, Options<PostAdminPeersPublishData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postAdminPeersPublish({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Peer
 *
 * DELETE /api/v2/admin/peers/{peer_id}
 */
export const deletePeerMutation = (options?: Partial<Options<DeletePeerData>>): UseMutationOptions<DeletePeerResponse, AxiosError<DeletePeerError>, Options<DeletePeerData>> => {
    const mutationOptions: UseMutationOptions<DeletePeerResponse, AxiosError<DeletePeerError>, Options<DeletePeerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deletePeer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPeerQueryKey = (options: Options<GetPeerData>) => createQueryKey('getPeer', options);

/**
 * Get Peer
 *
 * GET /api/v2/admin/peers/{peer_id}
 */
export const getPeerOptions = (options: Options<GetPeerData>) => queryOptions<GetPeerResponse, AxiosError<GetPeerError>, GetPeerResponse, ReturnType<typeof getPeerQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPeer({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPeerQueryKey(options)
});

/**
 * Put Peer Status
 *
 * PUT /api/v2/admin/peers/{peer_id}/status
 */
export const putPeerStatusMutation = (options?: Partial<Options<PutPeerStatusData>>): UseMutationOptions<PutPeerStatusResponse, AxiosError<PutPeerStatusError>, Options<PutPeerStatusData>> => {
    const mutationOptions: UseMutationOptions<PutPeerStatusResponse, AxiosError<PutPeerStatusError>, Options<PutPeerStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putPeerStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Put Peer Assignees
 *
 * PUT /api/v2/admin/peers/{peer_id}/assignees
 */
export const putPeerAssigneesMutation = (options?: Partial<Options<PutPeerAssigneesData>>): UseMutationOptions<PutPeerAssigneesResponse, AxiosError<PutPeerAssigneesError>, Options<PutPeerAssigneesData>> => {
    const mutationOptions: UseMutationOptions<PutPeerAssigneesResponse, AxiosError<PutPeerAssigneesError>, Options<PutPeerAssigneesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putPeerAssignees({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Put Peer Introduction
 *
 * PUT /api/v2/admin/peers/{peer_id}/introduction
 */
export const putPeerIntroductionMutation = (options?: Partial<Options<PutPeerIntroductionData>>): UseMutationOptions<PutPeerIntroductionResponse, AxiosError<PutPeerIntroductionError>, Options<PutPeerIntroductionData>> => {
    const mutationOptions: UseMutationOptions<PutPeerIntroductionResponse, AxiosError<PutPeerIntroductionError>, Options<PutPeerIntroductionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putPeerIntroduction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPeerActivityQueryKey = (options: Options<GetPeerActivityData>) => createQueryKey('getPeerActivity', options);

/**
 * Get Peer Activity
 *
 * GET /api/v2/admin/peers/{peer_id}/activity
 */
export const getPeerActivityOptions = (options: Options<GetPeerActivityData>) => queryOptions<GetPeerActivityResponse, AxiosError<GetPeerActivityError>, GetPeerActivityResponse, ReturnType<typeof getPeerActivityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPeerActivity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPeerActivityQueryKey(options)
});

export const getPeerActivityInfiniteQueryKey = (options: Options<GetPeerActivityData>): QueryKey<Options<GetPeerActivityData>> => createQueryKey('getPeerActivity', options, true);

/**
 * Get Peer Activity
 *
 * GET /api/v2/admin/peers/{peer_id}/activity
 */
export const getPeerActivityInfiniteOptions = (options: Options<GetPeerActivityData>) => {
    const opts = infiniteQueryOptions<GetPeerActivityResponse, AxiosError<GetPeerActivityError>, InfiniteData<GetPeerActivityResponse>, QueryKey<Options<GetPeerActivityData>>, number | Pick<QueryKey<Options<GetPeerActivityData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetPeerActivityData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getPeerActivity({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPeerActivityInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const postPeerCommentQueryKey = (options: Options<PostPeerCommentData>) => createQueryKey('postPeerComment', options);

/**
 * Post Peer Comment
 *
 * POST /api/v2/admin/peers/{peer_id}/comments
 */
export const postPeerCommentOptions = (options: Options<PostPeerCommentData>) => queryOptions<PostPeerCommentResponse, AxiosError<PostPeerCommentError>, PostPeerCommentResponse, ReturnType<typeof postPeerCommentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postPeerComment({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postPeerCommentQueryKey(options)
});

/**
 * Post Peer Comment
 *
 * POST /api/v2/admin/peers/{peer_id}/comments
 */
export const postPeerCommentMutation = (options?: Partial<Options<PostPeerCommentData>>): UseMutationOptions<PostPeerCommentResponse, AxiosError<PostPeerCommentError>, Options<PostPeerCommentData>> => {
    const mutationOptions: UseMutationOptions<PostPeerCommentResponse, AxiosError<PostPeerCommentError>, Options<PostPeerCommentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postPeerComment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Peer Comment
 *
 * DELETE /api/v2/admin/peers/{peer_id}/comments/{peer_comment_id}
 */
export const deletePeerCommentMutation = (options?: Partial<Options<DeletePeerCommentData>>): UseMutationOptions<DeletePeerCommentResponse, AxiosError<DeletePeerCommentError>, Options<DeletePeerCommentData>> => {
    const mutationOptions: UseMutationOptions<DeletePeerCommentResponse, AxiosError<DeletePeerCommentError>, Options<DeletePeerCommentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deletePeerComment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postTasksQueryKey = (options: Options<PostTasksData>) => createQueryKey('postTasks', options);

/**
 * Post Tasks
 *
 * POST /api/v2/admin/tasks
 */
export const postTasksOptions = (options: Options<PostTasksData>) => queryOptions<PostTasksResponse, AxiosError<PostTasksError>, PostTasksResponse, ReturnType<typeof postTasksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postTasks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postTasksQueryKey(options)
});

/**
 * Post Tasks
 *
 * POST /api/v2/admin/tasks
 */
export const postTasksMutation = (options?: Partial<Options<PostTasksData>>): UseMutationOptions<PostTasksResponse, AxiosError<PostTasksError>, Options<PostTasksData>> => {
    const mutationOptions: UseMutationOptions<PostTasksResponse, AxiosError<PostTasksError>, Options<PostTasksData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTasks({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postTasksFilterQueryKey = (options: Options<PostTasksFilterData>) => createQueryKey('postTasksFilter', options);

/**
 * Post Tasks Filter
 *
 * POST /api/v2/admin/tasks/filter
 */
export const postTasksFilterOptions = (options: Options<PostTasksFilterData>) => queryOptions<PostTasksFilterResponse, AxiosError<PostTasksFilterError>, PostTasksFilterResponse, ReturnType<typeof postTasksFilterQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postTasksFilter({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postTasksFilterQueryKey(options)
});

export const postTasksFilterInfiniteQueryKey = (options: Options<PostTasksFilterData>): QueryKey<Options<PostTasksFilterData>> => createQueryKey('postTasksFilter', options, true);

/**
 * Post Tasks Filter
 *
 * POST /api/v2/admin/tasks/filter
 */
export const postTasksFilterInfiniteOptions = (options: Options<PostTasksFilterData>) => {
    const opts = infiniteQueryOptions<PostTasksFilterResponse, AxiosError<PostTasksFilterError>, InfiniteData<PostTasksFilterResponse>, QueryKey<Options<PostTasksFilterData>>, number | Pick<QueryKey<Options<PostTasksFilterData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PostTasksFilterData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                body: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await postTasksFilter({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postTasksFilterInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Post Tasks Filter
 *
 * POST /api/v2/admin/tasks/filter
 */
export const postTasksFilterMutation = (options?: Partial<Options<PostTasksFilterData>>): UseMutationOptions<PostTasksFilterResponse, AxiosError<PostTasksFilterError>, Options<PostTasksFilterData>> => {
    const mutationOptions: UseMutationOptions<PostTasksFilterResponse, AxiosError<PostTasksFilterError>, Options<PostTasksFilterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTasksFilter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Task
 *
 * DELETE /api/v2/admin/tasks/{task_id}
 */
export const deleteTaskMutation = (options?: Partial<Options<DeleteTaskData>>): UseMutationOptions<DeleteTaskResponse, AxiosError<DeleteTaskError>, Options<DeleteTaskData>> => {
    const mutationOptions: UseMutationOptions<DeleteTaskResponse, AxiosError<DeleteTaskError>, Options<DeleteTaskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteTask({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTaskQueryKey = (options: Options<GetTaskData>) => createQueryKey('getTask', options);

/**
 * Get Task
 *
 * GET /api/v2/admin/tasks/{task_id}
 */
export const getTaskOptions = (options: Options<GetTaskData>) => queryOptions<GetTaskResponse, AxiosError<GetTaskError>, GetTaskResponse, ReturnType<typeof getTaskQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTask({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTaskQueryKey(options)
});

/**
 * Put Task
 *
 * PUT /api/v2/admin/tasks/{task_id}
 */
export const putTaskMutation = (options?: Partial<Options<PutTaskData>>): UseMutationOptions<PutTaskResponse, AxiosError<PutTaskError>, Options<PutTaskData>> => {
    const mutationOptions: UseMutationOptions<PutTaskResponse, AxiosError<PutTaskError>, Options<PutTaskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putTask({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Put Task Status
 *
 * PUT /api/v2/admin/tasks/{task_id}/status
 */
export const putTaskStatusMutation = (options?: Partial<Options<PutTaskStatusData>>): UseMutationOptions<PutTaskStatusResponse, AxiosError<PutTaskStatusError>, Options<PutTaskStatusData>> => {
    const mutationOptions: UseMutationOptions<PutTaskStatusResponse, AxiosError<PutTaskStatusError>, Options<PutTaskStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putTaskStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postTeamTransferToCompanyQueryKey = (options: Options<PostTeamTransferToCompanyData>) => createQueryKey('postTeamTransferToCompany', options);

/**
 * Post Team Transfer To Company
 *
 * POST /api/v2/admin/teams/{team_uuid}/transfer-to-company
 *
 * Transfer a team from one company to another.
 *
 * Updates:
 * - SearchTeam.company_id, team_name, slug
 * - Pipeline.company (the displayed company name) for all team pipelines
 * - PersonRole.company_id for all team members
 * - Feedback.company_id for all team feedback
 *
 * ES indices are automatically updated:
 * - teams index: via SearchTeam event listener (model_registry)
 * - pipelines index: via SearchTeam -> TeamInnerDoc sync
 * - recommendations index: via SearchTeam -> TeamInnerDoc sync
 * - people index: manually synced after commit
 */
export const postTeamTransferToCompanyOptions = (options: Options<PostTeamTransferToCompanyData>) => queryOptions<PostTeamTransferToCompanyResponse, AxiosError<PostTeamTransferToCompanyError>, PostTeamTransferToCompanyResponse, ReturnType<typeof postTeamTransferToCompanyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postTeamTransferToCompany({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postTeamTransferToCompanyQueryKey(options)
});

/**
 * Post Team Transfer To Company
 *
 * POST /api/v2/admin/teams/{team_uuid}/transfer-to-company
 *
 * Transfer a team from one company to another.
 *
 * Updates:
 * - SearchTeam.company_id, team_name, slug
 * - Pipeline.company (the displayed company name) for all team pipelines
 * - PersonRole.company_id for all team members
 * - Feedback.company_id for all team feedback
 *
 * ES indices are automatically updated:
 * - teams index: via SearchTeam event listener (model_registry)
 * - pipelines index: via SearchTeam -> TeamInnerDoc sync
 * - recommendations index: via SearchTeam -> TeamInnerDoc sync
 * - people index: manually synced after commit
 */
export const postTeamTransferToCompanyMutation = (options?: Partial<Options<PostTeamTransferToCompanyData>>): UseMutationOptions<PostTeamTransferToCompanyResponse, AxiosError<PostTeamTransferToCompanyError>, Options<PostTeamTransferToCompanyData>> => {
    const mutationOptions: UseMutationOptions<PostTeamTransferToCompanyResponse, AxiosError<PostTeamTransferToCompanyError>, Options<PostTeamTransferToCompanyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTeamTransferToCompany({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postTeamMergeQueryKey = (options: Options<PostTeamMergeData>) => createQueryKey('postTeamMerge', options);

/**
 * Post Team Merge
 *
 * POST /api/v2/admin/teams/{team_uuid}/merge
 *
 * Merge a source team into the target (path) team. The path team is the
 * base team that survives; the source team is folded into it and then
 * deactivated. Both teams must belong to the same company.
 *
 * Re-points every reference (pipelines, recommendations, feedback,
 * members, comments, invitations, intros, evaluations, email events) from
 * the source onto the target. ES teams/pipelines/recommendations indices
 * sync automatically on commit; the aggregate candidates / team-candidates
 * indices are refreshed via a separate reindex.
 */
export const postTeamMergeOptions = (options: Options<PostTeamMergeData>) => queryOptions<PostTeamMergeResponse, AxiosError<PostTeamMergeError>, PostTeamMergeResponse, ReturnType<typeof postTeamMergeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postTeamMerge({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postTeamMergeQueryKey(options)
});

/**
 * Post Team Merge
 *
 * POST /api/v2/admin/teams/{team_uuid}/merge
 *
 * Merge a source team into the target (path) team. The path team is the
 * base team that survives; the source team is folded into it and then
 * deactivated. Both teams must belong to the same company.
 *
 * Re-points every reference (pipelines, recommendations, feedback,
 * members, comments, invitations, intros, evaluations, email events) from
 * the source onto the target. ES teams/pipelines/recommendations indices
 * sync automatically on commit; the aggregate candidates / team-candidates
 * indices are refreshed via a separate reindex.
 */
export const postTeamMergeMutation = (options?: Partial<Options<PostTeamMergeData>>): UseMutationOptions<PostTeamMergeResponse, AxiosError<PostTeamMergeError>, Options<PostTeamMergeData>> => {
    const mutationOptions: UseMutationOptions<PostTeamMergeResponse, AxiosError<PostTeamMergeError>, Options<PostTeamMergeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTeamMerge({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postTaskModulesQueryKey = (options: Options<PostTaskModulesData>) => createQueryKey('postTaskModules', options);

/**
 * Post Task Modules
 *
 * POST /api/v2/admin/task-modules
 */
export const postTaskModulesOptions = (options: Options<PostTaskModulesData>) => queryOptions<PostTaskModulesResponse, AxiosError<PostTaskModulesError>, PostTaskModulesResponse, ReturnType<typeof postTaskModulesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postTaskModules({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postTaskModulesQueryKey(options)
});

/**
 * Post Task Modules
 *
 * POST /api/v2/admin/task-modules
 */
export const postTaskModulesMutation = (options?: Partial<Options<PostTaskModulesData>>): UseMutationOptions<PostTaskModulesResponse, AxiosError<PostTaskModulesError>, Options<PostTaskModulesData>> => {
    const mutationOptions: UseMutationOptions<PostTaskModulesResponse, AxiosError<PostTaskModulesError>, Options<PostTaskModulesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTaskModules({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Task Module
 *
 * DELETE /api/v2/admin/task-modules/{task_module_id}
 */
export const deleteTaskModuleMutation = (options?: Partial<Options<DeleteTaskModuleData>>): UseMutationOptions<DeleteTaskModuleResponse, AxiosError<DeleteTaskModuleError>, Options<DeleteTaskModuleData>> => {
    const mutationOptions: UseMutationOptions<DeleteTaskModuleResponse, AxiosError<DeleteTaskModuleError>, Options<DeleteTaskModuleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteTaskModule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTaskModuleQueryKey = (options: Options<GetTaskModuleData>) => createQueryKey('getTaskModule', options);

/**
 * Get Task Module
 *
 * GET /api/v2/admin/task-modules/{task_module_id}
 */
export const getTaskModuleOptions = (options: Options<GetTaskModuleData>) => queryOptions<GetTaskModuleResponse, AxiosError<GetTaskModuleError>, GetTaskModuleResponse, ReturnType<typeof getTaskModuleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTaskModule({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTaskModuleQueryKey(options)
});

/**
 * Put Task Module
 *
 * PUT /api/v2/admin/task-modules/{task_module_id}
 */
export const putTaskModuleMutation = (options?: Partial<Options<PutTaskModuleData>>): UseMutationOptions<PutTaskModuleResponse, AxiosError<PutTaskModuleError>, Options<PutTaskModuleData>> => {
    const mutationOptions: UseMutationOptions<PutTaskModuleResponse, AxiosError<PutTaskModuleError>, Options<PutTaskModuleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putTaskModule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Put Task Module Status
 *
 * PUT /api/v2/admin/task-modules/{task_module_id}/status
 */
export const putTaskModuleStatusMutation = (options?: Partial<Options<PutTaskModuleStatusData>>): UseMutationOptions<PutTaskModuleStatusResponse, AxiosError<PutTaskModuleStatusError>, Options<PutTaskModuleStatusData>> => {
    const mutationOptions: UseMutationOptions<PutTaskModuleStatusResponse, AxiosError<PutTaskModuleStatusError>, Options<PutTaskModuleStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putTaskModuleStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postAdminPipelineCandidatesFilterQueryKey = (options: Options<PostAdminPipelineCandidatesFilterData>) => createQueryKey('postAdminPipelineCandidatesFilter', options);

/**
 * Post Admin Pipeline Candidates Filter
 *
 * POST /api/v2/pipelines/{pipeline_uuid}/candidates/filter
 */
export const postAdminPipelineCandidatesFilterOptions = (options: Options<PostAdminPipelineCandidatesFilterData>) => queryOptions<PostAdminPipelineCandidatesFilterResponse, AxiosError<PostAdminPipelineCandidatesFilterError>, PostAdminPipelineCandidatesFilterResponse, ReturnType<typeof postAdminPipelineCandidatesFilterQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postAdminPipelineCandidatesFilter({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postAdminPipelineCandidatesFilterQueryKey(options)
});

export const postAdminPipelineCandidatesFilterInfiniteQueryKey = (options: Options<PostAdminPipelineCandidatesFilterData>): QueryKey<Options<PostAdminPipelineCandidatesFilterData>> => createQueryKey('postAdminPipelineCandidatesFilter', options, true);

/**
 * Post Admin Pipeline Candidates Filter
 *
 * POST /api/v2/pipelines/{pipeline_uuid}/candidates/filter
 */
export const postAdminPipelineCandidatesFilterInfiniteOptions = (options: Options<PostAdminPipelineCandidatesFilterData>) => {
    const opts = infiniteQueryOptions<PostAdminPipelineCandidatesFilterResponse, AxiosError<PostAdminPipelineCandidatesFilterError>, InfiniteData<PostAdminPipelineCandidatesFilterResponse>, QueryKey<Options<PostAdminPipelineCandidatesFilterData>>, number | Pick<QueryKey<Options<PostAdminPipelineCandidatesFilterData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PostAdminPipelineCandidatesFilterData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                body: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await postAdminPipelineCandidatesFilter({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postAdminPipelineCandidatesFilterInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Post Admin Pipeline Candidates Filter
 *
 * POST /api/v2/pipelines/{pipeline_uuid}/candidates/filter
 */
export const postAdminPipelineCandidatesFilterMutation = (options?: Partial<Options<PostAdminPipelineCandidatesFilterData>>): UseMutationOptions<PostAdminPipelineCandidatesFilterResponse, AxiosError<PostAdminPipelineCandidatesFilterError>, Options<PostAdminPipelineCandidatesFilterData>> => {
    const mutationOptions: UseMutationOptions<PostAdminPipelineCandidatesFilterResponse, AxiosError<PostAdminPipelineCandidatesFilterError>, Options<PostAdminPipelineCandidatesFilterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postAdminPipelineCandidatesFilter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postPipelineTransferToTeamQueryKey = (options: Options<PostPipelineTransferToTeamData>) => createQueryKey('postPipelineTransferToTeam', options);

/**
 * Post Pipeline Transfer To Team
 *
 * POST /api/v2/admin/pipelines/transfer-to-team
 *
 * Transfer pipelines to another team.
 *
 * Updates (ORM-style for automatic ES sync):
 * - Pipeline.search_team_id
 * - Pipeline.company (set to target team's company name; cleared when the
 * target is an executive personal team, whose internal account-company
 * name must not surface on the pipeline)
 * - Pipeline.point_of_contact_person_id (set to NULL)
 * - SubmissionCandidate.search_team_id and team_uuid
 *
 * Updates (bulk SQL - no event listeners):
 * - RecommendationComment.team_uuid (comments move with the pipeline)
 * - Feedback.team_id and team_uuid
 * - InternalRecommendationComment.team_uuid
 * - EvaluationHistory.team_uuid
 *
 * Preserves:
 * - Pipeline.creator_person_id
 * - RecommendationComment author, content and timestamps (only team_uuid moves)
 *
 * Blocked if pipeline has:
 * - Pending RequestedIntro (introduced IS NULL - must be resolved first)
 *
 * Transfers:
 * - Completed RequestedIntro records (introduced IS NOT NULL) get team_id updated
 *
 * ES indices are automatically updated via event listeners:
 * - pipelines index: via Pipeline model listener
 * - recommendations index: via SubmissionCandidate model listener (rebuilt from
 * post-commit DB state, so it also reflects the moved comments)
 *
 * The team_candidates and candidates indices are not refreshed by this endpoint
 * (pre-existing behavior for moved recommendations); reindex them if the stale
 * (candidate, source team) rollups matter.
 */
export const postPipelineTransferToTeamOptions = (options: Options<PostPipelineTransferToTeamData>) => queryOptions<PostPipelineTransferToTeamResponse, AxiosError<PostPipelineTransferToTeamError>, PostPipelineTransferToTeamResponse, ReturnType<typeof postPipelineTransferToTeamQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postPipelineTransferToTeam({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postPipelineTransferToTeamQueryKey(options)
});

/**
 * Post Pipeline Transfer To Team
 *
 * POST /api/v2/admin/pipelines/transfer-to-team
 *
 * Transfer pipelines to another team.
 *
 * Updates (ORM-style for automatic ES sync):
 * - Pipeline.search_team_id
 * - Pipeline.company (set to target team's company name; cleared when the
 * target is an executive personal team, whose internal account-company
 * name must not surface on the pipeline)
 * - Pipeline.point_of_contact_person_id (set to NULL)
 * - SubmissionCandidate.search_team_id and team_uuid
 *
 * Updates (bulk SQL - no event listeners):
 * - RecommendationComment.team_uuid (comments move with the pipeline)
 * - Feedback.team_id and team_uuid
 * - InternalRecommendationComment.team_uuid
 * - EvaluationHistory.team_uuid
 *
 * Preserves:
 * - Pipeline.creator_person_id
 * - RecommendationComment author, content and timestamps (only team_uuid moves)
 *
 * Blocked if pipeline has:
 * - Pending RequestedIntro (introduced IS NULL - must be resolved first)
 *
 * Transfers:
 * - Completed RequestedIntro records (introduced IS NOT NULL) get team_id updated
 *
 * ES indices are automatically updated via event listeners:
 * - pipelines index: via Pipeline model listener
 * - recommendations index: via SubmissionCandidate model listener (rebuilt from
 * post-commit DB state, so it also reflects the moved comments)
 *
 * The team_candidates and candidates indices are not refreshed by this endpoint
 * (pre-existing behavior for moved recommendations); reindex them if the stale
 * (candidate, source team) rollups matter.
 */
export const postPipelineTransferToTeamMutation = (options?: Partial<Options<PostPipelineTransferToTeamData>>): UseMutationOptions<PostPipelineTransferToTeamResponse, AxiosError<PostPipelineTransferToTeamError>, Options<PostPipelineTransferToTeamData>> => {
    const mutationOptions: UseMutationOptions<PostPipelineTransferToTeamResponse, AxiosError<PostPipelineTransferToTeamError>, Options<PostPipelineTransferToTeamData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postPipelineTransferToTeam({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Patch User Role Remove Company
 *
 * PATCH /api/v2/admin/users/{person_uuid}/roles/{role_id}/remove-company
 *
 * Remove company association from an ANYMEMBR or APPADMIN role.
 * Sets company_id to None for the specified role.
 */
export const patchUserRoleRemoveCompanyMutation = (options?: Partial<Options<PatchUserRoleRemoveCompanyData>>): UseMutationOptions<PatchUserRoleRemoveCompanyResponse, AxiosError<PatchUserRoleRemoveCompanyError>, Options<PatchUserRoleRemoveCompanyData>> => {
    const mutationOptions: UseMutationOptions<PatchUserRoleRemoveCompanyResponse, AxiosError<PatchUserRoleRemoveCompanyError>, Options<PatchUserRoleRemoveCompanyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchUserRoleRemoveCompany({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Patch User
 *
 * PATCH /api/v2/admin/users/{person_uuid}
 *
 * Update user/person fields. All fields are optional - only provided fields will be updated.
 */
export const patchUserMutation = (options?: Partial<Options<PatchUserData>>): UseMutationOptions<PatchUserResponse, AxiosError<PatchUserError>, Options<PatchUserData>> => {
    const mutationOptions: UseMutationOptions<PatchUserResponse, AxiosError<PatchUserError>, Options<PatchUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postUserCompanyQueryKey = (options: Options<PostUserCompanyData>) => createQueryKey('postUserCompany', options);

/**
 * Post User Company
 *
 * POST /api/v2/admin/users/{person_uuid}/company
 *
 * Put a login in a company: the ANYMEMBR role with that company. No
 * invitation is sent. A login belongs to one company at a time, so this is
 * refused while it has one; remove its team roles, then its company role,
 * first. A leftover ANYMEMBR role with no company (what removing a company
 * leaves) is filled in rather than joined by a second one. An admin's or
 * an executive's login is refused.
 */
export const postUserCompanyOptions = (options: Options<PostUserCompanyData>) => queryOptions<PostUserCompanyResponse, AxiosError<PostUserCompanyError>, PostUserCompanyResponse, ReturnType<typeof postUserCompanyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postUserCompany({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postUserCompanyQueryKey(options)
});

/**
 * Post User Company
 *
 * POST /api/v2/admin/users/{person_uuid}/company
 *
 * Put a login in a company: the ANYMEMBR role with that company. No
 * invitation is sent. A login belongs to one company at a time, so this is
 * refused while it has one; remove its team roles, then its company role,
 * first. A leftover ANYMEMBR role with no company (what removing a company
 * leaves) is filled in rather than joined by a second one. An admin's or
 * an executive's login is refused.
 */
export const postUserCompanyMutation = (options?: Partial<Options<PostUserCompanyData>>): UseMutationOptions<PostUserCompanyResponse, AxiosError<PostUserCompanyError>, Options<PostUserCompanyData>> => {
    const mutationOptions: UseMutationOptions<PostUserCompanyResponse, AxiosError<PostUserCompanyError>, Options<PostUserCompanyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postUserCompany({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postUserTeamQueryKey = (options: Options<PostUserTeamData>) => createQueryKey('postUserTeam', options);

/**
 * Post User Team
 *
 * POST /api/v2/admin/users/{person_uuid}/teams
 *
 * Give a login a seat on a team, as a member or (``lead``) a lead, with the
 * role that fits the team's company type. No invitation is sent. The team
 * must belong to the login's company; a login with no company joins the
 * team's. An admin's or an executive's login is refused.
 */
export const postUserTeamOptions = (options: Options<PostUserTeamData>) => queryOptions<PostUserTeamResponse, AxiosError<PostUserTeamError>, PostUserTeamResponse, ReturnType<typeof postUserTeamQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postUserTeam({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postUserTeamQueryKey(options)
});

/**
 * Post User Team
 *
 * POST /api/v2/admin/users/{person_uuid}/teams
 *
 * Give a login a seat on a team, as a member or (``lead``) a lead, with the
 * role that fits the team's company type. No invitation is sent. The team
 * must belong to the login's company; a login with no company joins the
 * team's. An admin's or an executive's login is refused.
 */
export const postUserTeamMutation = (options?: Partial<Options<PostUserTeamData>>): UseMutationOptions<PostUserTeamResponse, AxiosError<PostUserTeamError>, Options<PostUserTeamData>> => {
    const mutationOptions: UseMutationOptions<PostUserTeamResponse, AxiosError<PostUserTeamError>, Options<PostUserTeamData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postUserTeam({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Candidate Company Metadata
 *
 * DELETE /api/v2/admin/companies/{company_id}/candidates/{candidate_uuid}/metadata
 */
export const deleteCandidateCompanyMetadataMutation = (options?: Partial<Options<DeleteCandidateCompanyMetadataData>>): UseMutationOptions<DeleteCandidateCompanyMetadataResponse, AxiosError<DeleteCandidateCompanyMetadataError>, Options<DeleteCandidateCompanyMetadataData>> => {
    const mutationOptions: UseMutationOptions<DeleteCandidateCompanyMetadataResponse, AxiosError<DeleteCandidateCompanyMetadataError>, Options<DeleteCandidateCompanyMetadataData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteCandidateCompanyMetadata({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCandidateCompanyMetadataQueryKey = (options: Options<GetCandidateCompanyMetadataData>) => createQueryKey('getCandidateCompanyMetadata', options);

/**
 * Get Candidate Company Metadata
 *
 * GET /api/v2/admin/companies/{company_id}/candidates/{candidate_uuid}/metadata
 */
export const getCandidateCompanyMetadataOptions = (options: Options<GetCandidateCompanyMetadataData>) => queryOptions<GetCandidateCompanyMetadataResponse, AxiosError<GetCandidateCompanyMetadataError>, GetCandidateCompanyMetadataResponse, ReturnType<typeof getCandidateCompanyMetadataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCandidateCompanyMetadata({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCandidateCompanyMetadataQueryKey(options)
});

export const upsertCandidateCompanyMetadataQueryKey = (options: Options<UpsertCandidateCompanyMetadataData>) => createQueryKey('upsertCandidateCompanyMetadata', options);

/**
 * Upsert Candidate Company Metadata
 *
 * POST /api/v2/admin/companies/{company_id}/candidates/{candidate_uuid}/metadata
 *
 * ``custom_keywords`` are applied via company tag vocabulary + associations,
 * then projected onto this row (and Elasticsearch) like member tag routes.
 */
export const upsertCandidateCompanyMetadataOptions = (options: Options<UpsertCandidateCompanyMetadataData>) => queryOptions<UpsertCandidateCompanyMetadataResponse, AxiosError<UpsertCandidateCompanyMetadataError>, UpsertCandidateCompanyMetadataResponse, ReturnType<typeof upsertCandidateCompanyMetadataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await upsertCandidateCompanyMetadata({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: upsertCandidateCompanyMetadataQueryKey(options)
});

/**
 * Upsert Candidate Company Metadata
 *
 * POST /api/v2/admin/companies/{company_id}/candidates/{candidate_uuid}/metadata
 *
 * ``custom_keywords`` are applied via company tag vocabulary + associations,
 * then projected onto this row (and Elasticsearch) like member tag routes.
 */
export const upsertCandidateCompanyMetadataMutation = (options?: Partial<Options<UpsertCandidateCompanyMetadataData>>): UseMutationOptions<UpsertCandidateCompanyMetadataResponse, AxiosError<UpsertCandidateCompanyMetadataError>, Options<UpsertCandidateCompanyMetadataData>> => {
    const mutationOptions: UseMutationOptions<UpsertCandidateCompanyMetadataResponse, AxiosError<UpsertCandidateCompanyMetadataError>, Options<UpsertCandidateCompanyMetadataData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await upsertCandidateCompanyMetadata({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const importCandidateCompanyMetadataQueryKey = (options: Options<ImportCandidateCompanyMetadataData>) => createQueryKey('importCandidateCompanyMetadata', options);

/**
 * Import Candidate Company Metadata
 *
 * POST /api/v2/admin/companies/{company_id}/candidate-metadata/import
 *
 * Batch-import company-scoped tags and comments for existing candidates.
 * The client parses CSV/spreadsheet rows and sends them in ``rows``.
 *
 * Each row requires ``candidate_uuid`` (resolved on the client), plus
 * ``custom_keywords`` and/or ``custom_notes``.
 */
export const importCandidateCompanyMetadataOptions = (options: Options<ImportCandidateCompanyMetadataData>) => queryOptions<ImportCandidateCompanyMetadataResponse, AxiosError<ImportCandidateCompanyMetadataError>, ImportCandidateCompanyMetadataResponse, ReturnType<typeof importCandidateCompanyMetadataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await importCandidateCompanyMetadata({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: importCandidateCompanyMetadataQueryKey(options)
});

/**
 * Import Candidate Company Metadata
 *
 * POST /api/v2/admin/companies/{company_id}/candidate-metadata/import
 *
 * Batch-import company-scoped tags and comments for existing candidates.
 * The client parses CSV/spreadsheet rows and sends them in ``rows``.
 *
 * Each row requires ``candidate_uuid`` (resolved on the client), plus
 * ``custom_keywords`` and/or ``custom_notes``.
 */
export const importCandidateCompanyMetadataMutation = (options?: Partial<Options<ImportCandidateCompanyMetadataData>>): UseMutationOptions<ImportCandidateCompanyMetadataResponse, AxiosError<ImportCandidateCompanyMetadataError>, Options<ImportCandidateCompanyMetadataData>> => {
    const mutationOptions: UseMutationOptions<ImportCandidateCompanyMetadataResponse, AxiosError<ImportCandidateCompanyMetadataError>, Options<ImportCandidateCompanyMetadataData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await importCandidateCompanyMetadata({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listCandidateCompanyMetadataQueryKey = (options: Options<ListCandidateCompanyMetadataData>) => createQueryKey('listCandidateCompanyMetadata', options);

/**
 * List Candidate Company Metadata
 *
 * GET /api/v2/admin/companies/{company_id}/candidate-metadata
 *
 * Returns active company-scoped metadata rows with an embedded candidate
 * summary. Sorted by ``last_modified`` descending. Rows whose candidate no
 * longer exists are omitted.
 */
export const listCandidateCompanyMetadataOptions = (options: Options<ListCandidateCompanyMetadataData>) => queryOptions<ListCandidateCompanyMetadataResponse, AxiosError<ListCandidateCompanyMetadataError>, ListCandidateCompanyMetadataResponse, ReturnType<typeof listCandidateCompanyMetadataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listCandidateCompanyMetadata({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listCandidateCompanyMetadataQueryKey(options)
});

export const listCandidateCompanyMetadataInfiniteQueryKey = (options: Options<ListCandidateCompanyMetadataData>): QueryKey<Options<ListCandidateCompanyMetadataData>> => createQueryKey('listCandidateCompanyMetadata', options, true);

/**
 * List Candidate Company Metadata
 *
 * GET /api/v2/admin/companies/{company_id}/candidate-metadata
 *
 * Returns active company-scoped metadata rows with an embedded candidate
 * summary. Sorted by ``last_modified`` descending. Rows whose candidate no
 * longer exists are omitted.
 */
export const listCandidateCompanyMetadataInfiniteOptions = (options: Options<ListCandidateCompanyMetadataData>) => {
    const opts = infiniteQueryOptions<ListCandidateCompanyMetadataResponse, AxiosError<ListCandidateCompanyMetadataError>, InfiniteData<ListCandidateCompanyMetadataResponse>, QueryKey<Options<ListCandidateCompanyMetadataData>>, number | Pick<QueryKey<Options<ListCandidateCompanyMetadataData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListCandidateCompanyMetadataData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listCandidateCompanyMetadata({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listCandidateCompanyMetadataInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const postCompanyPeopleFilterQueryKey = (options: Options<PostCompanyPeopleFilterData>) => createQueryKey('postCompanyPeopleFilter', options);

/**
 * Post Company People Filter
 *
 * POST /api/v2/admin/companies/{company_id}/people/filter
 *
 * Company-scoped people list combining metadata prep rows and candidates
 * shared on any company team (pipeline or trending recommendations).
 */
export const postCompanyPeopleFilterOptions = (options: Options<PostCompanyPeopleFilterData>) => queryOptions<PostCompanyPeopleFilterResponse, AxiosError<PostCompanyPeopleFilterError>, PostCompanyPeopleFilterResponse, ReturnType<typeof postCompanyPeopleFilterQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postCompanyPeopleFilter({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postCompanyPeopleFilterQueryKey(options)
});

export const postCompanyPeopleFilterInfiniteQueryKey = (options: Options<PostCompanyPeopleFilterData>): QueryKey<Options<PostCompanyPeopleFilterData>> => createQueryKey('postCompanyPeopleFilter', options, true);

/**
 * Post Company People Filter
 *
 * POST /api/v2/admin/companies/{company_id}/people/filter
 *
 * Company-scoped people list combining metadata prep rows and candidates
 * shared on any company team (pipeline or trending recommendations).
 */
export const postCompanyPeopleFilterInfiniteOptions = (options: Options<PostCompanyPeopleFilterData>) => {
    const opts = infiniteQueryOptions<PostCompanyPeopleFilterResponse, AxiosError<PostCompanyPeopleFilterError>, InfiniteData<PostCompanyPeopleFilterResponse>, QueryKey<Options<PostCompanyPeopleFilterData>>, number | Pick<QueryKey<Options<PostCompanyPeopleFilterData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PostCompanyPeopleFilterData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                body: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await postCompanyPeopleFilter({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postCompanyPeopleFilterInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Post Company People Filter
 *
 * POST /api/v2/admin/companies/{company_id}/people/filter
 *
 * Company-scoped people list combining metadata prep rows and candidates
 * shared on any company team (pipeline or trending recommendations).
 */
export const postCompanyPeopleFilterMutation = (options?: Partial<Options<PostCompanyPeopleFilterData>>): UseMutationOptions<PostCompanyPeopleFilterResponse, AxiosError<PostCompanyPeopleFilterError>, Options<PostCompanyPeopleFilterData>> => {
    const mutationOptions: UseMutationOptions<PostCompanyPeopleFilterResponse, AxiosError<PostCompanyPeopleFilterError>, Options<PostCompanyPeopleFilterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCompanyPeopleFilter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postActivateExecutiveQueryKey = (options: Options<PostActivateExecutiveData>) => createQueryKey('postActivateExecutive', options);

/**
 * Post Activate Executive
 *
 * POST /api/v2/admin/executives/{candidate_uuid}/activate
 *
 * Activate an executive candidate for platform access.
 * Creates Person + ExecutiveSettings + Clerk invitation.
 * Idempotent: returns existing settings if already activated.
 */
export const postActivateExecutiveOptions = (options: Options<PostActivateExecutiveData>) => queryOptions<PostActivateExecutiveResponse, AxiosError<PostActivateExecutiveError>, PostActivateExecutiveResponse, ReturnType<typeof postActivateExecutiveQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postActivateExecutive({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postActivateExecutiveQueryKey(options)
});

/**
 * Post Activate Executive
 *
 * POST /api/v2/admin/executives/{candidate_uuid}/activate
 *
 * Activate an executive candidate for platform access.
 * Creates Person + ExecutiveSettings + Clerk invitation.
 * Idempotent: returns existing settings if already activated.
 */
export const postActivateExecutiveMutation = (options?: Partial<Options<PostActivateExecutiveData>>): UseMutationOptions<PostActivateExecutiveResponse, AxiosError<PostActivateExecutiveError>, Options<PostActivateExecutiveData>> => {
    const mutationOptions: UseMutationOptions<PostActivateExecutiveResponse, AxiosError<PostActivateExecutiveError>, Options<PostActivateExecutiveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postActivateExecutive({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postBulkActivateExecutivesQueryKey = (options: Options<PostBulkActivateExecutivesData>) => createQueryKey('postBulkActivateExecutives', options);

/**
 * Post Bulk Activate Executives
 *
 * POST /api/v2/admin/executives/bulk-activate
 *
 * Activate a batch of executive candidates by UUID. Per-candidate failures
 * are reported in the response without aborting the batch.
 */
export const postBulkActivateExecutivesOptions = (options: Options<PostBulkActivateExecutivesData>) => queryOptions<PostBulkActivateExecutivesResponse, AxiosError<PostBulkActivateExecutivesError>, PostBulkActivateExecutivesResponse, ReturnType<typeof postBulkActivateExecutivesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postBulkActivateExecutives({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postBulkActivateExecutivesQueryKey(options)
});

/**
 * Post Bulk Activate Executives
 *
 * POST /api/v2/admin/executives/bulk-activate
 *
 * Activate a batch of executive candidates by UUID. Per-candidate failures
 * are reported in the response without aborting the batch.
 */
export const postBulkActivateExecutivesMutation = (options?: Partial<Options<PostBulkActivateExecutivesData>>): UseMutationOptions<PostBulkActivateExecutivesResponse, AxiosError<PostBulkActivateExecutivesError>, Options<PostBulkActivateExecutivesData>> => {
    const mutationOptions: UseMutationOptions<PostBulkActivateExecutivesResponse, AxiosError<PostBulkActivateExecutivesError>, Options<PostBulkActivateExecutivesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postBulkActivateExecutives({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Executive Activation
 *
 * DELETE /api/v2/admin/executives/{person_uuid}/activation
 *
 * Undo a silent activation: deletes ExecutiveSettings and the
 * EXECUTIVE/EXECLEAD roles, deactivates the exec's empty personal team,
 * and deactivates the person if activation created it (no Clerk login,
 * no other roles). The candidate<->person link is untouched.
 *
 * 409 when the invitation was already sent, or when the exec team still
 * owns pipelines/recommendations (transfer them away first).
 */
export const deleteExecutiveActivationMutation = (options?: Partial<Options<DeleteExecutiveActivationData>>): UseMutationOptions<DeleteExecutiveActivationResponse, AxiosError<DeleteExecutiveActivationError>, Options<DeleteExecutiveActivationData>> => {
    const mutationOptions: UseMutationOptions<DeleteExecutiveActivationResponse, AxiosError<DeleteExecutiveActivationError>, Options<DeleteExecutiveActivationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteExecutiveActivation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postSendExecutiveInvitationQueryKey = (options: Options<PostSendExecutiveInvitationData>) => createQueryKey('postSendExecutiveInvitation', options);

/**
 * Post Send Executive Invitation
 *
 * POST /api/v2/admin/executives/{person_uuid}/send-invitation
 *
 * Send (or resend) the Clerk invitation email to an already-activated
 * executive. On resend, revokes the prior Clerk invitation and replaces
 * it so only one live invite exists at a time.
 */
export const postSendExecutiveInvitationOptions = (options: Options<PostSendExecutiveInvitationData>) => queryOptions<PostSendExecutiveInvitationResponse, AxiosError<PostSendExecutiveInvitationError>, PostSendExecutiveInvitationResponse, ReturnType<typeof postSendExecutiveInvitationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postSendExecutiveInvitation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postSendExecutiveInvitationQueryKey(options)
});

/**
 * Post Send Executive Invitation
 *
 * POST /api/v2/admin/executives/{person_uuid}/send-invitation
 *
 * Send (or resend) the Clerk invitation email to an already-activated
 * executive. On resend, revokes the prior Clerk invitation and replaces
 * it so only one live invite exists at a time.
 */
export const postSendExecutiveInvitationMutation = (options?: Partial<Options<PostSendExecutiveInvitationData>>): UseMutationOptions<PostSendExecutiveInvitationResponse, AxiosError<PostSendExecutiveInvitationError>, Options<PostSendExecutiveInvitationData>> => {
    const mutationOptions: UseMutationOptions<PostSendExecutiveInvitationResponse, AxiosError<PostSendExecutiveInvitationError>, Options<PostSendExecutiveInvitationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postSendExecutiveInvitation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getExecutivesQueryKey = (options?: Options<GetExecutivesData>) => createQueryKey('getExecutives', options);

/**
 * Get Executives
 *
 * GET /api/v2/admin/executives
 *
 * List all activated executives.
 */
export const getExecutivesOptions = (options?: Options<GetExecutivesData>) => queryOptions<GetExecutivesResponse, AxiosError<DefaultError>, GetExecutivesResponse, ReturnType<typeof getExecutivesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getExecutives({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getExecutivesQueryKey(options)
});

export const getExecutiveQueryKey = (options: Options<GetExecutiveData>) => createQueryKey('getExecutive', options);

/**
 * Get Executive
 *
 * GET /api/v2/admin/executives/{person_uuid}
 *
 * Get a specific executive by person UUID.
 */
export const getExecutiveOptions = (options: Options<GetExecutiveData>) => queryOptions<GetExecutiveResponse, AxiosError<GetExecutiveError>, GetExecutiveResponse, ReturnType<typeof getExecutiveQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getExecutive({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getExecutiveQueryKey(options)
});

/**
 * Patch Executive Settings
 *
 * PATCH /api/v2/admin/executives/{person_uuid}/settings
 *
 * Update executive settings and/or login email.
 */
export const patchExecutiveSettingsMutation = (options?: Partial<Options<PatchExecutiveSettingsData>>): UseMutationOptions<PatchExecutiveSettingsResponse, AxiosError<PatchExecutiveSettingsError>, Options<PatchExecutiveSettingsData>> => {
    const mutationOptions: UseMutationOptions<PatchExecutiveSettingsResponse, AxiosError<PatchExecutiveSettingsError>, Options<PatchExecutiveSettingsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchExecutiveSettings({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getExecutiveClientSettingsQueryKey = (options: Options<GetExecutiveClientSettingsData>) => createQueryKey('getExecutiveClientSettings', options);

/**
 * Get Executive Client Settings
 *
 * GET /api/v2/clients/{person_uuid}/settings
 *
 * View executive profile and preferences.
 */
export const getExecutiveClientSettingsOptions = (options: Options<GetExecutiveClientSettingsData>) => queryOptions<GetExecutiveClientSettingsResponse, AxiosError<GetExecutiveClientSettingsError>, GetExecutiveClientSettingsResponse, ReturnType<typeof getExecutiveClientSettingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getExecutiveClientSettings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getExecutiveClientSettingsQueryKey(options)
});

/**
 * Patch Executive Client Settings
 *
 * PATCH /api/v2/clients/{person_uuid}/settings
 *
 * Update executive-editable settings (name, email, email preferences).
 */
export const patchExecutiveClientSettingsMutation = (options?: Partial<Options<PatchExecutiveClientSettingsData>>): UseMutationOptions<PatchExecutiveClientSettingsResponse, AxiosError<PatchExecutiveClientSettingsError>, Options<PatchExecutiveClientSettingsData>> => {
    const mutationOptions: UseMutationOptions<PatchExecutiveClientSettingsResponse, AxiosError<PatchExecutiveClientSettingsError>, Options<PatchExecutiveClientSettingsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchExecutiveClientSettings({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getExecutiveClientTeamQueryKey = (options: Options<GetExecutiveClientTeamData>) => createQueryKey('getExecutiveClientTeam', options);

/**
 * Get Executive Client Team
 *
 * GET /api/v2/clients/{person_uuid}/team
 *
 * Return the exec's personal SearchTeam UUID, creating it lazily on first call.
 * The returned team_uuid is used with the standard team pipeline endpoints.
 */
export const getExecutiveClientTeamOptions = (options: Options<GetExecutiveClientTeamData>) => queryOptions<GetExecutiveClientTeamResponse, AxiosError<GetExecutiveClientTeamError>, GetExecutiveClientTeamResponse, ReturnType<typeof getExecutiveClientTeamQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getExecutiveClientTeam({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getExecutiveClientTeamQueryKey(options)
});

export const postExecutiveClientContactPipelinesQueryKey = (options: Options<PostExecutiveClientContactPipelinesData>) => createQueryKey('postExecutiveClientContactPipelines', options);

/**
 * Post Executive Client Contact Pipelines
 *
 * POST /api/v2/clients/{person_uuid}/contacts/{contact_uuid}/pipelines
 *
 * Add one of the exec's own contacts to one or more of their own requests.
 *
 * The team-scoped equivalent requires the candidate to already have a published
 * recommendation on the team, which is never true for the events, P2P and
 * referral contacts that make up most of an exec's network — so it 404s and the
 * exec cannot add their own contacts to their own requests. Here the exec having
 * the contact resolves that, and pipelines are still constrained to the exec's
 * own team by ``add_candidate_to_pipelines``.
 *
 * The actor is the caller, not the exec, so an advisor acting on the exec's
 * behalf is recorded as themselves.
 */
export const postExecutiveClientContactPipelinesOptions = (options: Options<PostExecutiveClientContactPipelinesData>) => queryOptions<PostExecutiveClientContactPipelinesResponse, AxiosError<PostExecutiveClientContactPipelinesError>, PostExecutiveClientContactPipelinesResponse, ReturnType<typeof postExecutiveClientContactPipelinesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postExecutiveClientContactPipelines({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postExecutiveClientContactPipelinesQueryKey(options)
});

/**
 * Post Executive Client Contact Pipelines
 *
 * POST /api/v2/clients/{person_uuid}/contacts/{contact_uuid}/pipelines
 *
 * Add one of the exec's own contacts to one or more of their own requests.
 *
 * The team-scoped equivalent requires the candidate to already have a published
 * recommendation on the team, which is never true for the events, P2P and
 * referral contacts that make up most of an exec's network — so it 404s and the
 * exec cannot add their own contacts to their own requests. Here the exec having
 * the contact resolves that, and pipelines are still constrained to the exec's
 * own team by ``add_candidate_to_pipelines``.
 *
 * The actor is the caller, not the exec, so an advisor acting on the exec's
 * behalf is recorded as themselves.
 */
export const postExecutiveClientContactPipelinesMutation = (options?: Partial<Options<PostExecutiveClientContactPipelinesData>>): UseMutationOptions<PostExecutiveClientContactPipelinesResponse, AxiosError<PostExecutiveClientContactPipelinesError>, Options<PostExecutiveClientContactPipelinesData>> => {
    const mutationOptions: UseMutationOptions<PostExecutiveClientContactPipelinesResponse, AxiosError<PostExecutiveClientContactPipelinesError>, Options<PostExecutiveClientContactPipelinesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postExecutiveClientContactPipelines({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getExecutiveClientPersonDetailQueryKey = (options: Options<GetExecutiveClientPersonDetailData>) => createQueryKey('getExecutiveClientPersonDetail', options);

/**
 * Get Executive Client Person Detail
 *
 * GET /api/v2/clients/{person_uuid}/people/{contact_person_uuid}
 *
 * Return detail for a person-only contact (no candidate record) when that person
 * appears in the executive's gathered contacts.
 *
 * Deprecated: use the unified
 * ``GET /api/v2/clients/{person_uuid}/contacts/{contact_uuid}`` instead, which
 * returns this person under ``person`` alongside the canonical contact fields.
 *
 * @deprecated
 */
export const getExecutiveClientPersonDetailOptions = (options: Options<GetExecutiveClientPersonDetailData>) => queryOptions<GetExecutiveClientPersonDetailResponse, AxiosError<GetExecutiveClientPersonDetailError>, GetExecutiveClientPersonDetailResponse, ReturnType<typeof getExecutiveClientPersonDetailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getExecutiveClientPersonDetail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getExecutiveClientPersonDetailQueryKey(options)
});

export const postExecutiveClientPeopleSearchQueryKey = (options: Options<PostExecutiveClientPeopleSearchData>) => createQueryKey('postExecutiveClientPeopleSearch', options);

/**
 * Post Executive Client People Search
 *
 * POST /api/v2/clients/{person_uuid}/people/search
 *
 * Search and sort the exec's contacts across all sources
 * (P2P, events, B4B intros, referrals).
 * Contacts with a candidate record are searched via the candidates index.
 * Person-only contacts (no candidate record) are searched via the people index.
 * All results are merged before sorting and pagination so that both work
 * across the full combined set.
 */
export const postExecutiveClientPeopleSearchOptions = (options: Options<PostExecutiveClientPeopleSearchData>) => queryOptions<PostExecutiveClientPeopleSearchResponse, AxiosError<PostExecutiveClientPeopleSearchError>, PostExecutiveClientPeopleSearchResponse, ReturnType<typeof postExecutiveClientPeopleSearchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postExecutiveClientPeopleSearch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postExecutiveClientPeopleSearchQueryKey(options)
});

export const postExecutiveClientPeopleSearchInfiniteQueryKey = (options: Options<PostExecutiveClientPeopleSearchData>): QueryKey<Options<PostExecutiveClientPeopleSearchData>> => createQueryKey('postExecutiveClientPeopleSearch', options, true);

/**
 * Post Executive Client People Search
 *
 * POST /api/v2/clients/{person_uuid}/people/search
 *
 * Search and sort the exec's contacts across all sources
 * (P2P, events, B4B intros, referrals).
 * Contacts with a candidate record are searched via the candidates index.
 * Person-only contacts (no candidate record) are searched via the people index.
 * All results are merged before sorting and pagination so that both work
 * across the full combined set.
 */
export const postExecutiveClientPeopleSearchInfiniteOptions = (options: Options<PostExecutiveClientPeopleSearchData>) => {
    const opts = infiniteQueryOptions<PostExecutiveClientPeopleSearchResponse, AxiosError<PostExecutiveClientPeopleSearchError>, InfiniteData<PostExecutiveClientPeopleSearchResponse>, QueryKey<Options<PostExecutiveClientPeopleSearchData>>, number | Pick<QueryKey<Options<PostExecutiveClientPeopleSearchData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PostExecutiveClientPeopleSearchData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                body: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await postExecutiveClientPeopleSearch({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postExecutiveClientPeopleSearchInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Post Executive Client People Search
 *
 * POST /api/v2/clients/{person_uuid}/people/search
 *
 * Search and sort the exec's contacts across all sources
 * (P2P, events, B4B intros, referrals).
 * Contacts with a candidate record are searched via the candidates index.
 * Person-only contacts (no candidate record) are searched via the people index.
 * All results are merged before sorting and pagination so that both work
 * across the full combined set.
 */
export const postExecutiveClientPeopleSearchMutation = (options?: Partial<Options<PostExecutiveClientPeopleSearchData>>): UseMutationOptions<PostExecutiveClientPeopleSearchResponse, AxiosError<PostExecutiveClientPeopleSearchError>, Options<PostExecutiveClientPeopleSearchData>> => {
    const mutationOptions: UseMutationOptions<PostExecutiveClientPeopleSearchResponse, AxiosError<PostExecutiveClientPeopleSearchError>, Options<PostExecutiveClientPeopleSearchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postExecutiveClientPeopleSearch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getExecutiveClientCandidateQueryKey = (options: Options<GetExecutiveClientCandidateData>) => createQueryKey('getExecutiveClientCandidate', options);

/**
 * Get Executive Client Candidate
 *
 * GET /api/v2/clients/{person_uuid}/candidates/{candidate_uuid}
 *
 * Same payload as ``GET /api/v2/teams/{team_uuid}/candidates/{candidate_uuid}`` for
 * the executive's personal team, when the candidate appears in their people list
 * (``gather_contacts``).
 *
 * Deprecated: use the unified
 * ``GET /api/v2/clients/{person_uuid}/contacts/{contact_uuid}`` instead, which
 * embeds this candidate profile under ``candidate`` and also exposes the
 * canonical ``was_introduced`` / ``is_favorite`` fields.
 *
 * @deprecated
 */
export const getExecutiveClientCandidateOptions = (options: Options<GetExecutiveClientCandidateData>) => queryOptions<GetExecutiveClientCandidateResponse, AxiosError<GetExecutiveClientCandidateError>, GetExecutiveClientCandidateResponse, ReturnType<typeof getExecutiveClientCandidateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getExecutiveClientCandidate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getExecutiveClientCandidateQueryKey(options)
});

export const getExecutiveClientContactQueryKey = (options: Options<GetExecutiveClientContactData>) => createQueryKey('getExecutiveClientContact', options);

/**
 * Get Executive Client Contact
 *
 * GET /api/v2/clients/{person_uuid}/contacts/{contact_uuid}
 *
 * Unified detail for one of the exec's contacts. ``contact_uuid`` accepts
 * either a ``Person.uuid`` or a ``ContenderCandidate.uuid`` (the People page
 * returns both kinds). Returns one canonical envelope exposing
 * ``was_introduced`` / ``is_favorite`` / gated ``email`` / ``source_types`` /
 * ``personal_tags`` consistently, embedding the full candidate profile and/or
 * the linked person when present.
 */
export const getExecutiveClientContactOptions = (options: Options<GetExecutiveClientContactData>) => queryOptions<GetExecutiveClientContactResponse, AxiosError<GetExecutiveClientContactError>, GetExecutiveClientContactResponse, ReturnType<typeof getExecutiveClientContactQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getExecutiveClientContact({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getExecutiveClientContactQueryKey(options)
});

export const getExecutiveClientTrendingQueryKey = (options: Options<GetExecutiveClientTrendingData>) => createQueryKey('getExecutiveClientTrending', options);

/**
 * Get Executive Client Trending
 *
 * GET /api/v2/clients/{person_uuid}/trending
 *
 * Return Banff-curated trending candidates published to the exec's personal
 * SearchTeam.
 */
export const getExecutiveClientTrendingOptions = (options: Options<GetExecutiveClientTrendingData>) => queryOptions<GetExecutiveClientTrendingResponse, AxiosError<GetExecutiveClientTrendingError>, GetExecutiveClientTrendingResponse, ReturnType<typeof getExecutiveClientTrendingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getExecutiveClientTrending({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getExecutiveClientTrendingQueryKey(options)
});

export const getExecutiveClientTrendingRecommendationQueryKey = (options: Options<GetExecutiveClientTrendingRecommendationData>) => createQueryKey('getExecutiveClientTrendingRecommendation', options);

/**
 * Get Executive Client Trending Recommendation
 *
 * GET /api/v2/clients/{person_uuid}/trending/{recommendation_uuid}
 *
 * Return a single trending recommendation published to the exec's personal
 * SearchTeam. Mirrors `GET /api/v2/teams/{team_uuid}/trending/{rec}` but
 * scopes to the exec's ghost team instead of an arbitrary team slug.
 */
export const getExecutiveClientTrendingRecommendationOptions = (options: Options<GetExecutiveClientTrendingRecommendationData>) => queryOptions<GetExecutiveClientTrendingRecommendationResponse, AxiosError<GetExecutiveClientTrendingRecommendationError>, GetExecutiveClientTrendingRecommendationResponse, ReturnType<typeof getExecutiveClientTrendingRecommendationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getExecutiveClientTrendingRecommendation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getExecutiveClientTrendingRecommendationQueryKey(options)
});

export const postAdminExecutiveClientActivityQueryKey = (options: Options<PostAdminExecutiveClientActivityData>) => createQueryKey('postAdminExecutiveClientActivity', options);

/**
 * Post Admin Executive Client Activity
 *
 * POST /api/v2/clients/{person_uuid}/activity
 *
 * Admin-only full activity feed for an executive client.
 */
export const postAdminExecutiveClientActivityOptions = (options: Options<PostAdminExecutiveClientActivityData>) => queryOptions<PostAdminExecutiveClientActivityResponse, AxiosError<PostAdminExecutiveClientActivityError>, PostAdminExecutiveClientActivityResponse, ReturnType<typeof postAdminExecutiveClientActivityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postAdminExecutiveClientActivity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postAdminExecutiveClientActivityQueryKey(options)
});

export const postAdminExecutiveClientActivityInfiniteQueryKey = (options: Options<PostAdminExecutiveClientActivityData>): QueryKey<Options<PostAdminExecutiveClientActivityData>> => createQueryKey('postAdminExecutiveClientActivity', options, true);

/**
 * Post Admin Executive Client Activity
 *
 * POST /api/v2/clients/{person_uuid}/activity
 *
 * Admin-only full activity feed for an executive client.
 */
export const postAdminExecutiveClientActivityInfiniteOptions = (options: Options<PostAdminExecutiveClientActivityData>) => {
    const opts = infiniteQueryOptions<PostAdminExecutiveClientActivityResponse, AxiosError<PostAdminExecutiveClientActivityError>, InfiniteData<PostAdminExecutiveClientActivityResponse>, QueryKey<Options<PostAdminExecutiveClientActivityData>>, number | Pick<QueryKey<Options<PostAdminExecutiveClientActivityData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PostAdminExecutiveClientActivityData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                body: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await postAdminExecutiveClientActivity({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postAdminExecutiveClientActivityInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Post Admin Executive Client Activity
 *
 * POST /api/v2/clients/{person_uuid}/activity
 *
 * Admin-only full activity feed for an executive client.
 */
export const postAdminExecutiveClientActivityMutation = (options?: Partial<Options<PostAdminExecutiveClientActivityData>>): UseMutationOptions<PostAdminExecutiveClientActivityResponse, AxiosError<PostAdminExecutiveClientActivityError>, Options<PostAdminExecutiveClientActivityData>> => {
    const mutationOptions: UseMutationOptions<PostAdminExecutiveClientActivityResponse, AxiosError<PostAdminExecutiveClientActivityError>, Options<PostAdminExecutiveClientActivityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postAdminExecutiveClientActivity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postExecutiveClientActivityQueryKey = (options: Options<PostExecutiveClientActivityData>) => createQueryKey('postExecutiveClientActivity', options);

/**
 * Post Executive Client Activity
 *
 * POST /api/v2/clients/{person_uuid}/contacts/{contact_uuid}/activity
 *
 * Unified activity feed for the exec. Mixes `CandidateActivityLog` rows
 * with synthetic items from connection-source models (events attended,
 * P2P intros, B4B pipeline intros, uploaded-network referrals), narrowed
 * to interactions involving the path `contact_uuid`.
 * `contact_uuid` accepts either a `Person.uuid` or a
 * `ContenderCandidate.uuid` — the People-page returns both kinds.
 * Items are ordered by `date` DESC. Pagination is body-driven via
 * `page` / `size`.
 */
export const postExecutiveClientActivityOptions = (options: Options<PostExecutiveClientActivityData>) => queryOptions<PostExecutiveClientActivityResponse, AxiosError<PostExecutiveClientActivityError>, PostExecutiveClientActivityResponse, ReturnType<typeof postExecutiveClientActivityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postExecutiveClientActivity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postExecutiveClientActivityQueryKey(options)
});

export const postExecutiveClientActivityInfiniteQueryKey = (options: Options<PostExecutiveClientActivityData>): QueryKey<Options<PostExecutiveClientActivityData>> => createQueryKey('postExecutiveClientActivity', options, true);

/**
 * Post Executive Client Activity
 *
 * POST /api/v2/clients/{person_uuid}/contacts/{contact_uuid}/activity
 *
 * Unified activity feed for the exec. Mixes `CandidateActivityLog` rows
 * with synthetic items from connection-source models (events attended,
 * P2P intros, B4B pipeline intros, uploaded-network referrals), narrowed
 * to interactions involving the path `contact_uuid`.
 * `contact_uuid` accepts either a `Person.uuid` or a
 * `ContenderCandidate.uuid` — the People-page returns both kinds.
 * Items are ordered by `date` DESC. Pagination is body-driven via
 * `page` / `size`.
 */
export const postExecutiveClientActivityInfiniteOptions = (options: Options<PostExecutiveClientActivityData>) => {
    const opts = infiniteQueryOptions<PostExecutiveClientActivityResponse, AxiosError<PostExecutiveClientActivityError>, InfiniteData<PostExecutiveClientActivityResponse>, QueryKey<Options<PostExecutiveClientActivityData>>, number | Pick<QueryKey<Options<PostExecutiveClientActivityData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PostExecutiveClientActivityData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                body: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await postExecutiveClientActivity({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postExecutiveClientActivityInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Post Executive Client Activity
 *
 * POST /api/v2/clients/{person_uuid}/contacts/{contact_uuid}/activity
 *
 * Unified activity feed for the exec. Mixes `CandidateActivityLog` rows
 * with synthetic items from connection-source models (events attended,
 * P2P intros, B4B pipeline intros, uploaded-network referrals), narrowed
 * to interactions involving the path `contact_uuid`.
 * `contact_uuid` accepts either a `Person.uuid` or a
 * `ContenderCandidate.uuid` — the People-page returns both kinds.
 * Items are ordered by `date` DESC. Pagination is body-driven via
 * `page` / `size`.
 */
export const postExecutiveClientActivityMutation = (options?: Partial<Options<PostExecutiveClientActivityData>>): UseMutationOptions<PostExecutiveClientActivityResponse, AxiosError<PostExecutiveClientActivityError>, Options<PostExecutiveClientActivityData>> => {
    const mutationOptions: UseMutationOptions<PostExecutiveClientActivityResponse, AxiosError<PostExecutiveClientActivityError>, Options<PostExecutiveClientActivityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postExecutiveClientActivity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listExecutiveClientEventsQueryKey = (options: Options<ListExecutiveClientEventsData>) => createQueryKey('listExecutiveClientEvents', options);

/**
 * List Executive Client Events
 *
 * GET /api/v2/clients/{person_uuid}/events
 *
 * List the published events the executive is a guest of (any date),
 * paginated and sortable by event date or event name. Each item carries the
 * same event info and the exec's own RSVP status as the detail view, plus
 * headline attendee counts — without the per-attendee detail the detail
 * endpoint returns.
 */
export const listExecutiveClientEventsOptions = (options: Options<ListExecutiveClientEventsData>) => queryOptions<ListExecutiveClientEventsResponse, AxiosError<ListExecutiveClientEventsError>, ListExecutiveClientEventsResponse, ReturnType<typeof listExecutiveClientEventsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listExecutiveClientEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listExecutiveClientEventsQueryKey(options)
});

export const listExecutiveClientEventsInfiniteQueryKey = (options: Options<ListExecutiveClientEventsData>): QueryKey<Options<ListExecutiveClientEventsData>> => createQueryKey('listExecutiveClientEvents', options, true);

/**
 * List Executive Client Events
 *
 * GET /api/v2/clients/{person_uuid}/events
 *
 * List the published events the executive is a guest of (any date),
 * paginated and sortable by event date or event name. Each item carries the
 * same event info and the exec's own RSVP status as the detail view, plus
 * headline attendee counts — without the per-attendee detail the detail
 * endpoint returns.
 */
export const listExecutiveClientEventsInfiniteOptions = (options: Options<ListExecutiveClientEventsData>) => {
    const opts = infiniteQueryOptions<ListExecutiveClientEventsResponse, AxiosError<ListExecutiveClientEventsError>, InfiniteData<ListExecutiveClientEventsResponse>, QueryKey<Options<ListExecutiveClientEventsData>>, number | Pick<QueryKey<Options<ListExecutiveClientEventsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListExecutiveClientEventsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listExecutiveClientEvents({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listExecutiveClientEventsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getExecutiveClientEventQueryKey = (options: Options<GetExecutiveClientEventData>) => createQueryKey('getExecutiveClientEvent', options);

/**
 * Get Executive Client Event
 *
 * GET /api/v2/clients/{person_uuid}/events/{event_uuid}
 *
 * View a published event the executive is a guest of (any date). Returns the
 * public event detail plus an attendee list scoped by the rules in
 * :class:`ExecutiveClientEventResponse`.
 */
export const getExecutiveClientEventOptions = (options: Options<GetExecutiveClientEventData>) => queryOptions<GetExecutiveClientEventResponse, AxiosError<GetExecutiveClientEventError>, GetExecutiveClientEventResponse, ReturnType<typeof getExecutiveClientEventQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getExecutiveClientEvent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getExecutiveClientEventQueryKey(options)
});

/**
 * Update Executive Client Event Rsvp
 *
 * PATCH /api/v2/clients/{person_uuid}/events/{event_uuid}/rsvp
 *
 * Set the executive's own RSVP (going / cant_go) for a published event they
 * are a guest of. An exec may RSVP regardless of invite state — the invite
 * email is only a notification; visibility implies the right to respond.
 *
 * Guards mirror the public token flow: the event must be published (enforced
 * by the loader), have RSVP enabled, and not have already started.
 */
export const updateExecutiveClientEventRsvpMutation = (options?: Partial<Options<UpdateExecutiveClientEventRsvpData>>): UseMutationOptions<UpdateExecutiveClientEventRsvpResponse, AxiosError<UpdateExecutiveClientEventRsvpError>, Options<UpdateExecutiveClientEventRsvpData>> => {
    const mutationOptions: UseMutationOptions<UpdateExecutiveClientEventRsvpResponse, AxiosError<UpdateExecutiveClientEventRsvpError>, Options<UpdateExecutiveClientEventRsvpData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateExecutiveClientEventRsvp({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postPeopleV2QueryKey = (options: Options<PostPeopleV2Data>) => createQueryKey('postPeopleV2', options);

/**
 * Post People V2
 *
 * POST /api/v2/people
 */
export const postPeopleV2Options = (options: Options<PostPeopleV2Data>) => queryOptions<PostPeopleV2Response, AxiosError<PostPeopleV2Error>, PostPeopleV2Response, ReturnType<typeof postPeopleV2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postPeopleV2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postPeopleV2QueryKey(options)
});

/**
 * Post People V2
 *
 * POST /api/v2/people
 */
export const postPeopleV2Mutation = (options?: Partial<Options<PostPeopleV2Data>>): UseMutationOptions<PostPeopleV2Response, AxiosError<PostPeopleV2Error>, Options<PostPeopleV2Data>> => {
    const mutationOptions: UseMutationOptions<PostPeopleV2Response, AxiosError<PostPeopleV2Error>, Options<PostPeopleV2Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postPeopleV2({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const updatePersonMetadataV2QueryKey = (options: Options<UpdatePersonMetadataV2Data>) => createQueryKey('updatePersonMetadataV2', options);

/**
 * Update Person Metadata V2
 *
 * POST /api/v2/people/metadata
 */
export const updatePersonMetadataV2Options = (options: Options<UpdatePersonMetadataV2Data>) => queryOptions<UpdatePersonMetadataV2Response, AxiosError<UpdatePersonMetadataV2Error>, UpdatePersonMetadataV2Response, ReturnType<typeof updatePersonMetadataV2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await updatePersonMetadataV2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: updatePersonMetadataV2QueryKey(options)
});

/**
 * Update Person Metadata V2
 *
 * POST /api/v2/people/metadata
 */
export const updatePersonMetadataV2Mutation = (options?: Partial<Options<UpdatePersonMetadataV2Data>>): UseMutationOptions<UpdatePersonMetadataV2Response, AxiosError<UpdatePersonMetadataV2Error>, Options<UpdatePersonMetadataV2Data>> => {
    const mutationOptions: UseMutationOptions<UpdatePersonMetadataV2Response, AxiosError<UpdatePersonMetadataV2Error>, Options<UpdatePersonMetadataV2Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updatePersonMetadataV2({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Patch People Current
 *
 * PATCH /api/v2/people/current
 *
 * Self-service update for external person fields. Response shape matches GET
 * ``/people/current``.
 */
export const patchPeopleCurrentMutation = (options?: Partial<Options<PatchPeopleCurrentData>>): UseMutationOptions<PatchPeopleCurrentResponse, AxiosError<PatchPeopleCurrentError>, Options<PatchPeopleCurrentData>> => {
    const mutationOptions: UseMutationOptions<PatchPeopleCurrentResponse, AxiosError<PatchPeopleCurrentError>, Options<PatchPeopleCurrentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchPeopleCurrent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Put People Current Password
 *
 * PUT /api/v2/people/current/password
 *
 * Self-service Clerk password update for the authenticated user.
 */
export const putPeopleCurrentPasswordMutation = (options?: Partial<Options<PutPeopleCurrentPasswordData>>): UseMutationOptions<PutPeopleCurrentPasswordResponse, AxiosError<PutPeopleCurrentPasswordError>, Options<PutPeopleCurrentPasswordData>> => {
    const mutationOptions: UseMutationOptions<PutPeopleCurrentPasswordResponse, AxiosError<PutPeopleCurrentPasswordError>, Options<PutPeopleCurrentPasswordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putPeopleCurrentPassword({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postPersonClerkUserQueryKey = (options: Options<PostPersonClerkUserData>) => createQueryKey('postPersonClerkUser', options);

/**
 * Post Person Clerk User
 *
 * Create a Clerk user for an existing person record.
 */
export const postPersonClerkUserOptions = (options: Options<PostPersonClerkUserData>) => queryOptions<PostPersonClerkUserResponse2, AxiosError<PostPersonClerkUserError>, PostPersonClerkUserResponse2, ReturnType<typeof postPersonClerkUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postPersonClerkUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postPersonClerkUserQueryKey(options)
});

/**
 * Post Person Clerk User
 *
 * Create a Clerk user for an existing person record.
 */
export const postPersonClerkUserMutation = (options?: Partial<Options<PostPersonClerkUserData>>): UseMutationOptions<PostPersonClerkUserResponse2, AxiosError<PostPersonClerkUserError>, Options<PostPersonClerkUserData>> => {
    const mutationOptions: UseMutationOptions<PostPersonClerkUserResponse2, AxiosError<PostPersonClerkUserError>, Options<PostPersonClerkUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postPersonClerkUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Patch Person Email Notifications
 *
 * PATCH /api/v2/people/{person_uuid}/email-notifications
 *
 * Enable or disable preregistration notifications for a person.
 *
 * Admin-only endpoint to control whether pending users receive preregistration emails.
 */
export const patchPersonEmailNotificationsMutation = (options?: Partial<Options<PatchPersonEmailNotificationsData>>): UseMutationOptions<PatchPersonEmailNotificationsResponse, AxiosError<PatchPersonEmailNotificationsError>, Options<PatchPersonEmailNotificationsData>> => {
    const mutationOptions: UseMutationOptions<PatchPersonEmailNotificationsResponse, AxiosError<PatchPersonEmailNotificationsError>, Options<PatchPersonEmailNotificationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchPersonEmailNotifications({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Patch Person
 *
 * PATCH /api/v2/people/{person_uuid}
 *
 * Partially update person fields.
 */
export const patchPersonMutation = (options?: Partial<Options<PatchPersonData>>): UseMutationOptions<PatchPersonResponse, AxiosError<PatchPersonError>, Options<PatchPersonData>> => {
    const mutationOptions: UseMutationOptions<PatchPersonResponse, AxiosError<PatchPersonError>, Options<PatchPersonData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchPerson({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPeopleInternalQueryKey = (options?: Options<GetPeopleInternalData>) => createQueryKey('getPeopleInternal', options);

/**
 * Get People Internal
 *
 * GET /api/v2/people/internal/customer_success - Get all Banff team members (APPADMIN role)
 */
export const getPeopleInternalOptions = (options?: Options<GetPeopleInternalData>) => queryOptions<GetPeopleInternalResponse, AxiosError<DefaultError>, GetPeopleInternalResponse, ReturnType<typeof getPeopleInternalQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPeopleInternal({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPeopleInternalQueryKey(options)
});

export const resolvePersonCandidateByEmailQueryKey = (options: Options<ResolvePersonCandidateByEmailData>) => createQueryKey('resolvePersonCandidateByEmail', options);

/**
 * Resolve Person Candidate By Email
 *
 * POST /api/v2/people/resolve-by-email
 *
 * Advisor-only lookup that resolves an email to `person_uuid` and/or
 * `candidate_uuid` in one request.
 */
export const resolvePersonCandidateByEmailOptions = (options: Options<ResolvePersonCandidateByEmailData>) => queryOptions<ResolvePersonCandidateByEmailResponse2, AxiosError<ResolvePersonCandidateByEmailError>, ResolvePersonCandidateByEmailResponse2, ReturnType<typeof resolvePersonCandidateByEmailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await resolvePersonCandidateByEmail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: resolvePersonCandidateByEmailQueryKey(options)
});

/**
 * Resolve Person Candidate By Email
 *
 * POST /api/v2/people/resolve-by-email
 *
 * Advisor-only lookup that resolves an email to `person_uuid` and/or
 * `candidate_uuid` in one request.
 */
export const resolvePersonCandidateByEmailMutation = (options?: Partial<Options<ResolvePersonCandidateByEmailData>>): UseMutationOptions<ResolvePersonCandidateByEmailResponse2, AxiosError<ResolvePersonCandidateByEmailError>, Options<ResolvePersonCandidateByEmailData>> => {
    const mutationOptions: UseMutationOptions<ResolvePersonCandidateByEmailResponse2, AxiosError<ResolvePersonCandidateByEmailError>, Options<ResolvePersonCandidateByEmailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resolvePersonCandidateByEmail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listPersonContactTagsQueryKey = (options: Options<ListPersonContactTagsData>) => createQueryKey('listPersonContactTags', options);

/**
 * List Person Contact Tags
 *
 * GET /api/v2/people/{person_uuid}/contacts/tags — list this person's tag vocabulary.
 */
export const listPersonContactTagsOptions = (options: Options<ListPersonContactTagsData>) => queryOptions<ListPersonContactTagsResponse, AxiosError<ListPersonContactTagsError>, ListPersonContactTagsResponse, ReturnType<typeof listPersonContactTagsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPersonContactTags({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPersonContactTagsQueryKey(options)
});

export const createPersonContactTagDefinitionQueryKey = (options: Options<CreatePersonContactTagDefinitionData>) => createQueryKey('createPersonContactTagDefinition', options);

/**
 * Create Person Contact Tag Definition
 *
 * POST /api/v2/people/{person_uuid}/contacts/tags — create a tag label (vocabulary only).
 */
export const createPersonContactTagDefinitionOptions = (options: Options<CreatePersonContactTagDefinitionData>) => queryOptions<CreatePersonContactTagDefinitionResponse, AxiosError<CreatePersonContactTagDefinitionError>, CreatePersonContactTagDefinitionResponse, ReturnType<typeof createPersonContactTagDefinitionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await createPersonContactTagDefinition({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: createPersonContactTagDefinitionQueryKey(options)
});

/**
 * Create Person Contact Tag Definition
 *
 * POST /api/v2/people/{person_uuid}/contacts/tags — create a tag label (vocabulary only).
 */
export const createPersonContactTagDefinitionMutation = (options?: Partial<Options<CreatePersonContactTagDefinitionData>>): UseMutationOptions<CreatePersonContactTagDefinitionResponse, AxiosError<CreatePersonContactTagDefinitionError>, Options<CreatePersonContactTagDefinitionData>> => {
    const mutationOptions: UseMutationOptions<CreatePersonContactTagDefinitionResponse, AxiosError<CreatePersonContactTagDefinitionError>, Options<CreatePersonContactTagDefinitionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createPersonContactTagDefinition({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Person Contact Tag Definition
 *
 * DELETE .../contacts/tags/{tag_definition_uuid} — remove tag and associations.
 */
export const deletePersonContactTagDefinitionMutation = (options?: Partial<Options<DeletePersonContactTagDefinitionData>>): UseMutationOptions<DeletePersonContactTagDefinitionResponse, AxiosError<DeletePersonContactTagDefinitionError>, Options<DeletePersonContactTagDefinitionData>> => {
    const mutationOptions: UseMutationOptions<DeletePersonContactTagDefinitionResponse, AxiosError<DeletePersonContactTagDefinitionError>, Options<DeletePersonContactTagDefinitionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deletePersonContactTagDefinition({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Patch Person Contact Tag Definition
 *
 * PATCH /api/v2/people/{person_uuid}/contacts/tags/{tag_definition_uuid} — rename a tag.
 */
export const patchPersonContactTagDefinitionMutation = (options?: Partial<Options<PatchPersonContactTagDefinitionData>>): UseMutationOptions<PatchPersonContactTagDefinitionResponse, AxiosError<PatchPersonContactTagDefinitionError>, Options<PatchPersonContactTagDefinitionData>> => {
    const mutationOptions: UseMutationOptions<PatchPersonContactTagDefinitionResponse, AxiosError<PatchPersonContactTagDefinitionError>, Options<PatchPersonContactTagDefinitionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchPersonContactTagDefinition({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const addPersonContactTagQueryKey = (options: Options<AddPersonContactTagData>) => createQueryKey('addPersonContactTag', options);

/**
 * Add Person Contact Tag
 *
 * POST .../contacts/{contact_uuid}/tags — link one tag to a contact.
 */
export const addPersonContactTagOptions = (options: Options<AddPersonContactTagData>) => queryOptions<AddPersonContactTagResponse, AxiosError<AddPersonContactTagError>, AddPersonContactTagResponse, ReturnType<typeof addPersonContactTagQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await addPersonContactTag({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: addPersonContactTagQueryKey(options)
});

/**
 * Add Person Contact Tag
 *
 * POST .../contacts/{contact_uuid}/tags — link one tag to a contact.
 */
export const addPersonContactTagMutation = (options?: Partial<Options<AddPersonContactTagData>>): UseMutationOptions<AddPersonContactTagResponse, AxiosError<AddPersonContactTagError>, Options<AddPersonContactTagData>> => {
    const mutationOptions: UseMutationOptions<AddPersonContactTagResponse, AxiosError<AddPersonContactTagError>, Options<AddPersonContactTagData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addPersonContactTag({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Person Contact Tag
 *
 * DELETE /api/v2/people/{person_uuid}/contacts/{contact_uuid}/tags/{tag_definition_uuid}.
 */
export const removePersonContactTagMutation = (options?: Partial<Options<RemovePersonContactTagData>>): UseMutationOptions<RemovePersonContactTagResponse, AxiosError<RemovePersonContactTagError>, Options<RemovePersonContactTagData>> => {
    const mutationOptions: UseMutationOptions<RemovePersonContactTagResponse, AxiosError<RemovePersonContactTagError>, Options<RemovePersonContactTagData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removePersonContactTag({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postPersonContactFavoriteQueryKey = (options: Options<PostPersonContactFavoriteData>) => createQueryKey('postPersonContactFavorite', options);

/**
 * Post Person Contact Favorite
 *
 * POST /api/v2/people/{person_uuid}/contacts/{contact_uuid}/favorite
 *
 * Scoped to ``user:only-self``: favorites are owned by the person whose feed
 * they appear on, and the people feed reads ``is_favorite`` for that person.
 * Advisors are deliberately not allowed to favorite on behalf of an exec —
 * an advisor's favorite would be stored under the advisor and never surface
 * in the exec's feed, so the action is blocked rather than silently lost.
 */
export const postPersonContactFavoriteOptions = (options: Options<PostPersonContactFavoriteData>) => queryOptions<PostPersonContactFavoriteResponse, AxiosError<PostPersonContactFavoriteError>, PostPersonContactFavoriteResponse, ReturnType<typeof postPersonContactFavoriteQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postPersonContactFavorite({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postPersonContactFavoriteQueryKey(options)
});

/**
 * Post Person Contact Favorite
 *
 * POST /api/v2/people/{person_uuid}/contacts/{contact_uuid}/favorite
 *
 * Scoped to ``user:only-self``: favorites are owned by the person whose feed
 * they appear on, and the people feed reads ``is_favorite`` for that person.
 * Advisors are deliberately not allowed to favorite on behalf of an exec —
 * an advisor's favorite would be stored under the advisor and never surface
 * in the exec's feed, so the action is blocked rather than silently lost.
 */
export const postPersonContactFavoriteMutation = (options?: Partial<Options<PostPersonContactFavoriteData>>): UseMutationOptions<PostPersonContactFavoriteResponse, AxiosError<PostPersonContactFavoriteError>, Options<PostPersonContactFavoriteData>> => {
    const mutationOptions: UseMutationOptions<PostPersonContactFavoriteResponse, AxiosError<PostPersonContactFavoriteError>, Options<PostPersonContactFavoriteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postPersonContactFavorite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUserEventsQueryKey = (options: Options<GetUserEventsData>) => createQueryKey('getUserEvents', options);

/**
 * Get User Events
 *
 * List events where this user (person) is a guest. Optionally filter by
 * event_date bounds. Sorted by event_date (direction via sort_event_date),
 * then created descending.
 */
export const getUserEventsOptions = (options: Options<GetUserEventsData>) => queryOptions<GetUserEventsResponse, AxiosError<GetUserEventsError>, GetUserEventsResponse, ReturnType<typeof getUserEventsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserEventsQueryKey(options)
});

export const getUserEventsInfiniteQueryKey = (options: Options<GetUserEventsData>): QueryKey<Options<GetUserEventsData>> => createQueryKey('getUserEvents', options, true);

/**
 * Get User Events
 *
 * List events where this user (person) is a guest. Optionally filter by
 * event_date bounds. Sorted by event_date (direction via sort_event_date),
 * then created descending.
 */
export const getUserEventsInfiniteOptions = (options: Options<GetUserEventsData>) => {
    const opts = infiniteQueryOptions<GetUserEventsResponse, AxiosError<GetUserEventsError>, InfiniteData<GetUserEventsResponse>, QueryKey<Options<GetUserEventsData>>, number | Pick<QueryKey<Options<GetUserEventsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetUserEventsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getUserEvents({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getUserEventsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Delete User V2
 *
 * DELETE /api/v2/users/{user_uuid}
 *
 * Deletes a user only when they are not currently a member of any team or
 * company (no PersonRole with team/company foreign keys). Any person can be
 * deleted, whether or not they appear in the Users list.
 */
export const deleteUserV2Mutation = (options?: Partial<Options<DeleteUserV2Data>>): UseMutationOptions<DeleteUserV2Response, AxiosError<DeleteUserV2Error>, Options<DeleteUserV2Data>> => {
    const mutationOptions: UseMutationOptions<DeleteUserV2Response, AxiosError<DeleteUserV2Error>, Options<DeleteUserV2Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteUserV2({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUserV2QueryKey = (options: Options<GetUserV2Data>) => createQueryKey('getUserV2', options);

/**
 * Get User V2
 *
 * GET /api/v2/users/{user_uuid}
 *
 * Returns detailed information about a single user including their roles,
 * company, and teams.
 */
export const getUserV2Options = (options: Options<GetUserV2Data>) => queryOptions<GetUserV2Response, AxiosError<GetUserV2Error>, GetUserV2Response, ReturnType<typeof getUserV2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserV2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserV2QueryKey(options)
});

export const postUsersBulkDeleteV2QueryKey = (options: Options<PostUsersBulkDeleteV2Data>) => createQueryKey('postUsersBulkDeleteV2', options);

/**
 * Post Users Bulk Delete V2
 *
 * POST /api/v2/users/bulk-delete
 *
 * Deletes each listed person under the same rules as
 * DELETE /api/v2/users/{user_uuid}, one commit per person, so one refusal does
 * not undo the others. Choosing the rows is the caller's job.
 */
export const postUsersBulkDeleteV2Options = (options: Options<PostUsersBulkDeleteV2Data>) => queryOptions<PostUsersBulkDeleteV2Response, AxiosError<PostUsersBulkDeleteV2Error>, PostUsersBulkDeleteV2Response, ReturnType<typeof postUsersBulkDeleteV2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postUsersBulkDeleteV2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postUsersBulkDeleteV2QueryKey(options)
});

/**
 * Post Users Bulk Delete V2
 *
 * POST /api/v2/users/bulk-delete
 *
 * Deletes each listed person under the same rules as
 * DELETE /api/v2/users/{user_uuid}, one commit per person, so one refusal does
 * not undo the others. Choosing the rows is the caller's job.
 */
export const postUsersBulkDeleteV2Mutation = (options?: Partial<Options<PostUsersBulkDeleteV2Data>>): UseMutationOptions<PostUsersBulkDeleteV2Response, AxiosError<PostUsersBulkDeleteV2Error>, Options<PostUsersBulkDeleteV2Data>> => {
    const mutationOptions: UseMutationOptions<PostUsersBulkDeleteV2Response, AxiosError<PostUsersBulkDeleteV2Error>, Options<PostUsersBulkDeleteV2Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postUsersBulkDeleteV2({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postUsersSearchV2QueryKey = (options?: Options<PostUsersSearchV2Data>) => createQueryKey('postUsersSearchV2', options);

/**
 * Post Users Search V2
 *
 * POST /api/v2/users/search
 *
 * Elasticsearch-backed users list/search with highlights.
 *
 * Phrase search (with highlights), filtering, sorting and pagination are served by
 * the ``people`` index; the response payload is hydrated from Postgres. Company
 * filtering is resolved in the DB and intersected with ES results, and sorting by
 * ``teams_count`` or ``last_login`` uses a DB hybrid path.
 */
export const postUsersSearchV2Options = (options?: Options<PostUsersSearchV2Data>) => queryOptions<PostUsersSearchV2Response, AxiosError<PostUsersSearchV2Error>, PostUsersSearchV2Response, ReturnType<typeof postUsersSearchV2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postUsersSearchV2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postUsersSearchV2QueryKey(options)
});

export const postUsersSearchV2InfiniteQueryKey = (options?: Options<PostUsersSearchV2Data>): QueryKey<Options<PostUsersSearchV2Data>> => createQueryKey('postUsersSearchV2', options, true);

/**
 * Post Users Search V2
 *
 * POST /api/v2/users/search
 *
 * Elasticsearch-backed users list/search with highlights.
 *
 * Phrase search (with highlights), filtering, sorting and pagination are served by
 * the ``people`` index; the response payload is hydrated from Postgres. Company
 * filtering is resolved in the DB and intersected with ES results, and sorting by
 * ``teams_count`` or ``last_login`` uses a DB hybrid path.
 */
export const postUsersSearchV2InfiniteOptions = (options?: Options<PostUsersSearchV2Data>) => {
    const opts = infiniteQueryOptions<PostUsersSearchV2Response, AxiosError<PostUsersSearchV2Error>, InfiniteData<PostUsersSearchV2Response>, QueryKey<Options<PostUsersSearchV2Data>>, number | Pick<QueryKey<Options<PostUsersSearchV2Data>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PostUsersSearchV2Data>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                body: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await postUsersSearchV2({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postUsersSearchV2InfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Post Users Search V2
 *
 * POST /api/v2/users/search
 *
 * Elasticsearch-backed users list/search with highlights.
 *
 * Phrase search (with highlights), filtering, sorting and pagination are served by
 * the ``people`` index; the response payload is hydrated from Postgres. Company
 * filtering is resolved in the DB and intersected with ES results, and sorting by
 * ``teams_count`` or ``last_login`` uses a DB hybrid path.
 */
export const postUsersSearchV2Mutation = (options?: Partial<Options<PostUsersSearchV2Data>>): UseMutationOptions<PostUsersSearchV2Response, AxiosError<PostUsersSearchV2Error>, Options<PostUsersSearchV2Data>> => {
    const mutationOptions: UseMutationOptions<PostUsersSearchV2Response, AxiosError<PostUsersSearchV2Error>, Options<PostUsersSearchV2Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postUsersSearchV2({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listEmailTemplatesQueryKey = (options?: Options<ListEmailTemplatesData>) => createQueryKey('listEmailTemplates', options);

/**
 * List Email Templates
 *
 * List email templates with pagination. Admin only.
 * Optionally filter by template_type.
 */
export const listEmailTemplatesOptions = (options?: Options<ListEmailTemplatesData>) => queryOptions<ListEmailTemplatesResponse, AxiosError<ListEmailTemplatesError>, ListEmailTemplatesResponse, ReturnType<typeof listEmailTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listEmailTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listEmailTemplatesQueryKey(options)
});

export const listEmailTemplatesInfiniteQueryKey = (options?: Options<ListEmailTemplatesData>): QueryKey<Options<ListEmailTemplatesData>> => createQueryKey('listEmailTemplates', options, true);

/**
 * List Email Templates
 *
 * List email templates with pagination. Admin only.
 * Optionally filter by template_type.
 */
export const listEmailTemplatesInfiniteOptions = (options?: Options<ListEmailTemplatesData>) => {
    const opts = infiniteQueryOptions<ListEmailTemplatesResponse, AxiosError<ListEmailTemplatesError>, InfiniteData<ListEmailTemplatesResponse>, QueryKey<Options<ListEmailTemplatesData>>, number | Pick<QueryKey<Options<ListEmailTemplatesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListEmailTemplatesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listEmailTemplates({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listEmailTemplatesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const createEmailTemplateQueryKey = (options: Options<CreateEmailTemplateData>) => createQueryKey('createEmailTemplate', options);

/**
 * Create Email Template
 *
 * Create a new shared email template. Admin only. A type can have several;
 * which one is the default is chosen with PUT /defaults/{template_type}.
 * 422 when the text uses a placeholder the type does not have.
 */
export const createEmailTemplateOptions = (options: Options<CreateEmailTemplateData>) => queryOptions<CreateEmailTemplateResponse, AxiosError<CreateEmailTemplateError>, CreateEmailTemplateResponse, ReturnType<typeof createEmailTemplateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await createEmailTemplate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: createEmailTemplateQueryKey(options)
});

/**
 * Create Email Template
 *
 * Create a new shared email template. Admin only. A type can have several;
 * which one is the default is chosen with PUT /defaults/{template_type}.
 * 422 when the text uses a placeholder the type does not have.
 */
export const createEmailTemplateMutation = (options?: Partial<Options<CreateEmailTemplateData>>): UseMutationOptions<CreateEmailTemplateResponse, AxiosError<CreateEmailTemplateError>, Options<CreateEmailTemplateData>> => {
    const mutationOptions: UseMutationOptions<CreateEmailTemplateResponse, AxiosError<CreateEmailTemplateError>, Options<CreateEmailTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createEmailTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listEmailTemplateDefaultsQueryKey = (options?: Options<ListEmailTemplateDefaultsData>) => createQueryKey('listEmailTemplateDefaults', options);

/**
 * List Email Template Defaults
 *
 * The default template of each type that has one.
 */
export const listEmailTemplateDefaultsOptions = (options?: Options<ListEmailTemplateDefaultsData>) => queryOptions<ListEmailTemplateDefaultsResponse, AxiosError<ListEmailTemplateDefaultsError>, ListEmailTemplateDefaultsResponse, ReturnType<typeof listEmailTemplateDefaultsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listEmailTemplateDefaults({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listEmailTemplateDefaultsQueryKey(options)
});

/**
 * Delete Email Template Default
 *
 * Delete the default template of a type, leaving the type without one.
 * Sends that would use it then refuse, and RSVP confirmations are not sent.
 * A default an email was sent from is hidden instead of deleted.
 */
export const deleteEmailTemplateDefaultMutation = (options?: Partial<Options<DeleteEmailTemplateDefaultData>>): UseMutationOptions<DeleteEmailTemplateDefaultResponse, AxiosError<DeleteEmailTemplateDefaultError>, Options<DeleteEmailTemplateDefaultData>> => {
    const mutationOptions: UseMutationOptions<DeleteEmailTemplateDefaultResponse, AxiosError<DeleteEmailTemplateDefaultError>, Options<DeleteEmailTemplateDefaultData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteEmailTemplateDefault({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Put Email Template Default
 *
 * Write the default template of a type. Event emails use it when the event
 * has no template of its own of that type.
 *
 * Edits the current default, or creates one when the type has none. Like any
 * template, a default an email was sent from is replaced by a new version
 * when edited; it stays the default. 422 when the text uses a placeholder
 * the type does not have.
 */
export const putEmailTemplateDefaultMutation = (options?: Partial<Options<PutEmailTemplateDefaultData>>): UseMutationOptions<PutEmailTemplateDefaultResponse, AxiosError<PutEmailTemplateDefaultError>, Options<PutEmailTemplateDefaultData>> => {
    const mutationOptions: UseMutationOptions<PutEmailTemplateDefaultResponse, AxiosError<PutEmailTemplateDefaultError>, Options<PutEmailTemplateDefaultData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putEmailTemplateDefault({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Email Template
 *
 * Delete an email template. Admin only. A template an email was sent from is
 * hidden instead, so the email history can still show what was sent. Deleting
 * a type's default leaves the type without one.
 */
export const deleteEmailTemplateMutation = (options?: Partial<Options<DeleteEmailTemplateData>>): UseMutationOptions<DeleteEmailTemplateResponse, AxiosError<DeleteEmailTemplateError>, Options<DeleteEmailTemplateData>> => {
    const mutationOptions: UseMutationOptions<DeleteEmailTemplateResponse, AxiosError<DeleteEmailTemplateError>, Options<DeleteEmailTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteEmailTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getEmailTemplateQueryKey = (options: Options<GetEmailTemplateData>) => createQueryKey('getEmailTemplate', options);

/**
 * Get Email Template
 *
 * Get a single email template by UUID. Admin only.
 */
export const getEmailTemplateOptions = (options: Options<GetEmailTemplateData>) => queryOptions<GetEmailTemplateResponse, AxiosError<GetEmailTemplateError>, GetEmailTemplateResponse, ReturnType<typeof getEmailTemplateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEmailTemplate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEmailTemplateQueryKey(options)
});

/**
 * Update Email Template
 *
 * Update an email template. Admin only. Only provided fields are updated.
 *
 * Changes the template in place until an email has been sent from it. After
 * that, the old version is hidden and the response is a new template, with a
 * new uuid, holding the new text.
 */
export const updateEmailTemplateMutation = (options?: Partial<Options<UpdateEmailTemplateData>>): UseMutationOptions<UpdateEmailTemplateResponse, AxiosError<UpdateEmailTemplateError>, Options<UpdateEmailTemplateData>> => {
    const mutationOptions: UseMutationOptions<UpdateEmailTemplateResponse, AxiosError<UpdateEmailTemplateError>, Options<UpdateEmailTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateEmailTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listEmailTypesQueryKey = (options?: Options<ListEmailTypesData>) => createQueryKey('listEmailTypes', options);

/**
 * List Email Types
 *
 * Every kind of email Contender sends (the types in sent_email), with its
 * category and, for types that can be edited as templates, the placeholders a
 * template may use. The list is defined in code; this shows what it holds.
 * Types rendered in Contender list their template variants under previews.
 */
export const listEmailTypesOptions = (options?: Options<ListEmailTypesData>) => queryOptions<ListEmailTypesResponse, AxiosError<DefaultError>, ListEmailTypesResponse, ReturnType<typeof listEmailTypesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listEmailTypes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listEmailTypesQueryKey(options)
});

export const getEmailPreviewQueryKey = (options: Options<GetEmailPreviewData>) => createQueryKey('getEmailPreview', options);

/**
 * Get Email Preview
 *
 * GET /api/v2/email-types/previews/{key}
 *
 * One template variant rendered with fixed sample values: its subject and
 * HTML, exactly as the send renders them. Links point at this app. Nothing is
 * stored and nothing is sent.
 */
export const getEmailPreviewOptions = (options: Options<GetEmailPreviewData>) => queryOptions<GetEmailPreviewResponse, AxiosError<GetEmailPreviewError>, GetEmailPreviewResponse, ReturnType<typeof getEmailPreviewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEmailPreview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEmailPreviewQueryKey(options)
});

export const listEventEmailTemplatesQueryKey = (options: Options<ListEventEmailTemplatesData>) => createQueryKey('listEventEmailTemplates', options);

/**
 * List Event Email Templates
 *
 * The event's own templates, newest first. Hidden ones are left out.
 */
export const listEventEmailTemplatesOptions = (options: Options<ListEventEmailTemplatesData>) => queryOptions<ListEventEmailTemplatesResponse, AxiosError<ListEventEmailTemplatesError>, ListEventEmailTemplatesResponse, ReturnType<typeof listEventEmailTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listEventEmailTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listEventEmailTemplatesQueryKey(options)
});

export const createEventEmailTemplateQueryKey = (options: Options<CreateEventEmailTemplateData>) => createQueryKey('createEventEmailTemplate', options);

/**
 * Create Event Email Template
 *
 * Add a template to the event.
 */
export const createEventEmailTemplateOptions = (options: Options<CreateEventEmailTemplateData>) => queryOptions<CreateEventEmailTemplateResponse, AxiosError<CreateEventEmailTemplateError>, CreateEventEmailTemplateResponse, ReturnType<typeof createEventEmailTemplateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await createEventEmailTemplate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: createEventEmailTemplateQueryKey(options)
});

/**
 * Create Event Email Template
 *
 * Add a template to the event.
 */
export const createEventEmailTemplateMutation = (options?: Partial<Options<CreateEventEmailTemplateData>>): UseMutationOptions<CreateEventEmailTemplateResponse, AxiosError<CreateEventEmailTemplateError>, Options<CreateEventEmailTemplateData>> => {
    const mutationOptions: UseMutationOptions<CreateEventEmailTemplateResponse, AxiosError<CreateEventEmailTemplateError>, Options<CreateEventEmailTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createEventEmailTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Event Email Template
 *
 * Delete one of the event's templates. One an email was sent from is
 * hidden instead, so the email history can still show what was sent.
 */
export const deleteEventEmailTemplateMutation = (options?: Partial<Options<DeleteEventEmailTemplateData>>): UseMutationOptions<DeleteEventEmailTemplateResponse, AxiosError<DeleteEventEmailTemplateError>, Options<DeleteEventEmailTemplateData>> => {
    const mutationOptions: UseMutationOptions<DeleteEventEmailTemplateResponse, AxiosError<DeleteEventEmailTemplateError>, Options<DeleteEventEmailTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteEventEmailTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Event Email Template
 *
 * Edit one of the event's templates. Only provided fields change.
 *
 * Changes the template in place until an email has been sent from it. After
 * that, the old version is hidden and the response is a new template, with a
 * new uuid, holding the new text.
 */
export const updateEventEmailTemplateMutation = (options?: Partial<Options<UpdateEventEmailTemplateData>>): UseMutationOptions<UpdateEventEmailTemplateResponse, AxiosError<UpdateEventEmailTemplateError>, Options<UpdateEventEmailTemplateData>> => {
    const mutationOptions: UseMutationOptions<UpdateEventEmailTemplateResponse, AxiosError<UpdateEventEmailTemplateError>, Options<UpdateEventEmailTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateEventEmailTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const previewEventEmailQueryKey = (options: Options<PreviewEventEmailData>) => createQueryKey('previewEventEmail', options);

/**
 * Preview Event Email
 *
 * Send a preview of any of this event's emails, to yourself or `email`.
 *
 * Works for every template type: a saved template (the event's own or a
 * shared template), with optional edited subject/body, or unsaved text of a
 * given type. The preview is rendered like the real email, with a preview
 * RSVP link, and is not logged.
 */
export const previewEventEmailOptions = (options: Options<PreviewEventEmailData>) => queryOptions<PreviewEventEmailResponse, AxiosError<PreviewEventEmailError>, PreviewEventEmailResponse, ReturnType<typeof previewEventEmailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await previewEventEmail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: previewEventEmailQueryKey(options)
});

/**
 * Preview Event Email
 *
 * Send a preview of any of this event's emails, to yourself or `email`.
 *
 * Works for every template type: a saved template (the event's own or a
 * shared template), with optional edited subject/body, or unsaved text of a
 * given type. The preview is rendered like the real email, with a preview
 * RSVP link, and is not logged.
 */
export const previewEventEmailMutation = (options?: Partial<Options<PreviewEventEmailData>>): UseMutationOptions<PreviewEventEmailResponse, AxiosError<PreviewEventEmailError>, Options<PreviewEventEmailData>> => {
    const mutationOptions: UseMutationOptions<PreviewEventEmailResponse, AxiosError<PreviewEventEmailError>, Options<PreviewEventEmailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await previewEventEmail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postPotentialGuestsQueryKey = (options?: Options<PostPotentialGuestsData>) => createQueryKey('postPotentialGuests', options);

/**
 * Post Potential Guests
 *
 * List potential guests for event guest lists.
 *
 * Performance: event aggregates use indexes and LATERAL/grouped subqueries.
 * For fastest time-to-results, use include_total=false, include_aggregations=false
 * to get only the current page; then request total and/or aggregations in
 * parallel with include_results=false and the same filter/sort params.
 *
 * Returns a unified pool of:
 * - B4B users (same as users endpoint but excluding advisory/APPADMIN)
 * - Candidates (executives in the candidate pool)
 * - Standalone event guests from previous events (not linked to a person or candidate)
 *
 * When a person is both a user and a candidate, they appear once as a user with
 * optional candidate_uuid. Search phrase matches name, role, company, keyword,
 * notes, or location (PRD).
 *
 * Supports filters: source_type, client_type, tier, advisor_id, event_uuids, company_ids,
 * has_attended_events, has_invited_events,
 * events_attended_count min/max, events_invited_count min/max, last_event_date range.
 * Supports sort_rules (name, email, created, source_type, tier, warm, underrepresented,
 * advisor_name, last_event_date,
 * events_attended_count, events_invited_count, advisor_name). When include_aggregations=true,
 * returns counts per source_type, client_type, tier, advisor_id, event_uuids, company_ids,
 * has_attended_events, and has_invited_events.
 *
 * Each result carries client_types: server-computed classification mirroring
 * the users-table company-type taxonomy (executive, search, investor,
 * corporate, advisory; enterprise roles win over candidate linkage).
 */
export const postPotentialGuestsOptions = (options?: Options<PostPotentialGuestsData>) => queryOptions<PostPotentialGuestsResponse, AxiosError<PostPotentialGuestsError>, PostPotentialGuestsResponse, ReturnType<typeof postPotentialGuestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postPotentialGuests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postPotentialGuestsQueryKey(options)
});

export const postPotentialGuestsInfiniteQueryKey = (options?: Options<PostPotentialGuestsData>): QueryKey<Options<PostPotentialGuestsData>> => createQueryKey('postPotentialGuests', options, true);

/**
 * Post Potential Guests
 *
 * List potential guests for event guest lists.
 *
 * Performance: event aggregates use indexes and LATERAL/grouped subqueries.
 * For fastest time-to-results, use include_total=false, include_aggregations=false
 * to get only the current page; then request total and/or aggregations in
 * parallel with include_results=false and the same filter/sort params.
 *
 * Returns a unified pool of:
 * - B4B users (same as users endpoint but excluding advisory/APPADMIN)
 * - Candidates (executives in the candidate pool)
 * - Standalone event guests from previous events (not linked to a person or candidate)
 *
 * When a person is both a user and a candidate, they appear once as a user with
 * optional candidate_uuid. Search phrase matches name, role, company, keyword,
 * notes, or location (PRD).
 *
 * Supports filters: source_type, client_type, tier, advisor_id, event_uuids, company_ids,
 * has_attended_events, has_invited_events,
 * events_attended_count min/max, events_invited_count min/max, last_event_date range.
 * Supports sort_rules (name, email, created, source_type, tier, warm, underrepresented,
 * advisor_name, last_event_date,
 * events_attended_count, events_invited_count, advisor_name). When include_aggregations=true,
 * returns counts per source_type, client_type, tier, advisor_id, event_uuids, company_ids,
 * has_attended_events, and has_invited_events.
 *
 * Each result carries client_types: server-computed classification mirroring
 * the users-table company-type taxonomy (executive, search, investor,
 * corporate, advisory; enterprise roles win over candidate linkage).
 */
export const postPotentialGuestsInfiniteOptions = (options?: Options<PostPotentialGuestsData>) => {
    const opts = infiniteQueryOptions<PostPotentialGuestsResponse, AxiosError<PostPotentialGuestsError>, InfiniteData<PostPotentialGuestsResponse>, QueryKey<Options<PostPotentialGuestsData>>, number | Pick<QueryKey<Options<PostPotentialGuestsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PostPotentialGuestsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                body: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await postPotentialGuests({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postPotentialGuestsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Post Potential Guests
 *
 * List potential guests for event guest lists.
 *
 * Performance: event aggregates use indexes and LATERAL/grouped subqueries.
 * For fastest time-to-results, use include_total=false, include_aggregations=false
 * to get only the current page; then request total and/or aggregations in
 * parallel with include_results=false and the same filter/sort params.
 *
 * Returns a unified pool of:
 * - B4B users (same as users endpoint but excluding advisory/APPADMIN)
 * - Candidates (executives in the candidate pool)
 * - Standalone event guests from previous events (not linked to a person or candidate)
 *
 * When a person is both a user and a candidate, they appear once as a user with
 * optional candidate_uuid. Search phrase matches name, role, company, keyword,
 * notes, or location (PRD).
 *
 * Supports filters: source_type, client_type, tier, advisor_id, event_uuids, company_ids,
 * has_attended_events, has_invited_events,
 * events_attended_count min/max, events_invited_count min/max, last_event_date range.
 * Supports sort_rules (name, email, created, source_type, tier, warm, underrepresented,
 * advisor_name, last_event_date,
 * events_attended_count, events_invited_count, advisor_name). When include_aggregations=true,
 * returns counts per source_type, client_type, tier, advisor_id, event_uuids, company_ids,
 * has_attended_events, and has_invited_events.
 *
 * Each result carries client_types: server-computed classification mirroring
 * the users-table company-type taxonomy (executive, search, investor,
 * corporate, advisory; enterprise roles win over candidate linkage).
 */
export const postPotentialGuestsMutation = (options?: Partial<Options<PostPotentialGuestsData>>): UseMutationOptions<PostPotentialGuestsResponse, AxiosError<PostPotentialGuestsError>, Options<PostPotentialGuestsData>> => {
    const mutationOptions: UseMutationOptions<PostPotentialGuestsResponse, AxiosError<PostPotentialGuestsError>, Options<PostPotentialGuestsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postPotentialGuests({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postPotentialGuestsSelectionQueryKey = (options: Options<PostPotentialGuestsSelectionData>) => createQueryKey('postPotentialGuestsSelection', options);

/**
 * Post Potential Guests Selection
 *
 * Resolve selected potential guest rows with minimal fields for email actions.
 *
 * Reuses the exact potential guest search/filter logic. selection_mode:
 * - explicit: return only included_items
 * - all_matching: return all filtered rows except excluded_items
 */
export const postPotentialGuestsSelectionOptions = (options: Options<PostPotentialGuestsSelectionData>) => queryOptions<PostPotentialGuestsSelectionResponse, AxiosError<PostPotentialGuestsSelectionError>, PostPotentialGuestsSelectionResponse, ReturnType<typeof postPotentialGuestsSelectionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postPotentialGuestsSelection({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postPotentialGuestsSelectionQueryKey(options)
});

/**
 * Post Potential Guests Selection
 *
 * Resolve selected potential guest rows with minimal fields for email actions.
 *
 * Reuses the exact potential guest search/filter logic. selection_mode:
 * - explicit: return only included_items
 * - all_matching: return all filtered rows except excluded_items
 */
export const postPotentialGuestsSelectionMutation = (options?: Partial<Options<PostPotentialGuestsSelectionData>>): UseMutationOptions<PostPotentialGuestsSelectionResponse, AxiosError<PostPotentialGuestsSelectionError>, Options<PostPotentialGuestsSelectionData>> => {
    const mutationOptions: UseMutationOptions<PostPotentialGuestsSelectionResponse, AxiosError<PostPotentialGuestsSelectionError>, Options<PostPotentialGuestsSelectionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postPotentialGuestsSelection({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getEventsQueryKey = (options?: Options<GetEventsData>) => createQueryKey('getEvents', options);

/**
 * Get Events
 *
 * List events with pagination. Optionally filter by draft status, event_date
 * bounds, and search phrase. Sorted by event_date (direction via sort_event_date,
 * nulls last), then created descending.
 */
export const getEventsOptions = (options?: Options<GetEventsData>) => queryOptions<GetEventsResponse, AxiosError<GetEventsError>, GetEventsResponse, ReturnType<typeof getEventsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEventsQueryKey(options)
});

export const getEventsInfiniteQueryKey = (options?: Options<GetEventsData>): QueryKey<Options<GetEventsData>> => createQueryKey('getEvents', options, true);

/**
 * Get Events
 *
 * List events with pagination. Optionally filter by draft status, event_date
 * bounds, and search phrase. Sorted by event_date (direction via sort_event_date,
 * nulls last), then created descending.
 */
export const getEventsInfiniteOptions = (options?: Options<GetEventsData>) => {
    const opts = infiniteQueryOptions<GetEventsResponse, AxiosError<GetEventsError>, InfiniteData<GetEventsResponse>, QueryKey<Options<GetEventsData>>, number | Pick<QueryKey<Options<GetEventsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetEventsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getEvents({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getEventsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const postEventQueryKey = (options: Options<PostEventData>) => createQueryKey('postEvent', options);

/**
 * Post Event
 *
 * Create a new event. Events default to draft mode (draft=true).
 */
export const postEventOptions = (options: Options<PostEventData>) => queryOptions<PostEventResponse, AxiosError<PostEventError>, PostEventResponse, ReturnType<typeof postEventQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postEvent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postEventQueryKey(options)
});

/**
 * Post Event
 *
 * Create a new event. Events default to draft mode (draft=true).
 */
export const postEventMutation = (options?: Partial<Options<PostEventData>>): UseMutationOptions<PostEventResponse, AxiosError<PostEventError>, Options<PostEventData>> => {
    const mutationOptions: UseMutationOptions<PostEventResponse, AxiosError<PostEventError>, Options<PostEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAllEventGuestsQueryKey = (options?: Options<GetAllEventGuestsData>) => createQueryKey('getAllEventGuests', options);

/**
 * Get All Event Guests
 *
 * List all event guests (participants) across all events, with pagination.
 *
 * Each item includes the event's uuid and title plus the guest record with
 * resolved name, role, company, email, and status. Sorted by event date
 * (desc, nulls last), then event created (desc), then guest created (asc).
 */
export const getAllEventGuestsOptions = (options?: Options<GetAllEventGuestsData>) => queryOptions<GetAllEventGuestsResponse, AxiosError<GetAllEventGuestsError>, GetAllEventGuestsResponse, ReturnType<typeof getAllEventGuestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAllEventGuests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAllEventGuestsQueryKey(options)
});

export const getAllEventGuestsInfiniteQueryKey = (options?: Options<GetAllEventGuestsData>): QueryKey<Options<GetAllEventGuestsData>> => createQueryKey('getAllEventGuests', options, true);

/**
 * Get All Event Guests
 *
 * List all event guests (participants) across all events, with pagination.
 *
 * Each item includes the event's uuid and title plus the guest record with
 * resolved name, role, company, email, and status. Sorted by event date
 * (desc, nulls last), then event created (desc), then guest created (asc).
 */
export const getAllEventGuestsInfiniteOptions = (options?: Options<GetAllEventGuestsData>) => {
    const opts = infiniteQueryOptions<GetAllEventGuestsResponse, AxiosError<GetAllEventGuestsError>, InfiniteData<GetAllEventGuestsResponse>, QueryKey<Options<GetAllEventGuestsData>>, number | Pick<QueryKey<Options<GetAllEventGuestsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetAllEventGuestsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getAllEventGuests({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllEventGuestsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getEventRsvpLandingQueryKey = (options: Options<GetEventRsvpLandingData>) => createQueryKey('getEventRsvpLanding', options);

/**
 * Get Event Rsvp Landing
 *
 * Public endpoint: get event details and guest's current RSVP status by invite token.
 * Returns 404 when the event is still in draft (unpublished). No authentication required.
 */
export const getEventRsvpLandingOptions = (options: Options<GetEventRsvpLandingData>) => queryOptions<GetEventRsvpLandingResponse, AxiosError<GetEventRsvpLandingError>, GetEventRsvpLandingResponse, ReturnType<typeof getEventRsvpLandingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEventRsvpLanding({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEventRsvpLandingQueryKey(options)
});

/**
 * Patch Event Rsvp
 *
 * Public endpoint: submit or update RSVP (going / cant_go) using the invite token.
 * Returns 404 when the event is still in draft. No authentication required.
 */
export const patchEventRsvpMutation = (options?: Partial<Options<PatchEventRsvpData>>): UseMutationOptions<PatchEventRsvpResponse, AxiosError<PatchEventRsvpError>, Options<PatchEventRsvpData>> => {
    const mutationOptions: UseMutationOptions<PatchEventRsvpResponse, AxiosError<PatchEventRsvpError>, Options<PatchEventRsvpData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchEventRsvp({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getEventRsvpLandingImageQueryKey = (options: Options<GetEventRsvpLandingImageData>) => createQueryKey('getEventRsvpLandingImage', options);

/**
 * Get Event Rsvp Landing Image
 *
 * Public: full-resolution landing hero image (no square crop). Same access rules as GET /rsvp.
 */
export const getEventRsvpLandingImageOptions = (options: Options<GetEventRsvpLandingImageData>) => queryOptions<unknown, AxiosError<GetEventRsvpLandingImageError>, unknown, ReturnType<typeof getEventRsvpLandingImageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEventRsvpLandingImage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEventRsvpLandingImageQueryKey(options)
});

export const getEventRsvpPreviewQueryKey = (options: Options<GetEventRsvpPreviewData>) => createQueryKey('getEventRsvpPreview', options);

/**
 * Get Event Rsvp Preview
 *
 * Admin-only: return event landing data for invite preview. Same shape as GET /events/rsvp
 * but without a real guest; use when the user opened the preview link from a preview email.
 * Frontend should show a preview banner and disable RSVP actions when is_preview is true.
 */
export const getEventRsvpPreviewOptions = (options: Options<GetEventRsvpPreviewData>) => queryOptions<GetEventRsvpPreviewResponse, AxiosError<GetEventRsvpPreviewError>, GetEventRsvpPreviewResponse, ReturnType<typeof getEventRsvpPreviewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEventRsvpPreview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEventRsvpPreviewQueryKey(options)
});

export const postEventRsvpPreviewQueryKey = (options: Options<PostEventRsvpPreviewData>) => createQueryKey('postEventRsvpPreview', options);

/**
 * Post Event Rsvp Preview
 *
 * Send the authenticated user a preview of the RSVP confirmation email (going or cant_go).
 * No RSVP is created or updated. Requires advisor auth.
 */
export const postEventRsvpPreviewOptions = (options: Options<PostEventRsvpPreviewData>) => queryOptions<PostEventRsvpPreviewResponse, AxiosError<PostEventRsvpPreviewError>, PostEventRsvpPreviewResponse, ReturnType<typeof postEventRsvpPreviewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postEventRsvpPreview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postEventRsvpPreviewQueryKey(options)
});

/**
 * Post Event Rsvp Preview
 *
 * Send the authenticated user a preview of the RSVP confirmation email (going or cant_go).
 * No RSVP is created or updated. Requires advisor auth.
 */
export const postEventRsvpPreviewMutation = (options?: Partial<Options<PostEventRsvpPreviewData>>): UseMutationOptions<PostEventRsvpPreviewResponse, AxiosError<PostEventRsvpPreviewError>, Options<PostEventRsvpPreviewData>> => {
    const mutationOptions: UseMutationOptions<PostEventRsvpPreviewResponse, AxiosError<PostEventRsvpPreviewError>, Options<PostEventRsvpPreviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postEventRsvpPreview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Event
 *
 * Delete an event.
 */
export const deleteEventMutation = (options?: Partial<Options<DeleteEventData>>): UseMutationOptions<DeleteEventResponse, AxiosError<DeleteEventError>, Options<DeleteEventData>> => {
    const mutationOptions: UseMutationOptions<DeleteEventResponse, AxiosError<DeleteEventError>, Options<DeleteEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getEventQueryKey = (options: Options<GetEventData>) => createQueryKey('getEvent', options);

/**
 * Get Event
 *
 * Get an event by UUID with its polymorphic guest list.
 *
 * Each guest includes source_type, linking ids (person_uuid/candidate_uuid),
 * resolved display fields (name, role, company, email), and event-guest metadata.
 */
export const getEventOptions = (options: Options<GetEventData>) => queryOptions<GetEventResponse, AxiosError<GetEventError>, GetEventResponse, ReturnType<typeof getEventQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEvent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEventQueryKey(options)
});

/**
 * Patch Event
 *
 * Update an event. Only provided fields are updated.
 */
export const patchEventMutation = (options?: Partial<Options<PatchEventData>>): UseMutationOptions<PatchEventResponse, AxiosError<PatchEventError>, Options<PatchEventData>> => {
    const mutationOptions: UseMutationOptions<PatchEventResponse, AxiosError<PatchEventError>, Options<PatchEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getEventLandingImagePublicQueryKey = (options: Options<GetEventLandingImagePublicData>) => createQueryKey('getEventLandingImagePublic', options);

/**
 * Get Event Landing Image Public
 *
 * Public: landing hero by event UUID (no auth, no square crop).
 */
export const getEventLandingImagePublicOptions = (options: Options<GetEventLandingImagePublicData>) => queryOptions<unknown, AxiosError<GetEventLandingImagePublicError>, unknown, ReturnType<typeof getEventLandingImagePublicQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEventLandingImagePublic({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEventLandingImagePublicQueryKey(options)
});

/**
 * Delete Event Landing Image
 *
 * Advisor: remove landing image; deletes storage object only if no other
 * event references it.
 */
export const deleteEventLandingImageMutation = (options?: Partial<Options<DeleteEventLandingImageData>>): UseMutationOptions<DeleteEventLandingImageResponse, AxiosError<DeleteEventLandingImageError>, Options<DeleteEventLandingImageData>> => {
    const mutationOptions: UseMutationOptions<DeleteEventLandingImageResponse, AxiosError<DeleteEventLandingImageError>, Options<DeleteEventLandingImageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteEventLandingImage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postEventLandingImageQueryKey = (options: Options<PostEventLandingImageData>) => createQueryKey('postEventLandingImage', options);

/**
 * Post Event Landing Image
 *
 * Advisor: upload a landing hero image in one step; replaces prior image when unshared.
 */
export const postEventLandingImageOptions = (options: Options<PostEventLandingImageData>) => queryOptions<PostEventLandingImageResponse, AxiosError<PostEventLandingImageError>, PostEventLandingImageResponse, ReturnType<typeof postEventLandingImageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postEventLandingImage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postEventLandingImageQueryKey(options)
});

/**
 * Post Event Landing Image
 *
 * Advisor: upload a landing hero image in one step; replaces prior image when unshared.
 */
export const postEventLandingImageMutation = (options?: Partial<Options<PostEventLandingImageData>>): UseMutationOptions<PostEventLandingImageResponse, AxiosError<PostEventLandingImageError>, Options<PostEventLandingImageData>> => {
    const mutationOptions: UseMutationOptions<PostEventLandingImageResponse, AxiosError<PostEventLandingImageError>, Options<PostEventLandingImageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postEventLandingImage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postEventInviteSendQueryKey = (options: Options<PostEventInviteSendData>) => createQueryKey('postEventInviteSend', options);

/**
 * Post Event Invite Send
 *
 * Queue sending the event's saved invite email. Send to all guests with emails, to
 * guest_uuids only, or to the single guest_uuid (legacy).
 * The invite body can contain {{event_link}}; it is replaced with a per-guest RSVP URL
 * using the app's web URL (WEB_URL env) or the request origin passed to the Celery task.
 */
export const postEventInviteSendOptions = (options: Options<PostEventInviteSendData>) => queryOptions<PostEventInviteSendResponse, AxiosError<PostEventInviteSendError>, PostEventInviteSendResponse, ReturnType<typeof postEventInviteSendQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postEventInviteSend({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postEventInviteSendQueryKey(options)
});

/**
 * Post Event Invite Send
 *
 * Queue sending the event's saved invite email. Send to all guests with emails, to
 * guest_uuids only, or to the single guest_uuid (legacy).
 * The invite body can contain {{event_link}}; it is replaced with a per-guest RSVP URL
 * using the app's web URL (WEB_URL env) or the request origin passed to the Celery task.
 */
export const postEventInviteSendMutation = (options?: Partial<Options<PostEventInviteSendData>>): UseMutationOptions<PostEventInviteSendResponse, AxiosError<PostEventInviteSendError>, Options<PostEventInviteSendData>> => {
    const mutationOptions: UseMutationOptions<PostEventInviteSendResponse, AxiosError<PostEventInviteSendError>, Options<PostEventInviteSendData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postEventInviteSend({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postEventInvitePreviewQueryKey = (options: Options<PostEventInvitePreviewData>) => createQueryKey('postEventInvitePreview', options);

/**
 * Post Event Invite Preview
 *
 * Send the event's invite email to the current user (or optional email) as a preview.
 * Uses the same content resolution as invite/send (event or default template).
 * {{event_link}} is replaced with a preview URL (see GET /events/{event_uuid}/rsvp-preview).
 */
export const postEventInvitePreviewOptions = (options: Options<PostEventInvitePreviewData>) => queryOptions<PostEventInvitePreviewResponse, AxiosError<PostEventInvitePreviewError>, PostEventInvitePreviewResponse, ReturnType<typeof postEventInvitePreviewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postEventInvitePreview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postEventInvitePreviewQueryKey(options)
});

/**
 * Post Event Invite Preview
 *
 * Send the event's invite email to the current user (or optional email) as a preview.
 * Uses the same content resolution as invite/send (event or default template).
 * {{event_link}} is replaced with a preview URL (see GET /events/{event_uuid}/rsvp-preview).
 */
export const postEventInvitePreviewMutation = (options?: Partial<Options<PostEventInvitePreviewData>>): UseMutationOptions<PostEventInvitePreviewResponse, AxiosError<PostEventInvitePreviewError>, Options<PostEventInvitePreviewData>> => {
    const mutationOptions: UseMutationOptions<PostEventInvitePreviewResponse, AxiosError<PostEventInvitePreviewError>, Options<PostEventInvitePreviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postEventInvitePreview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postEventReminderPreviewQueryKey = (options: Options<PostEventReminderPreviewData>) => createQueryKey('postEventReminderPreview', options);

/**
 * Post Event Reminder Preview
 *
 * Send a preview of the RSVP reminder (nudge) email to the current user or optional email.
 * Uses the event_rsvp_reminder template from the email_template table. Requires a default
 * reminder template to exist. Event links use WEB_URL.
 */
export const postEventReminderPreviewOptions = (options: Options<PostEventReminderPreviewData>) => queryOptions<PostEventReminderPreviewResponse, AxiosError<PostEventReminderPreviewError>, PostEventReminderPreviewResponse, ReturnType<typeof postEventReminderPreviewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postEventReminderPreview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postEventReminderPreviewQueryKey(options)
});

/**
 * Post Event Reminder Preview
 *
 * Send a preview of the RSVP reminder (nudge) email to the current user or optional email.
 * Uses the event_rsvp_reminder template from the email_template table. Requires a default
 * reminder template to exist. Event links use WEB_URL.
 */
export const postEventReminderPreviewMutation = (options?: Partial<Options<PostEventReminderPreviewData>>): UseMutationOptions<PostEventReminderPreviewResponse, AxiosError<PostEventReminderPreviewError>, Options<PostEventReminderPreviewData>> => {
    const mutationOptions: UseMutationOptions<PostEventReminderPreviewResponse, AxiosError<PostEventReminderPreviewError>, Options<PostEventReminderPreviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postEventReminderPreview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postEventReminderSendQueryKey = (options: Options<PostEventReminderSendData>) => createQueryKey('postEventReminderSend', options);

/**
 * Post Event Reminder Send
 *
 * Queue RSVP reminder emails for guests who were invited but have not responded.
 * Uses the default event_rsvp_reminder template. Omit guest targeting fields to remind
 * all eligible guests; use guest_uuids or guest_uuid (legacy) for a subset.
 */
export const postEventReminderSendOptions = (options: Options<PostEventReminderSendData>) => queryOptions<PostEventReminderSendResponse, AxiosError<PostEventReminderSendError>, PostEventReminderSendResponse, ReturnType<typeof postEventReminderSendQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postEventReminderSend({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postEventReminderSendQueryKey(options)
});

/**
 * Post Event Reminder Send
 *
 * Queue RSVP reminder emails for guests who were invited but have not responded.
 * Uses the default event_rsvp_reminder template. Omit guest targeting fields to remind
 * all eligible guests; use guest_uuids or guest_uuid (legacy) for a subset.
 */
export const postEventReminderSendMutation = (options?: Partial<Options<PostEventReminderSendData>>): UseMutationOptions<PostEventReminderSendResponse, AxiosError<PostEventReminderSendError>, Options<PostEventReminderSendData>> => {
    const mutationOptions: UseMutationOptions<PostEventReminderSendResponse, AxiosError<PostEventReminderSendError>, Options<PostEventReminderSendData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postEventReminderSend({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postEventAnnouncementSendQueryKey = (options: Options<PostEventAnnouncementSendData>) => createQueryKey('postEventAnnouncementSend', options);

/**
 * Post Event Announcement Send
 *
 * Queue an announcement to the selected guests: any guest with an email
 * address, whatever their RSVP and whether or not they were sent an invite.
 * Uses the given event_announcement template (the event's own or a shared
 * default). Allowed when RSVP is off, if the text has no {{event_link}}.
 */
export const postEventAnnouncementSendOptions = (options: Options<PostEventAnnouncementSendData>) => queryOptions<PostEventAnnouncementSendResponse, AxiosError<PostEventAnnouncementSendError>, PostEventAnnouncementSendResponse, ReturnType<typeof postEventAnnouncementSendQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postEventAnnouncementSend({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postEventAnnouncementSendQueryKey(options)
});

/**
 * Post Event Announcement Send
 *
 * Queue an announcement to the selected guests: any guest with an email
 * address, whatever their RSVP and whether or not they were sent an invite.
 * Uses the given event_announcement template (the event's own or a shared
 * default). Allowed when RSVP is off, if the text has no {{event_link}}.
 */
export const postEventAnnouncementSendMutation = (options?: Partial<Options<PostEventAnnouncementSendData>>): UseMutationOptions<PostEventAnnouncementSendResponse, AxiosError<PostEventAnnouncementSendError>, Options<PostEventAnnouncementSendData>> => {
    const mutationOptions: UseMutationOptions<PostEventAnnouncementSendResponse, AxiosError<PostEventAnnouncementSendError>, Options<PostEventAnnouncementSendData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postEventAnnouncementSend({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getEventEmailEventsQueryKey = (options: Options<GetEventEmailEventsData>) => createQueryKey('getEventEmailEvents', options);

/**
 * Get Event Email Events
 *
 * List the emails sent for an event (invites, reminders, RSVP confirmations),
 * one item per email with its lifecycle. Admin only. Newest send first.
 * Paginated by email, not by SendGrid event. Pass `batch_uuid` to expand one
 * send run (see /email-batches), `to_identity_uuid` to keep one person's
 * emails, `email_event_type` to keep some kinds of email (invites,
 * reminders), `sendgrid_event` to keep only the emails delivered, opened,
 * bounced and so on.
 */
export const getEventEmailEventsOptions = (options: Options<GetEventEmailEventsData>) => queryOptions<GetEventEmailEventsResponse, AxiosError<GetEventEmailEventsError>, GetEventEmailEventsResponse, ReturnType<typeof getEventEmailEventsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEventEmailEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEventEmailEventsQueryKey(options)
});

export const getEventEmailEventsInfiniteQueryKey = (options: Options<GetEventEmailEventsData>): QueryKey<Options<GetEventEmailEventsData>> => createQueryKey('getEventEmailEvents', options, true);

/**
 * Get Event Email Events
 *
 * List the emails sent for an event (invites, reminders, RSVP confirmations),
 * one item per email with its lifecycle. Admin only. Newest send first.
 * Paginated by email, not by SendGrid event. Pass `batch_uuid` to expand one
 * send run (see /email-batches), `to_identity_uuid` to keep one person's
 * emails, `email_event_type` to keep some kinds of email (invites,
 * reminders), `sendgrid_event` to keep only the emails delivered, opened,
 * bounced and so on.
 */
export const getEventEmailEventsInfiniteOptions = (options: Options<GetEventEmailEventsData>) => {
    const opts = infiniteQueryOptions<GetEventEmailEventsResponse, AxiosError<GetEventEmailEventsError>, InfiniteData<GetEventEmailEventsResponse>, QueryKey<Options<GetEventEmailEventsData>>, number | Pick<QueryKey<Options<GetEventEmailEventsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetEventEmailEventsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getEventEmailEvents({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getEventEmailEventsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getEventEmailBatchesQueryKey = (options: Options<GetEventEmailBatchesData>) => createQueryKey('getEventEmailBatches', options);

/**
 * Get Event Email Batches
 *
 * The event's email log as send runs: one row per batch (the invites sent in
 * one go, one reminder pass, one RSVP confirmation), newest first, with how
 * many emails it sent and how many were delivered, opened, clicked or failed.
 * Expand a run with `/email-events?batch_uuid=`.
 *
 * Takes the same filters as `/email-events`. A run is kept when any of its
 * emails matches them (`sendgrid_event=dropped`: the runs with a dropped
 * email), and its counts are still of all its emails.
 *
 * Each run comes with its first matching emails (`first_emails`), so the
 * page can show a run's emails without a request per run.
 */
export const getEventEmailBatchesOptions = (options: Options<GetEventEmailBatchesData>) => queryOptions<GetEventEmailBatchesResponse, AxiosError<GetEventEmailBatchesError>, GetEventEmailBatchesResponse, ReturnType<typeof getEventEmailBatchesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEventEmailBatches({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEventEmailBatchesQueryKey(options)
});

export const getEventEmailBatchesInfiniteQueryKey = (options: Options<GetEventEmailBatchesData>): QueryKey<Options<GetEventEmailBatchesData>> => createQueryKey('getEventEmailBatches', options, true);

/**
 * Get Event Email Batches
 *
 * The event's email log as send runs: one row per batch (the invites sent in
 * one go, one reminder pass, one RSVP confirmation), newest first, with how
 * many emails it sent and how many were delivered, opened, clicked or failed.
 * Expand a run with `/email-events?batch_uuid=`.
 *
 * Takes the same filters as `/email-events`. A run is kept when any of its
 * emails matches them (`sendgrid_event=dropped`: the runs with a dropped
 * email), and its counts are still of all its emails.
 *
 * Each run comes with its first matching emails (`first_emails`), so the
 * page can show a run's emails without a request per run.
 */
export const getEventEmailBatchesInfiniteOptions = (options: Options<GetEventEmailBatchesData>) => {
    const opts = infiniteQueryOptions<GetEventEmailBatchesResponse, AxiosError<GetEventEmailBatchesError>, InfiniteData<GetEventEmailBatchesResponse>, QueryKey<Options<GetEventEmailBatchesData>>, number | Pick<QueryKey<Options<GetEventEmailBatchesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetEventEmailBatchesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getEventEmailBatches({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getEventEmailBatchesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getEventGuestsQueryKey = (options: Options<GetEventGuestsData>) => createQueryKey('getEventGuests', options);

/**
 * Get Event Guests
 *
 * List guests for an event, filtered by status/client_type(s)/phrase, with
 * per-status totals. sort=name orders by resolved display name (candidate
 * name, else person name, else standalone guest name); sort=status orders
 * by workflow progress (need_invite, invited, going, cant_go); sort=created
 * is the plain creation order. order=desc reverses the primary sort key
 * only -- the id tiebreaker stays ascending.
 *
 * With a phrase and no sort, results rank by best match; passing sort
 * overrides. (There is no "best match" sort value to request -- it's the
 * implicit ranking while searching: name-prefix, then name-contains, then
 * email-contains, then everything else.) With no phrase and no sort,
 * results are in created order, same as before this feature existed.
 *
 * client_type may be repeated (e.g. ?client_type=executive&client_type=investor)
 * to match guests of ANY of the given types (OR).
 */
export const getEventGuestsOptions = (options: Options<GetEventGuestsData>) => queryOptions<GetEventGuestsResponse, AxiosError<GetEventGuestsError>, GetEventGuestsResponse, ReturnType<typeof getEventGuestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEventGuests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEventGuestsQueryKey(options)
});

export const getEventGuestsInfiniteQueryKey = (options: Options<GetEventGuestsData>): QueryKey<Options<GetEventGuestsData>> => createQueryKey('getEventGuests', options, true);

/**
 * Get Event Guests
 *
 * List guests for an event, filtered by status/client_type(s)/phrase, with
 * per-status totals. sort=name orders by resolved display name (candidate
 * name, else person name, else standalone guest name); sort=status orders
 * by workflow progress (need_invite, invited, going, cant_go); sort=created
 * is the plain creation order. order=desc reverses the primary sort key
 * only -- the id tiebreaker stays ascending.
 *
 * With a phrase and no sort, results rank by best match; passing sort
 * overrides. (There is no "best match" sort value to request -- it's the
 * implicit ranking while searching: name-prefix, then name-contains, then
 * email-contains, then everything else.) With no phrase and no sort,
 * results are in created order, same as before this feature existed.
 *
 * client_type may be repeated (e.g. ?client_type=executive&client_type=investor)
 * to match guests of ANY of the given types (OR).
 */
export const getEventGuestsInfiniteOptions = (options: Options<GetEventGuestsData>) => {
    const opts = infiniteQueryOptions<GetEventGuestsResponse, AxiosError<GetEventGuestsError>, InfiniteData<GetEventGuestsResponse>, QueryKey<Options<GetEventGuestsData>>, number | Pick<QueryKey<Options<GetEventGuestsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetEventGuestsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getEventGuests({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getEventGuestsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Patch Event Guests
 *
 * Set one status on many guests of an event (bulk action from the
 * selection pane). All-or-nothing: any unknown/foreign uuid fails the batch.
 */
export const patchEventGuestsMutation = (options?: Partial<Options<PatchEventGuestsData>>): UseMutationOptions<PatchEventGuestsResponse, AxiosError<PatchEventGuestsError>, Options<PatchEventGuestsData>> => {
    const mutationOptions: UseMutationOptions<PatchEventGuestsResponse, AxiosError<PatchEventGuestsError>, Options<PatchEventGuestsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchEventGuests({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postEventGuestsQueryKey = (options: Options<PostEventGuestsData>) => createQueryKey('postEventGuests', options);

/**
 * Post Event Guests
 *
 * Add guests to an event. Each guest is specified by person_uuid, candidate_uuid,
 * or standalone: guest_first_name + guest_last_name + guest_email
 * (and optional guest_role, guest_company).
 *
 * Batch-friendly: lookups, inserts, and response loading are set-based, so
 * large payloads (e.g. "add all" selections of a few thousand guests) run in
 * a handful of queries rather than several per guest.
 */
export const postEventGuestsOptions = (options: Options<PostEventGuestsData>) => queryOptions<PostEventGuestsResponse, AxiosError<PostEventGuestsError>, PostEventGuestsResponse, ReturnType<typeof postEventGuestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postEventGuests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postEventGuestsQueryKey(options)
});

/**
 * Post Event Guests
 *
 * Add guests to an event. Each guest is specified by person_uuid, candidate_uuid,
 * or standalone: guest_first_name + guest_last_name + guest_email
 * (and optional guest_role, guest_company).
 *
 * Batch-friendly: lookups, inserts, and response loading are set-based, so
 * large payloads (e.g. "add all" selections of a few thousand guests) run in
 * a handful of queries rather than several per guest.
 */
export const postEventGuestsMutation = (options?: Partial<Options<PostEventGuestsData>>): UseMutationOptions<PostEventGuestsResponse, AxiosError<PostEventGuestsError>, Options<PostEventGuestsData>> => {
    const mutationOptions: UseMutationOptions<PostEventGuestsResponse, AxiosError<PostEventGuestsError>, Options<PostEventGuestsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postEventGuests({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postEventGuestsSelectionQueryKey = (options: Options<PostEventGuestsSelectionData>) => createQueryKey('postEventGuestsSelection', options);

/**
 * Post Event Guests Selection
 *
 * Resolve the full guest set matching the filters (select-all support).
 * Same filter semantics as GET /{event_uuid}/guests.
 */
export const postEventGuestsSelectionOptions = (options: Options<PostEventGuestsSelectionData>) => queryOptions<PostEventGuestsSelectionResponse, AxiosError<PostEventGuestsSelectionError>, PostEventGuestsSelectionResponse, ReturnType<typeof postEventGuestsSelectionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postEventGuestsSelection({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postEventGuestsSelectionQueryKey(options)
});

/**
 * Post Event Guests Selection
 *
 * Resolve the full guest set matching the filters (select-all support).
 * Same filter semantics as GET /{event_uuid}/guests.
 */
export const postEventGuestsSelectionMutation = (options?: Partial<Options<PostEventGuestsSelectionData>>): UseMutationOptions<PostEventGuestsSelectionResponse, AxiosError<PostEventGuestsSelectionError>, Options<PostEventGuestsSelectionData>> => {
    const mutationOptions: UseMutationOptions<PostEventGuestsSelectionResponse, AxiosError<PostEventGuestsSelectionError>, Options<PostEventGuestsSelectionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postEventGuestsSelection({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Event Guest
 *
 * Remove a guest from an event. The guest record is deleted. If they were
 * already invited, their RSVP link will no longer work.
 */
export const deleteEventGuestMutation = (options?: Partial<Options<DeleteEventGuestData>>): UseMutationOptions<DeleteEventGuestResponse, AxiosError<DeleteEventGuestError>, Options<DeleteEventGuestData>> => {
    const mutationOptions: UseMutationOptions<DeleteEventGuestResponse, AxiosError<DeleteEventGuestError>, Options<DeleteEventGuestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteEventGuest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Patch Event Guest
 *
 * Update an event guest (e.g. RSVP). Banff Admin only.
 */
export const patchEventGuestMutation = (options?: Partial<Options<PatchEventGuestData>>): UseMutationOptions<PatchEventGuestResponse, AxiosError<PatchEventGuestError>, Options<PatchEventGuestData>> => {
    const mutationOptions: UseMutationOptions<PatchEventGuestResponse, AxiosError<PatchEventGuestError>, Options<PatchEventGuestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchEventGuest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postTeamMembersV2QueryKey = (options: Options<PostTeamMembersV2Data>) => createQueryKey('postTeamMembersV2', options);

/**
 * Post Team Members V2
 *
 * POST /api/v2/teams/{team_slug}/members
 */
export const postTeamMembersV2Options = (options: Options<PostTeamMembersV2Data>) => queryOptions<unknown, AxiosError<PostTeamMembersV2Error>, unknown, ReturnType<typeof postTeamMembersV2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postTeamMembersV2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postTeamMembersV2QueryKey(options)
});

/**
 * Post Team Members V2
 *
 * POST /api/v2/teams/{team_slug}/members
 */
export const postTeamMembersV2Mutation = (options?: Partial<Options<PostTeamMembersV2Data>>): UseMutationOptions<unknown, AxiosError<PostTeamMembersV2Error>, Options<PostTeamMembersV2Data>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostTeamMembersV2Error>, Options<PostTeamMembersV2Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTeamMembersV2({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postTeamMembersBulkV2QueryKey = (options: Options<PostTeamMembersBulkV2Data>) => createQueryKey('postTeamMembersBulkV2', options);

/**
 * Post Team Members Bulk V2
 *
 * POST /api/v2/teams/{team_slug}/members/bulk
 */
export const postTeamMembersBulkV2Options = (options: Options<PostTeamMembersBulkV2Data>) => queryOptions<unknown, AxiosError<PostTeamMembersBulkV2Error>, unknown, ReturnType<typeof postTeamMembersBulkV2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postTeamMembersBulkV2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postTeamMembersBulkV2QueryKey(options)
});

/**
 * Post Team Members Bulk V2
 *
 * POST /api/v2/teams/{team_slug}/members/bulk
 */
export const postTeamMembersBulkV2Mutation = (options?: Partial<Options<PostTeamMembersBulkV2Data>>): UseMutationOptions<unknown, AxiosError<PostTeamMembersBulkV2Error>, Options<PostTeamMembersBulkV2Data>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostTeamMembersBulkV2Error>, Options<PostTeamMembersBulkV2Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTeamMembersBulkV2({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTeamIntroInsightQueryKey = (options: Options<GetTeamIntroInsightData>) => createQueryKey('getTeamIntroInsight', options);

/**
 * Get Team Intro Insight
 *
 * GET /api/v2/teams/{team_slug}/intro-insight
 *
 * Live list of the team's up-to-10 most recent intro requests + the stored AI summary.
 */
export const getTeamIntroInsightOptions = (options: Options<GetTeamIntroInsightData>) => queryOptions<GetTeamIntroInsightResponse, AxiosError<GetTeamIntroInsightError>, GetTeamIntroInsightResponse, ReturnType<typeof getTeamIntroInsightQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTeamIntroInsight({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTeamIntroInsightQueryKey(options)
});

export const postSubmissionsQueryKey = (options: Options<PostSubmissionsData>) => createQueryKey('postSubmissions', options);

/**
 * Post Submissions
 *
 * POST /api/v3/submissions
 *
 * Also open to the Contender Actions connector (``X-MCP-API-Key`` +
 * ``X-Acting-User-Email``, see ``app.api.deps.auth.agent``).
 */
export const postSubmissionsOptions = (options: Options<PostSubmissionsData>) => queryOptions<PostSubmissionsResponse, AxiosError<PostSubmissionsError>, PostSubmissionsResponse, ReturnType<typeof postSubmissionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postSubmissions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postSubmissionsQueryKey(options)
});

/**
 * Post Submissions
 *
 * POST /api/v3/submissions
 *
 * Also open to the Contender Actions connector (``X-MCP-API-Key`` +
 * ``X-Acting-User-Email``, see ``app.api.deps.auth.agent``).
 */
export const postSubmissionsMutation = (options?: Partial<Options<PostSubmissionsData>>): UseMutationOptions<PostSubmissionsResponse, AxiosError<PostSubmissionsError>, Options<PostSubmissionsData>> => {
    const mutationOptions: UseMutationOptions<PostSubmissionsResponse, AxiosError<PostSubmissionsError>, Options<PostSubmissionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postSubmissions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postSubmissionEmailPreviewQueryKey = (options: Options<PostSubmissionEmailPreviewData>) => createQueryKey('postSubmissionEmailPreview', options);

/**
 * Post Submission Email Preview
 *
 * POST /api/v3/submissions/email-preview
 *
 * Render the trending email for an unsaved draft, exactly as a registered team
 * member would receive it. Nothing in the email depends on the recipient except
 * the links, so the preview is exact. Nothing is stored and nothing is sent.
 * ``payload`` is the same body the form saves; ``team_uuid`` picks which team's
 * links to render (default: the draft's first team; with no team yet the links
 * point at the app root).
 * The email is laid out as ``payload.notification_type`` says. A Plain v2
 * subject and message are checked as they would be at publish; text that could
 * not be sent is refused with what to fix (400). The recipient is not known, so
 * ``{{first_name}}`` is left blank.
 */
export const postSubmissionEmailPreviewOptions = (options: Options<PostSubmissionEmailPreviewData>) => queryOptions<PostSubmissionEmailPreviewResponse, AxiosError<PostSubmissionEmailPreviewError>, PostSubmissionEmailPreviewResponse, ReturnType<typeof postSubmissionEmailPreviewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postSubmissionEmailPreview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postSubmissionEmailPreviewQueryKey(options)
});

/**
 * Post Submission Email Preview
 *
 * POST /api/v3/submissions/email-preview
 *
 * Render the trending email for an unsaved draft, exactly as a registered team
 * member would receive it. Nothing in the email depends on the recipient except
 * the links, so the preview is exact. Nothing is stored and nothing is sent.
 * ``payload`` is the same body the form saves; ``team_uuid`` picks which team's
 * links to render (default: the draft's first team; with no team yet the links
 * point at the app root).
 * The email is laid out as ``payload.notification_type`` says. A Plain v2
 * subject and message are checked as they would be at publish; text that could
 * not be sent is refused with what to fix (400). The recipient is not known, so
 * ``{{first_name}}`` is left blank.
 */
export const postSubmissionEmailPreviewMutation = (options?: Partial<Options<PostSubmissionEmailPreviewData>>): UseMutationOptions<PostSubmissionEmailPreviewResponse, AxiosError<PostSubmissionEmailPreviewError>, Options<PostSubmissionEmailPreviewData>> => {
    const mutationOptions: UseMutationOptions<PostSubmissionEmailPreviewResponse, AxiosError<PostSubmissionEmailPreviewError>, Options<PostSubmissionEmailPreviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postSubmissionEmailPreview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTrendingMessageKeysQueryKey = (options?: Options<GetTrendingMessageKeysData>) => createQueryKey('getTrendingMessageKeys', options);

/**
 * Get Trending Message Keys
 *
 * GET /api/v3/submissions/trending-message-keys
 *
 * The keys a Plain trending email's subject and message can use, and the
 * subject and message a new campaign starts from.
 */
export const getTrendingMessageKeysOptions = (options?: Options<GetTrendingMessageKeysData>) => queryOptions<GetTrendingMessageKeysResponse, AxiosError<DefaultError>, GetTrendingMessageKeysResponse, ReturnType<typeof getTrendingMessageKeysQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTrendingMessageKeys({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTrendingMessageKeysQueryKey(options)
});

export const getTrendingMessagesQueryKey = (options: Options<GetTrendingMessagesData>) => createQueryKey('getTrendingMessages', options);

/**
 * Get Trending Messages
 *
 * GET /api/v3/submissions/trending-messages
 *
 * The messages advisors have sent in this candidate's Trending campaigns,
 * newest first, so a new campaign can start from one. The message is stored on
 * the submission when the campaign is published or scheduled. Campaigns that
 * sent the same body text (ignoring leading and trailing whitespace) are one
 * message; its subject and advisor are those of the latest campaign.
 *
 * Also open to the Contender Actions connector (``X-MCP-API-Key`` +
 * ``X-Acting-User-Email``, see ``app.api.deps.auth.agent``).
 */
export const getTrendingMessagesOptions = (options: Options<GetTrendingMessagesData>) => queryOptions<GetTrendingMessagesResponse, AxiosError<GetTrendingMessagesError>, GetTrendingMessagesResponse, ReturnType<typeof getTrendingMessagesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTrendingMessages({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTrendingMessagesQueryKey(options)
});

/**
 * Post Submission Cancel Recommendations
 *
 * DELETE /api/v3/submissions/{submission_uuid}/scheduled
 */
export const postSubmissionCancelRecommendationsMutation = (options?: Partial<Options<PostSubmissionCancelRecommendationsData>>): UseMutationOptions<PostSubmissionCancelRecommendationsResponse, AxiosError<PostSubmissionCancelRecommendationsError>, Options<PostSubmissionCancelRecommendationsData>> => {
    const mutationOptions: UseMutationOptions<PostSubmissionCancelRecommendationsResponse, AxiosError<PostSubmissionCancelRecommendationsError>, Options<PostSubmissionCancelRecommendationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postSubmissionCancelRecommendations({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Submission
 *
 * DELETE /api/v3/submissions/{submission_uuid}
 *
 * Also open to the Contender Actions connector (``X-MCP-API-Key`` +
 * ``X-Acting-User-Email``, see ``app.api.deps.auth.agent``).
 */
export const deleteSubmissionMutation = (options?: Partial<Options<DeleteSubmissionData>>): UseMutationOptions<DeleteSubmissionResponse, AxiosError<DeleteSubmissionError>, Options<DeleteSubmissionData>> => {
    const mutationOptions: UseMutationOptions<DeleteSubmissionResponse, AxiosError<DeleteSubmissionError>, Options<DeleteSubmissionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteSubmission({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSubmissionQueryKey = (options: Options<GetSubmissionData>) => createQueryKey('getSubmission', options);

/**
 * Get Submission
 *
 * GET /api/v3/submissions/{submission_uuid}
 *
 * Also open to the Contender Actions connector (``X-MCP-API-Key`` +
 * ``X-Acting-User-Email``, see ``app.api.deps.auth.agent``).
 */
export const getSubmissionOptions = (options: Options<GetSubmissionData>) => queryOptions<GetSubmissionResponse, AxiosError<GetSubmissionError>, GetSubmissionResponse, ReturnType<typeof getSubmissionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSubmission({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSubmissionQueryKey(options)
});

/**
 * Put Submission
 *
 * PUT /api/v3/submissions/{submission_uuid}
 */
export const putSubmissionMutation = (options?: Partial<Options<PutSubmissionData>>): UseMutationOptions<PutSubmissionResponse, AxiosError<PutSubmissionError>, Options<PutSubmissionData>> => {
    const mutationOptions: UseMutationOptions<PutSubmissionResponse, AxiosError<PutSubmissionError>, Options<PutSubmissionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putSubmission({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Put Submission Status
 *
 * PUT /api/v3/submissions/{submission_uuid}/status
 *
 * Also open to the Contender Actions connector (``X-MCP-API-Key`` +
 * ``X-Acting-User-Email``, see ``app.api.deps.auth.agent``).
 */
export const putSubmissionStatusMutation = (options?: Partial<Options<PutSubmissionStatusData>>): UseMutationOptions<PutSubmissionStatusResponse, AxiosError<PutSubmissionStatusError>, Options<PutSubmissionStatusData>> => {
    const mutationOptions: UseMutationOptions<PutSubmissionStatusResponse, AxiosError<PutSubmissionStatusError>, Options<PutSubmissionStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putSubmissionStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postTeamCandidatesFilterV3QueryKey = (options: Options<PostTeamCandidatesFilterV3Data>) => createQueryKey('postTeamCandidatesFilterV3', options);

/**
 * Post Team Candidates Filter V3
 *
 * POST /api/v3/teams/{team_uuid}/candidates/filter
 */
export const postTeamCandidatesFilterV3Options = (options: Options<PostTeamCandidatesFilterV3Data>) => queryOptions<PostTeamCandidatesFilterV3Response, AxiosError<PostTeamCandidatesFilterV3Error>, PostTeamCandidatesFilterV3Response, ReturnType<typeof postTeamCandidatesFilterV3QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await postTeamCandidatesFilterV3({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: postTeamCandidatesFilterV3QueryKey(options)
});

export const postTeamCandidatesFilterV3InfiniteQueryKey = (options: Options<PostTeamCandidatesFilterV3Data>): QueryKey<Options<PostTeamCandidatesFilterV3Data>> => createQueryKey('postTeamCandidatesFilterV3', options, true);

/**
 * Post Team Candidates Filter V3
 *
 * POST /api/v3/teams/{team_uuid}/candidates/filter
 */
export const postTeamCandidatesFilterV3InfiniteOptions = (options: Options<PostTeamCandidatesFilterV3Data>) => {
    const opts = infiniteQueryOptions<PostTeamCandidatesFilterV3Response, AxiosError<PostTeamCandidatesFilterV3Error>, InfiniteData<PostTeamCandidatesFilterV3Response>, QueryKey<Options<PostTeamCandidatesFilterV3Data>>, number | Pick<QueryKey<Options<PostTeamCandidatesFilterV3Data>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PostTeamCandidatesFilterV3Data>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                body: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await postTeamCandidatesFilterV3({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postTeamCandidatesFilterV3InfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Post Team Candidates Filter V3
 *
 * POST /api/v3/teams/{team_uuid}/candidates/filter
 */
export const postTeamCandidatesFilterV3Mutation = (options?: Partial<Options<PostTeamCandidatesFilterV3Data>>): UseMutationOptions<PostTeamCandidatesFilterV3Response, AxiosError<PostTeamCandidatesFilterV3Error>, Options<PostTeamCandidatesFilterV3Data>> => {
    const mutationOptions: UseMutationOptions<PostTeamCandidatesFilterV3Response, AxiosError<PostTeamCandidatesFilterV3Error>, Options<PostTeamCandidatesFilterV3Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTeamCandidatesFilterV3({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
